(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["alma-tokens"] = {}));
})(this, function (exports) {
  'use strict';
  /**
   * Do not edit directly
   * Generated on Thu, 27 Oct 2022 18:07:46 GMT
   */

  var BorderRadiusNone$8 = "0px";
  var BorderRadiusXs$8 = "4px";
  var BorderRadiusSm$8 = "8px";
  var BorderRadiusMd$8 = "16px";
  var BorderRadiusLg$8 = "24px";
  var BorderRadiusPill$8 = "960px";
  var BorderRadiusCircle$8 = "50%";
  var BorderWidthNone$8 = "0px";
  var BorderWidthHairline$8 = "1px";
  var BorderWidthThin$8 = "2px";
  var BorderWidthThick$8 = "4px";
  var BorderWidthHeavy$8 = "8px";
  var ColorDatavizInfoText$8 = "#0F58EA";
  var ColorDatavizInfoShape01$8 = "#3F7BF2";
  var ColorDatavizInfoShape02$8 = "#D9E5FC";
  var ColorDatavizInfoShape03$8 = "#F1F5FE";
  var ColorDatavizNegativeText$8 = "#BC293A";
  var ColorDatavizNegativeShape01$8 = "#EA4356";
  var ColorDatavizNegativeShape02$8 = "#FDDDE1";
  var ColorDatavizNegativeShape03$8 = "#FEF1F2";
  var ColorDatavizWarningText$8 = "#A04C03";
  var ColorDatavizWarningShape01$8 = "#D26404";
  var ColorDatavizWarningShape02$8 = "#FEE1C8";
  var ColorDatavizWarningShape03$8 = "#FEF1E6";
  var ColorDatavizPositiveText$8 = "#22723A";
  var ColorDatavizPositiveShape01$8 = "#2D954C";
  var ColorDatavizPositiveShape02$8 = "#C8EED3";
  var ColorDatavizPositiveShape03$8 = "#E8F8EC";
  var ColorDatavizCatAText$8 = "#9B18DC";
  var ColorDatavizCatAShape01$8 = "#B851EC";
  var ColorDatavizCatAShape02$8 = "#F2DFFB";
  var ColorDatavizCatAShape03$8 = "#F9F1FD";
  var ColorDatavizCatBText$8 = "#BA267B";
  var ColorDatavizCatBShape01$8 = "#DA499B";
  var ColorDatavizCatBShape02$8 = "#F8DDEC";
  var ColorDatavizCatBShape03$8 = "#FCF2F8";
  var ColorDatavizCatCText$8 = "#546E21";
  var ColorDatavizCatCShape01$8 = "#6C8D2B";
  var ColorDatavizCatCShape02$8 = "#DBEBBD";
  var ColorDatavizCatCShape03$8 = "#F0F7E4";
  var ColorDatavizCatDText$8 = "#0D735E";
  var ColorDatavizCatDShape01$8 = "#109379";
  var ColorDatavizCatDShape02$8 = "#BCF0E6";
  var ColorDatavizCatDShape03$8 = "#DFFBF6";
  var ColorDatavizInverseInfoText$8 = "#5C8FF5";
  var ColorDatavizInverseInfoShape01$8 = "#286BF1";
  var ColorDatavizInverseInfoShape02$8 = "#062560";
  var ColorDatavizInverseInfoShape03$8 = "#051B48";
  var ColorDatavizInverseNegativeText$8 = "#F55C6E";
  var ColorDatavizInverseNegativeShape01$8 = "#D83145";
  var ColorDatavizInverseNegativeShape02$8 = "#4F1119";
  var ColorDatavizInverseNegativeShape03$8 = "#3B0D12";
  var ColorDatavizInverseWarningText$8 = "#EB7005";
  var ColorDatavizInverseWarningShape01$8 = "#B95804";
  var ColorDatavizInverseWarningShape02$8 = "#462101";
  var ColorDatavizInverseWarningShape03$8 = "#321701";
  var ColorDatavizInversePositiveText$8 = "#32A454";
  var ColorDatavizInversePositiveShape01$8 = "#278142";
  var ColorDatavizInversePositiveShape02$8 = "#0E2F18";
  var ColorDatavizInversePositiveShape03$8 = "#0B2312";
  var ColorDatavizInverseCatAText$8 = "#C36CEF";
  var ColorDatavizInverseCatAShape01$8 = "#AD35E9";
  var ColorDatavizInverseCatAShape02$8 = "#440B60";
  var ColorDatavizInverseCatAShape03$8 = "#340849";
  var ColorDatavizInverseCatBText$8 = "#E067AB";
  var ColorDatavizInverseCatBShape01$8 = "#D42B8C";
  var ColorDatavizInverseCatBShape02$8 = "#4C1032";
  var ColorDatavizInverseCatBShape03$8 = "#3B0C27";
  var ColorDatavizInverseCatCText$8 = "#789D2F";
  var ColorDatavizInverseCatCShape01$8 = "#607E26";
  var ColorDatavizInverseCatCShape02$8 = "#212B0D";
  var ColorDatavizInverseCatCShape03$8 = "#1B230B";
  var ColorDatavizInverseCatDText$8 = "#12A588";
  var ColorDatavizInverseCatDShape01$8 = "#0F856D";
  var ColorDatavizInverseCatDShape02$8 = "#052E26";
  var ColorDatavizInverseCatDShape03$8 = "#04251E";
  var ColorInteractionBlend01$8 = "#1616160A";
  var ColorInteractionBlend02$8 = "#16161614";
  var ColorInteractionBlend03$8 = "#1616161F";
  var ColorInteractionBlend04$8 = "#1616163D";
  var ColorInteractionBlend05$8 = "#161616A3";
  var ColorInteractionBlend06$8 = "#161616B8";
  var ColorInteractionBlend07$8 = "#161616E0";
  var ColorInteractionBlend08$8 = "#161616";
  var ColorInteractionInverseBlend01$8 = "#FEFEFE14";
  var ColorInteractionInverseBlend02$8 = "#FEFEFE1F";
  var ColorInteractionInverseBlend03$8 = "#FEFEFE3D";
  var ColorInteractionInverseBlend04$8 = "#FEFEFE52";
  var ColorInteractionInverseBlend05$8 = "#FEFEFEA3";
  var ColorInteractionInverseBlend06$8 = "#FEFEFEB8";
  var ColorInteractionInverseBlend07$8 = "#FEFEFEE0";
  var ColorInteractionInverseBlend08$8 = "#FEFEFE";
  var ColorInteractionInverseAccent01$8 = "#BE99EE";
  var ColorInteractionInverseAccent02$8 = "#D2B8F3";
  var ColorInteractionInverseAccent03$8 = "#E5D7F8";
  var ColorInteractionInverseSubtle01$8 = "#BE99EE1F";
  var ColorInteractionInverseSubtle02$8 = "#BE99EE3D";
  var ColorInteractionInverseSubtle03$8 = "#BE99EE52";
  var ColorInteractionInverseSelectDefault$8 = "#595959";
  var ColorInteractionInverseSelectFocus$8 = "#FEFEFE";
  var ColorInteractionInverseSelectActive$8 = "#E5D7F8";
  var ColorInteractionInverseDanger01$8 = "#92202E";
  var ColorInteractionInverseDanger02$8 = "#A72534";
  var ColorInteractionInverseDanger03$8 = "#BC293A";
  var ColorInteractionInverseOnBrandAccent01$8 = "#161616";
  var ColorInteractionInverseOnBrandAccent02$8 = "#161616E8";
  var ColorInteractionInverseOnBrandAccent03$8 = "#161616B8";
  var ColorInteractionInverseOnBrandSubtle01$8 = "#16161614";
  var ColorInteractionInverseOnBrandSubtle02$8 = "#1616161F";
  var ColorInteractionInverseOnBrandSubtle03$8 = "#1616163D";
  var ColorInteractionInverseOnBrandSelectDefault$8 = "#161616";
  var ColorInteractionInverseOnBrandSelectFocus$8 = "#161616";
  var ColorInteractionInverseOnBrandSelectActive$8 = "#161616";
  var ColorInteractionInverseOnBrandBlend01$8 = "#1616160A";
  var ColorInteractionInverseOnBrandBlend02$8 = "#16161614";
  var ColorInteractionInverseOnBrandBlend03$8 = "#1616161F";
  var ColorInteractionInverseOnBrandBlend04$8 = "#1616163D";
  var ColorInteractionInverseOnBrandBlend05$8 = "#161616A3";
  var ColorInteractionInverseOnBrandBlend06$8 = "#161616B8";
  var ColorInteractionInverseOnBrandBlend07$8 = "#161616E0";
  var ColorInteractionInverseOnBrandBlend08$8 = "#161616";
  var ColorInteractionInverseOnBrandDanger01$8 = "#161616";
  var ColorInteractionInverseOnBrandDanger02$8 = "#161616E0";
  var ColorInteractionInverseOnBrandDanger03$8 = "#161616B8";
  var ColorInteractionAccent01$8 = "#833BDF";
  var ColorInteractionAccent02$8 = "#7A38CF";
  var ColorInteractionAccent03$8 = "#6932AF";
  var ColorInteractionSubtle01$8 = "#833BDF1F";
  var ColorInteractionSubtle02$8 = "#833BDF3D";
  var ColorInteractionSubtle03$8 = "#833BDF52";
  var ColorInteractionSelectDefault$8 = "#363636";
  var ColorInteractionSelectFocus$8 = "#161616";
  var ColorInteractionSelectActive$8 = "#6932AF";
  var ColorInteractionDanger01$8 = "#7E1B27";
  var ColorInteractionDanger02$8 = "#691721";
  var ColorInteractionDanger03$8 = "#4F1119";
  var ColorInteractionOnBrandAccent01$8 = "#FEFEFE";
  var ColorInteractionOnBrandAccent02$8 = "#FEFEFEE0";
  var ColorInteractionOnBrandAccent03$8 = "#FEFEFEB8";
  var ColorInteractionOnBrandSubtle01$8 = "#FEFEFE1F";
  var ColorInteractionOnBrandSubtle02$8 = "#FEFEFE3D";
  var ColorInteractionOnBrandSubtle03$8 = "#FEFEFE52";
  var ColorInteractionOnBrandSelectDefault$8 = "#FEFEFE";
  var ColorInteractionOnBrandSelectFocus$8 = "#FEFEFE";
  var ColorInteractionOnBrandSelectActive$8 = "#FEFEFE";
  var ColorInteractionOnBrandBlend01$8 = "#FEFEFE14";
  var ColorInteractionOnBrandBlend02$8 = "#FEFEFE1F";
  var ColorInteractionOnBrandBlend03$8 = "#FEFEFE3D";
  var ColorInteractionOnBrandBlend04$8 = "#FEFEFE52";
  var ColorInteractionOnBrandBlend05$8 = "#FEFEFEA3";
  var ColorInteractionOnBrandBlend06$8 = "#FEFEFEB8";
  var ColorInteractionOnBrandBlend07$8 = "#FEFEFEE0";
  var ColorInteractionOnBrandBlend08$8 = "#FEFEFE";
  var ColorInteractionOnBrandDanger01$8 = "#FEFEFE";
  var ColorInteractionOnBrandDanger02$8 = "#FEFEFEE0";
  var ColorInteractionOnBrandDanger03$8 = "#FEFEFEB8";
  var ColorNeutral10$8 = "#F5F5F5";
  var ColorNeutral20$8 = "#E6E6E6";
  var ColorNeutral30$8 = "#1616163D";
  var ColorNeutral00$8 = "#FEFEFE";
  var ColorNeutralInverse10$8 = "#1F1F1F";
  var ColorNeutralInverse20$8 = "#292929";
  var ColorNeutralInverse30$8 = "#FEFEFE3D";
  var ColorNeutralInverse00$8 = "#161616";
  var ColorNeutralInverseOnBrand10$8 = "#572C8F";
  var ColorNeutralInverseOnBrand20$8 = "#6932AF";
  var ColorNeutralInverseOnBrand30$8 = "#833BDFE0";
  var ColorNeutralInverseOnBrand00$8 = "#161616";
  var ColorNeutralOnBrand10$8 = "#EFE7FA";
  var ColorNeutralOnBrand20$8 = "#E5D7F8";
  var ColorNeutralOnBrand30$8 = "#BE99EEE0";
  var ColorNeutralOnBrand00$8 = "#FEFEFE";
  var ColorPaletteBlack$8 = "#161616";
  var ColorPaletteWhite$8 = "#FEFEFE";
  var ColorPaletteGray10$8 = "#1F1F1F";
  var ColorPaletteGray20$8 = "#292929";
  var ColorPaletteGray30$8 = "#363636";
  var ColorPaletteGray40$8 = "#404040";
  var ColorPaletteGray50$8 = "#4C4C4C";
  var ColorPaletteGray60$8 = "#595959";
  var ColorPaletteGray70$8 = "#666666";
  var ColorPaletteGray80$8 = "#737373";
  var ColorPaletteGray90$8 = "#828282";
  var ColorPaletteGray100$8 = "#919191";
  var ColorPaletteGray110$8 = "#A1A1A1";
  var ColorPaletteGray120$8 = "#B0B0B0";
  var ColorPaletteGray130$8 = "#C2C2C2";
  var ColorPaletteGray140$8 = "#D4D4D4";
  var ColorPaletteGray150$8 = "#E6E6E6";
  var ColorPaletteGray160$8 = "#F5F5F5";
  var ColorPaletteRed10$8 = "#3B0D12";
  var ColorPaletteRed20$8 = "#4F1119";
  var ColorPaletteRed30$8 = "#691721";
  var ColorPaletteRed40$8 = "#7E1B27";
  var ColorPaletteRed50$8 = "#92202E";
  var ColorPaletteRed60$8 = "#A72534";
  var ColorPaletteRed70$8 = "#BC293A";
  var ColorPaletteRed80$8 = "#D83145";
  var ColorPaletteRed90$8 = "#EA4356";
  var ColorPaletteRed100$8 = "#F55C6E";
  var ColorPaletteRed110$8 = "#F77E8C";
  var ColorPaletteRed120$8 = "#F895A1";
  var ColorPaletteRed130$8 = "#FAAEB6";
  var ColorPaletteRed140$8 = "#FBC5CC";
  var ColorPaletteRed150$8 = "#FDDDE1";
  var ColorPaletteRed160$8 = "#FEF1F2";
  var ColorPaletteYellow10$8 = "#321701";
  var ColorPaletteYellow20$8 = "#462101";
  var ColorPaletteYellow30$8 = "#552802";
  var ColorPaletteYellow40$8 = "#693102";
  var ColorPaletteYellow50$8 = "#7D3B03";
  var ColorPaletteYellow60$8 = "#914503";
  var ColorPaletteYellow70$8 = "#A04C03";
  var ColorPaletteYellow80$8 = "#B95804";
  var ColorPaletteYellow90$8 = "#D26404";
  var ColorPaletteYellow100$8 = "#EB7005";
  var ColorPaletteYellow110$8 = "#FA8219";
  var ColorPaletteYellow120$8 = "#FB9B46";
  var ColorPaletteYellow130$8 = "#FCB06E";
  var ColorPaletteYellow140$8 = "#FDC99B";
  var ColorPaletteYellow150$8 = "#FEE1C8";
  var ColorPaletteYellow160$8 = "#FEF1E6";
  var ColorPaletteLime10$8 = "#1B230B";
  var ColorPaletteLime20$8 = "#212B0D";
  var ColorPaletteLime30$8 = "#2D3B12";
  var ColorPaletteLime40$8 = "#364616";
  var ColorPaletteLime50$8 = "#3F5219";
  var ColorPaletteLime60$8 = "#485E1D";
  var ColorPaletteLime70$8 = "#546E21";
  var ColorPaletteLime80$8 = "#607E26";
  var ColorPaletteLime90$8 = "#6C8D2B";
  var ColorPaletteLime100$8 = "#789D2F";
  var ColorPaletteLime110$8 = "#84AC34";
  var ColorPaletteLime120$8 = "#93BF3A";
  var ColorPaletteLime130$8 = "#A9CF5E";
  var ColorPaletteLime140$8 = "#C2DD8D";
  var ColorPaletteLime150$8 = "#DBEBBD";
  var ColorPaletteLime160$8 = "#F0F7E4";
  var ColorPaletteGreen10$8 = "#0B2312";
  var ColorPaletteGreen20$8 = "#0E2F18";
  var ColorPaletteGreen30$8 = "#133E20";
  var ColorPaletteGreen40$8 = "#174A26";
  var ColorPaletteGreen50$8 = "#1A562C";
  var ColorPaletteGreen60$8 = "#1F6634";
  var ColorPaletteGreen70$8 = "#22723A";
  var ColorPaletteGreen80$8 = "#278142";
  var ColorPaletteGreen90$8 = "#2D954C";
  var ColorPaletteGreen100$8 = "#32A454";
  var ColorPaletteGreen110$8 = "#38B85E";
  var ColorPaletteGreen120$8 = "#4BC870";
  var ColorPaletteGreen130$8 = "#76D692";
  var ColorPaletteGreen140$8 = "#9DE2B1";
  var ColorPaletteGreen150$8 = "#C8EED3";
  var ColorPaletteGreen160$8 = "#E8F8EC";
  var ColorPaletteAcqua10$8 = "#04251E";
  var ColorPaletteAcqua20$8 = "#052E26";
  var ColorPaletteAcqua30$8 = "#073C31";
  var ColorPaletteAcqua40$8 = "#08493C";
  var ColorPaletteAcqua50$8 = "#0A5748";
  var ColorPaletteAcqua60$8 = "#0B6553";
  var ColorPaletteAcqua70$8 = "#0D735E";
  var ColorPaletteAcqua80$8 = "#0F856D";
  var ColorPaletteAcqua90$8 = "#109379";
  var ColorPaletteAcqua100$8 = "#12A588";
  var ColorPaletteAcqua110$8 = "#14B897";
  var ColorPaletteAcqua120$8 = "#31C4A6";
  var ColorPaletteAcqua130$8 = "#68D4BF";
  var ColorPaletteAcqua140$8 = "#8DE2D1";
  var ColorPaletteAcqua150$8 = "#BCF0E6";
  var ColorPaletteAcqua160$8 = "#DFFBF6";
  var ColorPaletteBlue10$8 = "#051B48";
  var ColorPaletteBlue20$8 = "#062560";
  var ColorPaletteBlue30$8 = "#082F7D";
  var ColorPaletteBlue40$8 = "#0A3A9A";
  var ColorPaletteBlue50$8 = "#0B43B1";
  var ColorPaletteBlue60$8 = "#0D4ECE";
  var ColorPaletteBlue70$8 = "#0F58EA";
  var ColorPaletteBlue80$8 = "#286BF1";
  var ColorPaletteBlue90$8 = "#3F7BF2";
  var ColorPaletteBlue100$8 = "#5C8FF5";
  var ColorPaletteBlue110$8 = "#73A0F7";
  var ColorPaletteBlue120$8 = "#8CB0F8";
  var ColorPaletteBlue130$8 = "#A9C4F9";
  var ColorPaletteBlue140$8 = "#C1D4FB";
  var ColorPaletteBlue150$8 = "#D9E5FC";
  var ColorPaletteBlue160$8 = "#F1F5FE";
  var ColorPalettePurple10$8 = "#340849";
  var ColorPalettePurple20$8 = "#440B60";
  var ColorPalettePurple30$8 = "#540D78";
  var ColorPalettePurple40$8 = "#671093";
  var ColorPalettePurple50$8 = "#7713AA";
  var ColorPalettePurple60$8 = "#8B16C5";
  var ColorPalettePurple70$8 = "#9B18DC";
  var ColorPalettePurple80$8 = "#AD35E9";
  var ColorPalettePurple90$8 = "#B851EC";
  var ColorPalettePurple100$8 = "#C36CEF";
  var ColorPalettePurple110$8 = "#CC83F1";
  var ColorPalettePurple120$8 = "#D69AF4";
  var ColorPalettePurple130$8 = "#DFB1F6";
  var ColorPalettePurple140$8 = "#E8C8F9";
  var ColorPalettePurple150$8 = "#F2DFFB";
  var ColorPalettePurple160$8 = "#F9F1FD";
  var ColorPalettePink10$8 = "#3B0C27";
  var ColorPalettePink20$8 = "#4C1032";
  var ColorPalettePink30$8 = "#661543";
  var ColorPalettePink40$8 = "#77184E";
  var ColorPalettePink50$8 = "#8C1C5D";
  var ColorPalettePink60$8 = "#A12169";
  var ColorPalettePink70$8 = "#BA267B";
  var ColorPalettePink80$8 = "#D42B8C";
  var ColorPalettePink90$8 = "#DA499B";
  var ColorPalettePink100$8 = "#E067AB";
  var ColorPalettePink110$8 = "#E580B9";
  var ColorPalettePink120$8 = "#EA99C7";
  var ColorPalettePink130$8 = "#EFAFD3";
  var ColorPalettePink140$8 = "#F4C8E1";
  var ColorPalettePink150$8 = "#F8DDEC";
  var ColorPalettePink160$8 = "#FCF2F8";
  var ColorTypefaceStrong$8 = "#161616";
  var ColorTypefacePure$8 = "#363636";
  var ColorTypefaceSmooth$8 = "#666666";
  var ColorTypefaceMeld$8 = "#1616163D";
  var ColorTypefaceInverseStrong$8 = "#FEFEFE";
  var ColorTypefaceInversePure$8 = "#D4D4D4";
  var ColorTypefaceInverseSmooth$8 = "#919191";
  var ColorTypefaceInverseMeld$8 = "#FEFEFE52";
  var ColorTypefaceInverseOnBrandStrong$8 = "#161616";
  var ColorTypefaceInverseOnBrandPure$8 = "#161616E0";
  var ColorTypefaceInverseOnBrandSmooth$8 = "#161616B8";
  var ColorTypefaceInverseOnBrandMeld$8 = "#1616163D";
  var ColorTypefaceOnBrandStrong$8 = "#FEFEFE";
  var ColorTypefaceOnBrandPure$8 = "#FEFEFEE0";
  var ColorTypefaceOnBrandSmooth$8 = "#FEFEFEB8";
  var ColorTypefaceOnBrandMeld$8 = "#FEFEFE52";
  var ColorBrandPrimary10$8 = "#572C8F";
  var ColorBrandPrimary20$8 = "#6932AF";
  var ColorBrandPrimary30$8 = "#7A38CF";
  var ColorBrandPrimary40$8 = "#833BDF";
  var ColorBrandPrimary50$8 = "#BE99EE";
  var ColorBrandPrimary60$8 = "#D2B8F3";
  var ColorBrandPrimary70$8 = "#E5D7F8";
  var ColorBrandPrimary80$8 = "#EFE7FA";
  var ColorFeedbackErrorText$8 = "#3B0D12";
  var ColorFeedbackErrorShape$8 = "#7E1B27";
  var ColorFeedbackSuccessText$8 = "#0B2312";
  var ColorFeedbackSuccessShape$8 = "#174A26";
  var ColorFeedbackOnBrandErrorText$8 = "#FEFEFE";
  var ColorFeedbackOnBrandErrorShape$8 = "#FEFEFEB8";
  var ColorFeedbackOnBrandSuccessText$8 = "#FEFEFE";
  var ColorFeedbackOnBrandSuccessShape$8 = "#FEFEFEB8";
  var ColorFeedbackInverseErrorText$8 = "#BC293A";
  var ColorFeedbackInverseErrorShape$8 = "#92202E";
  var ColorFeedbackInverseSuccessText$8 = "#22723A";
  var ColorFeedbackInverseSuccessShape$8 = "#1A562C";
  var ColorFeedbackInverseOnBrandErrorText$8 = "#161616";
  var ColorFeedbackInverseOnBrandErrorShape$8 = "#161616B8";
  var ColorFeedbackInverseOnBrandSuccessText$8 = "#161616";
  var ColorFeedbackInverseOnBrandSuccessShape$8 = "#161616B8";
  var ColorSupport01$8 = "#F358AC";
  var ColorSupport02$8 = "#E1479A";
  var ColorSupportOnBrand01$8 = "#FF9ED3";
  var ColorSupportOnBrand02$8 = "#FFC2DB";
  var ColorSupportInverse01$8 = "#FF6FBD";
  var ColorSupportInverse02$8 = "#FF6FBD";
  var ColorSupportInverseOnBrand01$8 = "#9F2868";
  var ColorSupportInverseOnBrand02$8 = "#8F245D";
  var Opacity01$8 = "0.04";
  var Opacity02$8 = "0.08";
  var Opacity03$8 = "0.12";
  var Opacity04$8 = "0.24";
  var Opacity05$8 = "0.32";
  var Opacity06$8 = "0.56";
  var Opacity07$8 = "0.64";
  var Opacity08$8 = "0.72";
  var Opacity09$8 = "0.88";
  var Shadow01$8 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
  var Shadow02$8 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
  var Shadow03$8 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
  var Shadow04$8 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
  var SpacingInlineQuark$8 = "4px";
  var SpacingInlineNano$8 = "8px";
  var SpacingInlineXxxs$8 = "16px";
  var SpacingInlineXxs$8 = "24px";
  var SpacingInlineXs$8 = "32px";
  var SpacingInlineSm$8 = "40px";
  var SpacingInlineMd$8 = "48px";
  var SpacingInlineLg$8 = "56px";
  var SpacingInlineXl$8 = "64px";
  var SpacingInlineXxl$8 = "80px";
  var SpacingInlineXxxl$8 = "120px";
  var SpacingInlineHuge$8 = "160px";
  var SpacingInlineGiant$8 = "200px";
  var SpacingInsetQuark$8 = "4px";
  var SpacingInsetNano$8 = "8px";
  var SpacingInsetXs$8 = "16px";
  var SpacingInsetSm$8 = "24px";
  var SpacingInsetMd$8 = "32px";
  var SpacingInsetLg$8 = "40px";
  var SpacingSquishQuark$8 = "4px 8px";
  var SpacingSquishNano$8 = "8px 16px";
  var SpacingSquishXs$8 = "16px 24px";
  var SpacingSquishSm$8 = "16px 32px";
  var SpacingStackQuark$8 = "4px";
  var SpacingStackNano$8 = "8px";
  var SpacingStackXxxs$8 = "16px";
  var SpacingStackXxs$8 = "24px";
  var SpacingStackXs$8 = "32px";
  var SpacingStackSm$8 = "40px";
  var SpacingStackMd$8 = "48px";
  var SpacingStackLg$8 = "56px";
  var SpacingStackXl$8 = "64px";
  var SpacingStackXxl$8 = "80px";
  var SpacingStackXxxl$8 = "120px";
  var SpacingStackHuge$8 = "160px";
  var SpacingStackGiant$8 = "200px";
  var FontFamilyBase$8 = "'Dasa Sans', 'sans-serif'";
  var FontSizeXxxs$8 = "0.75rem";
  var FontSizeXxs$8 = "0.875rem";
  var FontSizeXs$8 = "1rem";
  var FontSizeSm$8 = "1.25rem";
  var FontSizeMd$8 = "1.5rem";
  var FontSizeLg$8 = "2rem";
  var FontSizeXl$8 = "2.5rem";
  var FontSizeXxl$8 = "3rem";
  var FontSizeXxxl$8 = "4rem";
  var FontSizeDisplay$8 = "5rem";
  var FontSizeGiant$8 = "6rem";
  var FontWeightBold$8 = 700;
  var FontWeightSemibold$8 = 600;
  var FontWeightMedium$8 = 500;
  var FontWeightRegular$8 = 400;
  var FontWeightLight$8 = 300;
  var LetterSpacingStandard$8 = "0px";
  var LetterSpacingSmall$8 = "-1px";
  var LetterSpacingMedium$8 = "1.5px";
  var LineHeightStandard$8 = "100%";
  var LineHeightTiny$8 = "115%";
  var LineHeightMedium$8 = "120%";
  var LineHeightLarge$8 = "125%";
  var LineHeightDistant$8 = "133%";
  var LineHeightSuperdistant$8 = "150%";
  var LineHeightHuge$8 = "170%";
  var index$8 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BorderRadiusNone: BorderRadiusNone$8,
    BorderRadiusXs: BorderRadiusXs$8,
    BorderRadiusSm: BorderRadiusSm$8,
    BorderRadiusMd: BorderRadiusMd$8,
    BorderRadiusLg: BorderRadiusLg$8,
    BorderRadiusPill: BorderRadiusPill$8,
    BorderRadiusCircle: BorderRadiusCircle$8,
    BorderWidthNone: BorderWidthNone$8,
    BorderWidthHairline: BorderWidthHairline$8,
    BorderWidthThin: BorderWidthThin$8,
    BorderWidthThick: BorderWidthThick$8,
    BorderWidthHeavy: BorderWidthHeavy$8,
    ColorDatavizInfoText: ColorDatavizInfoText$8,
    ColorDatavizInfoShape01: ColorDatavizInfoShape01$8,
    ColorDatavizInfoShape02: ColorDatavizInfoShape02$8,
    ColorDatavizInfoShape03: ColorDatavizInfoShape03$8,
    ColorDatavizNegativeText: ColorDatavizNegativeText$8,
    ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$8,
    ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$8,
    ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$8,
    ColorDatavizWarningText: ColorDatavizWarningText$8,
    ColorDatavizWarningShape01: ColorDatavizWarningShape01$8,
    ColorDatavizWarningShape02: ColorDatavizWarningShape02$8,
    ColorDatavizWarningShape03: ColorDatavizWarningShape03$8,
    ColorDatavizPositiveText: ColorDatavizPositiveText$8,
    ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$8,
    ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$8,
    ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$8,
    ColorDatavizCatAText: ColorDatavizCatAText$8,
    ColorDatavizCatAShape01: ColorDatavizCatAShape01$8,
    ColorDatavizCatAShape02: ColorDatavizCatAShape02$8,
    ColorDatavizCatAShape03: ColorDatavizCatAShape03$8,
    ColorDatavizCatBText: ColorDatavizCatBText$8,
    ColorDatavizCatBShape01: ColorDatavizCatBShape01$8,
    ColorDatavizCatBShape02: ColorDatavizCatBShape02$8,
    ColorDatavizCatBShape03: ColorDatavizCatBShape03$8,
    ColorDatavizCatCText: ColorDatavizCatCText$8,
    ColorDatavizCatCShape01: ColorDatavizCatCShape01$8,
    ColorDatavizCatCShape02: ColorDatavizCatCShape02$8,
    ColorDatavizCatCShape03: ColorDatavizCatCShape03$8,
    ColorDatavizCatDText: ColorDatavizCatDText$8,
    ColorDatavizCatDShape01: ColorDatavizCatDShape01$8,
    ColorDatavizCatDShape02: ColorDatavizCatDShape02$8,
    ColorDatavizCatDShape03: ColorDatavizCatDShape03$8,
    ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$8,
    ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$8,
    ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$8,
    ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$8,
    ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$8,
    ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$8,
    ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$8,
    ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$8,
    ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$8,
    ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$8,
    ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$8,
    ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$8,
    ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$8,
    ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$8,
    ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$8,
    ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$8,
    ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$8,
    ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$8,
    ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$8,
    ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$8,
    ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$8,
    ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$8,
    ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$8,
    ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$8,
    ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$8,
    ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$8,
    ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$8,
    ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$8,
    ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$8,
    ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$8,
    ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$8,
    ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$8,
    ColorInteractionBlend01: ColorInteractionBlend01$8,
    ColorInteractionBlend02: ColorInteractionBlend02$8,
    ColorInteractionBlend03: ColorInteractionBlend03$8,
    ColorInteractionBlend04: ColorInteractionBlend04$8,
    ColorInteractionBlend05: ColorInteractionBlend05$8,
    ColorInteractionBlend06: ColorInteractionBlend06$8,
    ColorInteractionBlend07: ColorInteractionBlend07$8,
    ColorInteractionBlend08: ColorInteractionBlend08$8,
    ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$8,
    ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$8,
    ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$8,
    ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$8,
    ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$8,
    ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$8,
    ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$8,
    ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$8,
    ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$8,
    ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$8,
    ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$8,
    ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$8,
    ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$8,
    ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$8,
    ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$8,
    ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$8,
    ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$8,
    ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$8,
    ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$8,
    ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$8,
    ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$8,
    ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$8,
    ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$8,
    ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$8,
    ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$8,
    ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$8,
    ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$8,
    ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$8,
    ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$8,
    ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$8,
    ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$8,
    ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$8,
    ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$8,
    ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$8,
    ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$8,
    ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$8,
    ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$8,
    ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$8,
    ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$8,
    ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$8,
    ColorInteractionAccent01: ColorInteractionAccent01$8,
    ColorInteractionAccent02: ColorInteractionAccent02$8,
    ColorInteractionAccent03: ColorInteractionAccent03$8,
    ColorInteractionSubtle01: ColorInteractionSubtle01$8,
    ColorInteractionSubtle02: ColorInteractionSubtle02$8,
    ColorInteractionSubtle03: ColorInteractionSubtle03$8,
    ColorInteractionSelectDefault: ColorInteractionSelectDefault$8,
    ColorInteractionSelectFocus: ColorInteractionSelectFocus$8,
    ColorInteractionSelectActive: ColorInteractionSelectActive$8,
    ColorInteractionDanger01: ColorInteractionDanger01$8,
    ColorInteractionDanger02: ColorInteractionDanger02$8,
    ColorInteractionDanger03: ColorInteractionDanger03$8,
    ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$8,
    ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$8,
    ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$8,
    ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$8,
    ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$8,
    ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$8,
    ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$8,
    ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$8,
    ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$8,
    ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$8,
    ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$8,
    ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$8,
    ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$8,
    ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$8,
    ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$8,
    ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$8,
    ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$8,
    ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$8,
    ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$8,
    ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$8,
    ColorNeutral10: ColorNeutral10$8,
    ColorNeutral20: ColorNeutral20$8,
    ColorNeutral30: ColorNeutral30$8,
    ColorNeutral00: ColorNeutral00$8,
    ColorNeutralInverse10: ColorNeutralInverse10$8,
    ColorNeutralInverse20: ColorNeutralInverse20$8,
    ColorNeutralInverse30: ColorNeutralInverse30$8,
    ColorNeutralInverse00: ColorNeutralInverse00$8,
    ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$8,
    ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$8,
    ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$8,
    ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$8,
    ColorNeutralOnBrand10: ColorNeutralOnBrand10$8,
    ColorNeutralOnBrand20: ColorNeutralOnBrand20$8,
    ColorNeutralOnBrand30: ColorNeutralOnBrand30$8,
    ColorNeutralOnBrand00: ColorNeutralOnBrand00$8,
    ColorPaletteBlack: ColorPaletteBlack$8,
    ColorPaletteWhite: ColorPaletteWhite$8,
    ColorPaletteGray10: ColorPaletteGray10$8,
    ColorPaletteGray20: ColorPaletteGray20$8,
    ColorPaletteGray30: ColorPaletteGray30$8,
    ColorPaletteGray40: ColorPaletteGray40$8,
    ColorPaletteGray50: ColorPaletteGray50$8,
    ColorPaletteGray60: ColorPaletteGray60$8,
    ColorPaletteGray70: ColorPaletteGray70$8,
    ColorPaletteGray80: ColorPaletteGray80$8,
    ColorPaletteGray90: ColorPaletteGray90$8,
    ColorPaletteGray100: ColorPaletteGray100$8,
    ColorPaletteGray110: ColorPaletteGray110$8,
    ColorPaletteGray120: ColorPaletteGray120$8,
    ColorPaletteGray130: ColorPaletteGray130$8,
    ColorPaletteGray140: ColorPaletteGray140$8,
    ColorPaletteGray150: ColorPaletteGray150$8,
    ColorPaletteGray160: ColorPaletteGray160$8,
    ColorPaletteRed10: ColorPaletteRed10$8,
    ColorPaletteRed20: ColorPaletteRed20$8,
    ColorPaletteRed30: ColorPaletteRed30$8,
    ColorPaletteRed40: ColorPaletteRed40$8,
    ColorPaletteRed50: ColorPaletteRed50$8,
    ColorPaletteRed60: ColorPaletteRed60$8,
    ColorPaletteRed70: ColorPaletteRed70$8,
    ColorPaletteRed80: ColorPaletteRed80$8,
    ColorPaletteRed90: ColorPaletteRed90$8,
    ColorPaletteRed100: ColorPaletteRed100$8,
    ColorPaletteRed110: ColorPaletteRed110$8,
    ColorPaletteRed120: ColorPaletteRed120$8,
    ColorPaletteRed130: ColorPaletteRed130$8,
    ColorPaletteRed140: ColorPaletteRed140$8,
    ColorPaletteRed150: ColorPaletteRed150$8,
    ColorPaletteRed160: ColorPaletteRed160$8,
    ColorPaletteYellow10: ColorPaletteYellow10$8,
    ColorPaletteYellow20: ColorPaletteYellow20$8,
    ColorPaletteYellow30: ColorPaletteYellow30$8,
    ColorPaletteYellow40: ColorPaletteYellow40$8,
    ColorPaletteYellow50: ColorPaletteYellow50$8,
    ColorPaletteYellow60: ColorPaletteYellow60$8,
    ColorPaletteYellow70: ColorPaletteYellow70$8,
    ColorPaletteYellow80: ColorPaletteYellow80$8,
    ColorPaletteYellow90: ColorPaletteYellow90$8,
    ColorPaletteYellow100: ColorPaletteYellow100$8,
    ColorPaletteYellow110: ColorPaletteYellow110$8,
    ColorPaletteYellow120: ColorPaletteYellow120$8,
    ColorPaletteYellow130: ColorPaletteYellow130$8,
    ColorPaletteYellow140: ColorPaletteYellow140$8,
    ColorPaletteYellow150: ColorPaletteYellow150$8,
    ColorPaletteYellow160: ColorPaletteYellow160$8,
    ColorPaletteLime10: ColorPaletteLime10$8,
    ColorPaletteLime20: ColorPaletteLime20$8,
    ColorPaletteLime30: ColorPaletteLime30$8,
    ColorPaletteLime40: ColorPaletteLime40$8,
    ColorPaletteLime50: ColorPaletteLime50$8,
    ColorPaletteLime60: ColorPaletteLime60$8,
    ColorPaletteLime70: ColorPaletteLime70$8,
    ColorPaletteLime80: ColorPaletteLime80$8,
    ColorPaletteLime90: ColorPaletteLime90$8,
    ColorPaletteLime100: ColorPaletteLime100$8,
    ColorPaletteLime110: ColorPaletteLime110$8,
    ColorPaletteLime120: ColorPaletteLime120$8,
    ColorPaletteLime130: ColorPaletteLime130$8,
    ColorPaletteLime140: ColorPaletteLime140$8,
    ColorPaletteLime150: ColorPaletteLime150$8,
    ColorPaletteLime160: ColorPaletteLime160$8,
    ColorPaletteGreen10: ColorPaletteGreen10$8,
    ColorPaletteGreen20: ColorPaletteGreen20$8,
    ColorPaletteGreen30: ColorPaletteGreen30$8,
    ColorPaletteGreen40: ColorPaletteGreen40$8,
    ColorPaletteGreen50: ColorPaletteGreen50$8,
    ColorPaletteGreen60: ColorPaletteGreen60$8,
    ColorPaletteGreen70: ColorPaletteGreen70$8,
    ColorPaletteGreen80: ColorPaletteGreen80$8,
    ColorPaletteGreen90: ColorPaletteGreen90$8,
    ColorPaletteGreen100: ColorPaletteGreen100$8,
    ColorPaletteGreen110: ColorPaletteGreen110$8,
    ColorPaletteGreen120: ColorPaletteGreen120$8,
    ColorPaletteGreen130: ColorPaletteGreen130$8,
    ColorPaletteGreen140: ColorPaletteGreen140$8,
    ColorPaletteGreen150: ColorPaletteGreen150$8,
    ColorPaletteGreen160: ColorPaletteGreen160$8,
    ColorPaletteAcqua10: ColorPaletteAcqua10$8,
    ColorPaletteAcqua20: ColorPaletteAcqua20$8,
    ColorPaletteAcqua30: ColorPaletteAcqua30$8,
    ColorPaletteAcqua40: ColorPaletteAcqua40$8,
    ColorPaletteAcqua50: ColorPaletteAcqua50$8,
    ColorPaletteAcqua60: ColorPaletteAcqua60$8,
    ColorPaletteAcqua70: ColorPaletteAcqua70$8,
    ColorPaletteAcqua80: ColorPaletteAcqua80$8,
    ColorPaletteAcqua90: ColorPaletteAcqua90$8,
    ColorPaletteAcqua100: ColorPaletteAcqua100$8,
    ColorPaletteAcqua110: ColorPaletteAcqua110$8,
    ColorPaletteAcqua120: ColorPaletteAcqua120$8,
    ColorPaletteAcqua130: ColorPaletteAcqua130$8,
    ColorPaletteAcqua140: ColorPaletteAcqua140$8,
    ColorPaletteAcqua150: ColorPaletteAcqua150$8,
    ColorPaletteAcqua160: ColorPaletteAcqua160$8,
    ColorPaletteBlue10: ColorPaletteBlue10$8,
    ColorPaletteBlue20: ColorPaletteBlue20$8,
    ColorPaletteBlue30: ColorPaletteBlue30$8,
    ColorPaletteBlue40: ColorPaletteBlue40$8,
    ColorPaletteBlue50: ColorPaletteBlue50$8,
    ColorPaletteBlue60: ColorPaletteBlue60$8,
    ColorPaletteBlue70: ColorPaletteBlue70$8,
    ColorPaletteBlue80: ColorPaletteBlue80$8,
    ColorPaletteBlue90: ColorPaletteBlue90$8,
    ColorPaletteBlue100: ColorPaletteBlue100$8,
    ColorPaletteBlue110: ColorPaletteBlue110$8,
    ColorPaletteBlue120: ColorPaletteBlue120$8,
    ColorPaletteBlue130: ColorPaletteBlue130$8,
    ColorPaletteBlue140: ColorPaletteBlue140$8,
    ColorPaletteBlue150: ColorPaletteBlue150$8,
    ColorPaletteBlue160: ColorPaletteBlue160$8,
    ColorPalettePurple10: ColorPalettePurple10$8,
    ColorPalettePurple20: ColorPalettePurple20$8,
    ColorPalettePurple30: ColorPalettePurple30$8,
    ColorPalettePurple40: ColorPalettePurple40$8,
    ColorPalettePurple50: ColorPalettePurple50$8,
    ColorPalettePurple60: ColorPalettePurple60$8,
    ColorPalettePurple70: ColorPalettePurple70$8,
    ColorPalettePurple80: ColorPalettePurple80$8,
    ColorPalettePurple90: ColorPalettePurple90$8,
    ColorPalettePurple100: ColorPalettePurple100$8,
    ColorPalettePurple110: ColorPalettePurple110$8,
    ColorPalettePurple120: ColorPalettePurple120$8,
    ColorPalettePurple130: ColorPalettePurple130$8,
    ColorPalettePurple140: ColorPalettePurple140$8,
    ColorPalettePurple150: ColorPalettePurple150$8,
    ColorPalettePurple160: ColorPalettePurple160$8,
    ColorPalettePink10: ColorPalettePink10$8,
    ColorPalettePink20: ColorPalettePink20$8,
    ColorPalettePink30: ColorPalettePink30$8,
    ColorPalettePink40: ColorPalettePink40$8,
    ColorPalettePink50: ColorPalettePink50$8,
    ColorPalettePink60: ColorPalettePink60$8,
    ColorPalettePink70: ColorPalettePink70$8,
    ColorPalettePink80: ColorPalettePink80$8,
    ColorPalettePink90: ColorPalettePink90$8,
    ColorPalettePink100: ColorPalettePink100$8,
    ColorPalettePink110: ColorPalettePink110$8,
    ColorPalettePink120: ColorPalettePink120$8,
    ColorPalettePink130: ColorPalettePink130$8,
    ColorPalettePink140: ColorPalettePink140$8,
    ColorPalettePink150: ColorPalettePink150$8,
    ColorPalettePink160: ColorPalettePink160$8,
    ColorTypefaceStrong: ColorTypefaceStrong$8,
    ColorTypefacePure: ColorTypefacePure$8,
    ColorTypefaceSmooth: ColorTypefaceSmooth$8,
    ColorTypefaceMeld: ColorTypefaceMeld$8,
    ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$8,
    ColorTypefaceInversePure: ColorTypefaceInversePure$8,
    ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$8,
    ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$8,
    ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$8,
    ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$8,
    ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$8,
    ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$8,
    ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$8,
    ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$8,
    ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$8,
    ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$8,
    ColorBrandPrimary10: ColorBrandPrimary10$8,
    ColorBrandPrimary20: ColorBrandPrimary20$8,
    ColorBrandPrimary30: ColorBrandPrimary30$8,
    ColorBrandPrimary40: ColorBrandPrimary40$8,
    ColorBrandPrimary50: ColorBrandPrimary50$8,
    ColorBrandPrimary60: ColorBrandPrimary60$8,
    ColorBrandPrimary70: ColorBrandPrimary70$8,
    ColorBrandPrimary80: ColorBrandPrimary80$8,
    ColorFeedbackErrorText: ColorFeedbackErrorText$8,
    ColorFeedbackErrorShape: ColorFeedbackErrorShape$8,
    ColorFeedbackSuccessText: ColorFeedbackSuccessText$8,
    ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$8,
    ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$8,
    ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$8,
    ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$8,
    ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$8,
    ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$8,
    ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$8,
    ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$8,
    ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$8,
    ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$8,
    ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$8,
    ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$8,
    ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$8,
    ColorSupport01: ColorSupport01$8,
    ColorSupport02: ColorSupport02$8,
    ColorSupportOnBrand01: ColorSupportOnBrand01$8,
    ColorSupportOnBrand02: ColorSupportOnBrand02$8,
    ColorSupportInverse01: ColorSupportInverse01$8,
    ColorSupportInverse02: ColorSupportInverse02$8,
    ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$8,
    ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$8,
    Opacity01: Opacity01$8,
    Opacity02: Opacity02$8,
    Opacity03: Opacity03$8,
    Opacity04: Opacity04$8,
    Opacity05: Opacity05$8,
    Opacity06: Opacity06$8,
    Opacity07: Opacity07$8,
    Opacity08: Opacity08$8,
    Opacity09: Opacity09$8,
    Shadow01: Shadow01$8,
    Shadow02: Shadow02$8,
    Shadow03: Shadow03$8,
    Shadow04: Shadow04$8,
    SpacingInlineQuark: SpacingInlineQuark$8,
    SpacingInlineNano: SpacingInlineNano$8,
    SpacingInlineXxxs: SpacingInlineXxxs$8,
    SpacingInlineXxs: SpacingInlineXxs$8,
    SpacingInlineXs: SpacingInlineXs$8,
    SpacingInlineSm: SpacingInlineSm$8,
    SpacingInlineMd: SpacingInlineMd$8,
    SpacingInlineLg: SpacingInlineLg$8,
    SpacingInlineXl: SpacingInlineXl$8,
    SpacingInlineXxl: SpacingInlineXxl$8,
    SpacingInlineXxxl: SpacingInlineXxxl$8,
    SpacingInlineHuge: SpacingInlineHuge$8,
    SpacingInlineGiant: SpacingInlineGiant$8,
    SpacingInsetQuark: SpacingInsetQuark$8,
    SpacingInsetNano: SpacingInsetNano$8,
    SpacingInsetXs: SpacingInsetXs$8,
    SpacingInsetSm: SpacingInsetSm$8,
    SpacingInsetMd: SpacingInsetMd$8,
    SpacingInsetLg: SpacingInsetLg$8,
    SpacingSquishQuark: SpacingSquishQuark$8,
    SpacingSquishNano: SpacingSquishNano$8,
    SpacingSquishXs: SpacingSquishXs$8,
    SpacingSquishSm: SpacingSquishSm$8,
    SpacingStackQuark: SpacingStackQuark$8,
    SpacingStackNano: SpacingStackNano$8,
    SpacingStackXxxs: SpacingStackXxxs$8,
    SpacingStackXxs: SpacingStackXxs$8,
    SpacingStackXs: SpacingStackXs$8,
    SpacingStackSm: SpacingStackSm$8,
    SpacingStackMd: SpacingStackMd$8,
    SpacingStackLg: SpacingStackLg$8,
    SpacingStackXl: SpacingStackXl$8,
    SpacingStackXxl: SpacingStackXxl$8,
    SpacingStackXxxl: SpacingStackXxxl$8,
    SpacingStackHuge: SpacingStackHuge$8,
    SpacingStackGiant: SpacingStackGiant$8,
    FontFamilyBase: FontFamilyBase$8,
    FontSizeXxxs: FontSizeXxxs$8,
    FontSizeXxs: FontSizeXxs$8,
    FontSizeXs: FontSizeXs$8,
    FontSizeSm: FontSizeSm$8,
    FontSizeMd: FontSizeMd$8,
    FontSizeLg: FontSizeLg$8,
    FontSizeXl: FontSizeXl$8,
    FontSizeXxl: FontSizeXxl$8,
    FontSizeXxxl: FontSizeXxxl$8,
    FontSizeDisplay: FontSizeDisplay$8,
    FontSizeGiant: FontSizeGiant$8,
    FontWeightBold: FontWeightBold$8,
    FontWeightSemibold: FontWeightSemibold$8,
    FontWeightMedium: FontWeightMedium$8,
    FontWeightRegular: FontWeightRegular$8,
    FontWeightLight: FontWeightLight$8,
    LetterSpacingStandard: LetterSpacingStandard$8,
    LetterSpacingSmall: LetterSpacingSmall$8,
    LetterSpacingMedium: LetterSpacingMedium$8,
    LineHeightStandard: LineHeightStandard$8,
    LineHeightTiny: LineHeightTiny$8,
    LineHeightMedium: LineHeightMedium$8,
    LineHeightLarge: LineHeightLarge$8,
    LineHeightDistant: LineHeightDistant$8,
    LineHeightSuperdistant: LineHeightSuperdistant$8,
    LineHeightHuge: LineHeightHuge$8
  });
  /**
   * Do not edit directly
   * Generated on Thu, 27 Oct 2022 18:07:46 GMT
   */

  var BorderRadiusNone$7 = "0px";
  var BorderRadiusXs$7 = "4px";
  var BorderRadiusSm$7 = "8px";
  var BorderRadiusMd$7 = "16px";
  var BorderRadiusLg$7 = "24px";
  var BorderRadiusPill$7 = "960px";
  var BorderRadiusCircle$7 = "50%";
  var BorderWidthNone$7 = "0px";
  var BorderWidthHairline$7 = "1px";
  var BorderWidthThin$7 = "2px";
  var BorderWidthThick$7 = "4px";
  var BorderWidthHeavy$7 = "8px";
  var ColorDatavizInfoText$7 = "#0F58EA";
  var ColorDatavizInfoShape01$7 = "#3F7BF2";
  var ColorDatavizInfoShape02$7 = "#D9E5FC";
  var ColorDatavizInfoShape03$7 = "#F1F5FE";
  var ColorDatavizNegativeText$7 = "#BC293A";
  var ColorDatavizNegativeShape01$7 = "#EA4356";
  var ColorDatavizNegativeShape02$7 = "#FDDDE1";
  var ColorDatavizNegativeShape03$7 = "#FEF1F2";
  var ColorDatavizWarningText$7 = "#A04C03";
  var ColorDatavizWarningShape01$7 = "#D26404";
  var ColorDatavizWarningShape02$7 = "#FEE1C8";
  var ColorDatavizWarningShape03$7 = "#FEF1E6";
  var ColorDatavizPositiveText$7 = "#22723A";
  var ColorDatavizPositiveShape01$7 = "#2D954C";
  var ColorDatavizPositiveShape02$7 = "#C8EED3";
  var ColorDatavizPositiveShape03$7 = "#E8F8EC";
  var ColorDatavizCatAText$7 = "#9B18DC";
  var ColorDatavizCatAShape01$7 = "#B851EC";
  var ColorDatavizCatAShape02$7 = "#F2DFFB";
  var ColorDatavizCatAShape03$7 = "#F9F1FD";
  var ColorDatavizCatBText$7 = "#BA267B";
  var ColorDatavizCatBShape01$7 = "#DA499B";
  var ColorDatavizCatBShape02$7 = "#F8DDEC";
  var ColorDatavizCatBShape03$7 = "#FCF2F8";
  var ColorDatavizCatCText$7 = "#546E21";
  var ColorDatavizCatCShape01$7 = "#6C8D2B";
  var ColorDatavizCatCShape02$7 = "#DBEBBD";
  var ColorDatavizCatCShape03$7 = "#F0F7E4";
  var ColorDatavizCatDText$7 = "#0D735E";
  var ColorDatavizCatDShape01$7 = "#109379";
  var ColorDatavizCatDShape02$7 = "#BCF0E6";
  var ColorDatavizCatDShape03$7 = "#DFFBF6";
  var ColorDatavizInverseInfoText$7 = "#5C8FF5";
  var ColorDatavizInverseInfoShape01$7 = "#286BF1";
  var ColorDatavizInverseInfoShape02$7 = "#062560";
  var ColorDatavizInverseInfoShape03$7 = "#051B48";
  var ColorDatavizInverseNegativeText$7 = "#F55C6E";
  var ColorDatavizInverseNegativeShape01$7 = "#D83145";
  var ColorDatavizInverseNegativeShape02$7 = "#4F1119";
  var ColorDatavizInverseNegativeShape03$7 = "#3B0D12";
  var ColorDatavizInverseWarningText$7 = "#EB7005";
  var ColorDatavizInverseWarningShape01$7 = "#B95804";
  var ColorDatavizInverseWarningShape02$7 = "#462101";
  var ColorDatavizInverseWarningShape03$7 = "#321701";
  var ColorDatavizInversePositiveText$7 = "#32A454";
  var ColorDatavizInversePositiveShape01$7 = "#278142";
  var ColorDatavizInversePositiveShape02$7 = "#0E2F18";
  var ColorDatavizInversePositiveShape03$7 = "#0B2312";
  var ColorDatavizInverseCatAText$7 = "#C36CEF";
  var ColorDatavizInverseCatAShape01$7 = "#AD35E9";
  var ColorDatavizInverseCatAShape02$7 = "#440B60";
  var ColorDatavizInverseCatAShape03$7 = "#340849";
  var ColorDatavizInverseCatBText$7 = "#E067AB";
  var ColorDatavizInverseCatBShape01$7 = "#D42B8C";
  var ColorDatavizInverseCatBShape02$7 = "#4C1032";
  var ColorDatavizInverseCatBShape03$7 = "#3B0C27";
  var ColorDatavizInverseCatCText$7 = "#789D2F";
  var ColorDatavizInverseCatCShape01$7 = "#607E26";
  var ColorDatavizInverseCatCShape02$7 = "#212B0D";
  var ColorDatavizInverseCatCShape03$7 = "#1B230B";
  var ColorDatavizInverseCatDText$7 = "#12A588";
  var ColorDatavizInverseCatDShape01$7 = "#0F856D";
  var ColorDatavizInverseCatDShape02$7 = "#052E26";
  var ColorDatavizInverseCatDShape03$7 = "#04251E";
  var ColorInteractionBlend01$7 = "#1616160A";
  var ColorInteractionBlend02$7 = "#16161614";
  var ColorInteractionBlend03$7 = "#1616161F";
  var ColorInteractionBlend04$7 = "#1616163D";
  var ColorInteractionBlend05$7 = "#161616A3";
  var ColorInteractionBlend06$7 = "#161616B8";
  var ColorInteractionBlend07$7 = "#161616E0";
  var ColorInteractionBlend08$7 = "#161616";
  var ColorInteractionInverseBlend01$7 = "#FEFEFE14";
  var ColorInteractionInverseBlend02$7 = "#FEFEFE1F";
  var ColorInteractionInverseBlend03$7 = "#FEFEFE3D";
  var ColorInteractionInverseBlend04$7 = "#FEFEFE52";
  var ColorInteractionInverseBlend05$7 = "#FEFEFEA3";
  var ColorInteractionInverseBlend06$7 = "#FEFEFEB8";
  var ColorInteractionInverseBlend07$7 = "#FEFEFEE0";
  var ColorInteractionInverseBlend08$7 = "#FEFEFE";
  var ColorInteractionInverseAccent01$7 = "#E490C4";
  var ColorInteractionInverseAccent02$7 = "#E79DCA";
  var ColorInteractionInverseAccent03$7 = "#EDB5D7";
  var ColorInteractionInverseSubtle01$7 = "#EDB5D71F";
  var ColorInteractionInverseSubtle02$7 = "#EDB5D73D";
  var ColorInteractionInverseSubtle03$7 = "#EDB5D752";
  var ColorInteractionInverseSelectDefault$7 = "#666666";
  var ColorInteractionInverseSelectFocus$7 = "#919191";
  var ColorInteractionInverseSelectActive$7 = "#E490C4";
  var ColorInteractionInverseDanger01$7 = "#D83145";
  var ColorInteractionInverseDanger02$7 = "#EA4356";
  var ColorInteractionInverseDanger03$7 = "#F55C6E";
  var ColorInteractionInverseOnBrandAccent01$7 = "#7F1A54";
  var ColorInteractionInverseOnBrandAccent02$7 = "#661543";
  var ColorInteractionInverseOnBrandAccent03$7 = "#4C1032";
  var ColorInteractionInverseOnBrandSubtle01$7 = "#7F1A541F";
  var ColorInteractionInverseOnBrandSubtle02$7 = "#7F1A543D";
  var ColorInteractionInverseOnBrandSubtle03$7 = "#7F1A5452";
  var ColorInteractionInverseOnBrandSelectDefault$7 = "#404040";
  var ColorInteractionInverseOnBrandSelectFocus$7 = "#292929";
  var ColorInteractionInverseOnBrandSelectActive$7 = "#7F1A54";
  var ColorInteractionInverseOnBrandBlend01$7 = "#1616160A";
  var ColorInteractionInverseOnBrandBlend02$7 = "#16161614";
  var ColorInteractionInverseOnBrandBlend03$7 = "#1616161F";
  var ColorInteractionInverseOnBrandBlend04$7 = "#1616163D";
  var ColorInteractionInverseOnBrandBlend05$7 = "#161616A3";
  var ColorInteractionInverseOnBrandBlend06$7 = "#161616B8";
  var ColorInteractionInverseOnBrandBlend07$7 = "#161616E0";
  var ColorInteractionInverseOnBrandBlend08$7 = "#161616";
  var ColorInteractionInverseOnBrandDanger01$7 = "#4F1119";
  var ColorInteractionInverseOnBrandDanger02$7 = "#691721";
  var ColorInteractionInverseOnBrandDanger03$7 = "#7E1B27";
  var ColorInteractionAccent01$7 = "#7F1A54";
  var ColorInteractionAccent02$7 = "#661543";
  var ColorInteractionAccent03$7 = "#4C1032";
  var ColorInteractionSubtle01$7 = "#7F1A541F";
  var ColorInteractionSubtle02$7 = "#7F1A543D";
  var ColorInteractionSubtle03$7 = "#7F1A5452";
  var ColorInteractionSelectDefault$7 = "#595959";
  var ColorInteractionSelectFocus$7 = "#363636";
  var ColorInteractionSelectActive$7 = "#7F1A54";
  var ColorInteractionDanger01$7 = "#92202E";
  var ColorInteractionDanger02$7 = "#7E1B27";
  var ColorInteractionDanger03$7 = "#691721";
  var ColorInteractionOnBrandAccent01$7 = "#FEFEFE";
  var ColorInteractionOnBrandAccent02$7 = "#F7DEED";
  var ColorInteractionOnBrandAccent03$7 = "#EDB5D7";
  var ColorInteractionOnBrandSubtle01$7 = "#FEFEFE1F";
  var ColorInteractionOnBrandSubtle02$7 = "#FEFEFE3D";
  var ColorInteractionOnBrandSubtle03$7 = "#FEFEFE52";
  var ColorInteractionOnBrandSelectDefault$7 = "#F1C6E0";
  var ColorInteractionOnBrandSelectFocus$7 = "#F7DEED";
  var ColorInteractionOnBrandSelectActive$7 = "#FEFEFE";
  var ColorInteractionOnBrandBlend01$7 = "#FEFEFE14";
  var ColorInteractionOnBrandBlend02$7 = "#FEFEFE1F";
  var ColorInteractionOnBrandBlend03$7 = "#FEFEFE3D";
  var ColorInteractionOnBrandBlend04$7 = "#FEFEFE52";
  var ColorInteractionOnBrandBlend05$7 = "#FEFEFEA3";
  var ColorInteractionOnBrandBlend06$7 = "#FEFEFEB8";
  var ColorInteractionOnBrandBlend07$7 = "#FEFEFEE0";
  var ColorInteractionOnBrandBlend08$7 = "#FEFEFE";
  var ColorInteractionOnBrandDanger01$7 = "#FEFEFE";
  var ColorInteractionOnBrandDanger02$7 = "#F895A1";
  var ColorInteractionOnBrandDanger03$7 = "#F77E8C";
  var ColorNeutral10$7 = "#F5F5F5";
  var ColorNeutral20$7 = "#E6E6E6";
  var ColorNeutral30$7 = "#1616163D";
  var ColorNeutral00$7 = "#FEFEFE";
  var ColorNeutralInverse10$7 = "#1F1F1F";
  var ColorNeutralInverse20$7 = "#292929";
  var ColorNeutralInverse30$7 = "#FEFEFE3D";
  var ColorNeutralInverse00$7 = "#161616";
  var ColorNeutralInverseOnBrand10$7 = "#F7DEED";
  var ColorNeutralInverseOnBrand20$7 = "#F1C6E0";
  var ColorNeutralInverseOnBrand30$7 = "#7F1A547A";
  var ColorNeutralInverseOnBrand00$7 = "#FCF2F8";
  var ColorNeutralOnBrand10$7 = "#8C1C5D";
  var ColorNeutralOnBrand20$7 = "#981F65";
  var ColorNeutralOnBrand30$7 = "#E490C4A3";
  var ColorNeutralOnBrand00$7 = "#7F1A54";
  var ColorPaletteBlack$7 = "#161616";
  var ColorPaletteWhite$7 = "#FEFEFE";
  var ColorPaletteGray10$7 = "#1F1F1F";
  var ColorPaletteGray20$7 = "#292929";
  var ColorPaletteGray30$7 = "#363636";
  var ColorPaletteGray40$7 = "#404040";
  var ColorPaletteGray50$7 = "#4C4C4C";
  var ColorPaletteGray60$7 = "#595959";
  var ColorPaletteGray70$7 = "#666666";
  var ColorPaletteGray80$7 = "#737373";
  var ColorPaletteGray90$7 = "#828282";
  var ColorPaletteGray100$7 = "#919191";
  var ColorPaletteGray110$7 = "#A1A1A1";
  var ColorPaletteGray120$7 = "#B0B0B0";
  var ColorPaletteGray130$7 = "#C2C2C2";
  var ColorPaletteGray140$7 = "#D4D4D4";
  var ColorPaletteGray150$7 = "#E6E6E6";
  var ColorPaletteGray160$7 = "#F5F5F5";
  var ColorPaletteRed10$7 = "#3B0D12";
  var ColorPaletteRed20$7 = "#4F1119";
  var ColorPaletteRed30$7 = "#691721";
  var ColorPaletteRed40$7 = "#7E1B27";
  var ColorPaletteRed50$7 = "#92202E";
  var ColorPaletteRed60$7 = "#A72534";
  var ColorPaletteRed70$7 = "#BC293A";
  var ColorPaletteRed80$7 = "#D83145";
  var ColorPaletteRed90$7 = "#EA4356";
  var ColorPaletteRed100$7 = "#F55C6E";
  var ColorPaletteRed110$7 = "#F77E8C";
  var ColorPaletteRed120$7 = "#F895A1";
  var ColorPaletteRed130$7 = "#FAAEB6";
  var ColorPaletteRed140$7 = "#FBC5CC";
  var ColorPaletteRed150$7 = "#FDDDE1";
  var ColorPaletteRed160$7 = "#FEF1F2";
  var ColorPaletteYellow10$7 = "#321701";
  var ColorPaletteYellow20$7 = "#462101";
  var ColorPaletteYellow30$7 = "#552802";
  var ColorPaletteYellow40$7 = "#693102";
  var ColorPaletteYellow50$7 = "#7D3B03";
  var ColorPaletteYellow60$7 = "#914503";
  var ColorPaletteYellow70$7 = "#A04C03";
  var ColorPaletteYellow80$7 = "#B95804";
  var ColorPaletteYellow90$7 = "#D26404";
  var ColorPaletteYellow100$7 = "#EB7005";
  var ColorPaletteYellow110$7 = "#FA8219";
  var ColorPaletteYellow120$7 = "#FB9B46";
  var ColorPaletteYellow130$7 = "#FCB06E";
  var ColorPaletteYellow140$7 = "#FDC99B";
  var ColorPaletteYellow150$7 = "#FEE1C8";
  var ColorPaletteYellow160$7 = "#FEF1E6";
  var ColorPaletteLime10$7 = "#1B230B";
  var ColorPaletteLime20$7 = "#212B0D";
  var ColorPaletteLime30$7 = "#2D3B12";
  var ColorPaletteLime40$7 = "#364616";
  var ColorPaletteLime50$7 = "#3F5219";
  var ColorPaletteLime60$7 = "#485E1D";
  var ColorPaletteLime70$7 = "#546E21";
  var ColorPaletteLime80$7 = "#607E26";
  var ColorPaletteLime90$7 = "#6C8D2B";
  var ColorPaletteLime100$7 = "#789D2F";
  var ColorPaletteLime110$7 = "#84AC34";
  var ColorPaletteLime120$7 = "#93BF3A";
  var ColorPaletteLime130$7 = "#A9CF5E";
  var ColorPaletteLime140$7 = "#C2DD8D";
  var ColorPaletteLime150$7 = "#DBEBBD";
  var ColorPaletteLime160$7 = "#F0F7E4";
  var ColorPaletteGreen10$7 = "#0B2312";
  var ColorPaletteGreen20$7 = "#0E2F18";
  var ColorPaletteGreen30$7 = "#133E20";
  var ColorPaletteGreen40$7 = "#174A26";
  var ColorPaletteGreen50$7 = "#1A562C";
  var ColorPaletteGreen60$7 = "#1F6634";
  var ColorPaletteGreen70$7 = "#22723A";
  var ColorPaletteGreen80$7 = "#278142";
  var ColorPaletteGreen90$7 = "#2D954C";
  var ColorPaletteGreen100$7 = "#32A454";
  var ColorPaletteGreen110$7 = "#38B85E";
  var ColorPaletteGreen120$7 = "#4BC870";
  var ColorPaletteGreen130$7 = "#76D692";
  var ColorPaletteGreen140$7 = "#9DE2B1";
  var ColorPaletteGreen150$7 = "#C8EED3";
  var ColorPaletteGreen160$7 = "#E8F8EC";
  var ColorPaletteAcqua10$7 = "#04251E";
  var ColorPaletteAcqua20$7 = "#052E26";
  var ColorPaletteAcqua30$7 = "#073C31";
  var ColorPaletteAcqua40$7 = "#08493C";
  var ColorPaletteAcqua50$7 = "#0A5748";
  var ColorPaletteAcqua60$7 = "#0B6553";
  var ColorPaletteAcqua70$7 = "#0D735E";
  var ColorPaletteAcqua80$7 = "#0F856D";
  var ColorPaletteAcqua90$7 = "#109379";
  var ColorPaletteAcqua100$7 = "#12A588";
  var ColorPaletteAcqua110$7 = "#14B897";
  var ColorPaletteAcqua120$7 = "#31C4A6";
  var ColorPaletteAcqua130$7 = "#68D4BF";
  var ColorPaletteAcqua140$7 = "#8DE2D1";
  var ColorPaletteAcqua150$7 = "#BCF0E6";
  var ColorPaletteAcqua160$7 = "#DFFBF6";
  var ColorPaletteBlue10$7 = "#051B48";
  var ColorPaletteBlue20$7 = "#062560";
  var ColorPaletteBlue30$7 = "#082F7D";
  var ColorPaletteBlue40$7 = "#0A3A9A";
  var ColorPaletteBlue50$7 = "#0B43B1";
  var ColorPaletteBlue60$7 = "#0D4ECE";
  var ColorPaletteBlue70$7 = "#0F58EA";
  var ColorPaletteBlue80$7 = "#286BF1";
  var ColorPaletteBlue90$7 = "#3F7BF2";
  var ColorPaletteBlue100$7 = "#5C8FF5";
  var ColorPaletteBlue110$7 = "#73A0F7";
  var ColorPaletteBlue120$7 = "#8CB0F8";
  var ColorPaletteBlue130$7 = "#A9C4F9";
  var ColorPaletteBlue140$7 = "#C1D4FB";
  var ColorPaletteBlue150$7 = "#D9E5FC";
  var ColorPaletteBlue160$7 = "#F1F5FE";
  var ColorPalettePurple10$7 = "#340849";
  var ColorPalettePurple20$7 = "#440B60";
  var ColorPalettePurple30$7 = "#540D78";
  var ColorPalettePurple40$7 = "#671093";
  var ColorPalettePurple50$7 = "#7713AA";
  var ColorPalettePurple60$7 = "#8B16C5";
  var ColorPalettePurple70$7 = "#9B18DC";
  var ColorPalettePurple80$7 = "#AD35E9";
  var ColorPalettePurple90$7 = "#B851EC";
  var ColorPalettePurple100$7 = "#C36CEF";
  var ColorPalettePurple110$7 = "#CC83F1";
  var ColorPalettePurple120$7 = "#D69AF4";
  var ColorPalettePurple130$7 = "#DFB1F6";
  var ColorPalettePurple140$7 = "#E8C8F9";
  var ColorPalettePurple150$7 = "#F2DFFB";
  var ColorPalettePurple160$7 = "#F9F1FD";
  var ColorPalettePink10$7 = "#3B0C27";
  var ColorPalettePink20$7 = "#4C1032";
  var ColorPalettePink30$7 = "#661543";
  var ColorPalettePink40$7 = "#77184E";
  var ColorPalettePink50$7 = "#8C1C5D";
  var ColorPalettePink60$7 = "#A12169";
  var ColorPalettePink70$7 = "#BA267B";
  var ColorPalettePink80$7 = "#D42B8C";
  var ColorPalettePink90$7 = "#DA499B";
  var ColorPalettePink100$7 = "#E067AB";
  var ColorPalettePink110$7 = "#E580B9";
  var ColorPalettePink120$7 = "#EA99C7";
  var ColorPalettePink130$7 = "#EFAFD3";
  var ColorPalettePink140$7 = "#F4C8E1";
  var ColorPalettePink150$7 = "#F8DDEC";
  var ColorPalettePink160$7 = "#FCF2F8";
  var ColorTypefaceStrong$7 = "#161616";
  var ColorTypefacePure$7 = "#363636";
  var ColorTypefaceSmooth$7 = "#666666";
  var ColorTypefaceMeld$7 = "#1616163D";
  var ColorTypefaceInverseStrong$7 = "#FEFEFE";
  var ColorTypefaceInversePure$7 = "#D4D4D4";
  var ColorTypefaceInverseSmooth$7 = "#919191";
  var ColorTypefaceInverseMeld$7 = "#FEFEFE52";
  var ColorTypefaceInverseOnBrandStrong$7 = "#161616";
  var ColorTypefaceInverseOnBrandPure$7 = "#292929";
  var ColorTypefaceInverseOnBrandSmooth$7 = "#404040";
  var ColorTypefaceInverseOnBrandMeld$7 = "#1616163D";
  var ColorTypefaceOnBrandStrong$7 = "#FEFEFE";
  var ColorTypefaceOnBrandPure$7 = "#F7DEED";
  var ColorTypefaceOnBrandSmooth$7 = "#F1C6E0";
  var ColorTypefaceOnBrandMeld$7 = "#FEFEFE52";
  var ColorBrandPrimary10$7 = "#3B0C27";
  var ColorBrandPrimary20$7 = "#4C1032";
  var ColorBrandPrimary30$7 = "#661543";
  var ColorBrandPrimary40$7 = "#7F1A54";
  var ColorBrandPrimary50$7 = "#8C1C5D";
  var ColorBrandPrimary60$7 = "#981F65";
  var ColorBrandPrimary70$7 = "#E490C4";
  var ColorBrandPrimary80$7 = "#E79DCA";
  var ColorBrandPrimary90$7 = "#EDB5D7";
  var ColorBrandPrimary100$7 = "#F1C6E0";
  var ColorBrandPrimary110$7 = "#F7DEED";
  var ColorBrandPrimary120$7 = "#FCF2F8";
  var ColorBrandBase01$7 = "#7F1A54";
  var ColorBrandBase02$7 = "#EC2072";
  var ColorBrandBase03$6 = "#F05253";
  var ColorBrandBase04$6 = "#F78E26";
  var ColorFeedbackErrorText$7 = "#92202E";
  var ColorFeedbackErrorShape$7 = "#BC293A";
  var ColorFeedbackSuccessText$7 = "#1A562C";
  var ColorFeedbackSuccessShape$7 = "#22723A";
  var ColorFeedbackOnBrandErrorText$7 = "#F895A1";
  var ColorFeedbackOnBrandErrorShape$7 = "#F77E8C";
  var ColorFeedbackOnBrandSuccessText$7 = "#4BC870";
  var ColorFeedbackOnBrandSuccessShape$7 = "#38B85E";
  var ColorFeedbackInverseErrorText$7 = "#F55C6E";
  var ColorFeedbackInverseErrorShape$7 = "#D83145";
  var ColorFeedbackInverseSuccessText$7 = "#32A454";
  var ColorFeedbackInverseSuccessShape$7 = "#278142";
  var ColorFeedbackInverseOnBrandErrorText$7 = "#4F1119";
  var ColorFeedbackInverseOnBrandErrorShape$7 = "#7E1B27";
  var ColorFeedbackInverseOnBrandSuccessText$7 = "#0E2F18";
  var ColorFeedbackInverseOnBrandSuccessShape$7 = "#174A26";
  var ColorSupport01$7 = "#EC2072";
  var ColorSupport02$7 = "#EC2072";
  var ColorSupportOnBrand01$7 = "#F78E26";
  var ColorSupportOnBrand02$7 = "#F78E26";
  var ColorSupportInverse01$7 = "#F78E26";
  var ColorSupportInverse02$7 = "#F78E26";
  var ColorSupportInverseOnBrand01$7 = "#7F1A54";
  var ColorSupportInverseOnBrand02$7 = "#7F1A54";
  var Opacity01$7 = "0.04";
  var Opacity02$7 = "0.08";
  var Opacity03$7 = "0.12";
  var Opacity04$7 = "0.24";
  var Opacity05$7 = "0.32";
  var Opacity06$7 = "0.56";
  var Opacity07$7 = "0.64";
  var Opacity08$7 = "0.72";
  var Opacity09$7 = "0.88";
  var Shadow01$7 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
  var Shadow02$7 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
  var Shadow03$7 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
  var Shadow04$7 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
  var SpacingInlineQuark$7 = "4px";
  var SpacingInlineNano$7 = "8px";
  var SpacingInlineXxxs$7 = "16px";
  var SpacingInlineXxs$7 = "24px";
  var SpacingInlineXs$7 = "32px";
  var SpacingInlineSm$7 = "40px";
  var SpacingInlineMd$7 = "48px";
  var SpacingInlineLg$7 = "56px";
  var SpacingInlineXl$7 = "64px";
  var SpacingInlineXxl$7 = "80px";
  var SpacingInlineXxxl$7 = "120px";
  var SpacingInlineHuge$7 = "160px";
  var SpacingInlineGiant$7 = "200px";
  var SpacingInsetQuark$7 = "4px";
  var SpacingInsetNano$7 = "8px";
  var SpacingInsetXs$7 = "16px";
  var SpacingInsetSm$7 = "24px";
  var SpacingInsetMd$7 = "32px";
  var SpacingInsetLg$7 = "40px";
  var SpacingSquishQuark$7 = "4px 8px";
  var SpacingSquishNano$7 = "8px 16px";
  var SpacingSquishXs$7 = "16px 24px";
  var SpacingSquishSm$7 = "16px 32px";
  var SpacingStackQuark$7 = "4px";
  var SpacingStackNano$7 = "8px";
  var SpacingStackXxxs$7 = "16px";
  var SpacingStackXxs$7 = "24px";
  var SpacingStackXs$7 = "32px";
  var SpacingStackSm$7 = "40px";
  var SpacingStackMd$7 = "48px";
  var SpacingStackLg$7 = "56px";
  var SpacingStackXl$7 = "64px";
  var SpacingStackXxl$7 = "80px";
  var SpacingStackXxxl$7 = "120px";
  var SpacingStackHuge$7 = "160px";
  var SpacingStackGiant$7 = "200px";
  var FontFamilyBase$7 = "'Dasa Sans', 'sans-serif'";
  var FontSizeXxxs$7 = "0.75rem";
  var FontSizeXxs$7 = "0.875rem";
  var FontSizeXs$7 = "1rem";
  var FontSizeSm$7 = "1.25rem";
  var FontSizeMd$7 = "1.5rem";
  var FontSizeLg$7 = "2rem";
  var FontSizeXl$7 = "2.5rem";
  var FontSizeXxl$7 = "3rem";
  var FontSizeXxxl$7 = "4rem";
  var FontSizeDisplay$7 = "5rem";
  var FontSizeGiant$7 = "6rem";
  var FontWeightBold$7 = 700;
  var FontWeightSemibold$7 = 600;
  var FontWeightMedium$7 = 500;
  var FontWeightRegular$7 = 400;
  var FontWeightLight$7 = 300;
  var LetterSpacingStandard$7 = "0px";
  var LetterSpacingSmall$7 = "-1px";
  var LetterSpacingMedium$7 = "1.5px";
  var LineHeightStandard$7 = "100%";
  var LineHeightTiny$7 = "115%";
  var LineHeightMedium$7 = "120%";
  var LineHeightLarge$7 = "125%";
  var LineHeightDistant$7 = "133%";
  var LineHeightSuperdistant$7 = "150%";
  var LineHeightHuge$7 = "170%";
  var index$7 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BorderRadiusNone: BorderRadiusNone$7,
    BorderRadiusXs: BorderRadiusXs$7,
    BorderRadiusSm: BorderRadiusSm$7,
    BorderRadiusMd: BorderRadiusMd$7,
    BorderRadiusLg: BorderRadiusLg$7,
    BorderRadiusPill: BorderRadiusPill$7,
    BorderRadiusCircle: BorderRadiusCircle$7,
    BorderWidthNone: BorderWidthNone$7,
    BorderWidthHairline: BorderWidthHairline$7,
    BorderWidthThin: BorderWidthThin$7,
    BorderWidthThick: BorderWidthThick$7,
    BorderWidthHeavy: BorderWidthHeavy$7,
    ColorDatavizInfoText: ColorDatavizInfoText$7,
    ColorDatavizInfoShape01: ColorDatavizInfoShape01$7,
    ColorDatavizInfoShape02: ColorDatavizInfoShape02$7,
    ColorDatavizInfoShape03: ColorDatavizInfoShape03$7,
    ColorDatavizNegativeText: ColorDatavizNegativeText$7,
    ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$7,
    ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$7,
    ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$7,
    ColorDatavizWarningText: ColorDatavizWarningText$7,
    ColorDatavizWarningShape01: ColorDatavizWarningShape01$7,
    ColorDatavizWarningShape02: ColorDatavizWarningShape02$7,
    ColorDatavizWarningShape03: ColorDatavizWarningShape03$7,
    ColorDatavizPositiveText: ColorDatavizPositiveText$7,
    ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$7,
    ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$7,
    ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$7,
    ColorDatavizCatAText: ColorDatavizCatAText$7,
    ColorDatavizCatAShape01: ColorDatavizCatAShape01$7,
    ColorDatavizCatAShape02: ColorDatavizCatAShape02$7,
    ColorDatavizCatAShape03: ColorDatavizCatAShape03$7,
    ColorDatavizCatBText: ColorDatavizCatBText$7,
    ColorDatavizCatBShape01: ColorDatavizCatBShape01$7,
    ColorDatavizCatBShape02: ColorDatavizCatBShape02$7,
    ColorDatavizCatBShape03: ColorDatavizCatBShape03$7,
    ColorDatavizCatCText: ColorDatavizCatCText$7,
    ColorDatavizCatCShape01: ColorDatavizCatCShape01$7,
    ColorDatavizCatCShape02: ColorDatavizCatCShape02$7,
    ColorDatavizCatCShape03: ColorDatavizCatCShape03$7,
    ColorDatavizCatDText: ColorDatavizCatDText$7,
    ColorDatavizCatDShape01: ColorDatavizCatDShape01$7,
    ColorDatavizCatDShape02: ColorDatavizCatDShape02$7,
    ColorDatavizCatDShape03: ColorDatavizCatDShape03$7,
    ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$7,
    ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$7,
    ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$7,
    ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$7,
    ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$7,
    ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$7,
    ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$7,
    ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$7,
    ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$7,
    ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$7,
    ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$7,
    ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$7,
    ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$7,
    ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$7,
    ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$7,
    ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$7,
    ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$7,
    ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$7,
    ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$7,
    ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$7,
    ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$7,
    ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$7,
    ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$7,
    ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$7,
    ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$7,
    ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$7,
    ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$7,
    ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$7,
    ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$7,
    ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$7,
    ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$7,
    ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$7,
    ColorInteractionBlend01: ColorInteractionBlend01$7,
    ColorInteractionBlend02: ColorInteractionBlend02$7,
    ColorInteractionBlend03: ColorInteractionBlend03$7,
    ColorInteractionBlend04: ColorInteractionBlend04$7,
    ColorInteractionBlend05: ColorInteractionBlend05$7,
    ColorInteractionBlend06: ColorInteractionBlend06$7,
    ColorInteractionBlend07: ColorInteractionBlend07$7,
    ColorInteractionBlend08: ColorInteractionBlend08$7,
    ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$7,
    ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$7,
    ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$7,
    ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$7,
    ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$7,
    ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$7,
    ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$7,
    ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$7,
    ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$7,
    ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$7,
    ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$7,
    ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$7,
    ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$7,
    ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$7,
    ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$7,
    ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$7,
    ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$7,
    ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$7,
    ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$7,
    ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$7,
    ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$7,
    ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$7,
    ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$7,
    ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$7,
    ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$7,
    ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$7,
    ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$7,
    ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$7,
    ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$7,
    ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$7,
    ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$7,
    ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$7,
    ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$7,
    ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$7,
    ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$7,
    ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$7,
    ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$7,
    ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$7,
    ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$7,
    ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$7,
    ColorInteractionAccent01: ColorInteractionAccent01$7,
    ColorInteractionAccent02: ColorInteractionAccent02$7,
    ColorInteractionAccent03: ColorInteractionAccent03$7,
    ColorInteractionSubtle01: ColorInteractionSubtle01$7,
    ColorInteractionSubtle02: ColorInteractionSubtle02$7,
    ColorInteractionSubtle03: ColorInteractionSubtle03$7,
    ColorInteractionSelectDefault: ColorInteractionSelectDefault$7,
    ColorInteractionSelectFocus: ColorInteractionSelectFocus$7,
    ColorInteractionSelectActive: ColorInteractionSelectActive$7,
    ColorInteractionDanger01: ColorInteractionDanger01$7,
    ColorInteractionDanger02: ColorInteractionDanger02$7,
    ColorInteractionDanger03: ColorInteractionDanger03$7,
    ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$7,
    ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$7,
    ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$7,
    ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$7,
    ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$7,
    ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$7,
    ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$7,
    ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$7,
    ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$7,
    ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$7,
    ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$7,
    ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$7,
    ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$7,
    ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$7,
    ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$7,
    ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$7,
    ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$7,
    ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$7,
    ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$7,
    ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$7,
    ColorNeutral10: ColorNeutral10$7,
    ColorNeutral20: ColorNeutral20$7,
    ColorNeutral30: ColorNeutral30$7,
    ColorNeutral00: ColorNeutral00$7,
    ColorNeutralInverse10: ColorNeutralInverse10$7,
    ColorNeutralInverse20: ColorNeutralInverse20$7,
    ColorNeutralInverse30: ColorNeutralInverse30$7,
    ColorNeutralInverse00: ColorNeutralInverse00$7,
    ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$7,
    ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$7,
    ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$7,
    ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$7,
    ColorNeutralOnBrand10: ColorNeutralOnBrand10$7,
    ColorNeutralOnBrand20: ColorNeutralOnBrand20$7,
    ColorNeutralOnBrand30: ColorNeutralOnBrand30$7,
    ColorNeutralOnBrand00: ColorNeutralOnBrand00$7,
    ColorPaletteBlack: ColorPaletteBlack$7,
    ColorPaletteWhite: ColorPaletteWhite$7,
    ColorPaletteGray10: ColorPaletteGray10$7,
    ColorPaletteGray20: ColorPaletteGray20$7,
    ColorPaletteGray30: ColorPaletteGray30$7,
    ColorPaletteGray40: ColorPaletteGray40$7,
    ColorPaletteGray50: ColorPaletteGray50$7,
    ColorPaletteGray60: ColorPaletteGray60$7,
    ColorPaletteGray70: ColorPaletteGray70$7,
    ColorPaletteGray80: ColorPaletteGray80$7,
    ColorPaletteGray90: ColorPaletteGray90$7,
    ColorPaletteGray100: ColorPaletteGray100$7,
    ColorPaletteGray110: ColorPaletteGray110$7,
    ColorPaletteGray120: ColorPaletteGray120$7,
    ColorPaletteGray130: ColorPaletteGray130$7,
    ColorPaletteGray140: ColorPaletteGray140$7,
    ColorPaletteGray150: ColorPaletteGray150$7,
    ColorPaletteGray160: ColorPaletteGray160$7,
    ColorPaletteRed10: ColorPaletteRed10$7,
    ColorPaletteRed20: ColorPaletteRed20$7,
    ColorPaletteRed30: ColorPaletteRed30$7,
    ColorPaletteRed40: ColorPaletteRed40$7,
    ColorPaletteRed50: ColorPaletteRed50$7,
    ColorPaletteRed60: ColorPaletteRed60$7,
    ColorPaletteRed70: ColorPaletteRed70$7,
    ColorPaletteRed80: ColorPaletteRed80$7,
    ColorPaletteRed90: ColorPaletteRed90$7,
    ColorPaletteRed100: ColorPaletteRed100$7,
    ColorPaletteRed110: ColorPaletteRed110$7,
    ColorPaletteRed120: ColorPaletteRed120$7,
    ColorPaletteRed130: ColorPaletteRed130$7,
    ColorPaletteRed140: ColorPaletteRed140$7,
    ColorPaletteRed150: ColorPaletteRed150$7,
    ColorPaletteRed160: ColorPaletteRed160$7,
    ColorPaletteYellow10: ColorPaletteYellow10$7,
    ColorPaletteYellow20: ColorPaletteYellow20$7,
    ColorPaletteYellow30: ColorPaletteYellow30$7,
    ColorPaletteYellow40: ColorPaletteYellow40$7,
    ColorPaletteYellow50: ColorPaletteYellow50$7,
    ColorPaletteYellow60: ColorPaletteYellow60$7,
    ColorPaletteYellow70: ColorPaletteYellow70$7,
    ColorPaletteYellow80: ColorPaletteYellow80$7,
    ColorPaletteYellow90: ColorPaletteYellow90$7,
    ColorPaletteYellow100: ColorPaletteYellow100$7,
    ColorPaletteYellow110: ColorPaletteYellow110$7,
    ColorPaletteYellow120: ColorPaletteYellow120$7,
    ColorPaletteYellow130: ColorPaletteYellow130$7,
    ColorPaletteYellow140: ColorPaletteYellow140$7,
    ColorPaletteYellow150: ColorPaletteYellow150$7,
    ColorPaletteYellow160: ColorPaletteYellow160$7,
    ColorPaletteLime10: ColorPaletteLime10$7,
    ColorPaletteLime20: ColorPaletteLime20$7,
    ColorPaletteLime30: ColorPaletteLime30$7,
    ColorPaletteLime40: ColorPaletteLime40$7,
    ColorPaletteLime50: ColorPaletteLime50$7,
    ColorPaletteLime60: ColorPaletteLime60$7,
    ColorPaletteLime70: ColorPaletteLime70$7,
    ColorPaletteLime80: ColorPaletteLime80$7,
    ColorPaletteLime90: ColorPaletteLime90$7,
    ColorPaletteLime100: ColorPaletteLime100$7,
    ColorPaletteLime110: ColorPaletteLime110$7,
    ColorPaletteLime120: ColorPaletteLime120$7,
    ColorPaletteLime130: ColorPaletteLime130$7,
    ColorPaletteLime140: ColorPaletteLime140$7,
    ColorPaletteLime150: ColorPaletteLime150$7,
    ColorPaletteLime160: ColorPaletteLime160$7,
    ColorPaletteGreen10: ColorPaletteGreen10$7,
    ColorPaletteGreen20: ColorPaletteGreen20$7,
    ColorPaletteGreen30: ColorPaletteGreen30$7,
    ColorPaletteGreen40: ColorPaletteGreen40$7,
    ColorPaletteGreen50: ColorPaletteGreen50$7,
    ColorPaletteGreen60: ColorPaletteGreen60$7,
    ColorPaletteGreen70: ColorPaletteGreen70$7,
    ColorPaletteGreen80: ColorPaletteGreen80$7,
    ColorPaletteGreen90: ColorPaletteGreen90$7,
    ColorPaletteGreen100: ColorPaletteGreen100$7,
    ColorPaletteGreen110: ColorPaletteGreen110$7,
    ColorPaletteGreen120: ColorPaletteGreen120$7,
    ColorPaletteGreen130: ColorPaletteGreen130$7,
    ColorPaletteGreen140: ColorPaletteGreen140$7,
    ColorPaletteGreen150: ColorPaletteGreen150$7,
    ColorPaletteGreen160: ColorPaletteGreen160$7,
    ColorPaletteAcqua10: ColorPaletteAcqua10$7,
    ColorPaletteAcqua20: ColorPaletteAcqua20$7,
    ColorPaletteAcqua30: ColorPaletteAcqua30$7,
    ColorPaletteAcqua40: ColorPaletteAcqua40$7,
    ColorPaletteAcqua50: ColorPaletteAcqua50$7,
    ColorPaletteAcqua60: ColorPaletteAcqua60$7,
    ColorPaletteAcqua70: ColorPaletteAcqua70$7,
    ColorPaletteAcqua80: ColorPaletteAcqua80$7,
    ColorPaletteAcqua90: ColorPaletteAcqua90$7,
    ColorPaletteAcqua100: ColorPaletteAcqua100$7,
    ColorPaletteAcqua110: ColorPaletteAcqua110$7,
    ColorPaletteAcqua120: ColorPaletteAcqua120$7,
    ColorPaletteAcqua130: ColorPaletteAcqua130$7,
    ColorPaletteAcqua140: ColorPaletteAcqua140$7,
    ColorPaletteAcqua150: ColorPaletteAcqua150$7,
    ColorPaletteAcqua160: ColorPaletteAcqua160$7,
    ColorPaletteBlue10: ColorPaletteBlue10$7,
    ColorPaletteBlue20: ColorPaletteBlue20$7,
    ColorPaletteBlue30: ColorPaletteBlue30$7,
    ColorPaletteBlue40: ColorPaletteBlue40$7,
    ColorPaletteBlue50: ColorPaletteBlue50$7,
    ColorPaletteBlue60: ColorPaletteBlue60$7,
    ColorPaletteBlue70: ColorPaletteBlue70$7,
    ColorPaletteBlue80: ColorPaletteBlue80$7,
    ColorPaletteBlue90: ColorPaletteBlue90$7,
    ColorPaletteBlue100: ColorPaletteBlue100$7,
    ColorPaletteBlue110: ColorPaletteBlue110$7,
    ColorPaletteBlue120: ColorPaletteBlue120$7,
    ColorPaletteBlue130: ColorPaletteBlue130$7,
    ColorPaletteBlue140: ColorPaletteBlue140$7,
    ColorPaletteBlue150: ColorPaletteBlue150$7,
    ColorPaletteBlue160: ColorPaletteBlue160$7,
    ColorPalettePurple10: ColorPalettePurple10$7,
    ColorPalettePurple20: ColorPalettePurple20$7,
    ColorPalettePurple30: ColorPalettePurple30$7,
    ColorPalettePurple40: ColorPalettePurple40$7,
    ColorPalettePurple50: ColorPalettePurple50$7,
    ColorPalettePurple60: ColorPalettePurple60$7,
    ColorPalettePurple70: ColorPalettePurple70$7,
    ColorPalettePurple80: ColorPalettePurple80$7,
    ColorPalettePurple90: ColorPalettePurple90$7,
    ColorPalettePurple100: ColorPalettePurple100$7,
    ColorPalettePurple110: ColorPalettePurple110$7,
    ColorPalettePurple120: ColorPalettePurple120$7,
    ColorPalettePurple130: ColorPalettePurple130$7,
    ColorPalettePurple140: ColorPalettePurple140$7,
    ColorPalettePurple150: ColorPalettePurple150$7,
    ColorPalettePurple160: ColorPalettePurple160$7,
    ColorPalettePink10: ColorPalettePink10$7,
    ColorPalettePink20: ColorPalettePink20$7,
    ColorPalettePink30: ColorPalettePink30$7,
    ColorPalettePink40: ColorPalettePink40$7,
    ColorPalettePink50: ColorPalettePink50$7,
    ColorPalettePink60: ColorPalettePink60$7,
    ColorPalettePink70: ColorPalettePink70$7,
    ColorPalettePink80: ColorPalettePink80$7,
    ColorPalettePink90: ColorPalettePink90$7,
    ColorPalettePink100: ColorPalettePink100$7,
    ColorPalettePink110: ColorPalettePink110$7,
    ColorPalettePink120: ColorPalettePink120$7,
    ColorPalettePink130: ColorPalettePink130$7,
    ColorPalettePink140: ColorPalettePink140$7,
    ColorPalettePink150: ColorPalettePink150$7,
    ColorPalettePink160: ColorPalettePink160$7,
    ColorTypefaceStrong: ColorTypefaceStrong$7,
    ColorTypefacePure: ColorTypefacePure$7,
    ColorTypefaceSmooth: ColorTypefaceSmooth$7,
    ColorTypefaceMeld: ColorTypefaceMeld$7,
    ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$7,
    ColorTypefaceInversePure: ColorTypefaceInversePure$7,
    ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$7,
    ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$7,
    ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$7,
    ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$7,
    ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$7,
    ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$7,
    ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$7,
    ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$7,
    ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$7,
    ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$7,
    ColorBrandPrimary10: ColorBrandPrimary10$7,
    ColorBrandPrimary20: ColorBrandPrimary20$7,
    ColorBrandPrimary30: ColorBrandPrimary30$7,
    ColorBrandPrimary40: ColorBrandPrimary40$7,
    ColorBrandPrimary50: ColorBrandPrimary50$7,
    ColorBrandPrimary60: ColorBrandPrimary60$7,
    ColorBrandPrimary70: ColorBrandPrimary70$7,
    ColorBrandPrimary80: ColorBrandPrimary80$7,
    ColorBrandPrimary90: ColorBrandPrimary90$7,
    ColorBrandPrimary100: ColorBrandPrimary100$7,
    ColorBrandPrimary110: ColorBrandPrimary110$7,
    ColorBrandPrimary120: ColorBrandPrimary120$7,
    ColorBrandBase01: ColorBrandBase01$7,
    ColorBrandBase02: ColorBrandBase02$7,
    ColorBrandBase03: ColorBrandBase03$6,
    ColorBrandBase04: ColorBrandBase04$6,
    ColorFeedbackErrorText: ColorFeedbackErrorText$7,
    ColorFeedbackErrorShape: ColorFeedbackErrorShape$7,
    ColorFeedbackSuccessText: ColorFeedbackSuccessText$7,
    ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$7,
    ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$7,
    ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$7,
    ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$7,
    ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$7,
    ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$7,
    ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$7,
    ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$7,
    ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$7,
    ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$7,
    ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$7,
    ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$7,
    ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$7,
    ColorSupport01: ColorSupport01$7,
    ColorSupport02: ColorSupport02$7,
    ColorSupportOnBrand01: ColorSupportOnBrand01$7,
    ColorSupportOnBrand02: ColorSupportOnBrand02$7,
    ColorSupportInverse01: ColorSupportInverse01$7,
    ColorSupportInverse02: ColorSupportInverse02$7,
    ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$7,
    ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$7,
    Opacity01: Opacity01$7,
    Opacity02: Opacity02$7,
    Opacity03: Opacity03$7,
    Opacity04: Opacity04$7,
    Opacity05: Opacity05$7,
    Opacity06: Opacity06$7,
    Opacity07: Opacity07$7,
    Opacity08: Opacity08$7,
    Opacity09: Opacity09$7,
    Shadow01: Shadow01$7,
    Shadow02: Shadow02$7,
    Shadow03: Shadow03$7,
    Shadow04: Shadow04$7,
    SpacingInlineQuark: SpacingInlineQuark$7,
    SpacingInlineNano: SpacingInlineNano$7,
    SpacingInlineXxxs: SpacingInlineXxxs$7,
    SpacingInlineXxs: SpacingInlineXxs$7,
    SpacingInlineXs: SpacingInlineXs$7,
    SpacingInlineSm: SpacingInlineSm$7,
    SpacingInlineMd: SpacingInlineMd$7,
    SpacingInlineLg: SpacingInlineLg$7,
    SpacingInlineXl: SpacingInlineXl$7,
    SpacingInlineXxl: SpacingInlineXxl$7,
    SpacingInlineXxxl: SpacingInlineXxxl$7,
    SpacingInlineHuge: SpacingInlineHuge$7,
    SpacingInlineGiant: SpacingInlineGiant$7,
    SpacingInsetQuark: SpacingInsetQuark$7,
    SpacingInsetNano: SpacingInsetNano$7,
    SpacingInsetXs: SpacingInsetXs$7,
    SpacingInsetSm: SpacingInsetSm$7,
    SpacingInsetMd: SpacingInsetMd$7,
    SpacingInsetLg: SpacingInsetLg$7,
    SpacingSquishQuark: SpacingSquishQuark$7,
    SpacingSquishNano: SpacingSquishNano$7,
    SpacingSquishXs: SpacingSquishXs$7,
    SpacingSquishSm: SpacingSquishSm$7,
    SpacingStackQuark: SpacingStackQuark$7,
    SpacingStackNano: SpacingStackNano$7,
    SpacingStackXxxs: SpacingStackXxxs$7,
    SpacingStackXxs: SpacingStackXxs$7,
    SpacingStackXs: SpacingStackXs$7,
    SpacingStackSm: SpacingStackSm$7,
    SpacingStackMd: SpacingStackMd$7,
    SpacingStackLg: SpacingStackLg$7,
    SpacingStackXl: SpacingStackXl$7,
    SpacingStackXxl: SpacingStackXxl$7,
    SpacingStackXxxl: SpacingStackXxxl$7,
    SpacingStackHuge: SpacingStackHuge$7,
    SpacingStackGiant: SpacingStackGiant$7,
    FontFamilyBase: FontFamilyBase$7,
    FontSizeXxxs: FontSizeXxxs$7,
    FontSizeXxs: FontSizeXxs$7,
    FontSizeXs: FontSizeXs$7,
    FontSizeSm: FontSizeSm$7,
    FontSizeMd: FontSizeMd$7,
    FontSizeLg: FontSizeLg$7,
    FontSizeXl: FontSizeXl$7,
    FontSizeXxl: FontSizeXxl$7,
    FontSizeXxxl: FontSizeXxxl$7,
    FontSizeDisplay: FontSizeDisplay$7,
    FontSizeGiant: FontSizeGiant$7,
    FontWeightBold: FontWeightBold$7,
    FontWeightSemibold: FontWeightSemibold$7,
    FontWeightMedium: FontWeightMedium$7,
    FontWeightRegular: FontWeightRegular$7,
    FontWeightLight: FontWeightLight$7,
    LetterSpacingStandard: LetterSpacingStandard$7,
    LetterSpacingSmall: LetterSpacingSmall$7,
    LetterSpacingMedium: LetterSpacingMedium$7,
    LineHeightStandard: LineHeightStandard$7,
    LineHeightTiny: LineHeightTiny$7,
    LineHeightMedium: LineHeightMedium$7,
    LineHeightLarge: LineHeightLarge$7,
    LineHeightDistant: LineHeightDistant$7,
    LineHeightSuperdistant: LineHeightSuperdistant$7,
    LineHeightHuge: LineHeightHuge$7
  });
  /**
   * Do not edit directly
   * Generated on Thu, 27 Oct 2022 18:07:46 GMT
   */

  var BorderRadiusNone$6 = "0px";
  var BorderRadiusXs$6 = "4px";
  var BorderRadiusSm$6 = "8px";
  var BorderRadiusMd$6 = "16px";
  var BorderRadiusLg$6 = "24px";
  var BorderRadiusPill$6 = "960px";
  var BorderRadiusCircle$6 = "50%";
  var BorderWidthNone$6 = "0px";
  var BorderWidthHairline$6 = "1px";
  var BorderWidthThin$6 = "2px";
  var BorderWidthThick$6 = "4px";
  var BorderWidthHeavy$6 = "8px";
  var ColorDatavizInfoText$6 = "#0F58EA";
  var ColorDatavizInfoShape01$6 = "#3F7BF2";
  var ColorDatavizInfoShape02$6 = "#D9E5FC";
  var ColorDatavizInfoShape03$6 = "#F1F5FE";
  var ColorDatavizNegativeText$6 = "#BC293A";
  var ColorDatavizNegativeShape01$6 = "#EA4356";
  var ColorDatavizNegativeShape02$6 = "#FDDDE1";
  var ColorDatavizNegativeShape03$6 = "#FEF1F2";
  var ColorDatavizWarningText$6 = "#A04C03";
  var ColorDatavizWarningShape01$6 = "#D26404";
  var ColorDatavizWarningShape02$6 = "#FEE1C8";
  var ColorDatavizWarningShape03$6 = "#FEF1E6";
  var ColorDatavizPositiveText$6 = "#22723A";
  var ColorDatavizPositiveShape01$6 = "#2D954C";
  var ColorDatavizPositiveShape02$6 = "#C8EED3";
  var ColorDatavizPositiveShape03$6 = "#E8F8EC";
  var ColorDatavizCatAText$6 = "#9B18DC";
  var ColorDatavizCatAShape01$6 = "#B851EC";
  var ColorDatavizCatAShape02$6 = "#F2DFFB";
  var ColorDatavizCatAShape03$6 = "#F9F1FD";
  var ColorDatavizCatBText$6 = "#BA267B";
  var ColorDatavizCatBShape01$6 = "#DA499B";
  var ColorDatavizCatBShape02$6 = "#F8DDEC";
  var ColorDatavizCatBShape03$6 = "#FCF2F8";
  var ColorDatavizCatCText$6 = "#546E21";
  var ColorDatavizCatCShape01$6 = "#6C8D2B";
  var ColorDatavizCatCShape02$6 = "#DBEBBD";
  var ColorDatavizCatCShape03$6 = "#F0F7E4";
  var ColorDatavizCatDText$6 = "#0D735E";
  var ColorDatavizCatDShape01$6 = "#109379";
  var ColorDatavizCatDShape02$6 = "#BCF0E6";
  var ColorDatavizCatDShape03$6 = "#DFFBF6";
  var ColorDatavizInverseInfoText$6 = "#5C8FF5";
  var ColorDatavizInverseInfoShape01$6 = "#286BF1";
  var ColorDatavizInverseInfoShape02$6 = "#062560";
  var ColorDatavizInverseInfoShape03$6 = "#051B48";
  var ColorDatavizInverseNegativeText$6 = "#F55C6E";
  var ColorDatavizInverseNegativeShape01$6 = "#D83145";
  var ColorDatavizInverseNegativeShape02$6 = "#4F1119";
  var ColorDatavizInverseNegativeShape03$6 = "#3B0D12";
  var ColorDatavizInverseWarningText$6 = "#EB7005";
  var ColorDatavizInverseWarningShape01$6 = "#B95804";
  var ColorDatavizInverseWarningShape02$6 = "#462101";
  var ColorDatavizInverseWarningShape03$6 = "#321701";
  var ColorDatavizInversePositiveText$6 = "#32A454";
  var ColorDatavizInversePositiveShape01$6 = "#278142";
  var ColorDatavizInversePositiveShape02$6 = "#0E2F18";
  var ColorDatavizInversePositiveShape03$6 = "#0B2312";
  var ColorDatavizInverseCatAText$6 = "#C36CEF";
  var ColorDatavizInverseCatAShape01$6 = "#AD35E9";
  var ColorDatavizInverseCatAShape02$6 = "#440B60";
  var ColorDatavizInverseCatAShape03$6 = "#340849";
  var ColorDatavizInverseCatBText$6 = "#E067AB";
  var ColorDatavizInverseCatBShape01$6 = "#D42B8C";
  var ColorDatavizInverseCatBShape02$6 = "#4C1032";
  var ColorDatavizInverseCatBShape03$6 = "#3B0C27";
  var ColorDatavizInverseCatCText$6 = "#789D2F";
  var ColorDatavizInverseCatCShape01$6 = "#607E26";
  var ColorDatavizInverseCatCShape02$6 = "#212B0D";
  var ColorDatavizInverseCatCShape03$6 = "#1B230B";
  var ColorDatavizInverseCatDText$6 = "#12A588";
  var ColorDatavizInverseCatDShape01$6 = "#0F856D";
  var ColorDatavizInverseCatDShape02$6 = "#052E26";
  var ColorDatavizInverseCatDShape03$6 = "#04251E";
  var ColorInteractionBlend01$6 = "#1616160A";
  var ColorInteractionBlend02$6 = "#16161614";
  var ColorInteractionBlend03$6 = "#1616161F";
  var ColorInteractionBlend04$6 = "#1616163D";
  var ColorInteractionBlend05$6 = "#161616A3";
  var ColorInteractionBlend06$6 = "#161616B8";
  var ColorInteractionBlend07$6 = "#161616E0";
  var ColorInteractionBlend08$6 = "#161616";
  var ColorInteractionInverseBlend01$6 = "#FEFEFE14";
  var ColorInteractionInverseBlend02$6 = "#FEFEFE1F";
  var ColorInteractionInverseBlend03$6 = "#FEFEFE3D";
  var ColorInteractionInverseBlend04$6 = "#FEFEFE52";
  var ColorInteractionInverseBlend05$6 = "#FEFEFEA3";
  var ColorInteractionInverseBlend06$6 = "#FEFEFEB8";
  var ColorInteractionInverseBlend07$6 = "#FEFEFEE0";
  var ColorInteractionInverseBlend08$6 = "#FEFEFE";
  var ColorInteractionInverseAccent01$6 = "#B2C3FF";
  var ColorInteractionInverseAccent02$6 = "#DBE3FF";
  var ColorInteractionInverseAccent03$6 = "#DBE3FF";
  var ColorInteractionInverseSubtle01$6 = "#B2C3FF1F";
  var ColorInteractionInverseSubtle02$6 = "#B2C3FF3D";
  var ColorInteractionInverseSubtle03$6 = "#B2C3FF52";
  var ColorInteractionInverseSelectDefault$6 = "#666666";
  var ColorInteractionInverseSelectFocus$6 = "#919191";
  var ColorInteractionInverseSelectActive$6 = "#B2C3FF";
  var ColorInteractionInverseDanger01$6 = "#D83145";
  var ColorInteractionInverseDanger02$6 = "#EA4356";
  var ColorInteractionInverseDanger03$6 = "#F55C6E";
  var ColorInteractionInverseOnBrandAccent01$6 = "#000E40";
  var ColorInteractionInverseOnBrandAccent02$6 = "#001A7A";
  var ColorInteractionInverseOnBrandAccent03$6 = "#00229E";
  var ColorInteractionInverseOnBrandSubtle01$6 = "#000E4014";
  var ColorInteractionInverseOnBrandSubtle02$6 = "#000E401F";
  var ColorInteractionInverseOnBrandSubtle03$6 = "#000E403D";
  var ColorInteractionInverseOnBrandSelectDefault$6 = "#363636";
  var ColorInteractionInverseOnBrandSelectFocus$6 = "#292929";
  var ColorInteractionInverseOnBrandSelectActive$6 = "#000E40";
  var ColorInteractionInverseOnBrandBlend01$6 = "#1616160A";
  var ColorInteractionInverseOnBrandBlend02$6 = "#16161614";
  var ColorInteractionInverseOnBrandBlend03$6 = "#1616161F";
  var ColorInteractionInverseOnBrandBlend04$6 = "#1616163D";
  var ColorInteractionInverseOnBrandBlend05$6 = "#161616A3";
  var ColorInteractionInverseOnBrandBlend06$6 = "#161616B8";
  var ColorInteractionInverseOnBrandBlend07$6 = "#161616E0";
  var ColorInteractionInverseOnBrandBlend08$6 = "#161616";
  var ColorInteractionInverseOnBrandDanger01$6 = "#4F1119";
  var ColorInteractionInverseOnBrandDanger02$6 = "#691721";
  var ColorInteractionInverseOnBrandDanger03$6 = "#7E1B27";
  var ColorInteractionAccent01$6 = "#000E40";
  var ColorInteractionAccent02$6 = "#001A7A";
  var ColorInteractionAccent03$6 = "#00229E";
  var ColorInteractionSubtle01$6 = "#000E401F";
  var ColorInteractionSubtle02$6 = "#000E403D";
  var ColorInteractionSubtle03$6 = "#000E4052";
  var ColorInteractionSelectDefault$6 = "#595959";
  var ColorInteractionSelectFocus$6 = "#363636";
  var ColorInteractionSelectActive$6 = "#000E40";
  var ColorInteractionDanger01$6 = "#92202E";
  var ColorInteractionDanger02$6 = "#7E1B27";
  var ColorInteractionDanger03$6 = "#691721";
  var ColorInteractionOnBrandAccent01$6 = "#FEFEFE";
  var ColorInteractionOnBrandAccent02$6 = "#C7D3FF";
  var ColorInteractionOnBrandAccent03$6 = "#B2C3FF";
  var ColorInteractionOnBrandSubtle01$6 = "#FEFEFE1F";
  var ColorInteractionOnBrandSubtle02$6 = "#FEFEFE3D";
  var ColorInteractionOnBrandSubtle03$6 = "#FEFEFE52";
  var ColorInteractionOnBrandSelectDefault$6 = "#919191";
  var ColorInteractionOnBrandSelectFocus$6 = "#A1A1A1";
  var ColorInteractionOnBrandSelectActive$6 = "#B2C3FF";
  var ColorInteractionOnBrandBlend01$6 = "#FEFEFE14";
  var ColorInteractionOnBrandBlend02$6 = "#FEFEFE1F";
  var ColorInteractionOnBrandBlend03$6 = "#FEFEFE3D";
  var ColorInteractionOnBrandBlend04$6 = "#FEFEFE52";
  var ColorInteractionOnBrandBlend05$6 = "#FEFEFEA3";
  var ColorInteractionOnBrandBlend06$6 = "#FEFEFEB8";
  var ColorInteractionOnBrandBlend07$6 = "#FEFEFEE0";
  var ColorInteractionOnBrandBlend08$6 = "#FEFEFE";
  var ColorInteractionOnBrandDanger01$6 = "#EA4356";
  var ColorInteractionOnBrandDanger02$6 = "#F55C6E";
  var ColorInteractionOnBrandDanger03$6 = "#F77E8C";
  var ColorNeutral10$6 = "#F5F5F5";
  var ColorNeutral20$6 = "#E6E6E6";
  var ColorNeutral30$6 = "#1616163D";
  var ColorNeutral00$6 = "#FEFEFE";
  var ColorNeutralInverse10$6 = "#1F1F1F";
  var ColorNeutralInverse20$6 = "#292929";
  var ColorNeutralInverse30$6 = "#FEFEFE3D";
  var ColorNeutralInverse00$6 = "#161616";
  var ColorNeutralInverseOnBrand10$6 = "#DBE3FF";
  var ColorNeutralInverseOnBrand20$6 = "#C7D3FF";
  var ColorNeutralInverseOnBrand30$6 = "#000E4052";
  var ColorNeutralInverseOnBrand00$6 = "#F0F3FF";
  var ColorNeutralOnBrand10$6 = "#001A7A";
  var ColorNeutralOnBrand20$6 = "#00229E";
  var ColorNeutralOnBrand30$6 = "#0028B8E0";
  var ColorNeutralOnBrand00$6 = "#000E40";
  var ColorPaletteBlack$6 = "#161616";
  var ColorPaletteWhite$6 = "#FEFEFE";
  var ColorPaletteGray10$6 = "#1F1F1F";
  var ColorPaletteGray20$6 = "#292929";
  var ColorPaletteGray30$6 = "#363636";
  var ColorPaletteGray40$6 = "#404040";
  var ColorPaletteGray50$6 = "#4C4C4C";
  var ColorPaletteGray60$6 = "#595959";
  var ColorPaletteGray70$6 = "#666666";
  var ColorPaletteGray80$6 = "#737373";
  var ColorPaletteGray90$6 = "#828282";
  var ColorPaletteGray100$6 = "#919191";
  var ColorPaletteGray110$6 = "#A1A1A1";
  var ColorPaletteGray120$6 = "#B0B0B0";
  var ColorPaletteGray130$6 = "#C2C2C2";
  var ColorPaletteGray140$6 = "#D4D4D4";
  var ColorPaletteGray150$6 = "#E6E6E6";
  var ColorPaletteGray160$6 = "#F5F5F5";
  var ColorPaletteRed10$6 = "#3B0D12";
  var ColorPaletteRed20$6 = "#4F1119";
  var ColorPaletteRed30$6 = "#691721";
  var ColorPaletteRed40$6 = "#7E1B27";
  var ColorPaletteRed50$6 = "#92202E";
  var ColorPaletteRed60$6 = "#A72534";
  var ColorPaletteRed70$6 = "#BC293A";
  var ColorPaletteRed80$6 = "#D83145";
  var ColorPaletteRed90$6 = "#EA4356";
  var ColorPaletteRed100$6 = "#F55C6E";
  var ColorPaletteRed110$6 = "#F77E8C";
  var ColorPaletteRed120$6 = "#F895A1";
  var ColorPaletteRed130$6 = "#FAAEB6";
  var ColorPaletteRed140$6 = "#FBC5CC";
  var ColorPaletteRed150$6 = "#FDDDE1";
  var ColorPaletteRed160$6 = "#FEF1F2";
  var ColorPaletteYellow10$6 = "#321701";
  var ColorPaletteYellow20$6 = "#462101";
  var ColorPaletteYellow30$6 = "#552802";
  var ColorPaletteYellow40$6 = "#693102";
  var ColorPaletteYellow50$6 = "#7D3B03";
  var ColorPaletteYellow60$6 = "#914503";
  var ColorPaletteYellow70$6 = "#A04C03";
  var ColorPaletteYellow80$6 = "#B95804";
  var ColorPaletteYellow90$6 = "#D26404";
  var ColorPaletteYellow100$6 = "#EB7005";
  var ColorPaletteYellow110$6 = "#FA8219";
  var ColorPaletteYellow120$6 = "#FB9B46";
  var ColorPaletteYellow130$6 = "#FCB06E";
  var ColorPaletteYellow140$6 = "#FDC99B";
  var ColorPaletteYellow150$6 = "#FEE1C8";
  var ColorPaletteYellow160$6 = "#FEF1E6";
  var ColorPaletteLime10$6 = "#1B230B";
  var ColorPaletteLime20$6 = "#212B0D";
  var ColorPaletteLime30$6 = "#2D3B12";
  var ColorPaletteLime40$6 = "#364616";
  var ColorPaletteLime50$6 = "#3F5219";
  var ColorPaletteLime60$6 = "#485E1D";
  var ColorPaletteLime70$6 = "#546E21";
  var ColorPaletteLime80$6 = "#607E26";
  var ColorPaletteLime90$6 = "#6C8D2B";
  var ColorPaletteLime100$6 = "#789D2F";
  var ColorPaletteLime110$6 = "#84AC34";
  var ColorPaletteLime120$6 = "#93BF3A";
  var ColorPaletteLime130$6 = "#A9CF5E";
  var ColorPaletteLime140$6 = "#C2DD8D";
  var ColorPaletteLime150$6 = "#DBEBBD";
  var ColorPaletteLime160$6 = "#F0F7E4";
  var ColorPaletteGreen10$6 = "#0B2312";
  var ColorPaletteGreen20$6 = "#0E2F18";
  var ColorPaletteGreen30$6 = "#133E20";
  var ColorPaletteGreen40$6 = "#174A26";
  var ColorPaletteGreen50$6 = "#1A562C";
  var ColorPaletteGreen60$6 = "#1F6634";
  var ColorPaletteGreen70$6 = "#22723A";
  var ColorPaletteGreen80$6 = "#278142";
  var ColorPaletteGreen90$6 = "#2D954C";
  var ColorPaletteGreen100$6 = "#32A454";
  var ColorPaletteGreen110$6 = "#38B85E";
  var ColorPaletteGreen120$6 = "#4BC870";
  var ColorPaletteGreen130$6 = "#76D692";
  var ColorPaletteGreen140$6 = "#9DE2B1";
  var ColorPaletteGreen150$6 = "#C8EED3";
  var ColorPaletteGreen160$6 = "#E8F8EC";
  var ColorPaletteAcqua10$6 = "#04251E";
  var ColorPaletteAcqua20$6 = "#052E26";
  var ColorPaletteAcqua30$6 = "#073C31";
  var ColorPaletteAcqua40$6 = "#08493C";
  var ColorPaletteAcqua50$6 = "#0A5748";
  var ColorPaletteAcqua60$6 = "#0B6553";
  var ColorPaletteAcqua70$6 = "#0D735E";
  var ColorPaletteAcqua80$6 = "#0F856D";
  var ColorPaletteAcqua90$6 = "#109379";
  var ColorPaletteAcqua100$6 = "#12A588";
  var ColorPaletteAcqua110$6 = "#14B897";
  var ColorPaletteAcqua120$6 = "#31C4A6";
  var ColorPaletteAcqua130$6 = "#68D4BF";
  var ColorPaletteAcqua140$6 = "#8DE2D1";
  var ColorPaletteAcqua150$6 = "#BCF0E6";
  var ColorPaletteAcqua160$6 = "#DFFBF6";
  var ColorPaletteBlue10$6 = "#051B48";
  var ColorPaletteBlue20$6 = "#062560";
  var ColorPaletteBlue30$6 = "#082F7D";
  var ColorPaletteBlue40$6 = "#0A3A9A";
  var ColorPaletteBlue50$6 = "#0B43B1";
  var ColorPaletteBlue60$6 = "#0D4ECE";
  var ColorPaletteBlue70$6 = "#0F58EA";
  var ColorPaletteBlue80$6 = "#286BF1";
  var ColorPaletteBlue90$6 = "#3F7BF2";
  var ColorPaletteBlue100$6 = "#5C8FF5";
  var ColorPaletteBlue110$6 = "#73A0F7";
  var ColorPaletteBlue120$6 = "#8CB0F8";
  var ColorPaletteBlue130$6 = "#A9C4F9";
  var ColorPaletteBlue140$6 = "#C1D4FB";
  var ColorPaletteBlue150$6 = "#D9E5FC";
  var ColorPaletteBlue160$6 = "#F1F5FE";
  var ColorPalettePurple10$6 = "#340849";
  var ColorPalettePurple20$6 = "#440B60";
  var ColorPalettePurple30$6 = "#540D78";
  var ColorPalettePurple40$6 = "#671093";
  var ColorPalettePurple50$6 = "#7713AA";
  var ColorPalettePurple60$6 = "#8B16C5";
  var ColorPalettePurple70$6 = "#9B18DC";
  var ColorPalettePurple80$6 = "#AD35E9";
  var ColorPalettePurple90$6 = "#B851EC";
  var ColorPalettePurple100$6 = "#C36CEF";
  var ColorPalettePurple110$6 = "#CC83F1";
  var ColorPalettePurple120$6 = "#D69AF4";
  var ColorPalettePurple130$6 = "#DFB1F6";
  var ColorPalettePurple140$6 = "#E8C8F9";
  var ColorPalettePurple150$6 = "#F2DFFB";
  var ColorPalettePurple160$6 = "#F9F1FD";
  var ColorPalettePink10$6 = "#3B0C27";
  var ColorPalettePink20$6 = "#4C1032";
  var ColorPalettePink30$6 = "#661543";
  var ColorPalettePink40$6 = "#77184E";
  var ColorPalettePink50$6 = "#8C1C5D";
  var ColorPalettePink60$6 = "#A12169";
  var ColorPalettePink70$6 = "#BA267B";
  var ColorPalettePink80$6 = "#D42B8C";
  var ColorPalettePink90$6 = "#DA499B";
  var ColorPalettePink100$6 = "#E067AB";
  var ColorPalettePink110$6 = "#E580B9";
  var ColorPalettePink120$6 = "#EA99C7";
  var ColorPalettePink130$6 = "#EFAFD3";
  var ColorPalettePink140$6 = "#F4C8E1";
  var ColorPalettePink150$6 = "#F8DDEC";
  var ColorPalettePink160$6 = "#FCF2F8";
  var ColorTypefaceStrong$6 = "#161616";
  var ColorTypefacePure$6 = "#363636";
  var ColorTypefaceSmooth$6 = "#666666";
  var ColorTypefaceMeld$6 = "#1616163D";
  var ColorTypefaceInverseStrong$6 = "#FEFEFE";
  var ColorTypefaceInversePure$6 = "#D4D4D4";
  var ColorTypefaceInverseSmooth$6 = "#919191";
  var ColorTypefaceInverseMeld$6 = "#FEFEFE52";
  var ColorTypefaceInverseOnBrandStrong$6 = "#161616";
  var ColorTypefaceInverseOnBrandPure$6 = "#1F1F1F";
  var ColorTypefaceInverseOnBrandSmooth$6 = "#292929";
  var ColorTypefaceInverseOnBrandMeld$6 = "#1616163D";
  var ColorTypefaceOnBrandStrong$6 = "#FEFEFE";
  var ColorTypefaceOnBrandPure$6 = "#F0F3FF";
  var ColorTypefaceOnBrandSmooth$6 = "#DBE3FF";
  var ColorTypefaceOnBrandMeld$6 = "#FEFEFE52";
  var ColorBrandPrimary10$6 = "#000E40";
  var ColorBrandPrimary20$6 = "#001A7A";
  var ColorBrandPrimary30$6 = "#00229E";
  var ColorBrandPrimary40$6 = "#0028B8";
  var ColorBrandPrimary50$6 = "#002FDB";
  var ColorBrandPrimary60$6 = "#0034F0";
  var ColorBrandPrimary70$6 = "#8AA3FF";
  var ColorBrandPrimary80$6 = "#99AFFF";
  var ColorBrandPrimary90$6 = "#B2C3FF";
  var ColorBrandPrimary100$6 = "#C7D3FF";
  var ColorBrandPrimary110$6 = "#DBE3FF";
  var ColorBrandPrimary120$6 = "#F0F3FF";
  var ColorBrandBase01$6 = "#000E40";
  var ColorBrandBase02$6 = "#A6E1FF";
  var ColorBrandBase03$5 = "#FF4E33";
  var ColorBrandBase04$5 = "#0037FF";
  var ColorBrandBase05$5 = "#E5FF00";
  var ColorBrandBase06$3 = "#D1B287";
  var ColorFeedbackErrorText$6 = "#92202E";
  var ColorFeedbackErrorShape$6 = "#BC293A";
  var ColorFeedbackSuccessText$6 = "#1A562C";
  var ColorFeedbackSuccessShape$6 = "#22723A";
  var ColorFeedbackOnBrandErrorText$6 = "#EA4356";
  var ColorFeedbackOnBrandErrorShape$6 = "#D83145";
  var ColorFeedbackOnBrandSuccessText$6 = "#2D954C";
  var ColorFeedbackOnBrandSuccessShape$6 = "#22723A";
  var ColorFeedbackInverseErrorText$6 = "#F55C6E";
  var ColorFeedbackInverseErrorShape$6 = "#D83145";
  var ColorFeedbackInverseSuccessText$6 = "#32A454";
  var ColorFeedbackInverseSuccessShape$6 = "#278142";
  var ColorFeedbackInverseOnBrandErrorText$6 = "#7E1B27";
  var ColorFeedbackInverseOnBrandErrorShape$6 = "#92202E";
  var ColorFeedbackInverseOnBrandSuccessText$6 = "#174A26";
  var ColorFeedbackInverseOnBrandSuccessShape$6 = "#1A562C";
  var ColorSupport01$6 = "#FF4E33";
  var ColorSupport02$6 = "#EC4A31";
  var ColorSupportOnBrand01$6 = "#ABE6FF";
  var ColorSupportOnBrand02$6 = "#ABE6FF";
  var ColorSupportInverse01$6 = "#ABE6FF";
  var ColorSupportInverse02$6 = "#ABE6FF";
  var ColorSupportInverseOnBrand01$6 = "#000E40";
  var ColorSupportInverseOnBrand02$6 = "#000E40";
  var Opacity01$6 = "0.04";
  var Opacity02$6 = "0.08";
  var Opacity03$6 = "0.12";
  var Opacity04$6 = "0.24";
  var Opacity05$6 = "0.32";
  var Opacity06$6 = "0.56";
  var Opacity07$6 = "0.64";
  var Opacity08$6 = "0.72";
  var Opacity09$6 = "0.88";
  var Shadow01$6 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
  var Shadow02$6 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
  var Shadow03$6 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
  var Shadow04$6 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
  var SpacingInlineQuark$6 = "4px";
  var SpacingInlineNano$6 = "8px";
  var SpacingInlineXxxs$6 = "16px";
  var SpacingInlineXxs$6 = "24px";
  var SpacingInlineXs$6 = "32px";
  var SpacingInlineSm$6 = "40px";
  var SpacingInlineMd$6 = "48px";
  var SpacingInlineLg$6 = "56px";
  var SpacingInlineXl$6 = "64px";
  var SpacingInlineXxl$6 = "80px";
  var SpacingInlineXxxl$6 = "120px";
  var SpacingInlineHuge$6 = "160px";
  var SpacingInlineGiant$6 = "200px";
  var SpacingInsetQuark$6 = "4px";
  var SpacingInsetNano$6 = "8px";
  var SpacingInsetXs$6 = "16px";
  var SpacingInsetSm$6 = "24px";
  var SpacingInsetMd$6 = "32px";
  var SpacingInsetLg$6 = "40px";
  var SpacingSquishQuark$6 = "4px 8px";
  var SpacingSquishNano$6 = "8px 16px";
  var SpacingSquishXs$6 = "16px 24px";
  var SpacingSquishSm$6 = "16px 32px";
  var SpacingStackQuark$6 = "4px";
  var SpacingStackNano$6 = "8px";
  var SpacingStackXxxs$6 = "16px";
  var SpacingStackXxs$6 = "24px";
  var SpacingStackXs$6 = "32px";
  var SpacingStackSm$6 = "40px";
  var SpacingStackMd$6 = "48px";
  var SpacingStackLg$6 = "56px";
  var SpacingStackXl$6 = "64px";
  var SpacingStackXxl$6 = "80px";
  var SpacingStackXxxl$6 = "120px";
  var SpacingStackHuge$6 = "160px";
  var SpacingStackGiant$6 = "200px";
  var FontFamilyBase$6 = "'Dasa Sans', 'sans-serif'";
  var FontSizeXxxs$6 = "0.75rem";
  var FontSizeXxs$6 = "0.875rem";
  var FontSizeXs$6 = "1rem";
  var FontSizeSm$6 = "1.25rem";
  var FontSizeMd$6 = "1.5rem";
  var FontSizeLg$6 = "2rem";
  var FontSizeXl$6 = "2.5rem";
  var FontSizeXxl$6 = "3rem";
  var FontSizeXxxl$6 = "4rem";
  var FontSizeDisplay$6 = "5rem";
  var FontSizeGiant$6 = "6rem";
  var FontWeightBold$6 = 700;
  var FontWeightSemibold$6 = 600;
  var FontWeightMedium$6 = 500;
  var FontWeightRegular$6 = 400;
  var FontWeightLight$6 = 300;
  var LetterSpacingStandard$6 = "0px";
  var LetterSpacingSmall$6 = "-1px";
  var LetterSpacingMedium$6 = "1.5px";
  var LineHeightStandard$6 = "100%";
  var LineHeightTiny$6 = "115%";
  var LineHeightMedium$6 = "120%";
  var LineHeightLarge$6 = "125%";
  var LineHeightDistant$6 = "133%";
  var LineHeightSuperdistant$6 = "150%";
  var LineHeightHuge$6 = "170%";
  var index$6 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BorderRadiusNone: BorderRadiusNone$6,
    BorderRadiusXs: BorderRadiusXs$6,
    BorderRadiusSm: BorderRadiusSm$6,
    BorderRadiusMd: BorderRadiusMd$6,
    BorderRadiusLg: BorderRadiusLg$6,
    BorderRadiusPill: BorderRadiusPill$6,
    BorderRadiusCircle: BorderRadiusCircle$6,
    BorderWidthNone: BorderWidthNone$6,
    BorderWidthHairline: BorderWidthHairline$6,
    BorderWidthThin: BorderWidthThin$6,
    BorderWidthThick: BorderWidthThick$6,
    BorderWidthHeavy: BorderWidthHeavy$6,
    ColorDatavizInfoText: ColorDatavizInfoText$6,
    ColorDatavizInfoShape01: ColorDatavizInfoShape01$6,
    ColorDatavizInfoShape02: ColorDatavizInfoShape02$6,
    ColorDatavizInfoShape03: ColorDatavizInfoShape03$6,
    ColorDatavizNegativeText: ColorDatavizNegativeText$6,
    ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$6,
    ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$6,
    ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$6,
    ColorDatavizWarningText: ColorDatavizWarningText$6,
    ColorDatavizWarningShape01: ColorDatavizWarningShape01$6,
    ColorDatavizWarningShape02: ColorDatavizWarningShape02$6,
    ColorDatavizWarningShape03: ColorDatavizWarningShape03$6,
    ColorDatavizPositiveText: ColorDatavizPositiveText$6,
    ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$6,
    ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$6,
    ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$6,
    ColorDatavizCatAText: ColorDatavizCatAText$6,
    ColorDatavizCatAShape01: ColorDatavizCatAShape01$6,
    ColorDatavizCatAShape02: ColorDatavizCatAShape02$6,
    ColorDatavizCatAShape03: ColorDatavizCatAShape03$6,
    ColorDatavizCatBText: ColorDatavizCatBText$6,
    ColorDatavizCatBShape01: ColorDatavizCatBShape01$6,
    ColorDatavizCatBShape02: ColorDatavizCatBShape02$6,
    ColorDatavizCatBShape03: ColorDatavizCatBShape03$6,
    ColorDatavizCatCText: ColorDatavizCatCText$6,
    ColorDatavizCatCShape01: ColorDatavizCatCShape01$6,
    ColorDatavizCatCShape02: ColorDatavizCatCShape02$6,
    ColorDatavizCatCShape03: ColorDatavizCatCShape03$6,
    ColorDatavizCatDText: ColorDatavizCatDText$6,
    ColorDatavizCatDShape01: ColorDatavizCatDShape01$6,
    ColorDatavizCatDShape02: ColorDatavizCatDShape02$6,
    ColorDatavizCatDShape03: ColorDatavizCatDShape03$6,
    ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$6,
    ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$6,
    ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$6,
    ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$6,
    ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$6,
    ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$6,
    ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$6,
    ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$6,
    ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$6,
    ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$6,
    ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$6,
    ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$6,
    ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$6,
    ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$6,
    ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$6,
    ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$6,
    ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$6,
    ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$6,
    ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$6,
    ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$6,
    ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$6,
    ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$6,
    ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$6,
    ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$6,
    ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$6,
    ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$6,
    ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$6,
    ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$6,
    ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$6,
    ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$6,
    ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$6,
    ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$6,
    ColorInteractionBlend01: ColorInteractionBlend01$6,
    ColorInteractionBlend02: ColorInteractionBlend02$6,
    ColorInteractionBlend03: ColorInteractionBlend03$6,
    ColorInteractionBlend04: ColorInteractionBlend04$6,
    ColorInteractionBlend05: ColorInteractionBlend05$6,
    ColorInteractionBlend06: ColorInteractionBlend06$6,
    ColorInteractionBlend07: ColorInteractionBlend07$6,
    ColorInteractionBlend08: ColorInteractionBlend08$6,
    ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$6,
    ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$6,
    ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$6,
    ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$6,
    ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$6,
    ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$6,
    ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$6,
    ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$6,
    ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$6,
    ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$6,
    ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$6,
    ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$6,
    ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$6,
    ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$6,
    ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$6,
    ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$6,
    ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$6,
    ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$6,
    ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$6,
    ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$6,
    ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$6,
    ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$6,
    ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$6,
    ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$6,
    ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$6,
    ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$6,
    ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$6,
    ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$6,
    ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$6,
    ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$6,
    ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$6,
    ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$6,
    ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$6,
    ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$6,
    ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$6,
    ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$6,
    ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$6,
    ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$6,
    ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$6,
    ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$6,
    ColorInteractionAccent01: ColorInteractionAccent01$6,
    ColorInteractionAccent02: ColorInteractionAccent02$6,
    ColorInteractionAccent03: ColorInteractionAccent03$6,
    ColorInteractionSubtle01: ColorInteractionSubtle01$6,
    ColorInteractionSubtle02: ColorInteractionSubtle02$6,
    ColorInteractionSubtle03: ColorInteractionSubtle03$6,
    ColorInteractionSelectDefault: ColorInteractionSelectDefault$6,
    ColorInteractionSelectFocus: ColorInteractionSelectFocus$6,
    ColorInteractionSelectActive: ColorInteractionSelectActive$6,
    ColorInteractionDanger01: ColorInteractionDanger01$6,
    ColorInteractionDanger02: ColorInteractionDanger02$6,
    ColorInteractionDanger03: ColorInteractionDanger03$6,
    ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$6,
    ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$6,
    ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$6,
    ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$6,
    ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$6,
    ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$6,
    ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$6,
    ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$6,
    ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$6,
    ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$6,
    ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$6,
    ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$6,
    ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$6,
    ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$6,
    ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$6,
    ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$6,
    ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$6,
    ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$6,
    ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$6,
    ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$6,
    ColorNeutral10: ColorNeutral10$6,
    ColorNeutral20: ColorNeutral20$6,
    ColorNeutral30: ColorNeutral30$6,
    ColorNeutral00: ColorNeutral00$6,
    ColorNeutralInverse10: ColorNeutralInverse10$6,
    ColorNeutralInverse20: ColorNeutralInverse20$6,
    ColorNeutralInverse30: ColorNeutralInverse30$6,
    ColorNeutralInverse00: ColorNeutralInverse00$6,
    ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$6,
    ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$6,
    ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$6,
    ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$6,
    ColorNeutralOnBrand10: ColorNeutralOnBrand10$6,
    ColorNeutralOnBrand20: ColorNeutralOnBrand20$6,
    ColorNeutralOnBrand30: ColorNeutralOnBrand30$6,
    ColorNeutralOnBrand00: ColorNeutralOnBrand00$6,
    ColorPaletteBlack: ColorPaletteBlack$6,
    ColorPaletteWhite: ColorPaletteWhite$6,
    ColorPaletteGray10: ColorPaletteGray10$6,
    ColorPaletteGray20: ColorPaletteGray20$6,
    ColorPaletteGray30: ColorPaletteGray30$6,
    ColorPaletteGray40: ColorPaletteGray40$6,
    ColorPaletteGray50: ColorPaletteGray50$6,
    ColorPaletteGray60: ColorPaletteGray60$6,
    ColorPaletteGray70: ColorPaletteGray70$6,
    ColorPaletteGray80: ColorPaletteGray80$6,
    ColorPaletteGray90: ColorPaletteGray90$6,
    ColorPaletteGray100: ColorPaletteGray100$6,
    ColorPaletteGray110: ColorPaletteGray110$6,
    ColorPaletteGray120: ColorPaletteGray120$6,
    ColorPaletteGray130: ColorPaletteGray130$6,
    ColorPaletteGray140: ColorPaletteGray140$6,
    ColorPaletteGray150: ColorPaletteGray150$6,
    ColorPaletteGray160: ColorPaletteGray160$6,
    ColorPaletteRed10: ColorPaletteRed10$6,
    ColorPaletteRed20: ColorPaletteRed20$6,
    ColorPaletteRed30: ColorPaletteRed30$6,
    ColorPaletteRed40: ColorPaletteRed40$6,
    ColorPaletteRed50: ColorPaletteRed50$6,
    ColorPaletteRed60: ColorPaletteRed60$6,
    ColorPaletteRed70: ColorPaletteRed70$6,
    ColorPaletteRed80: ColorPaletteRed80$6,
    ColorPaletteRed90: ColorPaletteRed90$6,
    ColorPaletteRed100: ColorPaletteRed100$6,
    ColorPaletteRed110: ColorPaletteRed110$6,
    ColorPaletteRed120: ColorPaletteRed120$6,
    ColorPaletteRed130: ColorPaletteRed130$6,
    ColorPaletteRed140: ColorPaletteRed140$6,
    ColorPaletteRed150: ColorPaletteRed150$6,
    ColorPaletteRed160: ColorPaletteRed160$6,
    ColorPaletteYellow10: ColorPaletteYellow10$6,
    ColorPaletteYellow20: ColorPaletteYellow20$6,
    ColorPaletteYellow30: ColorPaletteYellow30$6,
    ColorPaletteYellow40: ColorPaletteYellow40$6,
    ColorPaletteYellow50: ColorPaletteYellow50$6,
    ColorPaletteYellow60: ColorPaletteYellow60$6,
    ColorPaletteYellow70: ColorPaletteYellow70$6,
    ColorPaletteYellow80: ColorPaletteYellow80$6,
    ColorPaletteYellow90: ColorPaletteYellow90$6,
    ColorPaletteYellow100: ColorPaletteYellow100$6,
    ColorPaletteYellow110: ColorPaletteYellow110$6,
    ColorPaletteYellow120: ColorPaletteYellow120$6,
    ColorPaletteYellow130: ColorPaletteYellow130$6,
    ColorPaletteYellow140: ColorPaletteYellow140$6,
    ColorPaletteYellow150: ColorPaletteYellow150$6,
    ColorPaletteYellow160: ColorPaletteYellow160$6,
    ColorPaletteLime10: ColorPaletteLime10$6,
    ColorPaletteLime20: ColorPaletteLime20$6,
    ColorPaletteLime30: ColorPaletteLime30$6,
    ColorPaletteLime40: ColorPaletteLime40$6,
    ColorPaletteLime50: ColorPaletteLime50$6,
    ColorPaletteLime60: ColorPaletteLime60$6,
    ColorPaletteLime70: ColorPaletteLime70$6,
    ColorPaletteLime80: ColorPaletteLime80$6,
    ColorPaletteLime90: ColorPaletteLime90$6,
    ColorPaletteLime100: ColorPaletteLime100$6,
    ColorPaletteLime110: ColorPaletteLime110$6,
    ColorPaletteLime120: ColorPaletteLime120$6,
    ColorPaletteLime130: ColorPaletteLime130$6,
    ColorPaletteLime140: ColorPaletteLime140$6,
    ColorPaletteLime150: ColorPaletteLime150$6,
    ColorPaletteLime160: ColorPaletteLime160$6,
    ColorPaletteGreen10: ColorPaletteGreen10$6,
    ColorPaletteGreen20: ColorPaletteGreen20$6,
    ColorPaletteGreen30: ColorPaletteGreen30$6,
    ColorPaletteGreen40: ColorPaletteGreen40$6,
    ColorPaletteGreen50: ColorPaletteGreen50$6,
    ColorPaletteGreen60: ColorPaletteGreen60$6,
    ColorPaletteGreen70: ColorPaletteGreen70$6,
    ColorPaletteGreen80: ColorPaletteGreen80$6,
    ColorPaletteGreen90: ColorPaletteGreen90$6,
    ColorPaletteGreen100: ColorPaletteGreen100$6,
    ColorPaletteGreen110: ColorPaletteGreen110$6,
    ColorPaletteGreen120: ColorPaletteGreen120$6,
    ColorPaletteGreen130: ColorPaletteGreen130$6,
    ColorPaletteGreen140: ColorPaletteGreen140$6,
    ColorPaletteGreen150: ColorPaletteGreen150$6,
    ColorPaletteGreen160: ColorPaletteGreen160$6,
    ColorPaletteAcqua10: ColorPaletteAcqua10$6,
    ColorPaletteAcqua20: ColorPaletteAcqua20$6,
    ColorPaletteAcqua30: ColorPaletteAcqua30$6,
    ColorPaletteAcqua40: ColorPaletteAcqua40$6,
    ColorPaletteAcqua50: ColorPaletteAcqua50$6,
    ColorPaletteAcqua60: ColorPaletteAcqua60$6,
    ColorPaletteAcqua70: ColorPaletteAcqua70$6,
    ColorPaletteAcqua80: ColorPaletteAcqua80$6,
    ColorPaletteAcqua90: ColorPaletteAcqua90$6,
    ColorPaletteAcqua100: ColorPaletteAcqua100$6,
    ColorPaletteAcqua110: ColorPaletteAcqua110$6,
    ColorPaletteAcqua120: ColorPaletteAcqua120$6,
    ColorPaletteAcqua130: ColorPaletteAcqua130$6,
    ColorPaletteAcqua140: ColorPaletteAcqua140$6,
    ColorPaletteAcqua150: ColorPaletteAcqua150$6,
    ColorPaletteAcqua160: ColorPaletteAcqua160$6,
    ColorPaletteBlue10: ColorPaletteBlue10$6,
    ColorPaletteBlue20: ColorPaletteBlue20$6,
    ColorPaletteBlue30: ColorPaletteBlue30$6,
    ColorPaletteBlue40: ColorPaletteBlue40$6,
    ColorPaletteBlue50: ColorPaletteBlue50$6,
    ColorPaletteBlue60: ColorPaletteBlue60$6,
    ColorPaletteBlue70: ColorPaletteBlue70$6,
    ColorPaletteBlue80: ColorPaletteBlue80$6,
    ColorPaletteBlue90: ColorPaletteBlue90$6,
    ColorPaletteBlue100: ColorPaletteBlue100$6,
    ColorPaletteBlue110: ColorPaletteBlue110$6,
    ColorPaletteBlue120: ColorPaletteBlue120$6,
    ColorPaletteBlue130: ColorPaletteBlue130$6,
    ColorPaletteBlue140: ColorPaletteBlue140$6,
    ColorPaletteBlue150: ColorPaletteBlue150$6,
    ColorPaletteBlue160: ColorPaletteBlue160$6,
    ColorPalettePurple10: ColorPalettePurple10$6,
    ColorPalettePurple20: ColorPalettePurple20$6,
    ColorPalettePurple30: ColorPalettePurple30$6,
    ColorPalettePurple40: ColorPalettePurple40$6,
    ColorPalettePurple50: ColorPalettePurple50$6,
    ColorPalettePurple60: ColorPalettePurple60$6,
    ColorPalettePurple70: ColorPalettePurple70$6,
    ColorPalettePurple80: ColorPalettePurple80$6,
    ColorPalettePurple90: ColorPalettePurple90$6,
    ColorPalettePurple100: ColorPalettePurple100$6,
    ColorPalettePurple110: ColorPalettePurple110$6,
    ColorPalettePurple120: ColorPalettePurple120$6,
    ColorPalettePurple130: ColorPalettePurple130$6,
    ColorPalettePurple140: ColorPalettePurple140$6,
    ColorPalettePurple150: ColorPalettePurple150$6,
    ColorPalettePurple160: ColorPalettePurple160$6,
    ColorPalettePink10: ColorPalettePink10$6,
    ColorPalettePink20: ColorPalettePink20$6,
    ColorPalettePink30: ColorPalettePink30$6,
    ColorPalettePink40: ColorPalettePink40$6,
    ColorPalettePink50: ColorPalettePink50$6,
    ColorPalettePink60: ColorPalettePink60$6,
    ColorPalettePink70: ColorPalettePink70$6,
    ColorPalettePink80: ColorPalettePink80$6,
    ColorPalettePink90: ColorPalettePink90$6,
    ColorPalettePink100: ColorPalettePink100$6,
    ColorPalettePink110: ColorPalettePink110$6,
    ColorPalettePink120: ColorPalettePink120$6,
    ColorPalettePink130: ColorPalettePink130$6,
    ColorPalettePink140: ColorPalettePink140$6,
    ColorPalettePink150: ColorPalettePink150$6,
    ColorPalettePink160: ColorPalettePink160$6,
    ColorTypefaceStrong: ColorTypefaceStrong$6,
    ColorTypefacePure: ColorTypefacePure$6,
    ColorTypefaceSmooth: ColorTypefaceSmooth$6,
    ColorTypefaceMeld: ColorTypefaceMeld$6,
    ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$6,
    ColorTypefaceInversePure: ColorTypefaceInversePure$6,
    ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$6,
    ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$6,
    ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$6,
    ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$6,
    ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$6,
    ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$6,
    ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$6,
    ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$6,
    ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$6,
    ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$6,
    ColorBrandPrimary10: ColorBrandPrimary10$6,
    ColorBrandPrimary20: ColorBrandPrimary20$6,
    ColorBrandPrimary30: ColorBrandPrimary30$6,
    ColorBrandPrimary40: ColorBrandPrimary40$6,
    ColorBrandPrimary50: ColorBrandPrimary50$6,
    ColorBrandPrimary60: ColorBrandPrimary60$6,
    ColorBrandPrimary70: ColorBrandPrimary70$6,
    ColorBrandPrimary80: ColorBrandPrimary80$6,
    ColorBrandPrimary90: ColorBrandPrimary90$6,
    ColorBrandPrimary100: ColorBrandPrimary100$6,
    ColorBrandPrimary110: ColorBrandPrimary110$6,
    ColorBrandPrimary120: ColorBrandPrimary120$6,
    ColorBrandBase01: ColorBrandBase01$6,
    ColorBrandBase02: ColorBrandBase02$6,
    ColorBrandBase03: ColorBrandBase03$5,
    ColorBrandBase04: ColorBrandBase04$5,
    ColorBrandBase05: ColorBrandBase05$5,
    ColorBrandBase06: ColorBrandBase06$3,
    ColorFeedbackErrorText: ColorFeedbackErrorText$6,
    ColorFeedbackErrorShape: ColorFeedbackErrorShape$6,
    ColorFeedbackSuccessText: ColorFeedbackSuccessText$6,
    ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$6,
    ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$6,
    ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$6,
    ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$6,
    ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$6,
    ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$6,
    ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$6,
    ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$6,
    ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$6,
    ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$6,
    ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$6,
    ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$6,
    ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$6,
    ColorSupport01: ColorSupport01$6,
    ColorSupport02: ColorSupport02$6,
    ColorSupportOnBrand01: ColorSupportOnBrand01$6,
    ColorSupportOnBrand02: ColorSupportOnBrand02$6,
    ColorSupportInverse01: ColorSupportInverse01$6,
    ColorSupportInverse02: ColorSupportInverse02$6,
    ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$6,
    ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$6,
    Opacity01: Opacity01$6,
    Opacity02: Opacity02$6,
    Opacity03: Opacity03$6,
    Opacity04: Opacity04$6,
    Opacity05: Opacity05$6,
    Opacity06: Opacity06$6,
    Opacity07: Opacity07$6,
    Opacity08: Opacity08$6,
    Opacity09: Opacity09$6,
    Shadow01: Shadow01$6,
    Shadow02: Shadow02$6,
    Shadow03: Shadow03$6,
    Shadow04: Shadow04$6,
    SpacingInlineQuark: SpacingInlineQuark$6,
    SpacingInlineNano: SpacingInlineNano$6,
    SpacingInlineXxxs: SpacingInlineXxxs$6,
    SpacingInlineXxs: SpacingInlineXxs$6,
    SpacingInlineXs: SpacingInlineXs$6,
    SpacingInlineSm: SpacingInlineSm$6,
    SpacingInlineMd: SpacingInlineMd$6,
    SpacingInlineLg: SpacingInlineLg$6,
    SpacingInlineXl: SpacingInlineXl$6,
    SpacingInlineXxl: SpacingInlineXxl$6,
    SpacingInlineXxxl: SpacingInlineXxxl$6,
    SpacingInlineHuge: SpacingInlineHuge$6,
    SpacingInlineGiant: SpacingInlineGiant$6,
    SpacingInsetQuark: SpacingInsetQuark$6,
    SpacingInsetNano: SpacingInsetNano$6,
    SpacingInsetXs: SpacingInsetXs$6,
    SpacingInsetSm: SpacingInsetSm$6,
    SpacingInsetMd: SpacingInsetMd$6,
    SpacingInsetLg: SpacingInsetLg$6,
    SpacingSquishQuark: SpacingSquishQuark$6,
    SpacingSquishNano: SpacingSquishNano$6,
    SpacingSquishXs: SpacingSquishXs$6,
    SpacingSquishSm: SpacingSquishSm$6,
    SpacingStackQuark: SpacingStackQuark$6,
    SpacingStackNano: SpacingStackNano$6,
    SpacingStackXxxs: SpacingStackXxxs$6,
    SpacingStackXxs: SpacingStackXxs$6,
    SpacingStackXs: SpacingStackXs$6,
    SpacingStackSm: SpacingStackSm$6,
    SpacingStackMd: SpacingStackMd$6,
    SpacingStackLg: SpacingStackLg$6,
    SpacingStackXl: SpacingStackXl$6,
    SpacingStackXxl: SpacingStackXxl$6,
    SpacingStackXxxl: SpacingStackXxxl$6,
    SpacingStackHuge: SpacingStackHuge$6,
    SpacingStackGiant: SpacingStackGiant$6,
    FontFamilyBase: FontFamilyBase$6,
    FontSizeXxxs: FontSizeXxxs$6,
    FontSizeXxs: FontSizeXxs$6,
    FontSizeXs: FontSizeXs$6,
    FontSizeSm: FontSizeSm$6,
    FontSizeMd: FontSizeMd$6,
    FontSizeLg: FontSizeLg$6,
    FontSizeXl: FontSizeXl$6,
    FontSizeXxl: FontSizeXxl$6,
    FontSizeXxxl: FontSizeXxxl$6,
    FontSizeDisplay: FontSizeDisplay$6,
    FontSizeGiant: FontSizeGiant$6,
    FontWeightBold: FontWeightBold$6,
    FontWeightSemibold: FontWeightSemibold$6,
    FontWeightMedium: FontWeightMedium$6,
    FontWeightRegular: FontWeightRegular$6,
    FontWeightLight: FontWeightLight$6,
    LetterSpacingStandard: LetterSpacingStandard$6,
    LetterSpacingSmall: LetterSpacingSmall$6,
    LetterSpacingMedium: LetterSpacingMedium$6,
    LineHeightStandard: LineHeightStandard$6,
    LineHeightTiny: LineHeightTiny$6,
    LineHeightMedium: LineHeightMedium$6,
    LineHeightLarge: LineHeightLarge$6,
    LineHeightDistant: LineHeightDistant$6,
    LineHeightSuperdistant: LineHeightSuperdistant$6,
    LineHeightHuge: LineHeightHuge$6
  });
  /**
   * Do not edit directly
   * Generated on Thu, 27 Oct 2022 18:07:46 GMT
   */

  var BorderRadiusNone$5 = "0px";
  var BorderRadiusXs$5 = "4px";
  var BorderRadiusSm$5 = "8px";
  var BorderRadiusMd$5 = "16px";
  var BorderRadiusLg$5 = "24px";
  var BorderRadiusPill$5 = "960px";
  var BorderRadiusCircle$5 = "50%";
  var BorderWidthNone$5 = "0px";
  var BorderWidthHairline$5 = "1px";
  var BorderWidthThin$5 = "2px";
  var BorderWidthThick$5 = "4px";
  var BorderWidthHeavy$5 = "8px";
  var ColorDatavizInfoText$5 = "#0F58EA";
  var ColorDatavizInfoShape01$5 = "#3F7BF2";
  var ColorDatavizInfoShape02$5 = "#D9E5FC";
  var ColorDatavizInfoShape03$5 = "#F1F5FE";
  var ColorDatavizNegativeText$5 = "#BC293A";
  var ColorDatavizNegativeShape01$5 = "#EA4356";
  var ColorDatavizNegativeShape02$5 = "#FDDDE1";
  var ColorDatavizNegativeShape03$5 = "#FEF1F2";
  var ColorDatavizWarningText$5 = "#A04C03";
  var ColorDatavizWarningShape01$5 = "#D26404";
  var ColorDatavizWarningShape02$5 = "#FEE1C8";
  var ColorDatavizWarningShape03$5 = "#FEF1E6";
  var ColorDatavizPositiveText$5 = "#22723A";
  var ColorDatavizPositiveShape01$5 = "#2D954C";
  var ColorDatavizPositiveShape02$5 = "#C8EED3";
  var ColorDatavizPositiveShape03$5 = "#E8F8EC";
  var ColorDatavizCatAText$5 = "#9B18DC";
  var ColorDatavizCatAShape01$5 = "#B851EC";
  var ColorDatavizCatAShape02$5 = "#F2DFFB";
  var ColorDatavizCatAShape03$5 = "#F9F1FD";
  var ColorDatavizCatBText$5 = "#BA267B";
  var ColorDatavizCatBShape01$5 = "#DA499B";
  var ColorDatavizCatBShape02$5 = "#F8DDEC";
  var ColorDatavizCatBShape03$5 = "#FCF2F8";
  var ColorDatavizCatCText$5 = "#546E21";
  var ColorDatavizCatCShape01$5 = "#6C8D2B";
  var ColorDatavizCatCShape02$5 = "#DBEBBD";
  var ColorDatavizCatCShape03$5 = "#F0F7E4";
  var ColorDatavizCatDText$5 = "#0D735E";
  var ColorDatavizCatDShape01$5 = "#109379";
  var ColorDatavizCatDShape02$5 = "#BCF0E6";
  var ColorDatavizCatDShape03$5 = "#DFFBF6";
  var ColorDatavizInverseInfoText$5 = "#5C8FF5";
  var ColorDatavizInverseInfoShape01$5 = "#286BF1";
  var ColorDatavizInverseInfoShape02$5 = "#062560";
  var ColorDatavizInverseInfoShape03$5 = "#051B48";
  var ColorDatavizInverseNegativeText$5 = "#F55C6E";
  var ColorDatavizInverseNegativeShape01$5 = "#D83145";
  var ColorDatavizInverseNegativeShape02$5 = "#4F1119";
  var ColorDatavizInverseNegativeShape03$5 = "#3B0D12";
  var ColorDatavizInverseWarningText$5 = "#EB7005";
  var ColorDatavizInverseWarningShape01$5 = "#B95804";
  var ColorDatavizInverseWarningShape02$5 = "#462101";
  var ColorDatavizInverseWarningShape03$5 = "#321701";
  var ColorDatavizInversePositiveText$5 = "#32A454";
  var ColorDatavizInversePositiveShape01$5 = "#278142";
  var ColorDatavizInversePositiveShape02$5 = "#0E2F18";
  var ColorDatavizInversePositiveShape03$5 = "#0B2312";
  var ColorDatavizInverseCatAText$5 = "#C36CEF";
  var ColorDatavizInverseCatAShape01$5 = "#AD35E9";
  var ColorDatavizInverseCatAShape02$5 = "#440B60";
  var ColorDatavizInverseCatAShape03$5 = "#340849";
  var ColorDatavizInverseCatBText$5 = "#E067AB";
  var ColorDatavizInverseCatBShape01$5 = "#D42B8C";
  var ColorDatavizInverseCatBShape02$5 = "#4C1032";
  var ColorDatavizInverseCatBShape03$5 = "#3B0C27";
  var ColorDatavizInverseCatCText$5 = "#789D2F";
  var ColorDatavizInverseCatCShape01$5 = "#607E26";
  var ColorDatavizInverseCatCShape02$5 = "#212B0D";
  var ColorDatavizInverseCatCShape03$5 = "#1B230B";
  var ColorDatavizInverseCatDText$5 = "#12A588";
  var ColorDatavizInverseCatDShape01$5 = "#0F856D";
  var ColorDatavizInverseCatDShape02$5 = "#052E26";
  var ColorDatavizInverseCatDShape03$5 = "#04251E";
  var ColorInteractionBlend01$5 = "#1616160A";
  var ColorInteractionBlend02$5 = "#16161614";
  var ColorInteractionBlend03$5 = "#1616161F";
  var ColorInteractionBlend04$5 = "#1616163D";
  var ColorInteractionBlend05$5 = "#161616A3";
  var ColorInteractionBlend06$5 = "#161616B8";
  var ColorInteractionBlend07$5 = "#161616E0";
  var ColorInteractionBlend08$5 = "#161616";
  var ColorInteractionInverseBlend01$5 = "#FEFEFE14";
  var ColorInteractionInverseBlend02$5 = "#FEFEFE1F";
  var ColorInteractionInverseBlend03$5 = "#FEFEFE3D";
  var ColorInteractionInverseBlend04$5 = "#FEFEFE52";
  var ColorInteractionInverseBlend05$5 = "#FEFEFEA3";
  var ColorInteractionInverseBlend06$5 = "#FEFEFEB8";
  var ColorInteractionInverseBlend07$5 = "#FEFEFEE0";
  var ColorInteractionInverseBlend08$5 = "#FEFEFE";
  var ColorInteractionInverseAccent01$5 = "#6B8BFF";
  var ColorInteractionInverseAccent02$5 = "#809BFF";
  var ColorInteractionInverseAccent03$5 = "#99AFFF";
  var ColorInteractionInverseSubtle01$5 = "#5277FF1F";
  var ColorInteractionInverseSubtle02$5 = "#5277FF3D";
  var ColorInteractionInverseSubtle03$5 = "#5277FF52";
  var ColorInteractionInverseSelectDefault$5 = "#919191";
  var ColorInteractionInverseSelectFocus$5 = "#D4D4D4";
  var ColorInteractionInverseSelectActive$5 = "#9C86E0";
  var ColorInteractionInverseDanger01$5 = "#F55C6E";
  var ColorInteractionInverseDanger02$5 = "#F77E8C";
  var ColorInteractionInverseDanger03$5 = "#F895A1";
  var ColorInteractionInverseOnBrandAccent01$5 = "#000E40";
  var ColorInteractionInverseOnBrandAccent02$5 = "#001A7A";
  var ColorInteractionInverseOnBrandAccent03$5 = "#00229E";
  var ColorInteractionInverseOnBrandSubtle01$5 = "#002FDB14";
  var ColorInteractionInverseOnBrandSubtle02$5 = "#002FDB1F";
  var ColorInteractionInverseOnBrandSubtle03$5 = "#002FDB3D";
  var ColorInteractionInverseOnBrandSelectDefault$5 = "#595959";
  var ColorInteractionInverseOnBrandSelectFocus$5 = "#404040";
  var ColorInteractionInverseOnBrandSelectActive$5 = "#603CCD";
  var ColorInteractionInverseOnBrandBlend01$5 = "#1616160A";
  var ColorInteractionInverseOnBrandBlend02$5 = "#16161614";
  var ColorInteractionInverseOnBrandBlend03$5 = "#1616161F";
  var ColorInteractionInverseOnBrandBlend04$5 = "#1616163D";
  var ColorInteractionInverseOnBrandBlend05$5 = "#161616A3";
  var ColorInteractionInverseOnBrandBlend06$5 = "#161616B8";
  var ColorInteractionInverseOnBrandBlend07$5 = "#161616E0";
  var ColorInteractionInverseOnBrandBlend08$5 = "#161616";
  var ColorInteractionInverseOnBrandDanger01$5 = "#A72534";
  var ColorInteractionInverseOnBrandDanger02$5 = "#92202E";
  var ColorInteractionInverseOnBrandDanger03$5 = "#7E1B27";
  var ColorInteractionAccent01$5 = "#000E40";
  var ColorInteractionAccent02$5 = "#001A7A";
  var ColorInteractionAccent03$5 = "#00229E";
  var ColorInteractionSubtle01$5 = "#0029BD1F";
  var ColorInteractionSubtle02$5 = "#0029BD3D";
  var ColorInteractionSubtle03$5 = "#0029BD52";
  var ColorInteractionSelectDefault$5 = "#666666";
  var ColorInteractionSelectFocus$5 = "#363636";
  var ColorInteractionSelectActive$5 = "#603CCD";
  var ColorInteractionDanger01$5 = "#BC293A";
  var ColorInteractionDanger02$5 = "#A72534";
  var ColorInteractionDanger03$5 = "#92202E";
  var ColorInteractionOnBrandAccent01$5 = "#ADBFFF";
  var ColorInteractionOnBrandAccent02$5 = "#99AFFF";
  var ColorInteractionOnBrandAccent03$5 = "#809BFF";
  var ColorInteractionOnBrandSubtle01$5 = "#5277FF1F";
  var ColorInteractionOnBrandSubtle02$5 = "#5277FF3D";
  var ColorInteractionOnBrandSubtle03$5 = "#5277FF52";
  var ColorInteractionOnBrandSelectDefault$5 = "#B0B0B0";
  var ColorInteractionOnBrandSelectFocus$5 = "#D4D4D4";
  var ColorInteractionOnBrandSelectActive$5 = "#809BFF";
  var ColorInteractionOnBrandBlend01$5 = "#FEFEFE14";
  var ColorInteractionOnBrandBlend02$5 = "#FEFEFE1F";
  var ColorInteractionOnBrandBlend03$5 = "#FEFEFE3D";
  var ColorInteractionOnBrandBlend04$5 = "#FEFEFE52";
  var ColorInteractionOnBrandBlend05$5 = "#FEFEFEA3";
  var ColorInteractionOnBrandBlend06$5 = "#FEFEFEB8";
  var ColorInteractionOnBrandBlend07$5 = "#FEFEFEE0";
  var ColorInteractionOnBrandBlend08$5 = "#FEFEFE";
  var ColorInteractionOnBrandDanger01$5 = "#F77E8C";
  var ColorInteractionOnBrandDanger02$5 = "#F895A1";
  var ColorInteractionOnBrandDanger03$5 = "#FAAEB6";
  var ColorNeutral10$5 = "#F5F5F5";
  var ColorNeutral20$5 = "#E6E6E6";
  var ColorNeutral30$5 = "#1616163D";
  var ColorNeutral00$5 = "#FEFEFE";
  var ColorNeutralInverse10$5 = "#1F1F1F";
  var ColorNeutralInverse20$5 = "#292929";
  var ColorNeutralInverse30$5 = "#FEFEFE3D";
  var ColorNeutralInverse00$5 = "#161616";
  var ColorNeutralInverseOnBrand10$5 = "#DBE3FF";
  var ColorNeutralInverseOnBrand20$5 = "#C7D3FF";
  var ColorNeutralInverseOnBrand30$5 = "#0029BD52";
  var ColorNeutralInverseOnBrand00$5 = "#F0F3FF";
  var ColorNeutralOnBrand10$5 = "#001A7A";
  var ColorNeutralOnBrand20$5 = "#00229E";
  var ColorNeutralOnBrand30$5 = "#5277FFA3";
  var ColorNeutralOnBrand00$5 = "#000E40";
  var ColorPaletteBlack$5 = "#161616";
  var ColorPaletteWhite$5 = "#FEFEFE";
  var ColorPaletteGray10$5 = "#1F1F1F";
  var ColorPaletteGray20$5 = "#292929";
  var ColorPaletteGray30$5 = "#363636";
  var ColorPaletteGray40$5 = "#404040";
  var ColorPaletteGray50$5 = "#4C4C4C";
  var ColorPaletteGray60$5 = "#595959";
  var ColorPaletteGray70$5 = "#666666";
  var ColorPaletteGray80$5 = "#737373";
  var ColorPaletteGray90$5 = "#828282";
  var ColorPaletteGray100$5 = "#919191";
  var ColorPaletteGray110$5 = "#A1A1A1";
  var ColorPaletteGray120$5 = "#B0B0B0";
  var ColorPaletteGray130$5 = "#C2C2C2";
  var ColorPaletteGray140$5 = "#D4D4D4";
  var ColorPaletteGray150$5 = "#E6E6E6";
  var ColorPaletteGray160$5 = "#F5F5F5";
  var ColorPaletteRed10$5 = "#3B0D12";
  var ColorPaletteRed20$5 = "#4F1119";
  var ColorPaletteRed30$5 = "#691721";
  var ColorPaletteRed40$5 = "#7E1B27";
  var ColorPaletteRed50$5 = "#92202E";
  var ColorPaletteRed60$5 = "#A72534";
  var ColorPaletteRed70$5 = "#BC293A";
  var ColorPaletteRed80$5 = "#D83145";
  var ColorPaletteRed90$5 = "#EA4356";
  var ColorPaletteRed100$5 = "#F55C6E";
  var ColorPaletteRed110$5 = "#F77E8C";
  var ColorPaletteRed120$5 = "#F895A1";
  var ColorPaletteRed130$5 = "#FAAEB6";
  var ColorPaletteRed140$5 = "#FBC5CC";
  var ColorPaletteRed150$5 = "#FDDDE1";
  var ColorPaletteRed160$5 = "#FEF1F2";
  var ColorPaletteYellow10$5 = "#321701";
  var ColorPaletteYellow20$5 = "#462101";
  var ColorPaletteYellow30$5 = "#552802";
  var ColorPaletteYellow40$5 = "#693102";
  var ColorPaletteYellow50$5 = "#7D3B03";
  var ColorPaletteYellow60$5 = "#914503";
  var ColorPaletteYellow70$5 = "#A04C03";
  var ColorPaletteYellow80$5 = "#B95804";
  var ColorPaletteYellow90$5 = "#D26404";
  var ColorPaletteYellow100$5 = "#EB7005";
  var ColorPaletteYellow110$5 = "#FA8219";
  var ColorPaletteYellow120$5 = "#FB9B46";
  var ColorPaletteYellow130$5 = "#FCB06E";
  var ColorPaletteYellow140$5 = "#FDC99B";
  var ColorPaletteYellow150$5 = "#FEE1C8";
  var ColorPaletteYellow160$5 = "#FEF1E6";
  var ColorPaletteLime10$5 = "#1B230B";
  var ColorPaletteLime20$5 = "#212B0D";
  var ColorPaletteLime30$5 = "#2D3B12";
  var ColorPaletteLime40$5 = "#364616";
  var ColorPaletteLime50$5 = "#3F5219";
  var ColorPaletteLime60$5 = "#485E1D";
  var ColorPaletteLime70$5 = "#546E21";
  var ColorPaletteLime80$5 = "#607E26";
  var ColorPaletteLime90$5 = "#6C8D2B";
  var ColorPaletteLime100$5 = "#789D2F";
  var ColorPaletteLime110$5 = "#84AC34";
  var ColorPaletteLime120$5 = "#93BF3A";
  var ColorPaletteLime130$5 = "#A9CF5E";
  var ColorPaletteLime140$5 = "#C2DD8D";
  var ColorPaletteLime150$5 = "#DBEBBD";
  var ColorPaletteLime160$5 = "#F0F7E4";
  var ColorPaletteGreen10$5 = "#0B2312";
  var ColorPaletteGreen20$5 = "#0E2F18";
  var ColorPaletteGreen30$5 = "#133E20";
  var ColorPaletteGreen40$5 = "#174A26";
  var ColorPaletteGreen50$5 = "#1A562C";
  var ColorPaletteGreen60$5 = "#1F6634";
  var ColorPaletteGreen70$5 = "#22723A";
  var ColorPaletteGreen80$5 = "#278142";
  var ColorPaletteGreen90$5 = "#2D954C";
  var ColorPaletteGreen100$5 = "#32A454";
  var ColorPaletteGreen110$5 = "#38B85E";
  var ColorPaletteGreen120$5 = "#4BC870";
  var ColorPaletteGreen130$5 = "#76D692";
  var ColorPaletteGreen140$5 = "#9DE2B1";
  var ColorPaletteGreen150$5 = "#C8EED3";
  var ColorPaletteGreen160$5 = "#E8F8EC";
  var ColorPaletteAcqua10$5 = "#04251E";
  var ColorPaletteAcqua20$5 = "#052E26";
  var ColorPaletteAcqua30$5 = "#073C31";
  var ColorPaletteAcqua40$5 = "#08493C";
  var ColorPaletteAcqua50$5 = "#0A5748";
  var ColorPaletteAcqua60$5 = "#0B6553";
  var ColorPaletteAcqua70$5 = "#0D735E";
  var ColorPaletteAcqua80$5 = "#0F856D";
  var ColorPaletteAcqua90$5 = "#109379";
  var ColorPaletteAcqua100$5 = "#12A588";
  var ColorPaletteAcqua110$5 = "#14B897";
  var ColorPaletteAcqua120$5 = "#31C4A6";
  var ColorPaletteAcqua130$5 = "#68D4BF";
  var ColorPaletteAcqua140$5 = "#8DE2D1";
  var ColorPaletteAcqua150$5 = "#BCF0E6";
  var ColorPaletteAcqua160$5 = "#DFFBF6";
  var ColorPaletteBlue10$5 = "#051B48";
  var ColorPaletteBlue20$5 = "#062560";
  var ColorPaletteBlue30$5 = "#082F7D";
  var ColorPaletteBlue40$5 = "#0A3A9A";
  var ColorPaletteBlue50$5 = "#0B43B1";
  var ColorPaletteBlue60$5 = "#0D4ECE";
  var ColorPaletteBlue70$5 = "#0F58EA";
  var ColorPaletteBlue80$5 = "#286BF1";
  var ColorPaletteBlue90$5 = "#3F7BF2";
  var ColorPaletteBlue100$5 = "#5C8FF5";
  var ColorPaletteBlue110$5 = "#73A0F7";
  var ColorPaletteBlue120$5 = "#8CB0F8";
  var ColorPaletteBlue130$5 = "#A9C4F9";
  var ColorPaletteBlue140$5 = "#C1D4FB";
  var ColorPaletteBlue150$5 = "#D9E5FC";
  var ColorPaletteBlue160$5 = "#F1F5FE";
  var ColorPalettePurple10$5 = "#340849";
  var ColorPalettePurple20$5 = "#440B60";
  var ColorPalettePurple30$5 = "#540D78";
  var ColorPalettePurple40$5 = "#671093";
  var ColorPalettePurple50$5 = "#7713AA";
  var ColorPalettePurple60$5 = "#8B16C5";
  var ColorPalettePurple70$5 = "#9B18DC";
  var ColorPalettePurple80$5 = "#AD35E9";
  var ColorPalettePurple90$5 = "#B851EC";
  var ColorPalettePurple100$5 = "#C36CEF";
  var ColorPalettePurple110$5 = "#CC83F1";
  var ColorPalettePurple120$5 = "#D69AF4";
  var ColorPalettePurple130$5 = "#DFB1F6";
  var ColorPalettePurple140$5 = "#E8C8F9";
  var ColorPalettePurple150$5 = "#F2DFFB";
  var ColorPalettePurple160$5 = "#F9F1FD";
  var ColorPalettePink10$5 = "#3B0C27";
  var ColorPalettePink20$5 = "#4C1032";
  var ColorPalettePink30$5 = "#661543";
  var ColorPalettePink40$5 = "#77184E";
  var ColorPalettePink50$5 = "#8C1C5D";
  var ColorPalettePink60$5 = "#A12169";
  var ColorPalettePink70$5 = "#BA267B";
  var ColorPalettePink80$5 = "#D42B8C";
  var ColorPalettePink90$5 = "#DA499B";
  var ColorPalettePink100$5 = "#E067AB";
  var ColorPalettePink110$5 = "#E580B9";
  var ColorPalettePink120$5 = "#EA99C7";
  var ColorPalettePink130$5 = "#EFAFD3";
  var ColorPalettePink140$5 = "#F4C8E1";
  var ColorPalettePink150$5 = "#F8DDEC";
  var ColorPalettePink160$5 = "#FCF2F8";
  var ColorTypefaceStrong$5 = "#161616";
  var ColorTypefacePure$5 = "#363636";
  var ColorTypefaceSmooth$5 = "#666666";
  var ColorTypefaceMeld$5 = "#1616163D";
  var ColorTypefaceInverseStrong$5 = "#FEFEFE";
  var ColorTypefaceInversePure$5 = "#D4D4D4";
  var ColorTypefaceInverseSmooth$5 = "#919191";
  var ColorTypefaceInverseMeld$5 = "#FEFEFE52";
  var ColorTypefaceInverseOnBrandStrong$5 = "#161616";
  var ColorTypefaceInverseOnBrandPure$5 = "#363636";
  var ColorTypefaceInverseOnBrandSmooth$5 = "#595959";
  var ColorTypefaceInverseOnBrandMeld$5 = "#1616163D";
  var ColorTypefaceOnBrandStrong$5 = "#FEFEFE";
  var ColorTypefaceOnBrandPure$5 = "#DBE3FF";
  var ColorTypefaceOnBrandSmooth$5 = "#C7D3FF";
  var ColorTypefaceOnBrandMeld$5 = "#FEFEFE52";
  var ColorBrandPrimary10$5 = "#000E40";
  var ColorBrandPrimary20$5 = "#001A7A";
  var ColorBrandPrimary30$5 = "#00229E";
  var ColorBrandPrimary40$5 = "#0029BD";
  var ColorBrandPrimary50$5 = "#002FDB";
  var ColorBrandPrimary60$5 = "#0037FF";
  var ColorBrandPrimary70$5 = "#1F4FFF";
  var ColorBrandPrimary80$5 = "#3863FF";
  var ColorBrandPrimary90$5 = "#5277FF";
  var ColorBrandPrimary100$5 = "#6B8BFF";
  var ColorBrandPrimary110$5 = "#809BFF";
  var ColorBrandPrimary120$5 = "#99AFFF";
  var ColorBrandPrimary130$4 = "#ADBFFF";
  var ColorBrandPrimary140$4 = "#C7D3FF";
  var ColorBrandPrimary150$4 = "#DBE3FF";
  var ColorBrandPrimary160$4 = "#F0F3FF";
  var ColorBrandBase01$5 = "#000E40";
  var ColorBrandBase02$5 = "#CF0F40";
  var ColorBrandBase03$4 = "#E84273";
  var ColorBrandBase04$4 = "#9C86E0";
  var ColorBrandBase05$4 = "#D8BD97";
  var ColorBrandBase06$2 = "#F6F4F4";
  var ColorBrandPalette0110$4 = "#000E40";
  var ColorBrandPalette0120$4 = "#001A7A";
  var ColorBrandPalette0130$4 = "#00229E";
  var ColorBrandPalette0140$4 = "#0029BD";
  var ColorBrandPalette0150$4 = "#002FDB";
  var ColorBrandPalette0160$4 = "#0037FF";
  var ColorBrandPalette0170$4 = "#1F4FFF";
  var ColorBrandPalette0180$4 = "#3863FF";
  var ColorBrandPalette0190$4 = "#5277FF";
  var ColorBrandPalette01100$4 = "#6B8BFF";
  var ColorBrandPalette01110$4 = "#809BFF";
  var ColorBrandPalette01120$4 = "#99AFFF";
  var ColorBrandPalette01130$4 = "#ADBFFF";
  var ColorBrandPalette01140$4 = "#C7D3FF";
  var ColorBrandPalette01150$4 = "#DBE3FF";
  var ColorBrandPalette01160$4 = "#F0F3FF";
  var ColorBrandPalette0210$4 = "#420514";
  var ColorBrandPalette0220$4 = "#55061A";
  var ColorBrandPalette0230$4 = "#6D0821";
  var ColorBrandPalette0240$4 = "#850A29";
  var ColorBrandPalette0250$4 = "#980B2F";
  var ColorBrandPalette0260$4 = "#AF0D36";
  var ColorBrandPalette0270$4 = "#CF0F40";
  var ColorBrandPalette0280$4 = "#E41146";
  var ColorBrandPalette0290$4 = "#F03866";
  var ColorBrandPalette02100$4 = "#F35E83";
  var ColorBrandPalette02110$4 = "#F57A99";
  var ColorBrandPalette02120$4 = "#F797AF";
  var ColorBrandPalette02130$4 = "#F9AEC1";
  var ColorBrandPalette02140$4 = "#FBC6D3";
  var ColorBrandPalette02150$4 = "#FDDEE5";
  var ColorBrandPalette02160$4 = "#FEF1F4";
  var ColorBrandPalette0310$2 = "#400819";
  var ColorBrandPalette0320$2 = "#560B21";
  var ColorBrandPalette0330$2 = "#6D0D2A";
  var ColorBrandPalette0340$2 = "#7F1031";
  var ColorBrandPalette0350$2 = "#96133A";
  var ColorBrandPalette0360$2 = "#AC1543";
  var ColorBrandPalette0370$2 = "#C3184B";
  var ColorBrandPalette0380$2 = "#DE1B56";
  var ColorBrandPalette0390$2 = "#E84273";
  var ColorBrandPalette03100$2 = "#EC658D";
  var ColorBrandPalette03110$2 = "#EF7B9E";
  var ColorBrandPalette03120$2 = "#F297B2";
  var ColorBrandPalette03130$2 = "#F5ADC3";
  var ColorBrandPalette03140$2 = "#F8C9D7";
  var ColorBrandPalette03150$2 = "#FBDFE8";
  var ColorBrandPalette03160$2 = "#FDF2F5";
  var ColorBrandPalette0410$3 = "#22144D";
  var ColorBrandPalette0420$3 = "#2D1A65";
  var ColorBrandPalette0430$3 = "#3A2182";
  var ColorBrandPalette0440$3 = "#46299E";
  var ColorBrandPalette0450$3 = "#5330BB";
  var ColorBrandPalette0460$3 = "#603CCD";
  var ColorBrandPalette0470$3 = "#6E4DD1";
  var ColorBrandPalette0480$3 = "#7E61D6";
  var ColorBrandPalette0490$3 = "#8B71DA";
  var ColorBrandPalette04100$3 = "#9C86E0";
  var ColorBrandPalette04110$3 = "#A996E4";
  var ColorBrandPalette04120$3 = "#BAAAE9";
  var ColorBrandPalette04130$3 = "#C7BAED";
  var ColorBrandPalette04140$3 = "#D7CEF2";
  var ColorBrandPalette04150$3 = "#E8E3F8";
  var ColorBrandPalette04160$3 = "#F5F3FC";
  var ColorBrandPalette0510$2 = "#251B0E";
  var ColorBrandPalette0520$2 = "#342614";
  var ColorBrandPalette0530$2 = "#433119";
  var ColorBrandPalette0540$2 = "#513C1F";
  var ColorBrandPalette0550$2 = "#604724";
  var ColorBrandPalette0560$2 = "#73552B";
  var ColorBrandPalette0570$2 = "#816031";
  var ColorBrandPalette0580$2 = "#946E38";
  var ColorBrandPalette0590$2 = "#A3793E";
  var ColorBrandPalette05100$2 = "#B98946";
  var ColorBrandPalette05110$2 = "#C39A60";
  var ColorBrandPalette05120$2 = "#CEAC7E";
  var ColorBrandPalette05130$2 = "#D8BD97";
  var ColorBrandPalette05140$2 = "#E3D0B5";
  var ColorBrandPalette05150$2 = "#EEE3D3";
  var ColorBrandPalette05160$2 = "#F8F3EC";
  var ColorBrandPalette0610$2 = "#1A1514";
  var ColorBrandPalette0620$2 = "#312826";
  var ColorBrandPalette0630$2 = "#3F3431";
  var ColorBrandPalette0640$2 = "#4A3D3A";
  var ColorBrandPalette0650$2 = "#594946";
  var ColorBrandPalette0660$2 = "#675451";
  var ColorBrandPalette0670$2 = "#75605C";
  var ColorBrandPalette0680$2 = "#866E69";
  var ColorBrandPalette0690$2 = "#967E79";
  var ColorBrandPalette06100$2 = "#A38E8A";
  var ColorBrandPalette06110$2 = "#AE9C98";
  var ColorBrandPalette06120$2 = "#BEAFAC";
  var ColorBrandPalette06130$2 = "#CBC0BD";
  var ColorBrandPalette06140$2 = "#D9D0CE";
  var ColorBrandPalette06150$2 = "#E9E4E3";
  var ColorBrandPalette06160$2 = "#F6F4F4";
  var ColorFeedbackErrorText$5 = "#BC293A";
  var ColorFeedbackErrorShape$5 = "#EA4356";
  var ColorFeedbackSuccessText$5 = "#22723A";
  var ColorFeedbackSuccessShape$5 = "#2D954C";
  var ColorFeedbackOnBrandErrorText$5 = "#F77E8C";
  var ColorFeedbackOnBrandErrorShape$5 = "#EA4356";
  var ColorFeedbackOnBrandSuccessText$5 = "#38B85E";
  var ColorFeedbackOnBrandSuccessShape$5 = "#2D954C";
  var ColorFeedbackInverseErrorText$5 = "#F55C6E";
  var ColorFeedbackInverseErrorShape$5 = "#D83145";
  var ColorFeedbackInverseSuccessText$5 = "#32A454";
  var ColorFeedbackInverseSuccessShape$5 = "#278142";
  var ColorFeedbackInverseOnBrandErrorText$5 = "#A72534";
  var ColorFeedbackInverseOnBrandErrorShape$5 = "#D83145";
  var ColorFeedbackInverseOnBrandSuccessText$5 = "#1F6634";
  var ColorFeedbackInverseOnBrandSuccessShape$5 = "#278142";
  var ColorSupport01$5 = "#CF0F40";
  var ColorSupport02$5 = "#CF0F40";
  var ColorSupportOnBrand01$5 = "#9C86E0";
  var ColorSupportOnBrand02$5 = "#9C86E0";
  var ColorSupportInverse01$5 = "#E84273";
  var ColorSupportInverse02$5 = "#E84273";
  var ColorSupportInverseOnBrand01$5 = "#CF0F40";
  var ColorSupportInverseOnBrand02$5 = "#CF0F40";
  var Opacity01$5 = "0.04";
  var Opacity02$5 = "0.08";
  var Opacity03$5 = "0.12";
  var Opacity04$5 = "0.24";
  var Opacity05$5 = "0.32";
  var Opacity06$5 = "0.56";
  var Opacity07$5 = "0.64";
  var Opacity08$5 = "0.72";
  var Opacity09$5 = "0.88";
  var Shadow01$5 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
  var Shadow02$5 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
  var Shadow03$5 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
  var Shadow04$5 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
  var SpacingInlineQuark$5 = "4px";
  var SpacingInlineNano$5 = "8px";
  var SpacingInlineXxxs$5 = "16px";
  var SpacingInlineXxs$5 = "24px";
  var SpacingInlineXs$5 = "32px";
  var SpacingInlineSm$5 = "40px";
  var SpacingInlineMd$5 = "48px";
  var SpacingInlineLg$5 = "56px";
  var SpacingInlineXl$5 = "64px";
  var SpacingInlineXxl$5 = "80px";
  var SpacingInlineXxxl$5 = "120px";
  var SpacingInlineHuge$5 = "160px";
  var SpacingInlineGiant$5 = "200px";
  var SpacingInsetQuark$5 = "4px";
  var SpacingInsetNano$5 = "8px";
  var SpacingInsetXs$5 = "16px";
  var SpacingInsetSm$5 = "24px";
  var SpacingInsetMd$5 = "32px";
  var SpacingInsetLg$5 = "40px";
  var SpacingSquishQuark$5 = "4px 8px";
  var SpacingSquishNano$5 = "8px 16px";
  var SpacingSquishXs$5 = "16px 24px";
  var SpacingSquishSm$5 = "16px 32px";
  var SpacingStackQuark$5 = "4px";
  var SpacingStackNano$5 = "8px";
  var SpacingStackXxxs$5 = "16px";
  var SpacingStackXxs$5 = "24px";
  var SpacingStackXs$5 = "32px";
  var SpacingStackSm$5 = "40px";
  var SpacingStackMd$5 = "48px";
  var SpacingStackLg$5 = "56px";
  var SpacingStackXl$5 = "64px";
  var SpacingStackXxl$5 = "80px";
  var SpacingStackXxxl$5 = "120px";
  var SpacingStackHuge$5 = "160px";
  var SpacingStackGiant$5 = "200px";
  var FontFamilyBase$5 = "'Dasa Sans', 'sans-serif'";
  var FontSizeXxxs$5 = "0.75rem";
  var FontSizeXxs$5 = "0.875rem";
  var FontSizeXs$5 = "1rem";
  var FontSizeSm$5 = "1.25rem";
  var FontSizeMd$5 = "1.5rem";
  var FontSizeLg$5 = "2rem";
  var FontSizeXl$5 = "2.5rem";
  var FontSizeXxl$5 = "3rem";
  var FontSizeXxxl$5 = "4rem";
  var FontSizeDisplay$5 = "5rem";
  var FontSizeGiant$5 = "6rem";
  var FontWeightBold$5 = 700;
  var FontWeightSemibold$5 = 600;
  var FontWeightMedium$5 = 500;
  var FontWeightRegular$5 = 400;
  var FontWeightLight$5 = 300;
  var LetterSpacingStandard$5 = "0px";
  var LetterSpacingSmall$5 = "-1px";
  var LetterSpacingMedium$5 = "1.5px";
  var LineHeightStandard$5 = "100%";
  var LineHeightTiny$5 = "115%";
  var LineHeightMedium$5 = "120%";
  var LineHeightLarge$5 = "125%";
  var LineHeightDistant$5 = "133%";
  var LineHeightSuperdistant$5 = "150%";
  var LineHeightHuge$5 = "170%";
  var index$5 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BorderRadiusNone: BorderRadiusNone$5,
    BorderRadiusXs: BorderRadiusXs$5,
    BorderRadiusSm: BorderRadiusSm$5,
    BorderRadiusMd: BorderRadiusMd$5,
    BorderRadiusLg: BorderRadiusLg$5,
    BorderRadiusPill: BorderRadiusPill$5,
    BorderRadiusCircle: BorderRadiusCircle$5,
    BorderWidthNone: BorderWidthNone$5,
    BorderWidthHairline: BorderWidthHairline$5,
    BorderWidthThin: BorderWidthThin$5,
    BorderWidthThick: BorderWidthThick$5,
    BorderWidthHeavy: BorderWidthHeavy$5,
    ColorDatavizInfoText: ColorDatavizInfoText$5,
    ColorDatavizInfoShape01: ColorDatavizInfoShape01$5,
    ColorDatavizInfoShape02: ColorDatavizInfoShape02$5,
    ColorDatavizInfoShape03: ColorDatavizInfoShape03$5,
    ColorDatavizNegativeText: ColorDatavizNegativeText$5,
    ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$5,
    ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$5,
    ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$5,
    ColorDatavizWarningText: ColorDatavizWarningText$5,
    ColorDatavizWarningShape01: ColorDatavizWarningShape01$5,
    ColorDatavizWarningShape02: ColorDatavizWarningShape02$5,
    ColorDatavizWarningShape03: ColorDatavizWarningShape03$5,
    ColorDatavizPositiveText: ColorDatavizPositiveText$5,
    ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$5,
    ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$5,
    ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$5,
    ColorDatavizCatAText: ColorDatavizCatAText$5,
    ColorDatavizCatAShape01: ColorDatavizCatAShape01$5,
    ColorDatavizCatAShape02: ColorDatavizCatAShape02$5,
    ColorDatavizCatAShape03: ColorDatavizCatAShape03$5,
    ColorDatavizCatBText: ColorDatavizCatBText$5,
    ColorDatavizCatBShape01: ColorDatavizCatBShape01$5,
    ColorDatavizCatBShape02: ColorDatavizCatBShape02$5,
    ColorDatavizCatBShape03: ColorDatavizCatBShape03$5,
    ColorDatavizCatCText: ColorDatavizCatCText$5,
    ColorDatavizCatCShape01: ColorDatavizCatCShape01$5,
    ColorDatavizCatCShape02: ColorDatavizCatCShape02$5,
    ColorDatavizCatCShape03: ColorDatavizCatCShape03$5,
    ColorDatavizCatDText: ColorDatavizCatDText$5,
    ColorDatavizCatDShape01: ColorDatavizCatDShape01$5,
    ColorDatavizCatDShape02: ColorDatavizCatDShape02$5,
    ColorDatavizCatDShape03: ColorDatavizCatDShape03$5,
    ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$5,
    ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$5,
    ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$5,
    ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$5,
    ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$5,
    ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$5,
    ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$5,
    ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$5,
    ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$5,
    ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$5,
    ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$5,
    ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$5,
    ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$5,
    ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$5,
    ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$5,
    ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$5,
    ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$5,
    ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$5,
    ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$5,
    ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$5,
    ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$5,
    ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$5,
    ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$5,
    ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$5,
    ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$5,
    ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$5,
    ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$5,
    ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$5,
    ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$5,
    ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$5,
    ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$5,
    ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$5,
    ColorInteractionBlend01: ColorInteractionBlend01$5,
    ColorInteractionBlend02: ColorInteractionBlend02$5,
    ColorInteractionBlend03: ColorInteractionBlend03$5,
    ColorInteractionBlend04: ColorInteractionBlend04$5,
    ColorInteractionBlend05: ColorInteractionBlend05$5,
    ColorInteractionBlend06: ColorInteractionBlend06$5,
    ColorInteractionBlend07: ColorInteractionBlend07$5,
    ColorInteractionBlend08: ColorInteractionBlend08$5,
    ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$5,
    ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$5,
    ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$5,
    ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$5,
    ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$5,
    ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$5,
    ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$5,
    ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$5,
    ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$5,
    ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$5,
    ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$5,
    ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$5,
    ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$5,
    ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$5,
    ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$5,
    ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$5,
    ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$5,
    ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$5,
    ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$5,
    ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$5,
    ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$5,
    ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$5,
    ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$5,
    ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$5,
    ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$5,
    ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$5,
    ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$5,
    ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$5,
    ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$5,
    ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$5,
    ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$5,
    ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$5,
    ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$5,
    ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$5,
    ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$5,
    ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$5,
    ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$5,
    ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$5,
    ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$5,
    ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$5,
    ColorInteractionAccent01: ColorInteractionAccent01$5,
    ColorInteractionAccent02: ColorInteractionAccent02$5,
    ColorInteractionAccent03: ColorInteractionAccent03$5,
    ColorInteractionSubtle01: ColorInteractionSubtle01$5,
    ColorInteractionSubtle02: ColorInteractionSubtle02$5,
    ColorInteractionSubtle03: ColorInteractionSubtle03$5,
    ColorInteractionSelectDefault: ColorInteractionSelectDefault$5,
    ColorInteractionSelectFocus: ColorInteractionSelectFocus$5,
    ColorInteractionSelectActive: ColorInteractionSelectActive$5,
    ColorInteractionDanger01: ColorInteractionDanger01$5,
    ColorInteractionDanger02: ColorInteractionDanger02$5,
    ColorInteractionDanger03: ColorInteractionDanger03$5,
    ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$5,
    ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$5,
    ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$5,
    ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$5,
    ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$5,
    ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$5,
    ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$5,
    ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$5,
    ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$5,
    ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$5,
    ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$5,
    ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$5,
    ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$5,
    ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$5,
    ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$5,
    ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$5,
    ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$5,
    ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$5,
    ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$5,
    ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$5,
    ColorNeutral10: ColorNeutral10$5,
    ColorNeutral20: ColorNeutral20$5,
    ColorNeutral30: ColorNeutral30$5,
    ColorNeutral00: ColorNeutral00$5,
    ColorNeutralInverse10: ColorNeutralInverse10$5,
    ColorNeutralInverse20: ColorNeutralInverse20$5,
    ColorNeutralInverse30: ColorNeutralInverse30$5,
    ColorNeutralInverse00: ColorNeutralInverse00$5,
    ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$5,
    ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$5,
    ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$5,
    ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$5,
    ColorNeutralOnBrand10: ColorNeutralOnBrand10$5,
    ColorNeutralOnBrand20: ColorNeutralOnBrand20$5,
    ColorNeutralOnBrand30: ColorNeutralOnBrand30$5,
    ColorNeutralOnBrand00: ColorNeutralOnBrand00$5,
    ColorPaletteBlack: ColorPaletteBlack$5,
    ColorPaletteWhite: ColorPaletteWhite$5,
    ColorPaletteGray10: ColorPaletteGray10$5,
    ColorPaletteGray20: ColorPaletteGray20$5,
    ColorPaletteGray30: ColorPaletteGray30$5,
    ColorPaletteGray40: ColorPaletteGray40$5,
    ColorPaletteGray50: ColorPaletteGray50$5,
    ColorPaletteGray60: ColorPaletteGray60$5,
    ColorPaletteGray70: ColorPaletteGray70$5,
    ColorPaletteGray80: ColorPaletteGray80$5,
    ColorPaletteGray90: ColorPaletteGray90$5,
    ColorPaletteGray100: ColorPaletteGray100$5,
    ColorPaletteGray110: ColorPaletteGray110$5,
    ColorPaletteGray120: ColorPaletteGray120$5,
    ColorPaletteGray130: ColorPaletteGray130$5,
    ColorPaletteGray140: ColorPaletteGray140$5,
    ColorPaletteGray150: ColorPaletteGray150$5,
    ColorPaletteGray160: ColorPaletteGray160$5,
    ColorPaletteRed10: ColorPaletteRed10$5,
    ColorPaletteRed20: ColorPaletteRed20$5,
    ColorPaletteRed30: ColorPaletteRed30$5,
    ColorPaletteRed40: ColorPaletteRed40$5,
    ColorPaletteRed50: ColorPaletteRed50$5,
    ColorPaletteRed60: ColorPaletteRed60$5,
    ColorPaletteRed70: ColorPaletteRed70$5,
    ColorPaletteRed80: ColorPaletteRed80$5,
    ColorPaletteRed90: ColorPaletteRed90$5,
    ColorPaletteRed100: ColorPaletteRed100$5,
    ColorPaletteRed110: ColorPaletteRed110$5,
    ColorPaletteRed120: ColorPaletteRed120$5,
    ColorPaletteRed130: ColorPaletteRed130$5,
    ColorPaletteRed140: ColorPaletteRed140$5,
    ColorPaletteRed150: ColorPaletteRed150$5,
    ColorPaletteRed160: ColorPaletteRed160$5,
    ColorPaletteYellow10: ColorPaletteYellow10$5,
    ColorPaletteYellow20: ColorPaletteYellow20$5,
    ColorPaletteYellow30: ColorPaletteYellow30$5,
    ColorPaletteYellow40: ColorPaletteYellow40$5,
    ColorPaletteYellow50: ColorPaletteYellow50$5,
    ColorPaletteYellow60: ColorPaletteYellow60$5,
    ColorPaletteYellow70: ColorPaletteYellow70$5,
    ColorPaletteYellow80: ColorPaletteYellow80$5,
    ColorPaletteYellow90: ColorPaletteYellow90$5,
    ColorPaletteYellow100: ColorPaletteYellow100$5,
    ColorPaletteYellow110: ColorPaletteYellow110$5,
    ColorPaletteYellow120: ColorPaletteYellow120$5,
    ColorPaletteYellow130: ColorPaletteYellow130$5,
    ColorPaletteYellow140: ColorPaletteYellow140$5,
    ColorPaletteYellow150: ColorPaletteYellow150$5,
    ColorPaletteYellow160: ColorPaletteYellow160$5,
    ColorPaletteLime10: ColorPaletteLime10$5,
    ColorPaletteLime20: ColorPaletteLime20$5,
    ColorPaletteLime30: ColorPaletteLime30$5,
    ColorPaletteLime40: ColorPaletteLime40$5,
    ColorPaletteLime50: ColorPaletteLime50$5,
    ColorPaletteLime60: ColorPaletteLime60$5,
    ColorPaletteLime70: ColorPaletteLime70$5,
    ColorPaletteLime80: ColorPaletteLime80$5,
    ColorPaletteLime90: ColorPaletteLime90$5,
    ColorPaletteLime100: ColorPaletteLime100$5,
    ColorPaletteLime110: ColorPaletteLime110$5,
    ColorPaletteLime120: ColorPaletteLime120$5,
    ColorPaletteLime130: ColorPaletteLime130$5,
    ColorPaletteLime140: ColorPaletteLime140$5,
    ColorPaletteLime150: ColorPaletteLime150$5,
    ColorPaletteLime160: ColorPaletteLime160$5,
    ColorPaletteGreen10: ColorPaletteGreen10$5,
    ColorPaletteGreen20: ColorPaletteGreen20$5,
    ColorPaletteGreen30: ColorPaletteGreen30$5,
    ColorPaletteGreen40: ColorPaletteGreen40$5,
    ColorPaletteGreen50: ColorPaletteGreen50$5,
    ColorPaletteGreen60: ColorPaletteGreen60$5,
    ColorPaletteGreen70: ColorPaletteGreen70$5,
    ColorPaletteGreen80: ColorPaletteGreen80$5,
    ColorPaletteGreen90: ColorPaletteGreen90$5,
    ColorPaletteGreen100: ColorPaletteGreen100$5,
    ColorPaletteGreen110: ColorPaletteGreen110$5,
    ColorPaletteGreen120: ColorPaletteGreen120$5,
    ColorPaletteGreen130: ColorPaletteGreen130$5,
    ColorPaletteGreen140: ColorPaletteGreen140$5,
    ColorPaletteGreen150: ColorPaletteGreen150$5,
    ColorPaletteGreen160: ColorPaletteGreen160$5,
    ColorPaletteAcqua10: ColorPaletteAcqua10$5,
    ColorPaletteAcqua20: ColorPaletteAcqua20$5,
    ColorPaletteAcqua30: ColorPaletteAcqua30$5,
    ColorPaletteAcqua40: ColorPaletteAcqua40$5,
    ColorPaletteAcqua50: ColorPaletteAcqua50$5,
    ColorPaletteAcqua60: ColorPaletteAcqua60$5,
    ColorPaletteAcqua70: ColorPaletteAcqua70$5,
    ColorPaletteAcqua80: ColorPaletteAcqua80$5,
    ColorPaletteAcqua90: ColorPaletteAcqua90$5,
    ColorPaletteAcqua100: ColorPaletteAcqua100$5,
    ColorPaletteAcqua110: ColorPaletteAcqua110$5,
    ColorPaletteAcqua120: ColorPaletteAcqua120$5,
    ColorPaletteAcqua130: ColorPaletteAcqua130$5,
    ColorPaletteAcqua140: ColorPaletteAcqua140$5,
    ColorPaletteAcqua150: ColorPaletteAcqua150$5,
    ColorPaletteAcqua160: ColorPaletteAcqua160$5,
    ColorPaletteBlue10: ColorPaletteBlue10$5,
    ColorPaletteBlue20: ColorPaletteBlue20$5,
    ColorPaletteBlue30: ColorPaletteBlue30$5,
    ColorPaletteBlue40: ColorPaletteBlue40$5,
    ColorPaletteBlue50: ColorPaletteBlue50$5,
    ColorPaletteBlue60: ColorPaletteBlue60$5,
    ColorPaletteBlue70: ColorPaletteBlue70$5,
    ColorPaletteBlue80: ColorPaletteBlue80$5,
    ColorPaletteBlue90: ColorPaletteBlue90$5,
    ColorPaletteBlue100: ColorPaletteBlue100$5,
    ColorPaletteBlue110: ColorPaletteBlue110$5,
    ColorPaletteBlue120: ColorPaletteBlue120$5,
    ColorPaletteBlue130: ColorPaletteBlue130$5,
    ColorPaletteBlue140: ColorPaletteBlue140$5,
    ColorPaletteBlue150: ColorPaletteBlue150$5,
    ColorPaletteBlue160: ColorPaletteBlue160$5,
    ColorPalettePurple10: ColorPalettePurple10$5,
    ColorPalettePurple20: ColorPalettePurple20$5,
    ColorPalettePurple30: ColorPalettePurple30$5,
    ColorPalettePurple40: ColorPalettePurple40$5,
    ColorPalettePurple50: ColorPalettePurple50$5,
    ColorPalettePurple60: ColorPalettePurple60$5,
    ColorPalettePurple70: ColorPalettePurple70$5,
    ColorPalettePurple80: ColorPalettePurple80$5,
    ColorPalettePurple90: ColorPalettePurple90$5,
    ColorPalettePurple100: ColorPalettePurple100$5,
    ColorPalettePurple110: ColorPalettePurple110$5,
    ColorPalettePurple120: ColorPalettePurple120$5,
    ColorPalettePurple130: ColorPalettePurple130$5,
    ColorPalettePurple140: ColorPalettePurple140$5,
    ColorPalettePurple150: ColorPalettePurple150$5,
    ColorPalettePurple160: ColorPalettePurple160$5,
    ColorPalettePink10: ColorPalettePink10$5,
    ColorPalettePink20: ColorPalettePink20$5,
    ColorPalettePink30: ColorPalettePink30$5,
    ColorPalettePink40: ColorPalettePink40$5,
    ColorPalettePink50: ColorPalettePink50$5,
    ColorPalettePink60: ColorPalettePink60$5,
    ColorPalettePink70: ColorPalettePink70$5,
    ColorPalettePink80: ColorPalettePink80$5,
    ColorPalettePink90: ColorPalettePink90$5,
    ColorPalettePink100: ColorPalettePink100$5,
    ColorPalettePink110: ColorPalettePink110$5,
    ColorPalettePink120: ColorPalettePink120$5,
    ColorPalettePink130: ColorPalettePink130$5,
    ColorPalettePink140: ColorPalettePink140$5,
    ColorPalettePink150: ColorPalettePink150$5,
    ColorPalettePink160: ColorPalettePink160$5,
    ColorTypefaceStrong: ColorTypefaceStrong$5,
    ColorTypefacePure: ColorTypefacePure$5,
    ColorTypefaceSmooth: ColorTypefaceSmooth$5,
    ColorTypefaceMeld: ColorTypefaceMeld$5,
    ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$5,
    ColorTypefaceInversePure: ColorTypefaceInversePure$5,
    ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$5,
    ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$5,
    ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$5,
    ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$5,
    ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$5,
    ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$5,
    ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$5,
    ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$5,
    ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$5,
    ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$5,
    ColorBrandPrimary10: ColorBrandPrimary10$5,
    ColorBrandPrimary20: ColorBrandPrimary20$5,
    ColorBrandPrimary30: ColorBrandPrimary30$5,
    ColorBrandPrimary40: ColorBrandPrimary40$5,
    ColorBrandPrimary50: ColorBrandPrimary50$5,
    ColorBrandPrimary60: ColorBrandPrimary60$5,
    ColorBrandPrimary70: ColorBrandPrimary70$5,
    ColorBrandPrimary80: ColorBrandPrimary80$5,
    ColorBrandPrimary90: ColorBrandPrimary90$5,
    ColorBrandPrimary100: ColorBrandPrimary100$5,
    ColorBrandPrimary110: ColorBrandPrimary110$5,
    ColorBrandPrimary120: ColorBrandPrimary120$5,
    ColorBrandPrimary130: ColorBrandPrimary130$4,
    ColorBrandPrimary140: ColorBrandPrimary140$4,
    ColorBrandPrimary150: ColorBrandPrimary150$4,
    ColorBrandPrimary160: ColorBrandPrimary160$4,
    ColorBrandBase01: ColorBrandBase01$5,
    ColorBrandBase02: ColorBrandBase02$5,
    ColorBrandBase03: ColorBrandBase03$4,
    ColorBrandBase04: ColorBrandBase04$4,
    ColorBrandBase05: ColorBrandBase05$4,
    ColorBrandBase06: ColorBrandBase06$2,
    ColorBrandPalette0110: ColorBrandPalette0110$4,
    ColorBrandPalette0120: ColorBrandPalette0120$4,
    ColorBrandPalette0130: ColorBrandPalette0130$4,
    ColorBrandPalette0140: ColorBrandPalette0140$4,
    ColorBrandPalette0150: ColorBrandPalette0150$4,
    ColorBrandPalette0160: ColorBrandPalette0160$4,
    ColorBrandPalette0170: ColorBrandPalette0170$4,
    ColorBrandPalette0180: ColorBrandPalette0180$4,
    ColorBrandPalette0190: ColorBrandPalette0190$4,
    ColorBrandPalette01100: ColorBrandPalette01100$4,
    ColorBrandPalette01110: ColorBrandPalette01110$4,
    ColorBrandPalette01120: ColorBrandPalette01120$4,
    ColorBrandPalette01130: ColorBrandPalette01130$4,
    ColorBrandPalette01140: ColorBrandPalette01140$4,
    ColorBrandPalette01150: ColorBrandPalette01150$4,
    ColorBrandPalette01160: ColorBrandPalette01160$4,
    ColorBrandPalette0210: ColorBrandPalette0210$4,
    ColorBrandPalette0220: ColorBrandPalette0220$4,
    ColorBrandPalette0230: ColorBrandPalette0230$4,
    ColorBrandPalette0240: ColorBrandPalette0240$4,
    ColorBrandPalette0250: ColorBrandPalette0250$4,
    ColorBrandPalette0260: ColorBrandPalette0260$4,
    ColorBrandPalette0270: ColorBrandPalette0270$4,
    ColorBrandPalette0280: ColorBrandPalette0280$4,
    ColorBrandPalette0290: ColorBrandPalette0290$4,
    ColorBrandPalette02100: ColorBrandPalette02100$4,
    ColorBrandPalette02110: ColorBrandPalette02110$4,
    ColorBrandPalette02120: ColorBrandPalette02120$4,
    ColorBrandPalette02130: ColorBrandPalette02130$4,
    ColorBrandPalette02140: ColorBrandPalette02140$4,
    ColorBrandPalette02150: ColorBrandPalette02150$4,
    ColorBrandPalette02160: ColorBrandPalette02160$4,
    ColorBrandPalette0310: ColorBrandPalette0310$2,
    ColorBrandPalette0320: ColorBrandPalette0320$2,
    ColorBrandPalette0330: ColorBrandPalette0330$2,
    ColorBrandPalette0340: ColorBrandPalette0340$2,
    ColorBrandPalette0350: ColorBrandPalette0350$2,
    ColorBrandPalette0360: ColorBrandPalette0360$2,
    ColorBrandPalette0370: ColorBrandPalette0370$2,
    ColorBrandPalette0380: ColorBrandPalette0380$2,
    ColorBrandPalette0390: ColorBrandPalette0390$2,
    ColorBrandPalette03100: ColorBrandPalette03100$2,
    ColorBrandPalette03110: ColorBrandPalette03110$2,
    ColorBrandPalette03120: ColorBrandPalette03120$2,
    ColorBrandPalette03130: ColorBrandPalette03130$2,
    ColorBrandPalette03140: ColorBrandPalette03140$2,
    ColorBrandPalette03150: ColorBrandPalette03150$2,
    ColorBrandPalette03160: ColorBrandPalette03160$2,
    ColorBrandPalette0410: ColorBrandPalette0410$3,
    ColorBrandPalette0420: ColorBrandPalette0420$3,
    ColorBrandPalette0430: ColorBrandPalette0430$3,
    ColorBrandPalette0440: ColorBrandPalette0440$3,
    ColorBrandPalette0450: ColorBrandPalette0450$3,
    ColorBrandPalette0460: ColorBrandPalette0460$3,
    ColorBrandPalette0470: ColorBrandPalette0470$3,
    ColorBrandPalette0480: ColorBrandPalette0480$3,
    ColorBrandPalette0490: ColorBrandPalette0490$3,
    ColorBrandPalette04100: ColorBrandPalette04100$3,
    ColorBrandPalette04110: ColorBrandPalette04110$3,
    ColorBrandPalette04120: ColorBrandPalette04120$3,
    ColorBrandPalette04130: ColorBrandPalette04130$3,
    ColorBrandPalette04140: ColorBrandPalette04140$3,
    ColorBrandPalette04150: ColorBrandPalette04150$3,
    ColorBrandPalette04160: ColorBrandPalette04160$3,
    ColorBrandPalette0510: ColorBrandPalette0510$2,
    ColorBrandPalette0520: ColorBrandPalette0520$2,
    ColorBrandPalette0530: ColorBrandPalette0530$2,
    ColorBrandPalette0540: ColorBrandPalette0540$2,
    ColorBrandPalette0550: ColorBrandPalette0550$2,
    ColorBrandPalette0560: ColorBrandPalette0560$2,
    ColorBrandPalette0570: ColorBrandPalette0570$2,
    ColorBrandPalette0580: ColorBrandPalette0580$2,
    ColorBrandPalette0590: ColorBrandPalette0590$2,
    ColorBrandPalette05100: ColorBrandPalette05100$2,
    ColorBrandPalette05110: ColorBrandPalette05110$2,
    ColorBrandPalette05120: ColorBrandPalette05120$2,
    ColorBrandPalette05130: ColorBrandPalette05130$2,
    ColorBrandPalette05140: ColorBrandPalette05140$2,
    ColorBrandPalette05150: ColorBrandPalette05150$2,
    ColorBrandPalette05160: ColorBrandPalette05160$2,
    ColorBrandPalette0610: ColorBrandPalette0610$2,
    ColorBrandPalette0620: ColorBrandPalette0620$2,
    ColorBrandPalette0630: ColorBrandPalette0630$2,
    ColorBrandPalette0640: ColorBrandPalette0640$2,
    ColorBrandPalette0650: ColorBrandPalette0650$2,
    ColorBrandPalette0660: ColorBrandPalette0660$2,
    ColorBrandPalette0670: ColorBrandPalette0670$2,
    ColorBrandPalette0680: ColorBrandPalette0680$2,
    ColorBrandPalette0690: ColorBrandPalette0690$2,
    ColorBrandPalette06100: ColorBrandPalette06100$2,
    ColorBrandPalette06110: ColorBrandPalette06110$2,
    ColorBrandPalette06120: ColorBrandPalette06120$2,
    ColorBrandPalette06130: ColorBrandPalette06130$2,
    ColorBrandPalette06140: ColorBrandPalette06140$2,
    ColorBrandPalette06150: ColorBrandPalette06150$2,
    ColorBrandPalette06160: ColorBrandPalette06160$2,
    ColorFeedbackErrorText: ColorFeedbackErrorText$5,
    ColorFeedbackErrorShape: ColorFeedbackErrorShape$5,
    ColorFeedbackSuccessText: ColorFeedbackSuccessText$5,
    ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$5,
    ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$5,
    ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$5,
    ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$5,
    ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$5,
    ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$5,
    ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$5,
    ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$5,
    ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$5,
    ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$5,
    ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$5,
    ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$5,
    ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$5,
    ColorSupport01: ColorSupport01$5,
    ColorSupport02: ColorSupport02$5,
    ColorSupportOnBrand01: ColorSupportOnBrand01$5,
    ColorSupportOnBrand02: ColorSupportOnBrand02$5,
    ColorSupportInverse01: ColorSupportInverse01$5,
    ColorSupportInverse02: ColorSupportInverse02$5,
    ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$5,
    ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$5,
    Opacity01: Opacity01$5,
    Opacity02: Opacity02$5,
    Opacity03: Opacity03$5,
    Opacity04: Opacity04$5,
    Opacity05: Opacity05$5,
    Opacity06: Opacity06$5,
    Opacity07: Opacity07$5,
    Opacity08: Opacity08$5,
    Opacity09: Opacity09$5,
    Shadow01: Shadow01$5,
    Shadow02: Shadow02$5,
    Shadow03: Shadow03$5,
    Shadow04: Shadow04$5,
    SpacingInlineQuark: SpacingInlineQuark$5,
    SpacingInlineNano: SpacingInlineNano$5,
    SpacingInlineXxxs: SpacingInlineXxxs$5,
    SpacingInlineXxs: SpacingInlineXxs$5,
    SpacingInlineXs: SpacingInlineXs$5,
    SpacingInlineSm: SpacingInlineSm$5,
    SpacingInlineMd: SpacingInlineMd$5,
    SpacingInlineLg: SpacingInlineLg$5,
    SpacingInlineXl: SpacingInlineXl$5,
    SpacingInlineXxl: SpacingInlineXxl$5,
    SpacingInlineXxxl: SpacingInlineXxxl$5,
    SpacingInlineHuge: SpacingInlineHuge$5,
    SpacingInlineGiant: SpacingInlineGiant$5,
    SpacingInsetQuark: SpacingInsetQuark$5,
    SpacingInsetNano: SpacingInsetNano$5,
    SpacingInsetXs: SpacingInsetXs$5,
    SpacingInsetSm: SpacingInsetSm$5,
    SpacingInsetMd: SpacingInsetMd$5,
    SpacingInsetLg: SpacingInsetLg$5,
    SpacingSquishQuark: SpacingSquishQuark$5,
    SpacingSquishNano: SpacingSquishNano$5,
    SpacingSquishXs: SpacingSquishXs$5,
    SpacingSquishSm: SpacingSquishSm$5,
    SpacingStackQuark: SpacingStackQuark$5,
    SpacingStackNano: SpacingStackNano$5,
    SpacingStackXxxs: SpacingStackXxxs$5,
    SpacingStackXxs: SpacingStackXxs$5,
    SpacingStackXs: SpacingStackXs$5,
    SpacingStackSm: SpacingStackSm$5,
    SpacingStackMd: SpacingStackMd$5,
    SpacingStackLg: SpacingStackLg$5,
    SpacingStackXl: SpacingStackXl$5,
    SpacingStackXxl: SpacingStackXxl$5,
    SpacingStackXxxl: SpacingStackXxxl$5,
    SpacingStackHuge: SpacingStackHuge$5,
    SpacingStackGiant: SpacingStackGiant$5,
    FontFamilyBase: FontFamilyBase$5,
    FontSizeXxxs: FontSizeXxxs$5,
    FontSizeXxs: FontSizeXxs$5,
    FontSizeXs: FontSizeXs$5,
    FontSizeSm: FontSizeSm$5,
    FontSizeMd: FontSizeMd$5,
    FontSizeLg: FontSizeLg$5,
    FontSizeXl: FontSizeXl$5,
    FontSizeXxl: FontSizeXxl$5,
    FontSizeXxxl: FontSizeXxxl$5,
    FontSizeDisplay: FontSizeDisplay$5,
    FontSizeGiant: FontSizeGiant$5,
    FontWeightBold: FontWeightBold$5,
    FontWeightSemibold: FontWeightSemibold$5,
    FontWeightMedium: FontWeightMedium$5,
    FontWeightRegular: FontWeightRegular$5,
    FontWeightLight: FontWeightLight$5,
    LetterSpacingStandard: LetterSpacingStandard$5,
    LetterSpacingSmall: LetterSpacingSmall$5,
    LetterSpacingMedium: LetterSpacingMedium$5,
    LineHeightStandard: LineHeightStandard$5,
    LineHeightTiny: LineHeightTiny$5,
    LineHeightMedium: LineHeightMedium$5,
    LineHeightLarge: LineHeightLarge$5,
    LineHeightDistant: LineHeightDistant$5,
    LineHeightSuperdistant: LineHeightSuperdistant$5,
    LineHeightHuge: LineHeightHuge$5
  });
  /**
   * Do not edit directly
   * Generated on Thu, 27 Oct 2022 18:07:46 GMT
   */

  var BorderRadiusNone$4 = "0px";
  var BorderRadiusXs$4 = "4px";
  var BorderRadiusSm$4 = "8px";
  var BorderRadiusMd$4 = "16px";
  var BorderRadiusLg$4 = "24px";
  var BorderRadiusPill$4 = "960px";
  var BorderRadiusCircle$4 = "50%";
  var BorderWidthNone$4 = "0px";
  var BorderWidthHairline$4 = "1px";
  var BorderWidthThin$4 = "2px";
  var BorderWidthThick$4 = "4px";
  var BorderWidthHeavy$4 = "8px";
  var ColorDatavizInfoText$4 = "#0F58EA";
  var ColorDatavizInfoShape01$4 = "#3F7BF2";
  var ColorDatavizInfoShape02$4 = "#D9E5FC";
  var ColorDatavizInfoShape03$4 = "#F1F5FE";
  var ColorDatavizNegativeText$4 = "#BC293A";
  var ColorDatavizNegativeShape01$4 = "#EA4356";
  var ColorDatavizNegativeShape02$4 = "#FDDDE1";
  var ColorDatavizNegativeShape03$4 = "#FEF1F2";
  var ColorDatavizWarningText$4 = "#A04C03";
  var ColorDatavizWarningShape01$4 = "#D26404";
  var ColorDatavizWarningShape02$4 = "#FEE1C8";
  var ColorDatavizWarningShape03$4 = "#FEF1E6";
  var ColorDatavizPositiveText$4 = "#22723A";
  var ColorDatavizPositiveShape01$4 = "#2D954C";
  var ColorDatavizPositiveShape02$4 = "#C8EED3";
  var ColorDatavizPositiveShape03$4 = "#E8F8EC";
  var ColorDatavizCatAText$4 = "#9B18DC";
  var ColorDatavizCatAShape01$4 = "#B851EC";
  var ColorDatavizCatAShape02$4 = "#F2DFFB";
  var ColorDatavizCatAShape03$4 = "#F9F1FD";
  var ColorDatavizCatBText$4 = "#BA267B";
  var ColorDatavizCatBShape01$4 = "#DA499B";
  var ColorDatavizCatBShape02$4 = "#F8DDEC";
  var ColorDatavizCatBShape03$4 = "#FCF2F8";
  var ColorDatavizCatCText$4 = "#546E21";
  var ColorDatavizCatCShape01$4 = "#6C8D2B";
  var ColorDatavizCatCShape02$4 = "#DBEBBD";
  var ColorDatavizCatCShape03$4 = "#F0F7E4";
  var ColorDatavizCatDText$4 = "#0D735E";
  var ColorDatavizCatDShape01$4 = "#109379";
  var ColorDatavizCatDShape02$4 = "#BCF0E6";
  var ColorDatavizCatDShape03$4 = "#DFFBF6";
  var ColorDatavizInverseInfoText$4 = "#5C8FF5";
  var ColorDatavizInverseInfoShape01$4 = "#286BF1";
  var ColorDatavizInverseInfoShape02$4 = "#062560";
  var ColorDatavizInverseInfoShape03$4 = "#051B48";
  var ColorDatavizInverseNegativeText$4 = "#F55C6E";
  var ColorDatavizInverseNegativeShape01$4 = "#D83145";
  var ColorDatavizInverseNegativeShape02$4 = "#4F1119";
  var ColorDatavizInverseNegativeShape03$4 = "#3B0D12";
  var ColorDatavizInverseWarningText$4 = "#EB7005";
  var ColorDatavizInverseWarningShape01$4 = "#B95804";
  var ColorDatavizInverseWarningShape02$4 = "#462101";
  var ColorDatavizInverseWarningShape03$4 = "#321701";
  var ColorDatavizInversePositiveText$4 = "#32A454";
  var ColorDatavizInversePositiveShape01$4 = "#278142";
  var ColorDatavizInversePositiveShape02$4 = "#0E2F18";
  var ColorDatavizInversePositiveShape03$4 = "#0B2312";
  var ColorDatavizInverseCatAText$4 = "#C36CEF";
  var ColorDatavizInverseCatAShape01$4 = "#AD35E9";
  var ColorDatavizInverseCatAShape02$4 = "#440B60";
  var ColorDatavizInverseCatAShape03$4 = "#340849";
  var ColorDatavizInverseCatBText$4 = "#E067AB";
  var ColorDatavizInverseCatBShape01$4 = "#D42B8C";
  var ColorDatavizInverseCatBShape02$4 = "#4C1032";
  var ColorDatavizInverseCatBShape03$4 = "#3B0C27";
  var ColorDatavizInverseCatCText$4 = "#789D2F";
  var ColorDatavizInverseCatCShape01$4 = "#607E26";
  var ColorDatavizInverseCatCShape02$4 = "#212B0D";
  var ColorDatavizInverseCatCShape03$4 = "#1B230B";
  var ColorDatavizInverseCatDText$4 = "#12A588";
  var ColorDatavizInverseCatDShape01$4 = "#0F856D";
  var ColorDatavizInverseCatDShape02$4 = "#052E26";
  var ColorDatavizInverseCatDShape03$4 = "#04251E";
  var ColorInteractionBlend01$4 = "#1616160A";
  var ColorInteractionBlend02$4 = "#16161614";
  var ColorInteractionBlend03$4 = "#1616161F";
  var ColorInteractionBlend04$4 = "#1616163D";
  var ColorInteractionBlend05$4 = "#161616A3";
  var ColorInteractionBlend06$4 = "#161616B8";
  var ColorInteractionBlend07$4 = "#161616E0";
  var ColorInteractionBlend08$4 = "#161616";
  var ColorInteractionInverseBlend01$4 = "#FEFEFE14";
  var ColorInteractionInverseBlend02$4 = "#FEFEFE1F";
  var ColorInteractionInverseBlend03$4 = "#FEFEFE3D";
  var ColorInteractionInverseBlend04$4 = "#FEFEFE52";
  var ColorInteractionInverseBlend05$4 = "#FEFEFEA3";
  var ColorInteractionInverseBlend06$4 = "#FEFEFEB8";
  var ColorInteractionInverseBlend07$4 = "#FEFEFEE0";
  var ColorInteractionInverseBlend08$4 = "#FEFEFE";
  var ColorInteractionInverseAccent01$4 = "#6B8BFF";
  var ColorInteractionInverseAccent02$4 = "#809BFF";
  var ColorInteractionInverseAccent03$4 = "#99AFFF";
  var ColorInteractionInverseSubtle01$4 = "#5277FF1F";
  var ColorInteractionInverseSubtle02$4 = "#5277FF3D";
  var ColorInteractionInverseSubtle03$4 = "#5277FF52";
  var ColorInteractionInverseSelectDefault$4 = "#919191";
  var ColorInteractionInverseSelectFocus$4 = "#D4D4D4";
  var ColorInteractionInverseSelectActive$4 = "#769D34";
  var ColorInteractionInverseDanger01$4 = "#F55C6E";
  var ColorInteractionInverseDanger02$4 = "#F77E8C";
  var ColorInteractionInverseDanger03$4 = "#F895A1";
  var ColorInteractionInverseOnBrandAccent01$4 = "#000E40";
  var ColorInteractionInverseOnBrandAccent02$4 = "#001A7A";
  var ColorInteractionInverseOnBrandAccent03$4 = "#00229E";
  var ColorInteractionInverseOnBrandSubtle01$4 = "#002FDB14";
  var ColorInteractionInverseOnBrandSubtle02$4 = "#002FDB1F";
  var ColorInteractionInverseOnBrandSubtle03$4 = "#002FDB3D";
  var ColorInteractionInverseOnBrandSelectDefault$4 = "#595959";
  var ColorInteractionInverseOnBrandSelectFocus$4 = "#404040";
  var ColorInteractionInverseOnBrandSelectActive$4 = "#486020";
  var ColorInteractionInverseOnBrandBlend01$4 = "#1616160A";
  var ColorInteractionInverseOnBrandBlend02$4 = "#16161614";
  var ColorInteractionInverseOnBrandBlend03$4 = "#1616161F";
  var ColorInteractionInverseOnBrandBlend04$4 = "#1616163D";
  var ColorInteractionInverseOnBrandBlend05$4 = "#161616A3";
  var ColorInteractionInverseOnBrandBlend06$4 = "#161616B8";
  var ColorInteractionInverseOnBrandBlend07$4 = "#161616E0";
  var ColorInteractionInverseOnBrandBlend08$4 = "#161616";
  var ColorInteractionInverseOnBrandDanger01$4 = "#A72534";
  var ColorInteractionInverseOnBrandDanger02$4 = "#92202E";
  var ColorInteractionInverseOnBrandDanger03$4 = "#7E1B27";
  var ColorInteractionAccent01$4 = "#000E40";
  var ColorInteractionAccent02$4 = "#001A7A";
  var ColorInteractionAccent03$4 = "#00229E";
  var ColorInteractionSubtle01$4 = "#0029BD1F";
  var ColorInteractionSubtle02$4 = "#0029BD3D";
  var ColorInteractionSubtle03$4 = "#0029BD52";
  var ColorInteractionSelectDefault$4 = "#666666";
  var ColorInteractionSelectFocus$4 = "#363636";
  var ColorInteractionSelectActive$4 = "#486020";
  var ColorInteractionDanger01$4 = "#BC293A";
  var ColorInteractionDanger02$4 = "#A72534";
  var ColorInteractionDanger03$4 = "#92202E";
  var ColorInteractionOnBrandAccent01$4 = "#ADBFFF";
  var ColorInteractionOnBrandAccent02$4 = "#99AFFF";
  var ColorInteractionOnBrandAccent03$4 = "#809BFF";
  var ColorInteractionOnBrandSubtle01$4 = "#5277FF1F";
  var ColorInteractionOnBrandSubtle02$4 = "#5277FF3D";
  var ColorInteractionOnBrandSubtle03$4 = "#5277FF52";
  var ColorInteractionOnBrandSelectDefault$4 = "#B0B0B0";
  var ColorInteractionOnBrandSelectFocus$4 = "#D4D4D4";
  var ColorInteractionOnBrandSelectActive$4 = "#809BFF";
  var ColorInteractionOnBrandBlend01$4 = "#FEFEFE14";
  var ColorInteractionOnBrandBlend02$4 = "#FEFEFE1F";
  var ColorInteractionOnBrandBlend03$4 = "#FEFEFE3D";
  var ColorInteractionOnBrandBlend04$4 = "#FEFEFE52";
  var ColorInteractionOnBrandBlend05$4 = "#FEFEFEA3";
  var ColorInteractionOnBrandBlend06$4 = "#FEFEFEB8";
  var ColorInteractionOnBrandBlend07$4 = "#FEFEFEE0";
  var ColorInteractionOnBrandBlend08$4 = "#FEFEFE";
  var ColorInteractionOnBrandDanger01$4 = "#F77E8C";
  var ColorInteractionOnBrandDanger02$4 = "#F895A1";
  var ColorInteractionOnBrandDanger03$4 = "#FAAEB6";
  var ColorNeutral10$4 = "#F5F5F5";
  var ColorNeutral20$4 = "#E6E6E6";
  var ColorNeutral30$4 = "#1616163D";
  var ColorNeutral00$4 = "#FEFEFE";
  var ColorNeutralInverse10$4 = "#1F1F1F";
  var ColorNeutralInverse20$4 = "#292929";
  var ColorNeutralInverse30$4 = "#FEFEFE3D";
  var ColorNeutralInverse00$4 = "#161616";
  var ColorNeutralInverseOnBrand10$4 = "#DBE3FF";
  var ColorNeutralInverseOnBrand20$4 = "#C7D3FF";
  var ColorNeutralInverseOnBrand30$4 = "#0029BD52";
  var ColorNeutralInverseOnBrand00$4 = "#F0F3FF";
  var ColorNeutralOnBrand10$4 = "#001A7A";
  var ColorNeutralOnBrand20$4 = "#00229E";
  var ColorNeutralOnBrand30$4 = "#5277FFA3";
  var ColorNeutralOnBrand00$4 = "#000E40";
  var ColorPaletteBlack$4 = "#161616";
  var ColorPaletteWhite$4 = "#FEFEFE";
  var ColorPaletteGray10$4 = "#1F1F1F";
  var ColorPaletteGray20$4 = "#292929";
  var ColorPaletteGray30$4 = "#363636";
  var ColorPaletteGray40$4 = "#404040";
  var ColorPaletteGray50$4 = "#4C4C4C";
  var ColorPaletteGray60$4 = "#595959";
  var ColorPaletteGray70$4 = "#666666";
  var ColorPaletteGray80$4 = "#737373";
  var ColorPaletteGray90$4 = "#828282";
  var ColorPaletteGray100$4 = "#919191";
  var ColorPaletteGray110$4 = "#A1A1A1";
  var ColorPaletteGray120$4 = "#B0B0B0";
  var ColorPaletteGray130$4 = "#C2C2C2";
  var ColorPaletteGray140$4 = "#D4D4D4";
  var ColorPaletteGray150$4 = "#E6E6E6";
  var ColorPaletteGray160$4 = "#F5F5F5";
  var ColorPaletteRed10$4 = "#3B0D12";
  var ColorPaletteRed20$4 = "#4F1119";
  var ColorPaletteRed30$4 = "#691721";
  var ColorPaletteRed40$4 = "#7E1B27";
  var ColorPaletteRed50$4 = "#92202E";
  var ColorPaletteRed60$4 = "#A72534";
  var ColorPaletteRed70$4 = "#BC293A";
  var ColorPaletteRed80$4 = "#D83145";
  var ColorPaletteRed90$4 = "#EA4356";
  var ColorPaletteRed100$4 = "#F55C6E";
  var ColorPaletteRed110$4 = "#F77E8C";
  var ColorPaletteRed120$4 = "#F895A1";
  var ColorPaletteRed130$4 = "#FAAEB6";
  var ColorPaletteRed140$4 = "#FBC5CC";
  var ColorPaletteRed150$4 = "#FDDDE1";
  var ColorPaletteRed160$4 = "#FEF1F2";
  var ColorPaletteYellow10$4 = "#321701";
  var ColorPaletteYellow20$4 = "#462101";
  var ColorPaletteYellow30$4 = "#552802";
  var ColorPaletteYellow40$4 = "#693102";
  var ColorPaletteYellow50$4 = "#7D3B03";
  var ColorPaletteYellow60$4 = "#914503";
  var ColorPaletteYellow70$4 = "#A04C03";
  var ColorPaletteYellow80$4 = "#B95804";
  var ColorPaletteYellow90$4 = "#D26404";
  var ColorPaletteYellow100$4 = "#EB7005";
  var ColorPaletteYellow110$4 = "#FA8219";
  var ColorPaletteYellow120$4 = "#FB9B46";
  var ColorPaletteYellow130$4 = "#FCB06E";
  var ColorPaletteYellow140$4 = "#FDC99B";
  var ColorPaletteYellow150$4 = "#FEE1C8";
  var ColorPaletteYellow160$4 = "#FEF1E6";
  var ColorPaletteLime10$4 = "#1B230B";
  var ColorPaletteLime20$4 = "#212B0D";
  var ColorPaletteLime30$4 = "#2D3B12";
  var ColorPaletteLime40$4 = "#364616";
  var ColorPaletteLime50$4 = "#3F5219";
  var ColorPaletteLime60$4 = "#485E1D";
  var ColorPaletteLime70$4 = "#546E21";
  var ColorPaletteLime80$4 = "#607E26";
  var ColorPaletteLime90$4 = "#6C8D2B";
  var ColorPaletteLime100$4 = "#789D2F";
  var ColorPaletteLime110$4 = "#84AC34";
  var ColorPaletteLime120$4 = "#93BF3A";
  var ColorPaletteLime130$4 = "#A9CF5E";
  var ColorPaletteLime140$4 = "#C2DD8D";
  var ColorPaletteLime150$4 = "#DBEBBD";
  var ColorPaletteLime160$4 = "#F0F7E4";
  var ColorPaletteGreen10$4 = "#0B2312";
  var ColorPaletteGreen20$4 = "#0E2F18";
  var ColorPaletteGreen30$4 = "#133E20";
  var ColorPaletteGreen40$4 = "#174A26";
  var ColorPaletteGreen50$4 = "#1A562C";
  var ColorPaletteGreen60$4 = "#1F6634";
  var ColorPaletteGreen70$4 = "#22723A";
  var ColorPaletteGreen80$4 = "#278142";
  var ColorPaletteGreen90$4 = "#2D954C";
  var ColorPaletteGreen100$4 = "#32A454";
  var ColorPaletteGreen110$4 = "#38B85E";
  var ColorPaletteGreen120$4 = "#4BC870";
  var ColorPaletteGreen130$4 = "#76D692";
  var ColorPaletteGreen140$4 = "#9DE2B1";
  var ColorPaletteGreen150$4 = "#C8EED3";
  var ColorPaletteGreen160$4 = "#E8F8EC";
  var ColorPaletteAcqua10$4 = "#04251E";
  var ColorPaletteAcqua20$4 = "#052E26";
  var ColorPaletteAcqua30$4 = "#073C31";
  var ColorPaletteAcqua40$4 = "#08493C";
  var ColorPaletteAcqua50$4 = "#0A5748";
  var ColorPaletteAcqua60$4 = "#0B6553";
  var ColorPaletteAcqua70$4 = "#0D735E";
  var ColorPaletteAcqua80$4 = "#0F856D";
  var ColorPaletteAcqua90$4 = "#109379";
  var ColorPaletteAcqua100$4 = "#12A588";
  var ColorPaletteAcqua110$4 = "#14B897";
  var ColorPaletteAcqua120$4 = "#31C4A6";
  var ColorPaletteAcqua130$4 = "#68D4BF";
  var ColorPaletteAcqua140$4 = "#8DE2D1";
  var ColorPaletteAcqua150$4 = "#BCF0E6";
  var ColorPaletteAcqua160$4 = "#DFFBF6";
  var ColorPaletteBlue10$4 = "#051B48";
  var ColorPaletteBlue20$4 = "#062560";
  var ColorPaletteBlue30$4 = "#082F7D";
  var ColorPaletteBlue40$4 = "#0A3A9A";
  var ColorPaletteBlue50$4 = "#0B43B1";
  var ColorPaletteBlue60$4 = "#0D4ECE";
  var ColorPaletteBlue70$4 = "#0F58EA";
  var ColorPaletteBlue80$4 = "#286BF1";
  var ColorPaletteBlue90$4 = "#3F7BF2";
  var ColorPaletteBlue100$4 = "#5C8FF5";
  var ColorPaletteBlue110$4 = "#73A0F7";
  var ColorPaletteBlue120$4 = "#8CB0F8";
  var ColorPaletteBlue130$4 = "#A9C4F9";
  var ColorPaletteBlue140$4 = "#C1D4FB";
  var ColorPaletteBlue150$4 = "#D9E5FC";
  var ColorPaletteBlue160$4 = "#F1F5FE";
  var ColorPalettePurple10$4 = "#340849";
  var ColorPalettePurple20$4 = "#440B60";
  var ColorPalettePurple30$4 = "#540D78";
  var ColorPalettePurple40$4 = "#671093";
  var ColorPalettePurple50$4 = "#7713AA";
  var ColorPalettePurple60$4 = "#8B16C5";
  var ColorPalettePurple70$4 = "#9B18DC";
  var ColorPalettePurple80$4 = "#AD35E9";
  var ColorPalettePurple90$4 = "#B851EC";
  var ColorPalettePurple100$4 = "#C36CEF";
  var ColorPalettePurple110$4 = "#CC83F1";
  var ColorPalettePurple120$4 = "#D69AF4";
  var ColorPalettePurple130$4 = "#DFB1F6";
  var ColorPalettePurple140$4 = "#E8C8F9";
  var ColorPalettePurple150$4 = "#F2DFFB";
  var ColorPalettePurple160$4 = "#F9F1FD";
  var ColorPalettePink10$4 = "#3B0C27";
  var ColorPalettePink20$4 = "#4C1032";
  var ColorPalettePink30$4 = "#661543";
  var ColorPalettePink40$4 = "#77184E";
  var ColorPalettePink50$4 = "#8C1C5D";
  var ColorPalettePink60$4 = "#A12169";
  var ColorPalettePink70$4 = "#BA267B";
  var ColorPalettePink80$4 = "#D42B8C";
  var ColorPalettePink90$4 = "#DA499B";
  var ColorPalettePink100$4 = "#E067AB";
  var ColorPalettePink110$4 = "#E580B9";
  var ColorPalettePink120$4 = "#EA99C7";
  var ColorPalettePink130$4 = "#EFAFD3";
  var ColorPalettePink140$4 = "#F4C8E1";
  var ColorPalettePink150$4 = "#F8DDEC";
  var ColorPalettePink160$4 = "#FCF2F8";
  var ColorTypefaceStrong$4 = "#161616";
  var ColorTypefacePure$4 = "#363636";
  var ColorTypefaceSmooth$4 = "#666666";
  var ColorTypefaceMeld$4 = "#1616163D";
  var ColorTypefaceInverseStrong$4 = "#FEFEFE";
  var ColorTypefaceInversePure$4 = "#D4D4D4";
  var ColorTypefaceInverseSmooth$4 = "#919191";
  var ColorTypefaceInverseMeld$4 = "#FEFEFE52";
  var ColorTypefaceInverseOnBrandStrong$4 = "#161616";
  var ColorTypefaceInverseOnBrandPure$4 = "#363636";
  var ColorTypefaceInverseOnBrandSmooth$4 = "#595959";
  var ColorTypefaceInverseOnBrandMeld$4 = "#1616163D";
  var ColorTypefaceOnBrandStrong$4 = "#FEFEFE";
  var ColorTypefaceOnBrandPure$4 = "#DBE3FF";
  var ColorTypefaceOnBrandSmooth$4 = "#C7D3FF";
  var ColorTypefaceOnBrandMeld$4 = "#FEFEFE52";
  var ColorBrandPrimary10$4 = "#000E40";
  var ColorBrandPrimary20$4 = "#001A7A";
  var ColorBrandPrimary30$4 = "#00229E";
  var ColorBrandPrimary40$4 = "#0029BD";
  var ColorBrandPrimary50$4 = "#002FDB";
  var ColorBrandPrimary60$4 = "#0037FF";
  var ColorBrandPrimary70$4 = "#1F4FFF";
  var ColorBrandPrimary80$4 = "#3863FF";
  var ColorBrandPrimary90$4 = "#5277FF";
  var ColorBrandPrimary100$4 = "#6B8BFF";
  var ColorBrandPrimary110$4 = "#809BFF";
  var ColorBrandPrimary120$4 = "#99AFFF";
  var ColorBrandPrimary130$3 = "#ADBFFF";
  var ColorBrandPrimary140$3 = "#C7D3FF";
  var ColorBrandPrimary150$3 = "#DBE3FF";
  var ColorBrandPrimary160$3 = "#F0F3FF";
  var ColorBrandBase01$4 = "#000E40";
  var ColorBrandBase02$4 = "#CF0F40";
  var ColorBrandBase03$3 = "#E84273";
  var ColorBrandBase04$3 = "#769D34";
  var ColorBrandBase05$3 = "#DBF49D";
  var ColorBrandBase06$1 = "#F6F4F4";
  var ColorBrandPalette0110$3 = "#000E40";
  var ColorBrandPalette0120$3 = "#001A7A";
  var ColorBrandPalette0130$3 = "#00229E";
  var ColorBrandPalette0140$3 = "#0029BD";
  var ColorBrandPalette0150$3 = "#002FDB";
  var ColorBrandPalette0160$3 = "#0037FF";
  var ColorBrandPalette0170$3 = "#1F4FFF";
  var ColorBrandPalette0180$3 = "#3863FF";
  var ColorBrandPalette0190$3 = "#5277FF";
  var ColorBrandPalette01100$3 = "#6B8BFF";
  var ColorBrandPalette01110$3 = "#809BFF";
  var ColorBrandPalette01120$3 = "#99AFFF";
  var ColorBrandPalette01130$3 = "#ADBFFF";
  var ColorBrandPalette01140$3 = "#C7D3FF";
  var ColorBrandPalette01150$3 = "#DBE3FF";
  var ColorBrandPalette01160$3 = "#F0F3FF";
  var ColorBrandPalette0210$3 = "#420514";
  var ColorBrandPalette0220$3 = "#55061A";
  var ColorBrandPalette0230$3 = "#6D0821";
  var ColorBrandPalette0240$3 = "#850A29";
  var ColorBrandPalette0250$3 = "#980B2F";
  var ColorBrandPalette0260$3 = "#AF0D36";
  var ColorBrandPalette0270$3 = "#CF0F40";
  var ColorBrandPalette0280$3 = "#E41146";
  var ColorBrandPalette0290$3 = "#F03866";
  var ColorBrandPalette02100$3 = "#F35E83";
  var ColorBrandPalette02110$3 = "#F57A99";
  var ColorBrandPalette02120$3 = "#F797AF";
  var ColorBrandPalette02130$3 = "#F9AEC1";
  var ColorBrandPalette02140$3 = "#FBC6D3";
  var ColorBrandPalette02150$3 = "#FDDEE5";
  var ColorBrandPalette02160$3 = "#FEF1F4";
  var ColorBrandPalette0310$1 = "#400819";
  var ColorBrandPalette0320$1 = "#560B21";
  var ColorBrandPalette0330$1 = "#6D0D2A";
  var ColorBrandPalette0340$1 = "#7F1031";
  var ColorBrandPalette0350$1 = "#96133A";
  var ColorBrandPalette0360$1 = "#AC1543";
  var ColorBrandPalette0370$1 = "#C3184B";
  var ColorBrandPalette0380$1 = "#DE1B56";
  var ColorBrandPalette0390$1 = "#E84273";
  var ColorBrandPalette03100$1 = "#EC658D";
  var ColorBrandPalette03110$1 = "#EF7B9E";
  var ColorBrandPalette03120$1 = "#F297B2";
  var ColorBrandPalette03130$1 = "#F5ADC3";
  var ColorBrandPalette03140$1 = "#F8C9D7";
  var ColorBrandPalette03150$1 = "#FBDFE8";
  var ColorBrandPalette03160$1 = "#FDF2F5";
  var ColorBrandPalette0410$2 = "#1A220B";
  var ColorBrandPalette0420$2 = "#232E0F";
  var ColorBrandPalette0430$2 = "#2B3913";
  var ColorBrandPalette0440$2 = "#344517";
  var ColorBrandPalette0450$2 = "#40541C";
  var ColorBrandPalette0460$2 = "#486020";
  var ColorBrandPalette0470$2 = "#546F25";
  var ColorBrandPalette0480$2 = "#5F7E2A";
  var ColorBrandPalette0490$2 = "#6B8E2F";
  var ColorBrandPalette04100$2 = "#769D34";
  var ColorBrandPalette04110$2 = "#85B03B";
  var ColorBrandPalette04120$2 = "#91BF40";
  var ColorBrandPalette04130$2 = "#A3CA60";
  var ColorBrandPalette04140$2 = "#C3DD98";
  var ColorBrandPalette04150$2 = "#DBF49D";
  var ColorBrandPalette04160$2 = "#F2F7E8";
  var ColorBrandPalette0610$1 = "#1A1514";
  var ColorBrandPalette0620$1 = "#312826";
  var ColorBrandPalette0630$1 = "#3F3431";
  var ColorBrandPalette0640$1 = "#4A3D3A";
  var ColorBrandPalette0650$1 = "#594946";
  var ColorBrandPalette0660$1 = "#675451";
  var ColorBrandPalette0670$1 = "#75605C";
  var ColorBrandPalette0680$1 = "#866E69";
  var ColorBrandPalette0690$1 = "#967E79";
  var ColorBrandPalette06100$1 = "#A38E8A";
  var ColorBrandPalette06110$1 = "#AE9C98";
  var ColorBrandPalette06120$1 = "#BEAFAC";
  var ColorBrandPalette06130$1 = "#CBC0BD";
  var ColorBrandPalette06140$1 = "#D9D0CE";
  var ColorBrandPalette06150$1 = "#E9E4E3";
  var ColorBrandPalette06160$1 = "#F6F4F4";
  var ColorFeedbackErrorText$4 = "#BC293A";
  var ColorFeedbackErrorShape$4 = "#EA4356";
  var ColorFeedbackSuccessText$4 = "#22723A";
  var ColorFeedbackSuccessShape$4 = "#2D954C";
  var ColorFeedbackOnBrandErrorText$4 = "#F77E8C";
  var ColorFeedbackOnBrandErrorShape$4 = "#EA4356";
  var ColorFeedbackOnBrandSuccessText$4 = "#38B85E";
  var ColorFeedbackOnBrandSuccessShape$4 = "#2D954C";
  var ColorFeedbackInverseErrorText$4 = "#F55C6E";
  var ColorFeedbackInverseErrorShape$4 = "#D83145";
  var ColorFeedbackInverseSuccessText$4 = "#32A454";
  var ColorFeedbackInverseSuccessShape$4 = "#278142";
  var ColorFeedbackInverseOnBrandErrorText$4 = "#A72534";
  var ColorFeedbackInverseOnBrandErrorShape$4 = "#D83145";
  var ColorFeedbackInverseOnBrandSuccessText$4 = "#1F6634";
  var ColorFeedbackInverseOnBrandSuccessShape$4 = "#278142";
  var ColorSupport01$4 = "#CF0F40";
  var ColorSupport02$4 = "#CF0F40";
  var ColorSupportOnBrand01$4 = "#A3CA60";
  var ColorSupportOnBrand02$4 = "#A3CA60";
  var ColorSupportInverse01$4 = "#E84273";
  var ColorSupportInverse02$4 = "#E84273";
  var ColorSupportInverseOnBrand01$4 = "#CF0F40";
  var ColorSupportInverseOnBrand02$4 = "#CF0F40";
  var Opacity01$4 = "0.04";
  var Opacity02$4 = "0.08";
  var Opacity03$4 = "0.12";
  var Opacity04$4 = "0.24";
  var Opacity05$4 = "0.32";
  var Opacity06$4 = "0.56";
  var Opacity07$4 = "0.64";
  var Opacity08$4 = "0.72";
  var Opacity09$4 = "0.88";
  var Shadow01$4 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
  var Shadow02$4 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
  var Shadow03$4 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
  var Shadow04$4 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
  var SpacingInlineQuark$4 = "4px";
  var SpacingInlineNano$4 = "8px";
  var SpacingInlineXxxs$4 = "16px";
  var SpacingInlineXxs$4 = "24px";
  var SpacingInlineXs$4 = "32px";
  var SpacingInlineSm$4 = "40px";
  var SpacingInlineMd$4 = "48px";
  var SpacingInlineLg$4 = "56px";
  var SpacingInlineXl$4 = "64px";
  var SpacingInlineXxl$4 = "80px";
  var SpacingInlineXxxl$4 = "120px";
  var SpacingInlineHuge$4 = "160px";
  var SpacingInlineGiant$4 = "200px";
  var SpacingInsetQuark$4 = "4px";
  var SpacingInsetNano$4 = "8px";
  var SpacingInsetXs$4 = "16px";
  var SpacingInsetSm$4 = "24px";
  var SpacingInsetMd$4 = "32px";
  var SpacingInsetLg$4 = "40px";
  var SpacingSquishQuark$4 = "4px 8px";
  var SpacingSquishNano$4 = "8px 16px";
  var SpacingSquishXs$4 = "16px 24px";
  var SpacingSquishSm$4 = "16px 32px";
  var SpacingStackQuark$4 = "4px";
  var SpacingStackNano$4 = "8px";
  var SpacingStackXxxs$4 = "16px";
  var SpacingStackXxs$4 = "24px";
  var SpacingStackXs$4 = "32px";
  var SpacingStackSm$4 = "40px";
  var SpacingStackMd$4 = "48px";
  var SpacingStackLg$4 = "56px";
  var SpacingStackXl$4 = "64px";
  var SpacingStackXxl$4 = "80px";
  var SpacingStackXxxl$4 = "120px";
  var SpacingStackHuge$4 = "160px";
  var SpacingStackGiant$4 = "200px";
  var FontFamilyBase$4 = "'Dasa Sans', 'sans-serif'";
  var FontSizeXxxs$4 = "0.75rem";
  var FontSizeXxs$4 = "0.875rem";
  var FontSizeXs$4 = "1rem";
  var FontSizeSm$4 = "1.25rem";
  var FontSizeMd$4 = "1.5rem";
  var FontSizeLg$4 = "2rem";
  var FontSizeXl$4 = "2.5rem";
  var FontSizeXxl$4 = "3rem";
  var FontSizeXxxl$4 = "4rem";
  var FontSizeDisplay$4 = "5rem";
  var FontSizeGiant$4 = "6rem";
  var FontWeightBold$4 = 700;
  var FontWeightSemibold$4 = 600;
  var FontWeightMedium$4 = 500;
  var FontWeightRegular$4 = 400;
  var FontWeightLight$4 = 300;
  var LetterSpacingStandard$4 = "0px";
  var LetterSpacingSmall$4 = "-1px";
  var LetterSpacingMedium$4 = "1.5px";
  var LineHeightStandard$4 = "100%";
  var LineHeightTiny$4 = "115%";
  var LineHeightMedium$4 = "120%";
  var LineHeightLarge$4 = "125%";
  var LineHeightDistant$4 = "133%";
  var LineHeightSuperdistant$4 = "150%";
  var LineHeightHuge$4 = "170%";
  var index$4 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BorderRadiusNone: BorderRadiusNone$4,
    BorderRadiusXs: BorderRadiusXs$4,
    BorderRadiusSm: BorderRadiusSm$4,
    BorderRadiusMd: BorderRadiusMd$4,
    BorderRadiusLg: BorderRadiusLg$4,
    BorderRadiusPill: BorderRadiusPill$4,
    BorderRadiusCircle: BorderRadiusCircle$4,
    BorderWidthNone: BorderWidthNone$4,
    BorderWidthHairline: BorderWidthHairline$4,
    BorderWidthThin: BorderWidthThin$4,
    BorderWidthThick: BorderWidthThick$4,
    BorderWidthHeavy: BorderWidthHeavy$4,
    ColorDatavizInfoText: ColorDatavizInfoText$4,
    ColorDatavizInfoShape01: ColorDatavizInfoShape01$4,
    ColorDatavizInfoShape02: ColorDatavizInfoShape02$4,
    ColorDatavizInfoShape03: ColorDatavizInfoShape03$4,
    ColorDatavizNegativeText: ColorDatavizNegativeText$4,
    ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$4,
    ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$4,
    ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$4,
    ColorDatavizWarningText: ColorDatavizWarningText$4,
    ColorDatavizWarningShape01: ColorDatavizWarningShape01$4,
    ColorDatavizWarningShape02: ColorDatavizWarningShape02$4,
    ColorDatavizWarningShape03: ColorDatavizWarningShape03$4,
    ColorDatavizPositiveText: ColorDatavizPositiveText$4,
    ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$4,
    ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$4,
    ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$4,
    ColorDatavizCatAText: ColorDatavizCatAText$4,
    ColorDatavizCatAShape01: ColorDatavizCatAShape01$4,
    ColorDatavizCatAShape02: ColorDatavizCatAShape02$4,
    ColorDatavizCatAShape03: ColorDatavizCatAShape03$4,
    ColorDatavizCatBText: ColorDatavizCatBText$4,
    ColorDatavizCatBShape01: ColorDatavizCatBShape01$4,
    ColorDatavizCatBShape02: ColorDatavizCatBShape02$4,
    ColorDatavizCatBShape03: ColorDatavizCatBShape03$4,
    ColorDatavizCatCText: ColorDatavizCatCText$4,
    ColorDatavizCatCShape01: ColorDatavizCatCShape01$4,
    ColorDatavizCatCShape02: ColorDatavizCatCShape02$4,
    ColorDatavizCatCShape03: ColorDatavizCatCShape03$4,
    ColorDatavizCatDText: ColorDatavizCatDText$4,
    ColorDatavizCatDShape01: ColorDatavizCatDShape01$4,
    ColorDatavizCatDShape02: ColorDatavizCatDShape02$4,
    ColorDatavizCatDShape03: ColorDatavizCatDShape03$4,
    ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$4,
    ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$4,
    ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$4,
    ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$4,
    ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$4,
    ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$4,
    ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$4,
    ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$4,
    ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$4,
    ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$4,
    ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$4,
    ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$4,
    ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$4,
    ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$4,
    ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$4,
    ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$4,
    ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$4,
    ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$4,
    ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$4,
    ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$4,
    ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$4,
    ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$4,
    ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$4,
    ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$4,
    ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$4,
    ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$4,
    ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$4,
    ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$4,
    ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$4,
    ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$4,
    ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$4,
    ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$4,
    ColorInteractionBlend01: ColorInteractionBlend01$4,
    ColorInteractionBlend02: ColorInteractionBlend02$4,
    ColorInteractionBlend03: ColorInteractionBlend03$4,
    ColorInteractionBlend04: ColorInteractionBlend04$4,
    ColorInteractionBlend05: ColorInteractionBlend05$4,
    ColorInteractionBlend06: ColorInteractionBlend06$4,
    ColorInteractionBlend07: ColorInteractionBlend07$4,
    ColorInteractionBlend08: ColorInteractionBlend08$4,
    ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$4,
    ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$4,
    ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$4,
    ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$4,
    ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$4,
    ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$4,
    ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$4,
    ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$4,
    ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$4,
    ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$4,
    ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$4,
    ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$4,
    ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$4,
    ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$4,
    ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$4,
    ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$4,
    ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$4,
    ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$4,
    ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$4,
    ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$4,
    ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$4,
    ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$4,
    ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$4,
    ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$4,
    ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$4,
    ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$4,
    ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$4,
    ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$4,
    ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$4,
    ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$4,
    ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$4,
    ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$4,
    ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$4,
    ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$4,
    ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$4,
    ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$4,
    ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$4,
    ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$4,
    ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$4,
    ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$4,
    ColorInteractionAccent01: ColorInteractionAccent01$4,
    ColorInteractionAccent02: ColorInteractionAccent02$4,
    ColorInteractionAccent03: ColorInteractionAccent03$4,
    ColorInteractionSubtle01: ColorInteractionSubtle01$4,
    ColorInteractionSubtle02: ColorInteractionSubtle02$4,
    ColorInteractionSubtle03: ColorInteractionSubtle03$4,
    ColorInteractionSelectDefault: ColorInteractionSelectDefault$4,
    ColorInteractionSelectFocus: ColorInteractionSelectFocus$4,
    ColorInteractionSelectActive: ColorInteractionSelectActive$4,
    ColorInteractionDanger01: ColorInteractionDanger01$4,
    ColorInteractionDanger02: ColorInteractionDanger02$4,
    ColorInteractionDanger03: ColorInteractionDanger03$4,
    ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$4,
    ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$4,
    ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$4,
    ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$4,
    ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$4,
    ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$4,
    ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$4,
    ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$4,
    ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$4,
    ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$4,
    ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$4,
    ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$4,
    ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$4,
    ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$4,
    ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$4,
    ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$4,
    ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$4,
    ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$4,
    ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$4,
    ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$4,
    ColorNeutral10: ColorNeutral10$4,
    ColorNeutral20: ColorNeutral20$4,
    ColorNeutral30: ColorNeutral30$4,
    ColorNeutral00: ColorNeutral00$4,
    ColorNeutralInverse10: ColorNeutralInverse10$4,
    ColorNeutralInverse20: ColorNeutralInverse20$4,
    ColorNeutralInverse30: ColorNeutralInverse30$4,
    ColorNeutralInverse00: ColorNeutralInverse00$4,
    ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$4,
    ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$4,
    ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$4,
    ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$4,
    ColorNeutralOnBrand10: ColorNeutralOnBrand10$4,
    ColorNeutralOnBrand20: ColorNeutralOnBrand20$4,
    ColorNeutralOnBrand30: ColorNeutralOnBrand30$4,
    ColorNeutralOnBrand00: ColorNeutralOnBrand00$4,
    ColorPaletteBlack: ColorPaletteBlack$4,
    ColorPaletteWhite: ColorPaletteWhite$4,
    ColorPaletteGray10: ColorPaletteGray10$4,
    ColorPaletteGray20: ColorPaletteGray20$4,
    ColorPaletteGray30: ColorPaletteGray30$4,
    ColorPaletteGray40: ColorPaletteGray40$4,
    ColorPaletteGray50: ColorPaletteGray50$4,
    ColorPaletteGray60: ColorPaletteGray60$4,
    ColorPaletteGray70: ColorPaletteGray70$4,
    ColorPaletteGray80: ColorPaletteGray80$4,
    ColorPaletteGray90: ColorPaletteGray90$4,
    ColorPaletteGray100: ColorPaletteGray100$4,
    ColorPaletteGray110: ColorPaletteGray110$4,
    ColorPaletteGray120: ColorPaletteGray120$4,
    ColorPaletteGray130: ColorPaletteGray130$4,
    ColorPaletteGray140: ColorPaletteGray140$4,
    ColorPaletteGray150: ColorPaletteGray150$4,
    ColorPaletteGray160: ColorPaletteGray160$4,
    ColorPaletteRed10: ColorPaletteRed10$4,
    ColorPaletteRed20: ColorPaletteRed20$4,
    ColorPaletteRed30: ColorPaletteRed30$4,
    ColorPaletteRed40: ColorPaletteRed40$4,
    ColorPaletteRed50: ColorPaletteRed50$4,
    ColorPaletteRed60: ColorPaletteRed60$4,
    ColorPaletteRed70: ColorPaletteRed70$4,
    ColorPaletteRed80: ColorPaletteRed80$4,
    ColorPaletteRed90: ColorPaletteRed90$4,
    ColorPaletteRed100: ColorPaletteRed100$4,
    ColorPaletteRed110: ColorPaletteRed110$4,
    ColorPaletteRed120: ColorPaletteRed120$4,
    ColorPaletteRed130: ColorPaletteRed130$4,
    ColorPaletteRed140: ColorPaletteRed140$4,
    ColorPaletteRed150: ColorPaletteRed150$4,
    ColorPaletteRed160: ColorPaletteRed160$4,
    ColorPaletteYellow10: ColorPaletteYellow10$4,
    ColorPaletteYellow20: ColorPaletteYellow20$4,
    ColorPaletteYellow30: ColorPaletteYellow30$4,
    ColorPaletteYellow40: ColorPaletteYellow40$4,
    ColorPaletteYellow50: ColorPaletteYellow50$4,
    ColorPaletteYellow60: ColorPaletteYellow60$4,
    ColorPaletteYellow70: ColorPaletteYellow70$4,
    ColorPaletteYellow80: ColorPaletteYellow80$4,
    ColorPaletteYellow90: ColorPaletteYellow90$4,
    ColorPaletteYellow100: ColorPaletteYellow100$4,
    ColorPaletteYellow110: ColorPaletteYellow110$4,
    ColorPaletteYellow120: ColorPaletteYellow120$4,
    ColorPaletteYellow130: ColorPaletteYellow130$4,
    ColorPaletteYellow140: ColorPaletteYellow140$4,
    ColorPaletteYellow150: ColorPaletteYellow150$4,
    ColorPaletteYellow160: ColorPaletteYellow160$4,
    ColorPaletteLime10: ColorPaletteLime10$4,
    ColorPaletteLime20: ColorPaletteLime20$4,
    ColorPaletteLime30: ColorPaletteLime30$4,
    ColorPaletteLime40: ColorPaletteLime40$4,
    ColorPaletteLime50: ColorPaletteLime50$4,
    ColorPaletteLime60: ColorPaletteLime60$4,
    ColorPaletteLime70: ColorPaletteLime70$4,
    ColorPaletteLime80: ColorPaletteLime80$4,
    ColorPaletteLime90: ColorPaletteLime90$4,
    ColorPaletteLime100: ColorPaletteLime100$4,
    ColorPaletteLime110: ColorPaletteLime110$4,
    ColorPaletteLime120: ColorPaletteLime120$4,
    ColorPaletteLime130: ColorPaletteLime130$4,
    ColorPaletteLime140: ColorPaletteLime140$4,
    ColorPaletteLime150: ColorPaletteLime150$4,
    ColorPaletteLime160: ColorPaletteLime160$4,
    ColorPaletteGreen10: ColorPaletteGreen10$4,
    ColorPaletteGreen20: ColorPaletteGreen20$4,
    ColorPaletteGreen30: ColorPaletteGreen30$4,
    ColorPaletteGreen40: ColorPaletteGreen40$4,
    ColorPaletteGreen50: ColorPaletteGreen50$4,
    ColorPaletteGreen60: ColorPaletteGreen60$4,
    ColorPaletteGreen70: ColorPaletteGreen70$4,
    ColorPaletteGreen80: ColorPaletteGreen80$4,
    ColorPaletteGreen90: ColorPaletteGreen90$4,
    ColorPaletteGreen100: ColorPaletteGreen100$4,
    ColorPaletteGreen110: ColorPaletteGreen110$4,
    ColorPaletteGreen120: ColorPaletteGreen120$4,
    ColorPaletteGreen130: ColorPaletteGreen130$4,
    ColorPaletteGreen140: ColorPaletteGreen140$4,
    ColorPaletteGreen150: ColorPaletteGreen150$4,
    ColorPaletteGreen160: ColorPaletteGreen160$4,
    ColorPaletteAcqua10: ColorPaletteAcqua10$4,
    ColorPaletteAcqua20: ColorPaletteAcqua20$4,
    ColorPaletteAcqua30: ColorPaletteAcqua30$4,
    ColorPaletteAcqua40: ColorPaletteAcqua40$4,
    ColorPaletteAcqua50: ColorPaletteAcqua50$4,
    ColorPaletteAcqua60: ColorPaletteAcqua60$4,
    ColorPaletteAcqua70: ColorPaletteAcqua70$4,
    ColorPaletteAcqua80: ColorPaletteAcqua80$4,
    ColorPaletteAcqua90: ColorPaletteAcqua90$4,
    ColorPaletteAcqua100: ColorPaletteAcqua100$4,
    ColorPaletteAcqua110: ColorPaletteAcqua110$4,
    ColorPaletteAcqua120: ColorPaletteAcqua120$4,
    ColorPaletteAcqua130: ColorPaletteAcqua130$4,
    ColorPaletteAcqua140: ColorPaletteAcqua140$4,
    ColorPaletteAcqua150: ColorPaletteAcqua150$4,
    ColorPaletteAcqua160: ColorPaletteAcqua160$4,
    ColorPaletteBlue10: ColorPaletteBlue10$4,
    ColorPaletteBlue20: ColorPaletteBlue20$4,
    ColorPaletteBlue30: ColorPaletteBlue30$4,
    ColorPaletteBlue40: ColorPaletteBlue40$4,
    ColorPaletteBlue50: ColorPaletteBlue50$4,
    ColorPaletteBlue60: ColorPaletteBlue60$4,
    ColorPaletteBlue70: ColorPaletteBlue70$4,
    ColorPaletteBlue80: ColorPaletteBlue80$4,
    ColorPaletteBlue90: ColorPaletteBlue90$4,
    ColorPaletteBlue100: ColorPaletteBlue100$4,
    ColorPaletteBlue110: ColorPaletteBlue110$4,
    ColorPaletteBlue120: ColorPaletteBlue120$4,
    ColorPaletteBlue130: ColorPaletteBlue130$4,
    ColorPaletteBlue140: ColorPaletteBlue140$4,
    ColorPaletteBlue150: ColorPaletteBlue150$4,
    ColorPaletteBlue160: ColorPaletteBlue160$4,
    ColorPalettePurple10: ColorPalettePurple10$4,
    ColorPalettePurple20: ColorPalettePurple20$4,
    ColorPalettePurple30: ColorPalettePurple30$4,
    ColorPalettePurple40: ColorPalettePurple40$4,
    ColorPalettePurple50: ColorPalettePurple50$4,
    ColorPalettePurple60: ColorPalettePurple60$4,
    ColorPalettePurple70: ColorPalettePurple70$4,
    ColorPalettePurple80: ColorPalettePurple80$4,
    ColorPalettePurple90: ColorPalettePurple90$4,
    ColorPalettePurple100: ColorPalettePurple100$4,
    ColorPalettePurple110: ColorPalettePurple110$4,
    ColorPalettePurple120: ColorPalettePurple120$4,
    ColorPalettePurple130: ColorPalettePurple130$4,
    ColorPalettePurple140: ColorPalettePurple140$4,
    ColorPalettePurple150: ColorPalettePurple150$4,
    ColorPalettePurple160: ColorPalettePurple160$4,
    ColorPalettePink10: ColorPalettePink10$4,
    ColorPalettePink20: ColorPalettePink20$4,
    ColorPalettePink30: ColorPalettePink30$4,
    ColorPalettePink40: ColorPalettePink40$4,
    ColorPalettePink50: ColorPalettePink50$4,
    ColorPalettePink60: ColorPalettePink60$4,
    ColorPalettePink70: ColorPalettePink70$4,
    ColorPalettePink80: ColorPalettePink80$4,
    ColorPalettePink90: ColorPalettePink90$4,
    ColorPalettePink100: ColorPalettePink100$4,
    ColorPalettePink110: ColorPalettePink110$4,
    ColorPalettePink120: ColorPalettePink120$4,
    ColorPalettePink130: ColorPalettePink130$4,
    ColorPalettePink140: ColorPalettePink140$4,
    ColorPalettePink150: ColorPalettePink150$4,
    ColorPalettePink160: ColorPalettePink160$4,
    ColorTypefaceStrong: ColorTypefaceStrong$4,
    ColorTypefacePure: ColorTypefacePure$4,
    ColorTypefaceSmooth: ColorTypefaceSmooth$4,
    ColorTypefaceMeld: ColorTypefaceMeld$4,
    ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$4,
    ColorTypefaceInversePure: ColorTypefaceInversePure$4,
    ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$4,
    ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$4,
    ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$4,
    ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$4,
    ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$4,
    ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$4,
    ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$4,
    ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$4,
    ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$4,
    ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$4,
    ColorBrandPrimary10: ColorBrandPrimary10$4,
    ColorBrandPrimary20: ColorBrandPrimary20$4,
    ColorBrandPrimary30: ColorBrandPrimary30$4,
    ColorBrandPrimary40: ColorBrandPrimary40$4,
    ColorBrandPrimary50: ColorBrandPrimary50$4,
    ColorBrandPrimary60: ColorBrandPrimary60$4,
    ColorBrandPrimary70: ColorBrandPrimary70$4,
    ColorBrandPrimary80: ColorBrandPrimary80$4,
    ColorBrandPrimary90: ColorBrandPrimary90$4,
    ColorBrandPrimary100: ColorBrandPrimary100$4,
    ColorBrandPrimary110: ColorBrandPrimary110$4,
    ColorBrandPrimary120: ColorBrandPrimary120$4,
    ColorBrandPrimary130: ColorBrandPrimary130$3,
    ColorBrandPrimary140: ColorBrandPrimary140$3,
    ColorBrandPrimary150: ColorBrandPrimary150$3,
    ColorBrandPrimary160: ColorBrandPrimary160$3,
    ColorBrandBase01: ColorBrandBase01$4,
    ColorBrandBase02: ColorBrandBase02$4,
    ColorBrandBase03: ColorBrandBase03$3,
    ColorBrandBase04: ColorBrandBase04$3,
    ColorBrandBase05: ColorBrandBase05$3,
    ColorBrandBase06: ColorBrandBase06$1,
    ColorBrandPalette0110: ColorBrandPalette0110$3,
    ColorBrandPalette0120: ColorBrandPalette0120$3,
    ColorBrandPalette0130: ColorBrandPalette0130$3,
    ColorBrandPalette0140: ColorBrandPalette0140$3,
    ColorBrandPalette0150: ColorBrandPalette0150$3,
    ColorBrandPalette0160: ColorBrandPalette0160$3,
    ColorBrandPalette0170: ColorBrandPalette0170$3,
    ColorBrandPalette0180: ColorBrandPalette0180$3,
    ColorBrandPalette0190: ColorBrandPalette0190$3,
    ColorBrandPalette01100: ColorBrandPalette01100$3,
    ColorBrandPalette01110: ColorBrandPalette01110$3,
    ColorBrandPalette01120: ColorBrandPalette01120$3,
    ColorBrandPalette01130: ColorBrandPalette01130$3,
    ColorBrandPalette01140: ColorBrandPalette01140$3,
    ColorBrandPalette01150: ColorBrandPalette01150$3,
    ColorBrandPalette01160: ColorBrandPalette01160$3,
    ColorBrandPalette0210: ColorBrandPalette0210$3,
    ColorBrandPalette0220: ColorBrandPalette0220$3,
    ColorBrandPalette0230: ColorBrandPalette0230$3,
    ColorBrandPalette0240: ColorBrandPalette0240$3,
    ColorBrandPalette0250: ColorBrandPalette0250$3,
    ColorBrandPalette0260: ColorBrandPalette0260$3,
    ColorBrandPalette0270: ColorBrandPalette0270$3,
    ColorBrandPalette0280: ColorBrandPalette0280$3,
    ColorBrandPalette0290: ColorBrandPalette0290$3,
    ColorBrandPalette02100: ColorBrandPalette02100$3,
    ColorBrandPalette02110: ColorBrandPalette02110$3,
    ColorBrandPalette02120: ColorBrandPalette02120$3,
    ColorBrandPalette02130: ColorBrandPalette02130$3,
    ColorBrandPalette02140: ColorBrandPalette02140$3,
    ColorBrandPalette02150: ColorBrandPalette02150$3,
    ColorBrandPalette02160: ColorBrandPalette02160$3,
    ColorBrandPalette0310: ColorBrandPalette0310$1,
    ColorBrandPalette0320: ColorBrandPalette0320$1,
    ColorBrandPalette0330: ColorBrandPalette0330$1,
    ColorBrandPalette0340: ColorBrandPalette0340$1,
    ColorBrandPalette0350: ColorBrandPalette0350$1,
    ColorBrandPalette0360: ColorBrandPalette0360$1,
    ColorBrandPalette0370: ColorBrandPalette0370$1,
    ColorBrandPalette0380: ColorBrandPalette0380$1,
    ColorBrandPalette0390: ColorBrandPalette0390$1,
    ColorBrandPalette03100: ColorBrandPalette03100$1,
    ColorBrandPalette03110: ColorBrandPalette03110$1,
    ColorBrandPalette03120: ColorBrandPalette03120$1,
    ColorBrandPalette03130: ColorBrandPalette03130$1,
    ColorBrandPalette03140: ColorBrandPalette03140$1,
    ColorBrandPalette03150: ColorBrandPalette03150$1,
    ColorBrandPalette03160: ColorBrandPalette03160$1,
    ColorBrandPalette0410: ColorBrandPalette0410$2,
    ColorBrandPalette0420: ColorBrandPalette0420$2,
    ColorBrandPalette0430: ColorBrandPalette0430$2,
    ColorBrandPalette0440: ColorBrandPalette0440$2,
    ColorBrandPalette0450: ColorBrandPalette0450$2,
    ColorBrandPalette0460: ColorBrandPalette0460$2,
    ColorBrandPalette0470: ColorBrandPalette0470$2,
    ColorBrandPalette0480: ColorBrandPalette0480$2,
    ColorBrandPalette0490: ColorBrandPalette0490$2,
    ColorBrandPalette04100: ColorBrandPalette04100$2,
    ColorBrandPalette04110: ColorBrandPalette04110$2,
    ColorBrandPalette04120: ColorBrandPalette04120$2,
    ColorBrandPalette04130: ColorBrandPalette04130$2,
    ColorBrandPalette04140: ColorBrandPalette04140$2,
    ColorBrandPalette04150: ColorBrandPalette04150$2,
    ColorBrandPalette04160: ColorBrandPalette04160$2,
    ColorBrandPalette0610: ColorBrandPalette0610$1,
    ColorBrandPalette0620: ColorBrandPalette0620$1,
    ColorBrandPalette0630: ColorBrandPalette0630$1,
    ColorBrandPalette0640: ColorBrandPalette0640$1,
    ColorBrandPalette0650: ColorBrandPalette0650$1,
    ColorBrandPalette0660: ColorBrandPalette0660$1,
    ColorBrandPalette0670: ColorBrandPalette0670$1,
    ColorBrandPalette0680: ColorBrandPalette0680$1,
    ColorBrandPalette0690: ColorBrandPalette0690$1,
    ColorBrandPalette06100: ColorBrandPalette06100$1,
    ColorBrandPalette06110: ColorBrandPalette06110$1,
    ColorBrandPalette06120: ColorBrandPalette06120$1,
    ColorBrandPalette06130: ColorBrandPalette06130$1,
    ColorBrandPalette06140: ColorBrandPalette06140$1,
    ColorBrandPalette06150: ColorBrandPalette06150$1,
    ColorBrandPalette06160: ColorBrandPalette06160$1,
    ColorFeedbackErrorText: ColorFeedbackErrorText$4,
    ColorFeedbackErrorShape: ColorFeedbackErrorShape$4,
    ColorFeedbackSuccessText: ColorFeedbackSuccessText$4,
    ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$4,
    ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$4,
    ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$4,
    ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$4,
    ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$4,
    ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$4,
    ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$4,
    ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$4,
    ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$4,
    ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$4,
    ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$4,
    ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$4,
    ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$4,
    ColorSupport01: ColorSupport01$4,
    ColorSupport02: ColorSupport02$4,
    ColorSupportOnBrand01: ColorSupportOnBrand01$4,
    ColorSupportOnBrand02: ColorSupportOnBrand02$4,
    ColorSupportInverse01: ColorSupportInverse01$4,
    ColorSupportInverse02: ColorSupportInverse02$4,
    ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$4,
    ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$4,
    Opacity01: Opacity01$4,
    Opacity02: Opacity02$4,
    Opacity03: Opacity03$4,
    Opacity04: Opacity04$4,
    Opacity05: Opacity05$4,
    Opacity06: Opacity06$4,
    Opacity07: Opacity07$4,
    Opacity08: Opacity08$4,
    Opacity09: Opacity09$4,
    Shadow01: Shadow01$4,
    Shadow02: Shadow02$4,
    Shadow03: Shadow03$4,
    Shadow04: Shadow04$4,
    SpacingInlineQuark: SpacingInlineQuark$4,
    SpacingInlineNano: SpacingInlineNano$4,
    SpacingInlineXxxs: SpacingInlineXxxs$4,
    SpacingInlineXxs: SpacingInlineXxs$4,
    SpacingInlineXs: SpacingInlineXs$4,
    SpacingInlineSm: SpacingInlineSm$4,
    SpacingInlineMd: SpacingInlineMd$4,
    SpacingInlineLg: SpacingInlineLg$4,
    SpacingInlineXl: SpacingInlineXl$4,
    SpacingInlineXxl: SpacingInlineXxl$4,
    SpacingInlineXxxl: SpacingInlineXxxl$4,
    SpacingInlineHuge: SpacingInlineHuge$4,
    SpacingInlineGiant: SpacingInlineGiant$4,
    SpacingInsetQuark: SpacingInsetQuark$4,
    SpacingInsetNano: SpacingInsetNano$4,
    SpacingInsetXs: SpacingInsetXs$4,
    SpacingInsetSm: SpacingInsetSm$4,
    SpacingInsetMd: SpacingInsetMd$4,
    SpacingInsetLg: SpacingInsetLg$4,
    SpacingSquishQuark: SpacingSquishQuark$4,
    SpacingSquishNano: SpacingSquishNano$4,
    SpacingSquishXs: SpacingSquishXs$4,
    SpacingSquishSm: SpacingSquishSm$4,
    SpacingStackQuark: SpacingStackQuark$4,
    SpacingStackNano: SpacingStackNano$4,
    SpacingStackXxxs: SpacingStackXxxs$4,
    SpacingStackXxs: SpacingStackXxs$4,
    SpacingStackXs: SpacingStackXs$4,
    SpacingStackSm: SpacingStackSm$4,
    SpacingStackMd: SpacingStackMd$4,
    SpacingStackLg: SpacingStackLg$4,
    SpacingStackXl: SpacingStackXl$4,
    SpacingStackXxl: SpacingStackXxl$4,
    SpacingStackXxxl: SpacingStackXxxl$4,
    SpacingStackHuge: SpacingStackHuge$4,
    SpacingStackGiant: SpacingStackGiant$4,
    FontFamilyBase: FontFamilyBase$4,
    FontSizeXxxs: FontSizeXxxs$4,
    FontSizeXxs: FontSizeXxs$4,
    FontSizeXs: FontSizeXs$4,
    FontSizeSm: FontSizeSm$4,
    FontSizeMd: FontSizeMd$4,
    FontSizeLg: FontSizeLg$4,
    FontSizeXl: FontSizeXl$4,
    FontSizeXxl: FontSizeXxl$4,
    FontSizeXxxl: FontSizeXxxl$4,
    FontSizeDisplay: FontSizeDisplay$4,
    FontSizeGiant: FontSizeGiant$4,
    FontWeightBold: FontWeightBold$4,
    FontWeightSemibold: FontWeightSemibold$4,
    FontWeightMedium: FontWeightMedium$4,
    FontWeightRegular: FontWeightRegular$4,
    FontWeightLight: FontWeightLight$4,
    LetterSpacingStandard: LetterSpacingStandard$4,
    LetterSpacingSmall: LetterSpacingSmall$4,
    LetterSpacingMedium: LetterSpacingMedium$4,
    LineHeightStandard: LineHeightStandard$4,
    LineHeightTiny: LineHeightTiny$4,
    LineHeightMedium: LineHeightMedium$4,
    LineHeightLarge: LineHeightLarge$4,
    LineHeightDistant: LineHeightDistant$4,
    LineHeightSuperdistant: LineHeightSuperdistant$4,
    LineHeightHuge: LineHeightHuge$4
  });
  /**
   * Do not edit directly
   * Generated on Thu, 27 Oct 2022 18:07:47 GMT
   */

  var BorderRadiusNone$3 = "0px";
  var BorderRadiusXs$3 = "4px";
  var BorderRadiusSm$3 = "8px";
  var BorderRadiusMd$3 = "16px";
  var BorderRadiusLg$3 = "24px";
  var BorderRadiusPill$3 = "960px";
  var BorderRadiusCircle$3 = "50%";
  var BorderWidthNone$3 = "0px";
  var BorderWidthHairline$3 = "1px";
  var BorderWidthThin$3 = "2px";
  var BorderWidthThick$3 = "4px";
  var BorderWidthHeavy$3 = "8px";
  var ColorDatavizInfoText$3 = "#0F58EA";
  var ColorDatavizInfoShape01$3 = "#3F7BF2";
  var ColorDatavizInfoShape02$3 = "#D9E5FC";
  var ColorDatavizInfoShape03$3 = "#F1F5FE";
  var ColorDatavizNegativeText$3 = "#BC293A";
  var ColorDatavizNegativeShape01$3 = "#EA4356";
  var ColorDatavizNegativeShape02$3 = "#FDDDE1";
  var ColorDatavizNegativeShape03$3 = "#FEF1F2";
  var ColorDatavizWarningText$3 = "#A04C03";
  var ColorDatavizWarningShape01$3 = "#D26404";
  var ColorDatavizWarningShape02$3 = "#FEE1C8";
  var ColorDatavizWarningShape03$3 = "#FEF1E6";
  var ColorDatavizPositiveText$3 = "#22723A";
  var ColorDatavizPositiveShape01$3 = "#2D954C";
  var ColorDatavizPositiveShape02$3 = "#C8EED3";
  var ColorDatavizPositiveShape03$3 = "#E8F8EC";
  var ColorDatavizCatAText$3 = "#9B18DC";
  var ColorDatavizCatAShape01$3 = "#B851EC";
  var ColorDatavizCatAShape02$3 = "#F2DFFB";
  var ColorDatavizCatAShape03$3 = "#F9F1FD";
  var ColorDatavizCatBText$3 = "#BA267B";
  var ColorDatavizCatBShape01$3 = "#DA499B";
  var ColorDatavizCatBShape02$3 = "#F8DDEC";
  var ColorDatavizCatBShape03$3 = "#FCF2F8";
  var ColorDatavizCatCText$3 = "#546E21";
  var ColorDatavizCatCShape01$3 = "#6C8D2B";
  var ColorDatavizCatCShape02$3 = "#DBEBBD";
  var ColorDatavizCatCShape03$3 = "#F0F7E4";
  var ColorDatavizCatDText$3 = "#0D735E";
  var ColorDatavizCatDShape01$3 = "#109379";
  var ColorDatavizCatDShape02$3 = "#BCF0E6";
  var ColorDatavizCatDShape03$3 = "#DFFBF6";
  var ColorDatavizInverseInfoText$3 = "#5C8FF5";
  var ColorDatavizInverseInfoShape01$3 = "#286BF1";
  var ColorDatavizInverseInfoShape02$3 = "#062560";
  var ColorDatavizInverseInfoShape03$3 = "#051B48";
  var ColorDatavizInverseNegativeText$3 = "#F55C6E";
  var ColorDatavizInverseNegativeShape01$3 = "#D83145";
  var ColorDatavizInverseNegativeShape02$3 = "#4F1119";
  var ColorDatavizInverseNegativeShape03$3 = "#3B0D12";
  var ColorDatavizInverseWarningText$3 = "#EB7005";
  var ColorDatavizInverseWarningShape01$3 = "#B95804";
  var ColorDatavizInverseWarningShape02$3 = "#462101";
  var ColorDatavizInverseWarningShape03$3 = "#321701";
  var ColorDatavizInversePositiveText$3 = "#32A454";
  var ColorDatavizInversePositiveShape01$3 = "#278142";
  var ColorDatavizInversePositiveShape02$3 = "#0E2F18";
  var ColorDatavizInversePositiveShape03$3 = "#0B2312";
  var ColorDatavizInverseCatAText$3 = "#C36CEF";
  var ColorDatavizInverseCatAShape01$3 = "#AD35E9";
  var ColorDatavizInverseCatAShape02$3 = "#440B60";
  var ColorDatavizInverseCatAShape03$3 = "#340849";
  var ColorDatavizInverseCatBText$3 = "#E067AB";
  var ColorDatavizInverseCatBShape01$3 = "#D42B8C";
  var ColorDatavizInverseCatBShape02$3 = "#4C1032";
  var ColorDatavizInverseCatBShape03$3 = "#3B0C27";
  var ColorDatavizInverseCatCText$3 = "#789D2F";
  var ColorDatavizInverseCatCShape01$3 = "#607E26";
  var ColorDatavizInverseCatCShape02$3 = "#212B0D";
  var ColorDatavizInverseCatCShape03$3 = "#1B230B";
  var ColorDatavizInverseCatDText$3 = "#12A588";
  var ColorDatavizInverseCatDShape01$3 = "#0F856D";
  var ColorDatavizInverseCatDShape02$3 = "#052E26";
  var ColorDatavizInverseCatDShape03$3 = "#04251E";
  var ColorInteractionBlend01$3 = "#1616160A";
  var ColorInteractionBlend02$3 = "#16161614";
  var ColorInteractionBlend03$3 = "#1616161F";
  var ColorInteractionBlend04$3 = "#1616163D";
  var ColorInteractionBlend05$3 = "#161616A3";
  var ColorInteractionBlend06$3 = "#161616B8";
  var ColorInteractionBlend07$3 = "#161616E0";
  var ColorInteractionBlend08$3 = "#161616";
  var ColorInteractionInverseBlend01$3 = "#FEFEFE14";
  var ColorInteractionInverseBlend02$3 = "#FEFEFE1F";
  var ColorInteractionInverseBlend03$3 = "#FEFEFE3D";
  var ColorInteractionInverseBlend04$3 = "#FEFEFE52";
  var ColorInteractionInverseBlend05$3 = "#FEFEFEA3";
  var ColorInteractionInverseBlend06$3 = "#FEFEFEB8";
  var ColorInteractionInverseBlend07$3 = "#FEFEFEE0";
  var ColorInteractionInverseBlend08$3 = "#FEFEFE";
  var ColorInteractionInverseAccent01$3 = "#6B8BFF";
  var ColorInteractionInverseAccent02$3 = "#809BFF";
  var ColorInteractionInverseAccent03$3 = "#99AFFF";
  var ColorInteractionInverseSubtle01$3 = "#5277FF1F";
  var ColorInteractionInverseSubtle02$3 = "#5277FF3D";
  var ColorInteractionInverseSubtle03$3 = "#5277FF52";
  var ColorInteractionInverseSelectDefault$3 = "#919191";
  var ColorInteractionInverseSelectFocus$3 = "#D4D4D4";
  var ColorInteractionInverseSelectActive$3 = "#E368A0";
  var ColorInteractionInverseDanger01$3 = "#F55C6E";
  var ColorInteractionInverseDanger02$3 = "#F77E8C";
  var ColorInteractionInverseDanger03$3 = "#F895A1";
  var ColorInteractionInverseOnBrandAccent01$3 = "#000E40";
  var ColorInteractionInverseOnBrandAccent02$3 = "#001A7A";
  var ColorInteractionInverseOnBrandAccent03$3 = "#00229E";
  var ColorInteractionInverseOnBrandSubtle01$3 = "#002FDB14";
  var ColorInteractionInverseOnBrandSubtle02$3 = "#002FDB1F";
  var ColorInteractionInverseOnBrandSubtle03$3 = "#002FDB3D";
  var ColorInteractionInverseOnBrandSelectDefault$3 = "#595959";
  var ColorInteractionInverseOnBrandSelectFocus$3 = "#404040";
  var ColorInteractionInverseOnBrandSelectActive$3 = "#A81F5D";
  var ColorInteractionInverseOnBrandBlend01$3 = "#1616160A";
  var ColorInteractionInverseOnBrandBlend02$3 = "#16161614";
  var ColorInteractionInverseOnBrandBlend03$3 = "#1616161F";
  var ColorInteractionInverseOnBrandBlend04$3 = "#1616163D";
  var ColorInteractionInverseOnBrandBlend05$3 = "#161616A3";
  var ColorInteractionInverseOnBrandBlend06$3 = "#161616B8";
  var ColorInteractionInverseOnBrandBlend07$3 = "#161616E0";
  var ColorInteractionInverseOnBrandBlend08$3 = "#161616";
  var ColorInteractionInverseOnBrandDanger01$3 = "#A72534";
  var ColorInteractionInverseOnBrandDanger02$3 = "#92202E";
  var ColorInteractionInverseOnBrandDanger03$3 = "#7E1B27";
  var ColorInteractionAccent01$3 = "#000E40";
  var ColorInteractionAccent02$3 = "#001A7A";
  var ColorInteractionAccent03$3 = "#00229E";
  var ColorInteractionSubtle01$3 = "#0029BD1F";
  var ColorInteractionSubtle02$3 = "#0029BD3D";
  var ColorInteractionSubtle03$3 = "#0029BD52";
  var ColorInteractionSelectDefault$3 = "#666666";
  var ColorInteractionSelectFocus$3 = "#363636";
  var ColorInteractionSelectActive$3 = "#BE2368";
  var ColorInteractionDanger01$3 = "#BC293A";
  var ColorInteractionDanger02$3 = "#A72534";
  var ColorInteractionDanger03$3 = "#92202E";
  var ColorInteractionOnBrandAccent01$3 = "#ADBFFF";
  var ColorInteractionOnBrandAccent02$3 = "#99AFFF";
  var ColorInteractionOnBrandAccent03$3 = "#809BFF";
  var ColorInteractionOnBrandSubtle01$3 = "#5277FF1F";
  var ColorInteractionOnBrandSubtle02$3 = "#5277FF3D";
  var ColorInteractionOnBrandSubtle03$3 = "#5277FF52";
  var ColorInteractionOnBrandSelectDefault$3 = "#B0B0B0";
  var ColorInteractionOnBrandSelectFocus$3 = "#D4D4D4";
  var ColorInteractionOnBrandSelectActive$3 = "#E882B0";
  var ColorInteractionOnBrandBlend01$3 = "#FEFEFE14";
  var ColorInteractionOnBrandBlend02$3 = "#FEFEFE1F";
  var ColorInteractionOnBrandBlend03$3 = "#FEFEFE3D";
  var ColorInteractionOnBrandBlend04$3 = "#FEFEFE52";
  var ColorInteractionOnBrandBlend05$3 = "#FEFEFEA3";
  var ColorInteractionOnBrandBlend06$3 = "#FEFEFEB8";
  var ColorInteractionOnBrandBlend07$3 = "#FEFEFEE0";
  var ColorInteractionOnBrandBlend08$3 = "#FEFEFE";
  var ColorInteractionOnBrandDanger01$3 = "#F77E8C";
  var ColorInteractionOnBrandDanger02$3 = "#F895A1";
  var ColorInteractionOnBrandDanger03$3 = "#FAAEB6";
  var ColorNeutral10$3 = "#F5F5F5";
  var ColorNeutral20$3 = "#E6E6E6";
  var ColorNeutral30$3 = "#1616163D";
  var ColorNeutral00$3 = "#FEFEFE";
  var ColorNeutralInverse10$3 = "#1F1F1F";
  var ColorNeutralInverse20$3 = "#292929";
  var ColorNeutralInverse30$3 = "#FEFEFE3D";
  var ColorNeutralInverse00$3 = "#161616";
  var ColorNeutralInverseOnBrand10$3 = "#DBE3FF";
  var ColorNeutralInverseOnBrand20$3 = "#C7D3FF";
  var ColorNeutralInverseOnBrand30$3 = "#0029BD52";
  var ColorNeutralInverseOnBrand00$3 = "#F0F3FF";
  var ColorNeutralOnBrand10$3 = "#001A7A";
  var ColorNeutralOnBrand20$3 = "#00229E";
  var ColorNeutralOnBrand30$3 = "#5277FFA3";
  var ColorNeutralOnBrand00$3 = "#000E40";
  var ColorPaletteBlack$3 = "#161616";
  var ColorPaletteWhite$3 = "#FEFEFE";
  var ColorPaletteGray10$3 = "#1F1F1F";
  var ColorPaletteGray20$3 = "#292929";
  var ColorPaletteGray30$3 = "#363636";
  var ColorPaletteGray40$3 = "#404040";
  var ColorPaletteGray50$3 = "#4C4C4C";
  var ColorPaletteGray60$3 = "#595959";
  var ColorPaletteGray70$3 = "#666666";
  var ColorPaletteGray80$3 = "#737373";
  var ColorPaletteGray90$3 = "#828282";
  var ColorPaletteGray100$3 = "#919191";
  var ColorPaletteGray110$3 = "#A1A1A1";
  var ColorPaletteGray120$3 = "#B0B0B0";
  var ColorPaletteGray130$3 = "#C2C2C2";
  var ColorPaletteGray140$3 = "#D4D4D4";
  var ColorPaletteGray150$3 = "#E6E6E6";
  var ColorPaletteGray160$3 = "#F5F5F5";
  var ColorPaletteRed10$3 = "#3B0D12";
  var ColorPaletteRed20$3 = "#4F1119";
  var ColorPaletteRed30$3 = "#691721";
  var ColorPaletteRed40$3 = "#7E1B27";
  var ColorPaletteRed50$3 = "#92202E";
  var ColorPaletteRed60$3 = "#A72534";
  var ColorPaletteRed70$3 = "#BC293A";
  var ColorPaletteRed80$3 = "#D83145";
  var ColorPaletteRed90$3 = "#EA4356";
  var ColorPaletteRed100$3 = "#F55C6E";
  var ColorPaletteRed110$3 = "#F77E8C";
  var ColorPaletteRed120$3 = "#F895A1";
  var ColorPaletteRed130$3 = "#FAAEB6";
  var ColorPaletteRed140$3 = "#FBC5CC";
  var ColorPaletteRed150$3 = "#FDDDE1";
  var ColorPaletteRed160$3 = "#FEF1F2";
  var ColorPaletteYellow10$3 = "#321701";
  var ColorPaletteYellow20$3 = "#462101";
  var ColorPaletteYellow30$3 = "#552802";
  var ColorPaletteYellow40$3 = "#693102";
  var ColorPaletteYellow50$3 = "#7D3B03";
  var ColorPaletteYellow60$3 = "#914503";
  var ColorPaletteYellow70$3 = "#A04C03";
  var ColorPaletteYellow80$3 = "#B95804";
  var ColorPaletteYellow90$3 = "#D26404";
  var ColorPaletteYellow100$3 = "#EB7005";
  var ColorPaletteYellow110$3 = "#FA8219";
  var ColorPaletteYellow120$3 = "#FB9B46";
  var ColorPaletteYellow130$3 = "#FCB06E";
  var ColorPaletteYellow140$3 = "#FDC99B";
  var ColorPaletteYellow150$3 = "#FEE1C8";
  var ColorPaletteYellow160$3 = "#FEF1E6";
  var ColorPaletteLime10$3 = "#1B230B";
  var ColorPaletteLime20$3 = "#212B0D";
  var ColorPaletteLime30$3 = "#2D3B12";
  var ColorPaletteLime40$3 = "#364616";
  var ColorPaletteLime50$3 = "#3F5219";
  var ColorPaletteLime60$3 = "#485E1D";
  var ColorPaletteLime70$3 = "#546E21";
  var ColorPaletteLime80$3 = "#607E26";
  var ColorPaletteLime90$3 = "#6C8D2B";
  var ColorPaletteLime100$3 = "#789D2F";
  var ColorPaletteLime110$3 = "#84AC34";
  var ColorPaletteLime120$3 = "#93BF3A";
  var ColorPaletteLime130$3 = "#A9CF5E";
  var ColorPaletteLime140$3 = "#C2DD8D";
  var ColorPaletteLime150$3 = "#DBEBBD";
  var ColorPaletteLime160$3 = "#F0F7E4";
  var ColorPaletteGreen10$3 = "#0B2312";
  var ColorPaletteGreen20$3 = "#0E2F18";
  var ColorPaletteGreen30$3 = "#133E20";
  var ColorPaletteGreen40$3 = "#174A26";
  var ColorPaletteGreen50$3 = "#1A562C";
  var ColorPaletteGreen60$3 = "#1F6634";
  var ColorPaletteGreen70$3 = "#22723A";
  var ColorPaletteGreen80$3 = "#278142";
  var ColorPaletteGreen90$3 = "#2D954C";
  var ColorPaletteGreen100$3 = "#32A454";
  var ColorPaletteGreen110$3 = "#38B85E";
  var ColorPaletteGreen120$3 = "#4BC870";
  var ColorPaletteGreen130$3 = "#76D692";
  var ColorPaletteGreen140$3 = "#9DE2B1";
  var ColorPaletteGreen150$3 = "#C8EED3";
  var ColorPaletteGreen160$3 = "#E8F8EC";
  var ColorPaletteAcqua10$3 = "#04251E";
  var ColorPaletteAcqua20$3 = "#052E26";
  var ColorPaletteAcqua30$3 = "#073C31";
  var ColorPaletteAcqua40$3 = "#08493C";
  var ColorPaletteAcqua50$3 = "#0A5748";
  var ColorPaletteAcqua60$3 = "#0B6553";
  var ColorPaletteAcqua70$3 = "#0D735E";
  var ColorPaletteAcqua80$3 = "#0F856D";
  var ColorPaletteAcqua90$3 = "#109379";
  var ColorPaletteAcqua100$3 = "#12A588";
  var ColorPaletteAcqua110$3 = "#14B897";
  var ColorPaletteAcqua120$3 = "#31C4A6";
  var ColorPaletteAcqua130$3 = "#68D4BF";
  var ColorPaletteAcqua140$3 = "#8DE2D1";
  var ColorPaletteAcqua150$3 = "#BCF0E6";
  var ColorPaletteAcqua160$3 = "#DFFBF6";
  var ColorPaletteBlue10$3 = "#051B48";
  var ColorPaletteBlue20$3 = "#062560";
  var ColorPaletteBlue30$3 = "#082F7D";
  var ColorPaletteBlue40$3 = "#0A3A9A";
  var ColorPaletteBlue50$3 = "#0B43B1";
  var ColorPaletteBlue60$3 = "#0D4ECE";
  var ColorPaletteBlue70$3 = "#0F58EA";
  var ColorPaletteBlue80$3 = "#286BF1";
  var ColorPaletteBlue90$3 = "#3F7BF2";
  var ColorPaletteBlue100$3 = "#5C8FF5";
  var ColorPaletteBlue110$3 = "#73A0F7";
  var ColorPaletteBlue120$3 = "#8CB0F8";
  var ColorPaletteBlue130$3 = "#A9C4F9";
  var ColorPaletteBlue140$3 = "#C1D4FB";
  var ColorPaletteBlue150$3 = "#D9E5FC";
  var ColorPaletteBlue160$3 = "#F1F5FE";
  var ColorPalettePurple10$3 = "#340849";
  var ColorPalettePurple20$3 = "#440B60";
  var ColorPalettePurple30$3 = "#540D78";
  var ColorPalettePurple40$3 = "#671093";
  var ColorPalettePurple50$3 = "#7713AA";
  var ColorPalettePurple60$3 = "#8B16C5";
  var ColorPalettePurple70$3 = "#9B18DC";
  var ColorPalettePurple80$3 = "#AD35E9";
  var ColorPalettePurple90$3 = "#B851EC";
  var ColorPalettePurple100$3 = "#C36CEF";
  var ColorPalettePurple110$3 = "#CC83F1";
  var ColorPalettePurple120$3 = "#D69AF4";
  var ColorPalettePurple130$3 = "#DFB1F6";
  var ColorPalettePurple140$3 = "#E8C8F9";
  var ColorPalettePurple150$3 = "#F2DFFB";
  var ColorPalettePurple160$3 = "#F9F1FD";
  var ColorPalettePink10$3 = "#3B0C27";
  var ColorPalettePink20$3 = "#4C1032";
  var ColorPalettePink30$3 = "#661543";
  var ColorPalettePink40$3 = "#77184E";
  var ColorPalettePink50$3 = "#8C1C5D";
  var ColorPalettePink60$3 = "#A12169";
  var ColorPalettePink70$3 = "#BA267B";
  var ColorPalettePink80$3 = "#D42B8C";
  var ColorPalettePink90$3 = "#DA499B";
  var ColorPalettePink100$3 = "#E067AB";
  var ColorPalettePink110$3 = "#E580B9";
  var ColorPalettePink120$3 = "#EA99C7";
  var ColorPalettePink130$3 = "#EFAFD3";
  var ColorPalettePink140$3 = "#F4C8E1";
  var ColorPalettePink150$3 = "#F8DDEC";
  var ColorPalettePink160$3 = "#FCF2F8";
  var ColorTypefaceStrong$3 = "#161616";
  var ColorTypefacePure$3 = "#363636";
  var ColorTypefaceSmooth$3 = "#666666";
  var ColorTypefaceMeld$3 = "#1616163D";
  var ColorTypefaceInverseStrong$3 = "#FEFEFE";
  var ColorTypefaceInversePure$3 = "#D4D4D4";
  var ColorTypefaceInverseSmooth$3 = "#919191";
  var ColorTypefaceInverseMeld$3 = "#FEFEFE52";
  var ColorTypefaceInverseOnBrandStrong$3 = "#161616";
  var ColorTypefaceInverseOnBrandPure$3 = "#363636";
  var ColorTypefaceInverseOnBrandSmooth$3 = "#595959";
  var ColorTypefaceInverseOnBrandMeld$3 = "#1616163D";
  var ColorTypefaceOnBrandStrong$3 = "#FEFEFE";
  var ColorTypefaceOnBrandPure$3 = "#DBE3FF";
  var ColorTypefaceOnBrandSmooth$3 = "#C7D3FF";
  var ColorTypefaceOnBrandMeld$3 = "#FEFEFE52";
  var ColorBrandPrimary10$3 = "#000E40";
  var ColorBrandPrimary20$3 = "#001A7A";
  var ColorBrandPrimary30$3 = "#00229E";
  var ColorBrandPrimary40$3 = "#0029BD";
  var ColorBrandPrimary50$3 = "#002FDB";
  var ColorBrandPrimary60$3 = "#0037FF";
  var ColorBrandPrimary70$3 = "#1F4FFF";
  var ColorBrandPrimary80$3 = "#3863FF";
  var ColorBrandPrimary90$3 = "#5277FF";
  var ColorBrandPrimary100$3 = "#6B8BFF";
  var ColorBrandPrimary110$3 = "#809BFF";
  var ColorBrandPrimary120$3 = "#99AFFF";
  var ColorBrandPrimary130$2 = "#ADBFFF";
  var ColorBrandPrimary140$2 = "#C7D3FF";
  var ColorBrandPrimary150$2 = "#DBE3FF";
  var ColorBrandPrimary160$2 = "#F0F3FF";
  var ColorBrandBase01$3 = "#000E40";
  var ColorBrandBase02$3 = "#D82777";
  var ColorBrandBase03$2 = "#A6E1FF";
  var ColorBrandBase04$2 = "#0037FF";
  var ColorBrandBase05$2 = "#D8BD97";
  var ColorBrandPalette0110$2 = "#000E40";
  var ColorBrandPalette0120$2 = "#001A7A";
  var ColorBrandPalette0130$2 = "#00229E";
  var ColorBrandPalette0140$2 = "#0029BD";
  var ColorBrandPalette0150$2 = "#002FDB";
  var ColorBrandPalette0160$2 = "#0037FF";
  var ColorBrandPalette0170$2 = "#1F4FFF";
  var ColorBrandPalette0180$2 = "#3863FF";
  var ColorBrandPalette0190$2 = "#5277FF";
  var ColorBrandPalette01100$2 = "#6B8BFF";
  var ColorBrandPalette01110$2 = "#809BFF";
  var ColorBrandPalette01120$2 = "#99AFFF";
  var ColorBrandPalette01130$2 = "#ADBFFF";
  var ColorBrandPalette01140$2 = "#C7D3FF";
  var ColorBrandPalette01150$2 = "#DBE3FF";
  var ColorBrandPalette01160$2 = "#F0F3FF";
  var ColorBrandPalette0210$2 = "#3C0B21";
  var ColorBrandPalette0220$2 = "#520F2D";
  var ColorBrandPalette0230$2 = "#671339";
  var ColorBrandPalette0240$2 = "#7D1745";
  var ColorBrandPalette0250$2 = "#931B51";
  var ColorBrandPalette0260$2 = "#A81F5D";
  var ColorBrandPalette0270$2 = "#BE2368";
  var ColorBrandPalette0280$2 = "#D82777";
  var ColorBrandPalette0290$2 = "#DE4A8C";
  var ColorBrandPalette02100$2 = "#E368A0";
  var ColorBrandPalette02110$2 = "#E882B0";
  var ColorBrandPalette02120$2 = "#EC98BE";
  var ColorBrandPalette02130$2 = "#F1B1CE";
  var ColorBrandPalette02140$2 = "#F5C7DC";
  var ColorBrandPalette02150$2 = "#F9DDE9";
  var ColorBrandPalette02160$2 = "#FDF2F7";
  var ColorBrandPalette0310 = "#002233";
  var ColorBrandPalette0320 = "#002C42";
  var ColorBrandPalette0330 = "#073B54";
  var ColorBrandPalette0340 = "#004466";
  var ColorBrandPalette0350 = "#00527A";
  var ColorBrandPalette0360 = "#005F8F";
  var ColorBrandPalette0370 = "#00699E";
  var ColorBrandPalette0380 = "#007AB8";
  var ColorBrandPalette0390 = "#0088CC";
  var ColorBrandPalette03100 = "#0099E5";
  var ColorBrandPalette03110 = "#00AAFF";
  var ColorBrandPalette03120 = "#38BDFF";
  var ColorBrandPalette03130 = "#6BCEFF";
  var ColorBrandPalette03140 = "#A6E1FF";
  var ColorBrandPalette03150 = "#C7ECFF";
  var ColorBrandPalette03160 = "#EBF8FF";
  var ColorBrandPalette0410$1 = "#001561";
  var ColorBrandPalette0420$1 = "#001A7A";
  var ColorBrandPalette0430$1 = "#00229E";
  var ColorBrandPalette0440$1 = "#0029BD";
  var ColorBrandPalette0450$1 = "#002FDB";
  var ColorBrandPalette0460$1 = "#0037FF";
  var ColorBrandPalette0470$1 = "#1F4FFF";
  var ColorBrandPalette0480$1 = "#3863FF";
  var ColorBrandPalette0490$1 = "#5277FF";
  var ColorBrandPalette04100$1 = "#6B8BFF";
  var ColorBrandPalette04110$1 = "#809BFF";
  var ColorBrandPalette04120$1 = "#99AFFF";
  var ColorBrandPalette04130$1 = "#ADBFFF";
  var ColorBrandPalette04140$1 = "#C7D3FF";
  var ColorBrandPalette04150$1 = "#DBE3FF";
  var ColorBrandPalette04160$1 = "#F0F3FF";
  var ColorBrandPalette0510$1 = "#251B0E";
  var ColorBrandPalette0520$1 = "#342614";
  var ColorBrandPalette0530$1 = "#433119";
  var ColorBrandPalette0540$1 = "#513C1F";
  var ColorBrandPalette0550$1 = "#604724";
  var ColorBrandPalette0560$1 = "#73552B";
  var ColorBrandPalette0570$1 = "#816031";
  var ColorBrandPalette0580$1 = "#946E38";
  var ColorBrandPalette0590$1 = "#A3793E";
  var ColorBrandPalette05100$1 = "#B98946";
  var ColorBrandPalette05110$1 = "#C39A60";
  var ColorBrandPalette05120$1 = "#CEAC7E";
  var ColorBrandPalette05130$1 = "#D8BD97";
  var ColorBrandPalette05140$1 = "#E3D0B5";
  var ColorBrandPalette05150$1 = "#EEE3D3";
  var ColorBrandPalette05160$1 = "#F8F3EC";
  var ColorFeedbackErrorText$3 = "#BC293A";
  var ColorFeedbackErrorShape$3 = "#EA4356";
  var ColorFeedbackSuccessText$3 = "#22723A";
  var ColorFeedbackSuccessShape$3 = "#2D954C";
  var ColorFeedbackOnBrandErrorText$3 = "#F77E8C";
  var ColorFeedbackOnBrandErrorShape$3 = "#EA4356";
  var ColorFeedbackOnBrandSuccessText$3 = "#38B85E";
  var ColorFeedbackOnBrandSuccessShape$3 = "#2D954C";
  var ColorFeedbackInverseErrorText$3 = "#F55C6E";
  var ColorFeedbackInverseErrorShape$3 = "#D83145";
  var ColorFeedbackInverseSuccessText$3 = "#32A454";
  var ColorFeedbackInverseSuccessShape$3 = "#278142";
  var ColorFeedbackInverseOnBrandErrorText$3 = "#A72534";
  var ColorFeedbackInverseOnBrandErrorShape$3 = "#D83145";
  var ColorFeedbackInverseOnBrandSuccessText$3 = "#1F6634";
  var ColorFeedbackInverseOnBrandSuccessShape$3 = "#278142";
  var ColorSupport01$3 = "#D82777";
  var ColorSupport02$3 = "#D82777";
  var ColorSupportOnBrand01$3 = "#D82777";
  var ColorSupportOnBrand02$3 = "#DE4A8C";
  var ColorSupportInverse01$3 = "#D82777";
  var ColorSupportInverse02$3 = "#D82777";
  var ColorSupportInverseOnBrand01$3 = "#D82777";
  var ColorSupportInverseOnBrand02$3 = "#D82777";
  var Opacity01$3 = "0.04";
  var Opacity02$3 = "0.08";
  var Opacity03$3 = "0.12";
  var Opacity04$3 = "0.24";
  var Opacity05$3 = "0.32";
  var Opacity06$3 = "0.56";
  var Opacity07$3 = "0.64";
  var Opacity08$3 = "0.72";
  var Opacity09$3 = "0.88";
  var Shadow01$3 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
  var Shadow02$3 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
  var Shadow03$3 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
  var Shadow04$3 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
  var SpacingInlineQuark$3 = "4px";
  var SpacingInlineNano$3 = "8px";
  var SpacingInlineXxxs$3 = "16px";
  var SpacingInlineXxs$3 = "24px";
  var SpacingInlineXs$3 = "32px";
  var SpacingInlineSm$3 = "40px";
  var SpacingInlineMd$3 = "48px";
  var SpacingInlineLg$3 = "56px";
  var SpacingInlineXl$3 = "64px";
  var SpacingInlineXxl$3 = "80px";
  var SpacingInlineXxxl$3 = "120px";
  var SpacingInlineHuge$3 = "160px";
  var SpacingInlineGiant$3 = "200px";
  var SpacingInsetQuark$3 = "4px";
  var SpacingInsetNano$3 = "8px";
  var SpacingInsetXs$3 = "16px";
  var SpacingInsetSm$3 = "24px";
  var SpacingInsetMd$3 = "32px";
  var SpacingInsetLg$3 = "40px";
  var SpacingSquishQuark$3 = "4px 8px";
  var SpacingSquishNano$3 = "8px 16px";
  var SpacingSquishXs$3 = "16px 24px";
  var SpacingSquishSm$3 = "16px 32px";
  var SpacingStackQuark$3 = "4px";
  var SpacingStackNano$3 = "8px";
  var SpacingStackXxxs$3 = "16px";
  var SpacingStackXxs$3 = "24px";
  var SpacingStackXs$3 = "32px";
  var SpacingStackSm$3 = "40px";
  var SpacingStackMd$3 = "48px";
  var SpacingStackLg$3 = "56px";
  var SpacingStackXl$3 = "64px";
  var SpacingStackXxl$3 = "80px";
  var SpacingStackXxxl$3 = "120px";
  var SpacingStackHuge$3 = "160px";
  var SpacingStackGiant$3 = "200px";
  var FontFamilyBase$3 = "'Dasa Sans', 'sans-serif'";
  var FontSizeXxxs$3 = "0.75rem";
  var FontSizeXxs$3 = "0.875rem";
  var FontSizeXs$3 = "1rem";
  var FontSizeSm$3 = "1.25rem";
  var FontSizeMd$3 = "1.5rem";
  var FontSizeLg$3 = "2rem";
  var FontSizeXl$3 = "2.5rem";
  var FontSizeXxl$3 = "3rem";
  var FontSizeXxxl$3 = "4rem";
  var FontSizeDisplay$3 = "5rem";
  var FontSizeGiant$3 = "6rem";
  var FontWeightBold$3 = 700;
  var FontWeightSemibold$3 = 600;
  var FontWeightMedium$3 = 500;
  var FontWeightRegular$3 = 400;
  var FontWeightLight$3 = 300;
  var LetterSpacingStandard$3 = "0px";
  var LetterSpacingSmall$3 = "-1px";
  var LetterSpacingMedium$3 = "1.5px";
  var LineHeightStandard$3 = "100%";
  var LineHeightTiny$3 = "115%";
  var LineHeightMedium$3 = "120%";
  var LineHeightLarge$3 = "125%";
  var LineHeightDistant$3 = "133%";
  var LineHeightSuperdistant$3 = "150%";
  var LineHeightHuge$3 = "170%";
  var index$3 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BorderRadiusNone: BorderRadiusNone$3,
    BorderRadiusXs: BorderRadiusXs$3,
    BorderRadiusSm: BorderRadiusSm$3,
    BorderRadiusMd: BorderRadiusMd$3,
    BorderRadiusLg: BorderRadiusLg$3,
    BorderRadiusPill: BorderRadiusPill$3,
    BorderRadiusCircle: BorderRadiusCircle$3,
    BorderWidthNone: BorderWidthNone$3,
    BorderWidthHairline: BorderWidthHairline$3,
    BorderWidthThin: BorderWidthThin$3,
    BorderWidthThick: BorderWidthThick$3,
    BorderWidthHeavy: BorderWidthHeavy$3,
    ColorDatavizInfoText: ColorDatavizInfoText$3,
    ColorDatavizInfoShape01: ColorDatavizInfoShape01$3,
    ColorDatavizInfoShape02: ColorDatavizInfoShape02$3,
    ColorDatavizInfoShape03: ColorDatavizInfoShape03$3,
    ColorDatavizNegativeText: ColorDatavizNegativeText$3,
    ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$3,
    ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$3,
    ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$3,
    ColorDatavizWarningText: ColorDatavizWarningText$3,
    ColorDatavizWarningShape01: ColorDatavizWarningShape01$3,
    ColorDatavizWarningShape02: ColorDatavizWarningShape02$3,
    ColorDatavizWarningShape03: ColorDatavizWarningShape03$3,
    ColorDatavizPositiveText: ColorDatavizPositiveText$3,
    ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$3,
    ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$3,
    ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$3,
    ColorDatavizCatAText: ColorDatavizCatAText$3,
    ColorDatavizCatAShape01: ColorDatavizCatAShape01$3,
    ColorDatavizCatAShape02: ColorDatavizCatAShape02$3,
    ColorDatavizCatAShape03: ColorDatavizCatAShape03$3,
    ColorDatavizCatBText: ColorDatavizCatBText$3,
    ColorDatavizCatBShape01: ColorDatavizCatBShape01$3,
    ColorDatavizCatBShape02: ColorDatavizCatBShape02$3,
    ColorDatavizCatBShape03: ColorDatavizCatBShape03$3,
    ColorDatavizCatCText: ColorDatavizCatCText$3,
    ColorDatavizCatCShape01: ColorDatavizCatCShape01$3,
    ColorDatavizCatCShape02: ColorDatavizCatCShape02$3,
    ColorDatavizCatCShape03: ColorDatavizCatCShape03$3,
    ColorDatavizCatDText: ColorDatavizCatDText$3,
    ColorDatavizCatDShape01: ColorDatavizCatDShape01$3,
    ColorDatavizCatDShape02: ColorDatavizCatDShape02$3,
    ColorDatavizCatDShape03: ColorDatavizCatDShape03$3,
    ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$3,
    ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$3,
    ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$3,
    ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$3,
    ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$3,
    ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$3,
    ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$3,
    ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$3,
    ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$3,
    ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$3,
    ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$3,
    ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$3,
    ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$3,
    ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$3,
    ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$3,
    ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$3,
    ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$3,
    ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$3,
    ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$3,
    ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$3,
    ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$3,
    ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$3,
    ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$3,
    ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$3,
    ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$3,
    ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$3,
    ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$3,
    ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$3,
    ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$3,
    ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$3,
    ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$3,
    ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$3,
    ColorInteractionBlend01: ColorInteractionBlend01$3,
    ColorInteractionBlend02: ColorInteractionBlend02$3,
    ColorInteractionBlend03: ColorInteractionBlend03$3,
    ColorInteractionBlend04: ColorInteractionBlend04$3,
    ColorInteractionBlend05: ColorInteractionBlend05$3,
    ColorInteractionBlend06: ColorInteractionBlend06$3,
    ColorInteractionBlend07: ColorInteractionBlend07$3,
    ColorInteractionBlend08: ColorInteractionBlend08$3,
    ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$3,
    ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$3,
    ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$3,
    ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$3,
    ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$3,
    ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$3,
    ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$3,
    ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$3,
    ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$3,
    ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$3,
    ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$3,
    ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$3,
    ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$3,
    ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$3,
    ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$3,
    ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$3,
    ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$3,
    ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$3,
    ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$3,
    ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$3,
    ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$3,
    ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$3,
    ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$3,
    ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$3,
    ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$3,
    ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$3,
    ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$3,
    ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$3,
    ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$3,
    ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$3,
    ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$3,
    ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$3,
    ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$3,
    ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$3,
    ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$3,
    ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$3,
    ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$3,
    ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$3,
    ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$3,
    ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$3,
    ColorInteractionAccent01: ColorInteractionAccent01$3,
    ColorInteractionAccent02: ColorInteractionAccent02$3,
    ColorInteractionAccent03: ColorInteractionAccent03$3,
    ColorInteractionSubtle01: ColorInteractionSubtle01$3,
    ColorInteractionSubtle02: ColorInteractionSubtle02$3,
    ColorInteractionSubtle03: ColorInteractionSubtle03$3,
    ColorInteractionSelectDefault: ColorInteractionSelectDefault$3,
    ColorInteractionSelectFocus: ColorInteractionSelectFocus$3,
    ColorInteractionSelectActive: ColorInteractionSelectActive$3,
    ColorInteractionDanger01: ColorInteractionDanger01$3,
    ColorInteractionDanger02: ColorInteractionDanger02$3,
    ColorInteractionDanger03: ColorInteractionDanger03$3,
    ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$3,
    ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$3,
    ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$3,
    ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$3,
    ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$3,
    ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$3,
    ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$3,
    ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$3,
    ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$3,
    ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$3,
    ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$3,
    ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$3,
    ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$3,
    ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$3,
    ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$3,
    ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$3,
    ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$3,
    ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$3,
    ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$3,
    ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$3,
    ColorNeutral10: ColorNeutral10$3,
    ColorNeutral20: ColorNeutral20$3,
    ColorNeutral30: ColorNeutral30$3,
    ColorNeutral00: ColorNeutral00$3,
    ColorNeutralInverse10: ColorNeutralInverse10$3,
    ColorNeutralInverse20: ColorNeutralInverse20$3,
    ColorNeutralInverse30: ColorNeutralInverse30$3,
    ColorNeutralInverse00: ColorNeutralInverse00$3,
    ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$3,
    ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$3,
    ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$3,
    ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$3,
    ColorNeutralOnBrand10: ColorNeutralOnBrand10$3,
    ColorNeutralOnBrand20: ColorNeutralOnBrand20$3,
    ColorNeutralOnBrand30: ColorNeutralOnBrand30$3,
    ColorNeutralOnBrand00: ColorNeutralOnBrand00$3,
    ColorPaletteBlack: ColorPaletteBlack$3,
    ColorPaletteWhite: ColorPaletteWhite$3,
    ColorPaletteGray10: ColorPaletteGray10$3,
    ColorPaletteGray20: ColorPaletteGray20$3,
    ColorPaletteGray30: ColorPaletteGray30$3,
    ColorPaletteGray40: ColorPaletteGray40$3,
    ColorPaletteGray50: ColorPaletteGray50$3,
    ColorPaletteGray60: ColorPaletteGray60$3,
    ColorPaletteGray70: ColorPaletteGray70$3,
    ColorPaletteGray80: ColorPaletteGray80$3,
    ColorPaletteGray90: ColorPaletteGray90$3,
    ColorPaletteGray100: ColorPaletteGray100$3,
    ColorPaletteGray110: ColorPaletteGray110$3,
    ColorPaletteGray120: ColorPaletteGray120$3,
    ColorPaletteGray130: ColorPaletteGray130$3,
    ColorPaletteGray140: ColorPaletteGray140$3,
    ColorPaletteGray150: ColorPaletteGray150$3,
    ColorPaletteGray160: ColorPaletteGray160$3,
    ColorPaletteRed10: ColorPaletteRed10$3,
    ColorPaletteRed20: ColorPaletteRed20$3,
    ColorPaletteRed30: ColorPaletteRed30$3,
    ColorPaletteRed40: ColorPaletteRed40$3,
    ColorPaletteRed50: ColorPaletteRed50$3,
    ColorPaletteRed60: ColorPaletteRed60$3,
    ColorPaletteRed70: ColorPaletteRed70$3,
    ColorPaletteRed80: ColorPaletteRed80$3,
    ColorPaletteRed90: ColorPaletteRed90$3,
    ColorPaletteRed100: ColorPaletteRed100$3,
    ColorPaletteRed110: ColorPaletteRed110$3,
    ColorPaletteRed120: ColorPaletteRed120$3,
    ColorPaletteRed130: ColorPaletteRed130$3,
    ColorPaletteRed140: ColorPaletteRed140$3,
    ColorPaletteRed150: ColorPaletteRed150$3,
    ColorPaletteRed160: ColorPaletteRed160$3,
    ColorPaletteYellow10: ColorPaletteYellow10$3,
    ColorPaletteYellow20: ColorPaletteYellow20$3,
    ColorPaletteYellow30: ColorPaletteYellow30$3,
    ColorPaletteYellow40: ColorPaletteYellow40$3,
    ColorPaletteYellow50: ColorPaletteYellow50$3,
    ColorPaletteYellow60: ColorPaletteYellow60$3,
    ColorPaletteYellow70: ColorPaletteYellow70$3,
    ColorPaletteYellow80: ColorPaletteYellow80$3,
    ColorPaletteYellow90: ColorPaletteYellow90$3,
    ColorPaletteYellow100: ColorPaletteYellow100$3,
    ColorPaletteYellow110: ColorPaletteYellow110$3,
    ColorPaletteYellow120: ColorPaletteYellow120$3,
    ColorPaletteYellow130: ColorPaletteYellow130$3,
    ColorPaletteYellow140: ColorPaletteYellow140$3,
    ColorPaletteYellow150: ColorPaletteYellow150$3,
    ColorPaletteYellow160: ColorPaletteYellow160$3,
    ColorPaletteLime10: ColorPaletteLime10$3,
    ColorPaletteLime20: ColorPaletteLime20$3,
    ColorPaletteLime30: ColorPaletteLime30$3,
    ColorPaletteLime40: ColorPaletteLime40$3,
    ColorPaletteLime50: ColorPaletteLime50$3,
    ColorPaletteLime60: ColorPaletteLime60$3,
    ColorPaletteLime70: ColorPaletteLime70$3,
    ColorPaletteLime80: ColorPaletteLime80$3,
    ColorPaletteLime90: ColorPaletteLime90$3,
    ColorPaletteLime100: ColorPaletteLime100$3,
    ColorPaletteLime110: ColorPaletteLime110$3,
    ColorPaletteLime120: ColorPaletteLime120$3,
    ColorPaletteLime130: ColorPaletteLime130$3,
    ColorPaletteLime140: ColorPaletteLime140$3,
    ColorPaletteLime150: ColorPaletteLime150$3,
    ColorPaletteLime160: ColorPaletteLime160$3,
    ColorPaletteGreen10: ColorPaletteGreen10$3,
    ColorPaletteGreen20: ColorPaletteGreen20$3,
    ColorPaletteGreen30: ColorPaletteGreen30$3,
    ColorPaletteGreen40: ColorPaletteGreen40$3,
    ColorPaletteGreen50: ColorPaletteGreen50$3,
    ColorPaletteGreen60: ColorPaletteGreen60$3,
    ColorPaletteGreen70: ColorPaletteGreen70$3,
    ColorPaletteGreen80: ColorPaletteGreen80$3,
    ColorPaletteGreen90: ColorPaletteGreen90$3,
    ColorPaletteGreen100: ColorPaletteGreen100$3,
    ColorPaletteGreen110: ColorPaletteGreen110$3,
    ColorPaletteGreen120: ColorPaletteGreen120$3,
    ColorPaletteGreen130: ColorPaletteGreen130$3,
    ColorPaletteGreen140: ColorPaletteGreen140$3,
    ColorPaletteGreen150: ColorPaletteGreen150$3,
    ColorPaletteGreen160: ColorPaletteGreen160$3,
    ColorPaletteAcqua10: ColorPaletteAcqua10$3,
    ColorPaletteAcqua20: ColorPaletteAcqua20$3,
    ColorPaletteAcqua30: ColorPaletteAcqua30$3,
    ColorPaletteAcqua40: ColorPaletteAcqua40$3,
    ColorPaletteAcqua50: ColorPaletteAcqua50$3,
    ColorPaletteAcqua60: ColorPaletteAcqua60$3,
    ColorPaletteAcqua70: ColorPaletteAcqua70$3,
    ColorPaletteAcqua80: ColorPaletteAcqua80$3,
    ColorPaletteAcqua90: ColorPaletteAcqua90$3,
    ColorPaletteAcqua100: ColorPaletteAcqua100$3,
    ColorPaletteAcqua110: ColorPaletteAcqua110$3,
    ColorPaletteAcqua120: ColorPaletteAcqua120$3,
    ColorPaletteAcqua130: ColorPaletteAcqua130$3,
    ColorPaletteAcqua140: ColorPaletteAcqua140$3,
    ColorPaletteAcqua150: ColorPaletteAcqua150$3,
    ColorPaletteAcqua160: ColorPaletteAcqua160$3,
    ColorPaletteBlue10: ColorPaletteBlue10$3,
    ColorPaletteBlue20: ColorPaletteBlue20$3,
    ColorPaletteBlue30: ColorPaletteBlue30$3,
    ColorPaletteBlue40: ColorPaletteBlue40$3,
    ColorPaletteBlue50: ColorPaletteBlue50$3,
    ColorPaletteBlue60: ColorPaletteBlue60$3,
    ColorPaletteBlue70: ColorPaletteBlue70$3,
    ColorPaletteBlue80: ColorPaletteBlue80$3,
    ColorPaletteBlue90: ColorPaletteBlue90$3,
    ColorPaletteBlue100: ColorPaletteBlue100$3,
    ColorPaletteBlue110: ColorPaletteBlue110$3,
    ColorPaletteBlue120: ColorPaletteBlue120$3,
    ColorPaletteBlue130: ColorPaletteBlue130$3,
    ColorPaletteBlue140: ColorPaletteBlue140$3,
    ColorPaletteBlue150: ColorPaletteBlue150$3,
    ColorPaletteBlue160: ColorPaletteBlue160$3,
    ColorPalettePurple10: ColorPalettePurple10$3,
    ColorPalettePurple20: ColorPalettePurple20$3,
    ColorPalettePurple30: ColorPalettePurple30$3,
    ColorPalettePurple40: ColorPalettePurple40$3,
    ColorPalettePurple50: ColorPalettePurple50$3,
    ColorPalettePurple60: ColorPalettePurple60$3,
    ColorPalettePurple70: ColorPalettePurple70$3,
    ColorPalettePurple80: ColorPalettePurple80$3,
    ColorPalettePurple90: ColorPalettePurple90$3,
    ColorPalettePurple100: ColorPalettePurple100$3,
    ColorPalettePurple110: ColorPalettePurple110$3,
    ColorPalettePurple120: ColorPalettePurple120$3,
    ColorPalettePurple130: ColorPalettePurple130$3,
    ColorPalettePurple140: ColorPalettePurple140$3,
    ColorPalettePurple150: ColorPalettePurple150$3,
    ColorPalettePurple160: ColorPalettePurple160$3,
    ColorPalettePink10: ColorPalettePink10$3,
    ColorPalettePink20: ColorPalettePink20$3,
    ColorPalettePink30: ColorPalettePink30$3,
    ColorPalettePink40: ColorPalettePink40$3,
    ColorPalettePink50: ColorPalettePink50$3,
    ColorPalettePink60: ColorPalettePink60$3,
    ColorPalettePink70: ColorPalettePink70$3,
    ColorPalettePink80: ColorPalettePink80$3,
    ColorPalettePink90: ColorPalettePink90$3,
    ColorPalettePink100: ColorPalettePink100$3,
    ColorPalettePink110: ColorPalettePink110$3,
    ColorPalettePink120: ColorPalettePink120$3,
    ColorPalettePink130: ColorPalettePink130$3,
    ColorPalettePink140: ColorPalettePink140$3,
    ColorPalettePink150: ColorPalettePink150$3,
    ColorPalettePink160: ColorPalettePink160$3,
    ColorTypefaceStrong: ColorTypefaceStrong$3,
    ColorTypefacePure: ColorTypefacePure$3,
    ColorTypefaceSmooth: ColorTypefaceSmooth$3,
    ColorTypefaceMeld: ColorTypefaceMeld$3,
    ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$3,
    ColorTypefaceInversePure: ColorTypefaceInversePure$3,
    ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$3,
    ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$3,
    ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$3,
    ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$3,
    ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$3,
    ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$3,
    ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$3,
    ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$3,
    ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$3,
    ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$3,
    ColorBrandPrimary10: ColorBrandPrimary10$3,
    ColorBrandPrimary20: ColorBrandPrimary20$3,
    ColorBrandPrimary30: ColorBrandPrimary30$3,
    ColorBrandPrimary40: ColorBrandPrimary40$3,
    ColorBrandPrimary50: ColorBrandPrimary50$3,
    ColorBrandPrimary60: ColorBrandPrimary60$3,
    ColorBrandPrimary70: ColorBrandPrimary70$3,
    ColorBrandPrimary80: ColorBrandPrimary80$3,
    ColorBrandPrimary90: ColorBrandPrimary90$3,
    ColorBrandPrimary100: ColorBrandPrimary100$3,
    ColorBrandPrimary110: ColorBrandPrimary110$3,
    ColorBrandPrimary120: ColorBrandPrimary120$3,
    ColorBrandPrimary130: ColorBrandPrimary130$2,
    ColorBrandPrimary140: ColorBrandPrimary140$2,
    ColorBrandPrimary150: ColorBrandPrimary150$2,
    ColorBrandPrimary160: ColorBrandPrimary160$2,
    ColorBrandBase01: ColorBrandBase01$3,
    ColorBrandBase02: ColorBrandBase02$3,
    ColorBrandBase03: ColorBrandBase03$2,
    ColorBrandBase04: ColorBrandBase04$2,
    ColorBrandBase05: ColorBrandBase05$2,
    ColorBrandPalette0110: ColorBrandPalette0110$2,
    ColorBrandPalette0120: ColorBrandPalette0120$2,
    ColorBrandPalette0130: ColorBrandPalette0130$2,
    ColorBrandPalette0140: ColorBrandPalette0140$2,
    ColorBrandPalette0150: ColorBrandPalette0150$2,
    ColorBrandPalette0160: ColorBrandPalette0160$2,
    ColorBrandPalette0170: ColorBrandPalette0170$2,
    ColorBrandPalette0180: ColorBrandPalette0180$2,
    ColorBrandPalette0190: ColorBrandPalette0190$2,
    ColorBrandPalette01100: ColorBrandPalette01100$2,
    ColorBrandPalette01110: ColorBrandPalette01110$2,
    ColorBrandPalette01120: ColorBrandPalette01120$2,
    ColorBrandPalette01130: ColorBrandPalette01130$2,
    ColorBrandPalette01140: ColorBrandPalette01140$2,
    ColorBrandPalette01150: ColorBrandPalette01150$2,
    ColorBrandPalette01160: ColorBrandPalette01160$2,
    ColorBrandPalette0210: ColorBrandPalette0210$2,
    ColorBrandPalette0220: ColorBrandPalette0220$2,
    ColorBrandPalette0230: ColorBrandPalette0230$2,
    ColorBrandPalette0240: ColorBrandPalette0240$2,
    ColorBrandPalette0250: ColorBrandPalette0250$2,
    ColorBrandPalette0260: ColorBrandPalette0260$2,
    ColorBrandPalette0270: ColorBrandPalette0270$2,
    ColorBrandPalette0280: ColorBrandPalette0280$2,
    ColorBrandPalette0290: ColorBrandPalette0290$2,
    ColorBrandPalette02100: ColorBrandPalette02100$2,
    ColorBrandPalette02110: ColorBrandPalette02110$2,
    ColorBrandPalette02120: ColorBrandPalette02120$2,
    ColorBrandPalette02130: ColorBrandPalette02130$2,
    ColorBrandPalette02140: ColorBrandPalette02140$2,
    ColorBrandPalette02150: ColorBrandPalette02150$2,
    ColorBrandPalette02160: ColorBrandPalette02160$2,
    ColorBrandPalette0310: ColorBrandPalette0310,
    ColorBrandPalette0320: ColorBrandPalette0320,
    ColorBrandPalette0330: ColorBrandPalette0330,
    ColorBrandPalette0340: ColorBrandPalette0340,
    ColorBrandPalette0350: ColorBrandPalette0350,
    ColorBrandPalette0360: ColorBrandPalette0360,
    ColorBrandPalette0370: ColorBrandPalette0370,
    ColorBrandPalette0380: ColorBrandPalette0380,
    ColorBrandPalette0390: ColorBrandPalette0390,
    ColorBrandPalette03100: ColorBrandPalette03100,
    ColorBrandPalette03110: ColorBrandPalette03110,
    ColorBrandPalette03120: ColorBrandPalette03120,
    ColorBrandPalette03130: ColorBrandPalette03130,
    ColorBrandPalette03140: ColorBrandPalette03140,
    ColorBrandPalette03150: ColorBrandPalette03150,
    ColorBrandPalette03160: ColorBrandPalette03160,
    ColorBrandPalette0410: ColorBrandPalette0410$1,
    ColorBrandPalette0420: ColorBrandPalette0420$1,
    ColorBrandPalette0430: ColorBrandPalette0430$1,
    ColorBrandPalette0440: ColorBrandPalette0440$1,
    ColorBrandPalette0450: ColorBrandPalette0450$1,
    ColorBrandPalette0460: ColorBrandPalette0460$1,
    ColorBrandPalette0470: ColorBrandPalette0470$1,
    ColorBrandPalette0480: ColorBrandPalette0480$1,
    ColorBrandPalette0490: ColorBrandPalette0490$1,
    ColorBrandPalette04100: ColorBrandPalette04100$1,
    ColorBrandPalette04110: ColorBrandPalette04110$1,
    ColorBrandPalette04120: ColorBrandPalette04120$1,
    ColorBrandPalette04130: ColorBrandPalette04130$1,
    ColorBrandPalette04140: ColorBrandPalette04140$1,
    ColorBrandPalette04150: ColorBrandPalette04150$1,
    ColorBrandPalette04160: ColorBrandPalette04160$1,
    ColorBrandPalette0510: ColorBrandPalette0510$1,
    ColorBrandPalette0520: ColorBrandPalette0520$1,
    ColorBrandPalette0530: ColorBrandPalette0530$1,
    ColorBrandPalette0540: ColorBrandPalette0540$1,
    ColorBrandPalette0550: ColorBrandPalette0550$1,
    ColorBrandPalette0560: ColorBrandPalette0560$1,
    ColorBrandPalette0570: ColorBrandPalette0570$1,
    ColorBrandPalette0580: ColorBrandPalette0580$1,
    ColorBrandPalette0590: ColorBrandPalette0590$1,
    ColorBrandPalette05100: ColorBrandPalette05100$1,
    ColorBrandPalette05110: ColorBrandPalette05110$1,
    ColorBrandPalette05120: ColorBrandPalette05120$1,
    ColorBrandPalette05130: ColorBrandPalette05130$1,
    ColorBrandPalette05140: ColorBrandPalette05140$1,
    ColorBrandPalette05150: ColorBrandPalette05150$1,
    ColorBrandPalette05160: ColorBrandPalette05160$1,
    ColorFeedbackErrorText: ColorFeedbackErrorText$3,
    ColorFeedbackErrorShape: ColorFeedbackErrorShape$3,
    ColorFeedbackSuccessText: ColorFeedbackSuccessText$3,
    ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$3,
    ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$3,
    ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$3,
    ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$3,
    ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$3,
    ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$3,
    ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$3,
    ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$3,
    ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$3,
    ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$3,
    ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$3,
    ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$3,
    ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$3,
    ColorSupport01: ColorSupport01$3,
    ColorSupport02: ColorSupport02$3,
    ColorSupportOnBrand01: ColorSupportOnBrand01$3,
    ColorSupportOnBrand02: ColorSupportOnBrand02$3,
    ColorSupportInverse01: ColorSupportInverse01$3,
    ColorSupportInverse02: ColorSupportInverse02$3,
    ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$3,
    ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$3,
    Opacity01: Opacity01$3,
    Opacity02: Opacity02$3,
    Opacity03: Opacity03$3,
    Opacity04: Opacity04$3,
    Opacity05: Opacity05$3,
    Opacity06: Opacity06$3,
    Opacity07: Opacity07$3,
    Opacity08: Opacity08$3,
    Opacity09: Opacity09$3,
    Shadow01: Shadow01$3,
    Shadow02: Shadow02$3,
    Shadow03: Shadow03$3,
    Shadow04: Shadow04$3,
    SpacingInlineQuark: SpacingInlineQuark$3,
    SpacingInlineNano: SpacingInlineNano$3,
    SpacingInlineXxxs: SpacingInlineXxxs$3,
    SpacingInlineXxs: SpacingInlineXxs$3,
    SpacingInlineXs: SpacingInlineXs$3,
    SpacingInlineSm: SpacingInlineSm$3,
    SpacingInlineMd: SpacingInlineMd$3,
    SpacingInlineLg: SpacingInlineLg$3,
    SpacingInlineXl: SpacingInlineXl$3,
    SpacingInlineXxl: SpacingInlineXxl$3,
    SpacingInlineXxxl: SpacingInlineXxxl$3,
    SpacingInlineHuge: SpacingInlineHuge$3,
    SpacingInlineGiant: SpacingInlineGiant$3,
    SpacingInsetQuark: SpacingInsetQuark$3,
    SpacingInsetNano: SpacingInsetNano$3,
    SpacingInsetXs: SpacingInsetXs$3,
    SpacingInsetSm: SpacingInsetSm$3,
    SpacingInsetMd: SpacingInsetMd$3,
    SpacingInsetLg: SpacingInsetLg$3,
    SpacingSquishQuark: SpacingSquishQuark$3,
    SpacingSquishNano: SpacingSquishNano$3,
    SpacingSquishXs: SpacingSquishXs$3,
    SpacingSquishSm: SpacingSquishSm$3,
    SpacingStackQuark: SpacingStackQuark$3,
    SpacingStackNano: SpacingStackNano$3,
    SpacingStackXxxs: SpacingStackXxxs$3,
    SpacingStackXxs: SpacingStackXxs$3,
    SpacingStackXs: SpacingStackXs$3,
    SpacingStackSm: SpacingStackSm$3,
    SpacingStackMd: SpacingStackMd$3,
    SpacingStackLg: SpacingStackLg$3,
    SpacingStackXl: SpacingStackXl$3,
    SpacingStackXxl: SpacingStackXxl$3,
    SpacingStackXxxl: SpacingStackXxxl$3,
    SpacingStackHuge: SpacingStackHuge$3,
    SpacingStackGiant: SpacingStackGiant$3,
    FontFamilyBase: FontFamilyBase$3,
    FontSizeXxxs: FontSizeXxxs$3,
    FontSizeXxs: FontSizeXxs$3,
    FontSizeXs: FontSizeXs$3,
    FontSizeSm: FontSizeSm$3,
    FontSizeMd: FontSizeMd$3,
    FontSizeLg: FontSizeLg$3,
    FontSizeXl: FontSizeXl$3,
    FontSizeXxl: FontSizeXxl$3,
    FontSizeXxxl: FontSizeXxxl$3,
    FontSizeDisplay: FontSizeDisplay$3,
    FontSizeGiant: FontSizeGiant$3,
    FontWeightBold: FontWeightBold$3,
    FontWeightSemibold: FontWeightSemibold$3,
    FontWeightMedium: FontWeightMedium$3,
    FontWeightRegular: FontWeightRegular$3,
    FontWeightLight: FontWeightLight$3,
    LetterSpacingStandard: LetterSpacingStandard$3,
    LetterSpacingSmall: LetterSpacingSmall$3,
    LetterSpacingMedium: LetterSpacingMedium$3,
    LineHeightStandard: LineHeightStandard$3,
    LineHeightTiny: LineHeightTiny$3,
    LineHeightMedium: LineHeightMedium$3,
    LineHeightLarge: LineHeightLarge$3,
    LineHeightDistant: LineHeightDistant$3,
    LineHeightSuperdistant: LineHeightSuperdistant$3,
    LineHeightHuge: LineHeightHuge$3
  });
  /**
   * Do not edit directly
   * Generated on Thu, 27 Oct 2022 18:07:47 GMT
   */

  var BorderRadiusNone$2 = "0px";
  var BorderRadiusXs$2 = "4px";
  var BorderRadiusSm$2 = "8px";
  var BorderRadiusMd$2 = "16px";
  var BorderRadiusLg$2 = "24px";
  var BorderRadiusPill$2 = "960px";
  var BorderRadiusCircle$2 = "50%";
  var BorderWidthNone$2 = "0px";
  var BorderWidthHairline$2 = "1px";
  var BorderWidthThin$2 = "2px";
  var BorderWidthThick$2 = "4px";
  var BorderWidthHeavy$2 = "8px";
  var ColorDatavizInfoText$2 = "#0F58EA";
  var ColorDatavizInfoShape01$2 = "#3F7BF2";
  var ColorDatavizInfoShape02$2 = "#D9E5FC";
  var ColorDatavizInfoShape03$2 = "#F1F5FE";
  var ColorDatavizNegativeText$2 = "#BC293A";
  var ColorDatavizNegativeShape01$2 = "#EA4356";
  var ColorDatavizNegativeShape02$2 = "#FDDDE1";
  var ColorDatavizNegativeShape03$2 = "#FEF1F2";
  var ColorDatavizWarningText$2 = "#A04C03";
  var ColorDatavizWarningShape01$2 = "#D26404";
  var ColorDatavizWarningShape02$2 = "#FEE1C8";
  var ColorDatavizWarningShape03$2 = "#FEF1E6";
  var ColorDatavizPositiveText$2 = "#22723A";
  var ColorDatavizPositiveShape01$2 = "#2D954C";
  var ColorDatavizPositiveShape02$2 = "#C8EED3";
  var ColorDatavizPositiveShape03$2 = "#E8F8EC";
  var ColorDatavizCatAText$2 = "#9B18DC";
  var ColorDatavizCatAShape01$2 = "#B851EC";
  var ColorDatavizCatAShape02$2 = "#F2DFFB";
  var ColorDatavizCatAShape03$2 = "#F9F1FD";
  var ColorDatavizCatBText$2 = "#BA267B";
  var ColorDatavizCatBShape01$2 = "#DA499B";
  var ColorDatavizCatBShape02$2 = "#F8DDEC";
  var ColorDatavizCatBShape03$2 = "#FCF2F8";
  var ColorDatavizCatCText$2 = "#546E21";
  var ColorDatavizCatCShape01$2 = "#6C8D2B";
  var ColorDatavizCatCShape02$2 = "#DBEBBD";
  var ColorDatavizCatCShape03$2 = "#F0F7E4";
  var ColorDatavizCatDText$2 = "#0D735E";
  var ColorDatavizCatDShape01$2 = "#109379";
  var ColorDatavizCatDShape02$2 = "#BCF0E6";
  var ColorDatavizCatDShape03$2 = "#DFFBF6";
  var ColorDatavizInverseInfoText$2 = "#5C8FF5";
  var ColorDatavizInverseInfoShape01$2 = "#286BF1";
  var ColorDatavizInverseInfoShape02$2 = "#062560";
  var ColorDatavizInverseInfoShape03$2 = "#051B48";
  var ColorDatavizInverseNegativeText$2 = "#F55C6E";
  var ColorDatavizInverseNegativeShape01$2 = "#D83145";
  var ColorDatavizInverseNegativeShape02$2 = "#4F1119";
  var ColorDatavizInverseNegativeShape03$2 = "#3B0D12";
  var ColorDatavizInverseWarningText$2 = "#EB7005";
  var ColorDatavizInverseWarningShape01$2 = "#B95804";
  var ColorDatavizInverseWarningShape02$2 = "#462101";
  var ColorDatavizInverseWarningShape03$2 = "#321701";
  var ColorDatavizInversePositiveText$2 = "#32A454";
  var ColorDatavizInversePositiveShape01$2 = "#278142";
  var ColorDatavizInversePositiveShape02$2 = "#0E2F18";
  var ColorDatavizInversePositiveShape03$2 = "#0B2312";
  var ColorDatavizInverseCatAText$2 = "#C36CEF";
  var ColorDatavizInverseCatAShape01$2 = "#AD35E9";
  var ColorDatavizInverseCatAShape02$2 = "#440B60";
  var ColorDatavizInverseCatAShape03$2 = "#340849";
  var ColorDatavizInverseCatBText$2 = "#E067AB";
  var ColorDatavizInverseCatBShape01$2 = "#D42B8C";
  var ColorDatavizInverseCatBShape02$2 = "#4C1032";
  var ColorDatavizInverseCatBShape03$2 = "#3B0C27";
  var ColorDatavizInverseCatCText$2 = "#789D2F";
  var ColorDatavizInverseCatCShape01$2 = "#607E26";
  var ColorDatavizInverseCatCShape02$2 = "#212B0D";
  var ColorDatavizInverseCatCShape03$2 = "#1B230B";
  var ColorDatavizInverseCatDText$2 = "#12A588";
  var ColorDatavizInverseCatDShape01$2 = "#0F856D";
  var ColorDatavizInverseCatDShape02$2 = "#052E26";
  var ColorDatavizInverseCatDShape03$2 = "#04251E";
  var ColorInteractionBlend01$2 = "#1616160A";
  var ColorInteractionBlend02$2 = "#16161614";
  var ColorInteractionBlend03$2 = "#1616161F";
  var ColorInteractionBlend04$2 = "#1616163D";
  var ColorInteractionBlend05$2 = "#161616A3";
  var ColorInteractionBlend06$2 = "#161616B8";
  var ColorInteractionBlend07$2 = "#161616E0";
  var ColorInteractionBlend08$2 = "#161616";
  var ColorInteractionInverseBlend01$2 = "#FEFEFE14";
  var ColorInteractionInverseBlend02$2 = "#FEFEFE1F";
  var ColorInteractionInverseBlend03$2 = "#FEFEFE3D";
  var ColorInteractionInverseBlend04$2 = "#FEFEFE52";
  var ColorInteractionInverseBlend05$2 = "#FEFEFEA3";
  var ColorInteractionInverseBlend06$2 = "#FEFEFEB8";
  var ColorInteractionInverseBlend07$2 = "#FEFEFEE0";
  var ColorInteractionInverseBlend08$2 = "#FEFEFE";
  var ColorInteractionInverseAccent01$2 = "#D661E5";
  var ColorInteractionInverseAccent02$2 = "#DE80EA";
  var ColorInteractionInverseAccent03$2 = "#E59AEF";
  var ColorInteractionInverseSubtle01$2 = "#CE42E01F";
  var ColorInteractionInverseSubtle02$2 = "#CE42E03D";
  var ColorInteractionInverseSubtle03$2 = "#CE42E052";
  var ColorInteractionInverseSelectDefault$2 = "#919191";
  var ColorInteractionInverseSelectFocus$2 = "#D4D4D4";
  var ColorInteractionInverseSelectActive$2 = "#D661E5";
  var ColorInteractionInverseDanger01$2 = "#F55C6E";
  var ColorInteractionInverseDanger02$2 = "#F77E8C";
  var ColorInteractionInverseDanger03$2 = "#F895A1";
  var ColorInteractionInverseOnBrandAccent01$2 = "#4C0056";
  var ColorInteractionInverseOnBrandAccent02$2 = "#5F006B";
  var ColorInteractionInverseOnBrandAccent03$2 = "#730382";
  var ColorInteractionInverseOnBrandSubtle01$2 = "#AD15C11F";
  var ColorInteractionInverseOnBrandSubtle02$2 = "#AD15C13D";
  var ColorInteractionInverseOnBrandSubtle03$2 = "#AD15C152";
  var ColorInteractionInverseOnBrandSelectDefault$2 = "#595959";
  var ColorInteractionInverseOnBrandSelectFocus$2 = "#363636";
  var ColorInteractionInverseOnBrandSelectActive$2 = "#730382";
  var ColorInteractionInverseOnBrandBlend01$2 = "#1616160A";
  var ColorInteractionInverseOnBrandBlend02$2 = "#16161614";
  var ColorInteractionInverseOnBrandBlend03$2 = "#1616161F";
  var ColorInteractionInverseOnBrandBlend04$2 = "#1616163D";
  var ColorInteractionInverseOnBrandBlend05$2 = "#161616A3";
  var ColorInteractionInverseOnBrandBlend06$2 = "#161616B8";
  var ColorInteractionInverseOnBrandBlend07$2 = "#161616E0";
  var ColorInteractionInverseOnBrandBlend08$2 = "#161616";
  var ColorInteractionInverseOnBrandDanger01$2 = "#A72534";
  var ColorInteractionInverseOnBrandDanger02$2 = "#92202E";
  var ColorInteractionInverseOnBrandDanger03$2 = "#7E1B27";
  var ColorInteractionAccent01$2 = "#4C0056";
  var ColorInteractionAccent02$2 = "#5F006B";
  var ColorInteractionAccent03$2 = "#730382";
  var ColorInteractionSubtle01$2 = "#C223D71F";
  var ColorInteractionSubtle02$2 = "#C223D73D";
  var ColorInteractionSubtle03$2 = "#C223D752";
  var ColorInteractionSelectDefault$2 = "#666666";
  var ColorInteractionSelectFocus$2 = "#363636";
  var ColorInteractionSelectActive$2 = "#730382";
  var ColorInteractionDanger01$2 = "#BC293A";
  var ColorInteractionDanger02$2 = "#A72534";
  var ColorInteractionDanger03$2 = "#92202E";
  var ColorInteractionOnBrandAccent01$2 = "#FEFEFE";
  var ColorInteractionOnBrandAccent02$2 = "#FCF2FD";
  var ColorInteractionOnBrandAccent03$2 = "#ECB4F3";
  var ColorInteractionOnBrandSubtle01$2 = "#DE80EA1F";
  var ColorInteractionOnBrandSubtle02$2 = "#DE80EA3D";
  var ColorInteractionOnBrandSubtle03$2 = "#DE80EA52";
  var ColorInteractionOnBrandSelectDefault$2 = "#E6E6E6";
  var ColorInteractionOnBrandSelectFocus$2 = "#FEFEFE";
  var ColorInteractionOnBrandSelectActive$2 = "#ECB4F3";
  var ColorInteractionOnBrandBlend01$2 = "#FEFEFE14";
  var ColorInteractionOnBrandBlend02$2 = "#FEFEFE1F";
  var ColorInteractionOnBrandBlend03$2 = "#FEFEFE3D";
  var ColorInteractionOnBrandBlend04$2 = "#FEFEFE52";
  var ColorInteractionOnBrandBlend05$2 = "#FEFEFEA3";
  var ColorInteractionOnBrandBlend06$2 = "#FEFEFEB8";
  var ColorInteractionOnBrandBlend07$2 = "#FEFEFEE0";
  var ColorInteractionOnBrandBlend08$2 = "#FEFEFE";
  var ColorInteractionOnBrandDanger01$2 = "#F895A1";
  var ColorInteractionOnBrandDanger02$2 = "#FAAEB6";
  var ColorInteractionOnBrandDanger03$2 = "#FBC5CC";
  var ColorNeutral10$2 = "#F5F5F5";
  var ColorNeutral20$2 = "#E6E6E6";
  var ColorNeutral30$2 = "#1616163D";
  var ColorNeutral00$2 = "#FEFEFE";
  var ColorNeutralInverse10$2 = "#1F1F1F";
  var ColorNeutralInverse20$2 = "#292929";
  var ColorNeutralInverse30$2 = "#FEFEFE3D";
  var ColorNeutralInverse00$2 = "#161616";
  var ColorNeutralInverseOnBrand10$2 = "#FCF2FD";
  var ColorNeutralInverseOnBrand20$2 = "#F1CAF6";
  var ColorNeutralInverseOnBrand30$2 = "#C223D77A";
  var ColorNeutralInverseOnBrand00$2 = "#FCF2FD";
  var ColorNeutralOnBrand10$2 = "#5F006B";
  var ColorNeutralOnBrand20$2 = "#730382";
  var ColorNeutralOnBrand30$2 = "#CE42E0A3";
  var ColorNeutralOnBrand00$2 = "#4C0056";
  var ColorPaletteBlack$2 = "#161616";
  var ColorPaletteWhite$2 = "#FEFEFE";
  var ColorPaletteGray10$2 = "#1F1F1F";
  var ColorPaletteGray20$2 = "#292929";
  var ColorPaletteGray30$2 = "#363636";
  var ColorPaletteGray40$2 = "#404040";
  var ColorPaletteGray50$2 = "#4C4C4C";
  var ColorPaletteGray60$2 = "#595959";
  var ColorPaletteGray70$2 = "#666666";
  var ColorPaletteGray80$2 = "#737373";
  var ColorPaletteGray90$2 = "#828282";
  var ColorPaletteGray100$2 = "#919191";
  var ColorPaletteGray110$2 = "#A1A1A1";
  var ColorPaletteGray120$2 = "#B0B0B0";
  var ColorPaletteGray130$2 = "#C2C2C2";
  var ColorPaletteGray140$2 = "#D4D4D4";
  var ColorPaletteGray150$2 = "#E6E6E6";
  var ColorPaletteGray160$2 = "#F5F5F5";
  var ColorPaletteRed10$2 = "#3B0D12";
  var ColorPaletteRed20$2 = "#4F1119";
  var ColorPaletteRed30$2 = "#691721";
  var ColorPaletteRed40$2 = "#7E1B27";
  var ColorPaletteRed50$2 = "#92202E";
  var ColorPaletteRed60$2 = "#A72534";
  var ColorPaletteRed70$2 = "#BC293A";
  var ColorPaletteRed80$2 = "#D83145";
  var ColorPaletteRed90$2 = "#EA4356";
  var ColorPaletteRed100$2 = "#F55C6E";
  var ColorPaletteRed110$2 = "#F77E8C";
  var ColorPaletteRed120$2 = "#F895A1";
  var ColorPaletteRed130$2 = "#FAAEB6";
  var ColorPaletteRed140$2 = "#FBC5CC";
  var ColorPaletteRed150$2 = "#FDDDE1";
  var ColorPaletteRed160$2 = "#FEF1F2";
  var ColorPaletteYellow10$2 = "#321701";
  var ColorPaletteYellow20$2 = "#462101";
  var ColorPaletteYellow30$2 = "#552802";
  var ColorPaletteYellow40$2 = "#693102";
  var ColorPaletteYellow50$2 = "#7D3B03";
  var ColorPaletteYellow60$2 = "#914503";
  var ColorPaletteYellow70$2 = "#A04C03";
  var ColorPaletteYellow80$2 = "#B95804";
  var ColorPaletteYellow90$2 = "#D26404";
  var ColorPaletteYellow100$2 = "#EB7005";
  var ColorPaletteYellow110$2 = "#FA8219";
  var ColorPaletteYellow120$2 = "#FB9B46";
  var ColorPaletteYellow130$2 = "#FCB06E";
  var ColorPaletteYellow140$2 = "#FDC99B";
  var ColorPaletteYellow150$2 = "#FEE1C8";
  var ColorPaletteYellow160$2 = "#FEF1E6";
  var ColorPaletteLime10$2 = "#1B230B";
  var ColorPaletteLime20$2 = "#212B0D";
  var ColorPaletteLime30$2 = "#2D3B12";
  var ColorPaletteLime40$2 = "#364616";
  var ColorPaletteLime50$2 = "#3F5219";
  var ColorPaletteLime60$2 = "#485E1D";
  var ColorPaletteLime70$2 = "#546E21";
  var ColorPaletteLime80$2 = "#607E26";
  var ColorPaletteLime90$2 = "#6C8D2B";
  var ColorPaletteLime100$2 = "#789D2F";
  var ColorPaletteLime110$2 = "#84AC34";
  var ColorPaletteLime120$2 = "#93BF3A";
  var ColorPaletteLime130$2 = "#A9CF5E";
  var ColorPaletteLime140$2 = "#C2DD8D";
  var ColorPaletteLime150$2 = "#DBEBBD";
  var ColorPaletteLime160$2 = "#F0F7E4";
  var ColorPaletteGreen10$2 = "#0B2312";
  var ColorPaletteGreen20$2 = "#0E2F18";
  var ColorPaletteGreen30$2 = "#133E20";
  var ColorPaletteGreen40$2 = "#174A26";
  var ColorPaletteGreen50$2 = "#1A562C";
  var ColorPaletteGreen60$2 = "#1F6634";
  var ColorPaletteGreen70$2 = "#22723A";
  var ColorPaletteGreen80$2 = "#278142";
  var ColorPaletteGreen90$2 = "#2D954C";
  var ColorPaletteGreen100$2 = "#32A454";
  var ColorPaletteGreen110$2 = "#38B85E";
  var ColorPaletteGreen120$2 = "#4BC870";
  var ColorPaletteGreen130$2 = "#76D692";
  var ColorPaletteGreen140$2 = "#9DE2B1";
  var ColorPaletteGreen150$2 = "#C8EED3";
  var ColorPaletteGreen160$2 = "#E8F8EC";
  var ColorPaletteAcqua10$2 = "#04251E";
  var ColorPaletteAcqua20$2 = "#052E26";
  var ColorPaletteAcqua30$2 = "#073C31";
  var ColorPaletteAcqua40$2 = "#08493C";
  var ColorPaletteAcqua50$2 = "#0A5748";
  var ColorPaletteAcqua60$2 = "#0B6553";
  var ColorPaletteAcqua70$2 = "#0D735E";
  var ColorPaletteAcqua80$2 = "#0F856D";
  var ColorPaletteAcqua90$2 = "#109379";
  var ColorPaletteAcqua100$2 = "#12A588";
  var ColorPaletteAcqua110$2 = "#14B897";
  var ColorPaletteAcqua120$2 = "#31C4A6";
  var ColorPaletteAcqua130$2 = "#68D4BF";
  var ColorPaletteAcqua140$2 = "#8DE2D1";
  var ColorPaletteAcqua150$2 = "#BCF0E6";
  var ColorPaletteAcqua160$2 = "#DFFBF6";
  var ColorPaletteBlue10$2 = "#051B48";
  var ColorPaletteBlue20$2 = "#062560";
  var ColorPaletteBlue30$2 = "#082F7D";
  var ColorPaletteBlue40$2 = "#0A3A9A";
  var ColorPaletteBlue50$2 = "#0B43B1";
  var ColorPaletteBlue60$2 = "#0D4ECE";
  var ColorPaletteBlue70$2 = "#0F58EA";
  var ColorPaletteBlue80$2 = "#286BF1";
  var ColorPaletteBlue90$2 = "#3F7BF2";
  var ColorPaletteBlue100$2 = "#5C8FF5";
  var ColorPaletteBlue110$2 = "#73A0F7";
  var ColorPaletteBlue120$2 = "#8CB0F8";
  var ColorPaletteBlue130$2 = "#A9C4F9";
  var ColorPaletteBlue140$2 = "#C1D4FB";
  var ColorPaletteBlue150$2 = "#D9E5FC";
  var ColorPaletteBlue160$2 = "#F1F5FE";
  var ColorPalettePurple10$2 = "#340849";
  var ColorPalettePurple20$2 = "#440B60";
  var ColorPalettePurple30$2 = "#540D78";
  var ColorPalettePurple40$2 = "#671093";
  var ColorPalettePurple50$2 = "#7713AA";
  var ColorPalettePurple60$2 = "#8B16C5";
  var ColorPalettePurple70$2 = "#9B18DC";
  var ColorPalettePurple80$2 = "#AD35E9";
  var ColorPalettePurple90$2 = "#B851EC";
  var ColorPalettePurple100$2 = "#C36CEF";
  var ColorPalettePurple110$2 = "#CC83F1";
  var ColorPalettePurple120$2 = "#D69AF4";
  var ColorPalettePurple130$2 = "#DFB1F6";
  var ColorPalettePurple140$2 = "#E8C8F9";
  var ColorPalettePurple150$2 = "#F2DFFB";
  var ColorPalettePurple160$2 = "#F9F1FD";
  var ColorPalettePink10$2 = "#3B0C27";
  var ColorPalettePink20$2 = "#4C1032";
  var ColorPalettePink30$2 = "#661543";
  var ColorPalettePink40$2 = "#77184E";
  var ColorPalettePink50$2 = "#8C1C5D";
  var ColorPalettePink60$2 = "#A12169";
  var ColorPalettePink70$2 = "#BA267B";
  var ColorPalettePink80$2 = "#D42B8C";
  var ColorPalettePink90$2 = "#DA499B";
  var ColorPalettePink100$2 = "#E067AB";
  var ColorPalettePink110$2 = "#E580B9";
  var ColorPalettePink120$2 = "#EA99C7";
  var ColorPalettePink130$2 = "#EFAFD3";
  var ColorPalettePink140$2 = "#F4C8E1";
  var ColorPalettePink150$2 = "#F8DDEC";
  var ColorPalettePink160$2 = "#FCF2F8";
  var ColorTypefaceStrong$2 = "#161616";
  var ColorTypefacePure$2 = "#363636";
  var ColorTypefaceSmooth$2 = "#666666";
  var ColorTypefaceMeld$2 = "#1616163D";
  var ColorTypefaceInverseStrong$2 = "#FEFEFE";
  var ColorTypefaceInversePure$2 = "#D4D4D4";
  var ColorTypefaceInverseSmooth$2 = "#919191";
  var ColorTypefaceInverseMeld$2 = "#FEFEFE52";
  var ColorTypefaceInverseOnBrandStrong$2 = "#161616";
  var ColorTypefaceInverseOnBrandPure$2 = "#363636";
  var ColorTypefaceInverseOnBrandSmooth$2 = "#666666";
  var ColorTypefaceInverseOnBrandMeld$2 = "#1616163D";
  var ColorTypefaceOnBrandStrong$2 = "#FEFEFE";
  var ColorTypefaceOnBrandPure$2 = "#FCF2FD";
  var ColorTypefaceOnBrandSmooth$2 = "#F1CAF6";
  var ColorTypefaceOnBrandMeld$2 = "#FEFEFE52";
  var ColorBrandPrimary10$2 = "#3B0042";
  var ColorBrandPrimary20$2 = "#4C0056";
  var ColorBrandPrimary30$2 = "#5F006B";
  var ColorBrandPrimary40$2 = "#730382";
  var ColorBrandPrimary50$2 = "#850396";
  var ColorBrandPrimary60$2 = "#9A0BAD";
  var ColorBrandPrimary70$2 = "#AD15C1";
  var ColorBrandPrimary80$2 = "#C223D7";
  var ColorBrandPrimary90$2 = "#CE42E0";
  var ColorBrandPrimary100$2 = "#D661E5";
  var ColorBrandPrimary110$2 = "#DE80EA";
  var ColorBrandPrimary120$2 = "#E59AEF";
  var ColorBrandPrimary130$1 = "#ECB4F3";
  var ColorBrandPrimary140$1 = "#F1CAF6";
  var ColorBrandPrimary150$1 = "#FCF2FD";
  var ColorBrandPrimary160$1 = "#FCF2FD";
  var ColorBrandBase01$2 = "#4C0056";
  var ColorBrandBase02$2 = "#3C698B";
  var ColorBrandPalette0110$1 = "#3B0042";
  var ColorBrandPalette0120$1 = "#4C0056";
  var ColorBrandPalette0130$1 = "#5F006B";
  var ColorBrandPalette0140$1 = "#730382";
  var ColorBrandPalette0150$1 = "#850396";
  var ColorBrandPalette0160$1 = "#9A0BAD";
  var ColorBrandPalette0170$1 = "#AD15C1";
  var ColorBrandPalette0180$1 = "#C223D7";
  var ColorBrandPalette0190$1 = "#CE42E0";
  var ColorBrandPalette01100$1 = "#D661E5";
  var ColorBrandPalette01110$1 = "#DE80EA";
  var ColorBrandPalette01120$1 = "#E59AEF";
  var ColorBrandPalette01130$1 = "#ECB4F3";
  var ColorBrandPalette01140$1 = "#F1CAF6";
  var ColorBrandPalette01150$1 = "#FCF2FD";
  var ColorBrandPalette01160$1 = "#FCF2FD";
  var ColorBrandPalette0210$1 = "#12202B";
  var ColorBrandPalette0220$1 = "#182B39";
  var ColorBrandPalette0230$1 = "#20384B";
  var ColorBrandPalette0240$1 = "#264359";
  var ColorBrandPalette0250$1 = "#2E516B";
  var ColorBrandPalette0260$1 = "#345B79";
  var ColorBrandPalette0270$1 = "#3C698B";
  var ColorBrandPalette0280$1 = "#4579A1";
  var ColorBrandPalette0290$1 = "#4D86B2";
  var ColorBrandPalette02100$1 = "#6597BD";
  var ColorBrandPalette02110$1 = "#7BA5C6";
  var ColorBrandPalette02120$1 = "#90B4D0";
  var ColorBrandPalette02130$1 = "#A9C5DA";
  var ColorBrandPalette02140$1 = "#C2D6E5";
  var ColorBrandPalette02150$1 = "#DBE7F0";
  var ColorBrandPalette02160$1 = "#F1F5F9";
  var ColorFeedbackErrorText$2 = "#BC293A";
  var ColorFeedbackErrorShape$2 = "#EA4356";
  var ColorFeedbackSuccessText$2 = "#22723A";
  var ColorFeedbackSuccessShape$2 = "#2D954C";
  var ColorFeedbackOnBrandErrorText$2 = "#F895A1";
  var ColorFeedbackOnBrandErrorShape$2 = "#F55C6E";
  var ColorFeedbackOnBrandSuccessText$2 = "#4BC870";
  var ColorFeedbackOnBrandSuccessShape$2 = "#32A454";
  var ColorFeedbackInverseErrorText$2 = "#F55C6E";
  var ColorFeedbackInverseErrorShape$2 = "#D83145";
  var ColorFeedbackInverseSuccessText$2 = "#32A454";
  var ColorFeedbackInverseSuccessShape$2 = "#278142";
  var ColorFeedbackInverseOnBrandErrorText$2 = "#A72534";
  var ColorFeedbackInverseOnBrandErrorShape$2 = "#D83145";
  var ColorFeedbackInverseOnBrandSuccessText$2 = "#1F6634";
  var ColorFeedbackInverseOnBrandSuccessShape$2 = "#278142";
  var ColorSupport01$2 = "#3C698B";
  var ColorSupport02$2 = "#3C698B";
  var ColorSupportOnBrand01$2 = "#6597BD";
  var ColorSupportOnBrand02$2 = "#6597BD";
  var ColorSupportInverse01$2 = "#4579A1";
  var ColorSupportInverse02$2 = "#4579A1";
  var ColorSupportInverseOnBrand01$2 = "#4579A1";
  var ColorSupportInverseOnBrand02$2 = "#4579A1";
  var Opacity01$2 = "0.04";
  var Opacity02$2 = "0.08";
  var Opacity03$2 = "0.12";
  var Opacity04$2 = "0.24";
  var Opacity05$2 = "0.32";
  var Opacity06$2 = "0.56";
  var Opacity07$2 = "0.64";
  var Opacity08$2 = "0.72";
  var Opacity09$2 = "0.88";
  var Shadow01$2 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
  var Shadow02$2 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
  var Shadow03$2 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
  var Shadow04$2 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
  var SpacingInlineQuark$2 = "4px";
  var SpacingInlineNano$2 = "8px";
  var SpacingInlineXxxs$2 = "16px";
  var SpacingInlineXxs$2 = "24px";
  var SpacingInlineXs$2 = "32px";
  var SpacingInlineSm$2 = "40px";
  var SpacingInlineMd$2 = "48px";
  var SpacingInlineLg$2 = "56px";
  var SpacingInlineXl$2 = "64px";
  var SpacingInlineXxl$2 = "80px";
  var SpacingInlineXxxl$2 = "120px";
  var SpacingInlineHuge$2 = "160px";
  var SpacingInlineGiant$2 = "200px";
  var SpacingInsetQuark$2 = "4px";
  var SpacingInsetNano$2 = "8px";
  var SpacingInsetXs$2 = "16px";
  var SpacingInsetSm$2 = "24px";
  var SpacingInsetMd$2 = "32px";
  var SpacingInsetLg$2 = "40px";
  var SpacingSquishQuark$2 = "4px 8px";
  var SpacingSquishNano$2 = "8px 16px";
  var SpacingSquishXs$2 = "16px 24px";
  var SpacingSquishSm$2 = "16px 32px";
  var SpacingStackQuark$2 = "4px";
  var SpacingStackNano$2 = "8px";
  var SpacingStackXxxs$2 = "16px";
  var SpacingStackXxs$2 = "24px";
  var SpacingStackXs$2 = "32px";
  var SpacingStackSm$2 = "40px";
  var SpacingStackMd$2 = "48px";
  var SpacingStackLg$2 = "56px";
  var SpacingStackXl$2 = "64px";
  var SpacingStackXxl$2 = "80px";
  var SpacingStackXxxl$2 = "120px";
  var SpacingStackHuge$2 = "160px";
  var SpacingStackGiant$2 = "200px";
  var FontFamilyBase$2 = "'Dasa Sans', 'sans-serif'";
  var FontSizeXxxs$2 = "0.75rem";
  var FontSizeXxs$2 = "0.875rem";
  var FontSizeXs$2 = "1rem";
  var FontSizeSm$2 = "1.25rem";
  var FontSizeMd$2 = "1.5rem";
  var FontSizeLg$2 = "2rem";
  var FontSizeXl$2 = "2.5rem";
  var FontSizeXxl$2 = "3rem";
  var FontSizeXxxl$2 = "4rem";
  var FontSizeDisplay$2 = "5rem";
  var FontSizeGiant$2 = "6rem";
  var FontWeightBold$2 = 700;
  var FontWeightSemibold$2 = 600;
  var FontWeightMedium$2 = 500;
  var FontWeightRegular$2 = 400;
  var FontWeightLight$2 = 300;
  var LetterSpacingStandard$2 = "0px";
  var LetterSpacingSmall$2 = "-1px";
  var LetterSpacingMedium$2 = "1.5px";
  var LineHeightStandard$2 = "100%";
  var LineHeightTiny$2 = "115%";
  var LineHeightMedium$2 = "120%";
  var LineHeightLarge$2 = "125%";
  var LineHeightDistant$2 = "133%";
  var LineHeightSuperdistant$2 = "150%";
  var LineHeightHuge$2 = "170%";
  var index$2 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BorderRadiusNone: BorderRadiusNone$2,
    BorderRadiusXs: BorderRadiusXs$2,
    BorderRadiusSm: BorderRadiusSm$2,
    BorderRadiusMd: BorderRadiusMd$2,
    BorderRadiusLg: BorderRadiusLg$2,
    BorderRadiusPill: BorderRadiusPill$2,
    BorderRadiusCircle: BorderRadiusCircle$2,
    BorderWidthNone: BorderWidthNone$2,
    BorderWidthHairline: BorderWidthHairline$2,
    BorderWidthThin: BorderWidthThin$2,
    BorderWidthThick: BorderWidthThick$2,
    BorderWidthHeavy: BorderWidthHeavy$2,
    ColorDatavizInfoText: ColorDatavizInfoText$2,
    ColorDatavizInfoShape01: ColorDatavizInfoShape01$2,
    ColorDatavizInfoShape02: ColorDatavizInfoShape02$2,
    ColorDatavizInfoShape03: ColorDatavizInfoShape03$2,
    ColorDatavizNegativeText: ColorDatavizNegativeText$2,
    ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$2,
    ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$2,
    ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$2,
    ColorDatavizWarningText: ColorDatavizWarningText$2,
    ColorDatavizWarningShape01: ColorDatavizWarningShape01$2,
    ColorDatavizWarningShape02: ColorDatavizWarningShape02$2,
    ColorDatavizWarningShape03: ColorDatavizWarningShape03$2,
    ColorDatavizPositiveText: ColorDatavizPositiveText$2,
    ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$2,
    ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$2,
    ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$2,
    ColorDatavizCatAText: ColorDatavizCatAText$2,
    ColorDatavizCatAShape01: ColorDatavizCatAShape01$2,
    ColorDatavizCatAShape02: ColorDatavizCatAShape02$2,
    ColorDatavizCatAShape03: ColorDatavizCatAShape03$2,
    ColorDatavizCatBText: ColorDatavizCatBText$2,
    ColorDatavizCatBShape01: ColorDatavizCatBShape01$2,
    ColorDatavizCatBShape02: ColorDatavizCatBShape02$2,
    ColorDatavizCatBShape03: ColorDatavizCatBShape03$2,
    ColorDatavizCatCText: ColorDatavizCatCText$2,
    ColorDatavizCatCShape01: ColorDatavizCatCShape01$2,
    ColorDatavizCatCShape02: ColorDatavizCatCShape02$2,
    ColorDatavizCatCShape03: ColorDatavizCatCShape03$2,
    ColorDatavizCatDText: ColorDatavizCatDText$2,
    ColorDatavizCatDShape01: ColorDatavizCatDShape01$2,
    ColorDatavizCatDShape02: ColorDatavizCatDShape02$2,
    ColorDatavizCatDShape03: ColorDatavizCatDShape03$2,
    ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$2,
    ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$2,
    ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$2,
    ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$2,
    ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$2,
    ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$2,
    ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$2,
    ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$2,
    ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$2,
    ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$2,
    ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$2,
    ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$2,
    ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$2,
    ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$2,
    ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$2,
    ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$2,
    ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$2,
    ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$2,
    ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$2,
    ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$2,
    ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$2,
    ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$2,
    ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$2,
    ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$2,
    ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$2,
    ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$2,
    ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$2,
    ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$2,
    ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$2,
    ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$2,
    ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$2,
    ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$2,
    ColorInteractionBlend01: ColorInteractionBlend01$2,
    ColorInteractionBlend02: ColorInteractionBlend02$2,
    ColorInteractionBlend03: ColorInteractionBlend03$2,
    ColorInteractionBlend04: ColorInteractionBlend04$2,
    ColorInteractionBlend05: ColorInteractionBlend05$2,
    ColorInteractionBlend06: ColorInteractionBlend06$2,
    ColorInteractionBlend07: ColorInteractionBlend07$2,
    ColorInteractionBlend08: ColorInteractionBlend08$2,
    ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$2,
    ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$2,
    ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$2,
    ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$2,
    ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$2,
    ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$2,
    ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$2,
    ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$2,
    ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$2,
    ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$2,
    ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$2,
    ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$2,
    ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$2,
    ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$2,
    ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$2,
    ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$2,
    ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$2,
    ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$2,
    ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$2,
    ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$2,
    ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$2,
    ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$2,
    ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$2,
    ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$2,
    ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$2,
    ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$2,
    ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$2,
    ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$2,
    ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$2,
    ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$2,
    ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$2,
    ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$2,
    ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$2,
    ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$2,
    ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$2,
    ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$2,
    ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$2,
    ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$2,
    ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$2,
    ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$2,
    ColorInteractionAccent01: ColorInteractionAccent01$2,
    ColorInteractionAccent02: ColorInteractionAccent02$2,
    ColorInteractionAccent03: ColorInteractionAccent03$2,
    ColorInteractionSubtle01: ColorInteractionSubtle01$2,
    ColorInteractionSubtle02: ColorInteractionSubtle02$2,
    ColorInteractionSubtle03: ColorInteractionSubtle03$2,
    ColorInteractionSelectDefault: ColorInteractionSelectDefault$2,
    ColorInteractionSelectFocus: ColorInteractionSelectFocus$2,
    ColorInteractionSelectActive: ColorInteractionSelectActive$2,
    ColorInteractionDanger01: ColorInteractionDanger01$2,
    ColorInteractionDanger02: ColorInteractionDanger02$2,
    ColorInteractionDanger03: ColorInteractionDanger03$2,
    ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$2,
    ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$2,
    ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$2,
    ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$2,
    ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$2,
    ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$2,
    ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$2,
    ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$2,
    ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$2,
    ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$2,
    ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$2,
    ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$2,
    ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$2,
    ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$2,
    ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$2,
    ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$2,
    ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$2,
    ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$2,
    ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$2,
    ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$2,
    ColorNeutral10: ColorNeutral10$2,
    ColorNeutral20: ColorNeutral20$2,
    ColorNeutral30: ColorNeutral30$2,
    ColorNeutral00: ColorNeutral00$2,
    ColorNeutralInverse10: ColorNeutralInverse10$2,
    ColorNeutralInverse20: ColorNeutralInverse20$2,
    ColorNeutralInverse30: ColorNeutralInverse30$2,
    ColorNeutralInverse00: ColorNeutralInverse00$2,
    ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$2,
    ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$2,
    ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$2,
    ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$2,
    ColorNeutralOnBrand10: ColorNeutralOnBrand10$2,
    ColorNeutralOnBrand20: ColorNeutralOnBrand20$2,
    ColorNeutralOnBrand30: ColorNeutralOnBrand30$2,
    ColorNeutralOnBrand00: ColorNeutralOnBrand00$2,
    ColorPaletteBlack: ColorPaletteBlack$2,
    ColorPaletteWhite: ColorPaletteWhite$2,
    ColorPaletteGray10: ColorPaletteGray10$2,
    ColorPaletteGray20: ColorPaletteGray20$2,
    ColorPaletteGray30: ColorPaletteGray30$2,
    ColorPaletteGray40: ColorPaletteGray40$2,
    ColorPaletteGray50: ColorPaletteGray50$2,
    ColorPaletteGray60: ColorPaletteGray60$2,
    ColorPaletteGray70: ColorPaletteGray70$2,
    ColorPaletteGray80: ColorPaletteGray80$2,
    ColorPaletteGray90: ColorPaletteGray90$2,
    ColorPaletteGray100: ColorPaletteGray100$2,
    ColorPaletteGray110: ColorPaletteGray110$2,
    ColorPaletteGray120: ColorPaletteGray120$2,
    ColorPaletteGray130: ColorPaletteGray130$2,
    ColorPaletteGray140: ColorPaletteGray140$2,
    ColorPaletteGray150: ColorPaletteGray150$2,
    ColorPaletteGray160: ColorPaletteGray160$2,
    ColorPaletteRed10: ColorPaletteRed10$2,
    ColorPaletteRed20: ColorPaletteRed20$2,
    ColorPaletteRed30: ColorPaletteRed30$2,
    ColorPaletteRed40: ColorPaletteRed40$2,
    ColorPaletteRed50: ColorPaletteRed50$2,
    ColorPaletteRed60: ColorPaletteRed60$2,
    ColorPaletteRed70: ColorPaletteRed70$2,
    ColorPaletteRed80: ColorPaletteRed80$2,
    ColorPaletteRed90: ColorPaletteRed90$2,
    ColorPaletteRed100: ColorPaletteRed100$2,
    ColorPaletteRed110: ColorPaletteRed110$2,
    ColorPaletteRed120: ColorPaletteRed120$2,
    ColorPaletteRed130: ColorPaletteRed130$2,
    ColorPaletteRed140: ColorPaletteRed140$2,
    ColorPaletteRed150: ColorPaletteRed150$2,
    ColorPaletteRed160: ColorPaletteRed160$2,
    ColorPaletteYellow10: ColorPaletteYellow10$2,
    ColorPaletteYellow20: ColorPaletteYellow20$2,
    ColorPaletteYellow30: ColorPaletteYellow30$2,
    ColorPaletteYellow40: ColorPaletteYellow40$2,
    ColorPaletteYellow50: ColorPaletteYellow50$2,
    ColorPaletteYellow60: ColorPaletteYellow60$2,
    ColorPaletteYellow70: ColorPaletteYellow70$2,
    ColorPaletteYellow80: ColorPaletteYellow80$2,
    ColorPaletteYellow90: ColorPaletteYellow90$2,
    ColorPaletteYellow100: ColorPaletteYellow100$2,
    ColorPaletteYellow110: ColorPaletteYellow110$2,
    ColorPaletteYellow120: ColorPaletteYellow120$2,
    ColorPaletteYellow130: ColorPaletteYellow130$2,
    ColorPaletteYellow140: ColorPaletteYellow140$2,
    ColorPaletteYellow150: ColorPaletteYellow150$2,
    ColorPaletteYellow160: ColorPaletteYellow160$2,
    ColorPaletteLime10: ColorPaletteLime10$2,
    ColorPaletteLime20: ColorPaletteLime20$2,
    ColorPaletteLime30: ColorPaletteLime30$2,
    ColorPaletteLime40: ColorPaletteLime40$2,
    ColorPaletteLime50: ColorPaletteLime50$2,
    ColorPaletteLime60: ColorPaletteLime60$2,
    ColorPaletteLime70: ColorPaletteLime70$2,
    ColorPaletteLime80: ColorPaletteLime80$2,
    ColorPaletteLime90: ColorPaletteLime90$2,
    ColorPaletteLime100: ColorPaletteLime100$2,
    ColorPaletteLime110: ColorPaletteLime110$2,
    ColorPaletteLime120: ColorPaletteLime120$2,
    ColorPaletteLime130: ColorPaletteLime130$2,
    ColorPaletteLime140: ColorPaletteLime140$2,
    ColorPaletteLime150: ColorPaletteLime150$2,
    ColorPaletteLime160: ColorPaletteLime160$2,
    ColorPaletteGreen10: ColorPaletteGreen10$2,
    ColorPaletteGreen20: ColorPaletteGreen20$2,
    ColorPaletteGreen30: ColorPaletteGreen30$2,
    ColorPaletteGreen40: ColorPaletteGreen40$2,
    ColorPaletteGreen50: ColorPaletteGreen50$2,
    ColorPaletteGreen60: ColorPaletteGreen60$2,
    ColorPaletteGreen70: ColorPaletteGreen70$2,
    ColorPaletteGreen80: ColorPaletteGreen80$2,
    ColorPaletteGreen90: ColorPaletteGreen90$2,
    ColorPaletteGreen100: ColorPaletteGreen100$2,
    ColorPaletteGreen110: ColorPaletteGreen110$2,
    ColorPaletteGreen120: ColorPaletteGreen120$2,
    ColorPaletteGreen130: ColorPaletteGreen130$2,
    ColorPaletteGreen140: ColorPaletteGreen140$2,
    ColorPaletteGreen150: ColorPaletteGreen150$2,
    ColorPaletteGreen160: ColorPaletteGreen160$2,
    ColorPaletteAcqua10: ColorPaletteAcqua10$2,
    ColorPaletteAcqua20: ColorPaletteAcqua20$2,
    ColorPaletteAcqua30: ColorPaletteAcqua30$2,
    ColorPaletteAcqua40: ColorPaletteAcqua40$2,
    ColorPaletteAcqua50: ColorPaletteAcqua50$2,
    ColorPaletteAcqua60: ColorPaletteAcqua60$2,
    ColorPaletteAcqua70: ColorPaletteAcqua70$2,
    ColorPaletteAcqua80: ColorPaletteAcqua80$2,
    ColorPaletteAcqua90: ColorPaletteAcqua90$2,
    ColorPaletteAcqua100: ColorPaletteAcqua100$2,
    ColorPaletteAcqua110: ColorPaletteAcqua110$2,
    ColorPaletteAcqua120: ColorPaletteAcqua120$2,
    ColorPaletteAcqua130: ColorPaletteAcqua130$2,
    ColorPaletteAcqua140: ColorPaletteAcqua140$2,
    ColorPaletteAcqua150: ColorPaletteAcqua150$2,
    ColorPaletteAcqua160: ColorPaletteAcqua160$2,
    ColorPaletteBlue10: ColorPaletteBlue10$2,
    ColorPaletteBlue20: ColorPaletteBlue20$2,
    ColorPaletteBlue30: ColorPaletteBlue30$2,
    ColorPaletteBlue40: ColorPaletteBlue40$2,
    ColorPaletteBlue50: ColorPaletteBlue50$2,
    ColorPaletteBlue60: ColorPaletteBlue60$2,
    ColorPaletteBlue70: ColorPaletteBlue70$2,
    ColorPaletteBlue80: ColorPaletteBlue80$2,
    ColorPaletteBlue90: ColorPaletteBlue90$2,
    ColorPaletteBlue100: ColorPaletteBlue100$2,
    ColorPaletteBlue110: ColorPaletteBlue110$2,
    ColorPaletteBlue120: ColorPaletteBlue120$2,
    ColorPaletteBlue130: ColorPaletteBlue130$2,
    ColorPaletteBlue140: ColorPaletteBlue140$2,
    ColorPaletteBlue150: ColorPaletteBlue150$2,
    ColorPaletteBlue160: ColorPaletteBlue160$2,
    ColorPalettePurple10: ColorPalettePurple10$2,
    ColorPalettePurple20: ColorPalettePurple20$2,
    ColorPalettePurple30: ColorPalettePurple30$2,
    ColorPalettePurple40: ColorPalettePurple40$2,
    ColorPalettePurple50: ColorPalettePurple50$2,
    ColorPalettePurple60: ColorPalettePurple60$2,
    ColorPalettePurple70: ColorPalettePurple70$2,
    ColorPalettePurple80: ColorPalettePurple80$2,
    ColorPalettePurple90: ColorPalettePurple90$2,
    ColorPalettePurple100: ColorPalettePurple100$2,
    ColorPalettePurple110: ColorPalettePurple110$2,
    ColorPalettePurple120: ColorPalettePurple120$2,
    ColorPalettePurple130: ColorPalettePurple130$2,
    ColorPalettePurple140: ColorPalettePurple140$2,
    ColorPalettePurple150: ColorPalettePurple150$2,
    ColorPalettePurple160: ColorPalettePurple160$2,
    ColorPalettePink10: ColorPalettePink10$2,
    ColorPalettePink20: ColorPalettePink20$2,
    ColorPalettePink30: ColorPalettePink30$2,
    ColorPalettePink40: ColorPalettePink40$2,
    ColorPalettePink50: ColorPalettePink50$2,
    ColorPalettePink60: ColorPalettePink60$2,
    ColorPalettePink70: ColorPalettePink70$2,
    ColorPalettePink80: ColorPalettePink80$2,
    ColorPalettePink90: ColorPalettePink90$2,
    ColorPalettePink100: ColorPalettePink100$2,
    ColorPalettePink110: ColorPalettePink110$2,
    ColorPalettePink120: ColorPalettePink120$2,
    ColorPalettePink130: ColorPalettePink130$2,
    ColorPalettePink140: ColorPalettePink140$2,
    ColorPalettePink150: ColorPalettePink150$2,
    ColorPalettePink160: ColorPalettePink160$2,
    ColorTypefaceStrong: ColorTypefaceStrong$2,
    ColorTypefacePure: ColorTypefacePure$2,
    ColorTypefaceSmooth: ColorTypefaceSmooth$2,
    ColorTypefaceMeld: ColorTypefaceMeld$2,
    ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$2,
    ColorTypefaceInversePure: ColorTypefaceInversePure$2,
    ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$2,
    ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$2,
    ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$2,
    ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$2,
    ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$2,
    ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$2,
    ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$2,
    ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$2,
    ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$2,
    ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$2,
    ColorBrandPrimary10: ColorBrandPrimary10$2,
    ColorBrandPrimary20: ColorBrandPrimary20$2,
    ColorBrandPrimary30: ColorBrandPrimary30$2,
    ColorBrandPrimary40: ColorBrandPrimary40$2,
    ColorBrandPrimary50: ColorBrandPrimary50$2,
    ColorBrandPrimary60: ColorBrandPrimary60$2,
    ColorBrandPrimary70: ColorBrandPrimary70$2,
    ColorBrandPrimary80: ColorBrandPrimary80$2,
    ColorBrandPrimary90: ColorBrandPrimary90$2,
    ColorBrandPrimary100: ColorBrandPrimary100$2,
    ColorBrandPrimary110: ColorBrandPrimary110$2,
    ColorBrandPrimary120: ColorBrandPrimary120$2,
    ColorBrandPrimary130: ColorBrandPrimary130$1,
    ColorBrandPrimary140: ColorBrandPrimary140$1,
    ColorBrandPrimary150: ColorBrandPrimary150$1,
    ColorBrandPrimary160: ColorBrandPrimary160$1,
    ColorBrandBase01: ColorBrandBase01$2,
    ColorBrandBase02: ColorBrandBase02$2,
    ColorBrandPalette0110: ColorBrandPalette0110$1,
    ColorBrandPalette0120: ColorBrandPalette0120$1,
    ColorBrandPalette0130: ColorBrandPalette0130$1,
    ColorBrandPalette0140: ColorBrandPalette0140$1,
    ColorBrandPalette0150: ColorBrandPalette0150$1,
    ColorBrandPalette0160: ColorBrandPalette0160$1,
    ColorBrandPalette0170: ColorBrandPalette0170$1,
    ColorBrandPalette0180: ColorBrandPalette0180$1,
    ColorBrandPalette0190: ColorBrandPalette0190$1,
    ColorBrandPalette01100: ColorBrandPalette01100$1,
    ColorBrandPalette01110: ColorBrandPalette01110$1,
    ColorBrandPalette01120: ColorBrandPalette01120$1,
    ColorBrandPalette01130: ColorBrandPalette01130$1,
    ColorBrandPalette01140: ColorBrandPalette01140$1,
    ColorBrandPalette01150: ColorBrandPalette01150$1,
    ColorBrandPalette01160: ColorBrandPalette01160$1,
    ColorBrandPalette0210: ColorBrandPalette0210$1,
    ColorBrandPalette0220: ColorBrandPalette0220$1,
    ColorBrandPalette0230: ColorBrandPalette0230$1,
    ColorBrandPalette0240: ColorBrandPalette0240$1,
    ColorBrandPalette0250: ColorBrandPalette0250$1,
    ColorBrandPalette0260: ColorBrandPalette0260$1,
    ColorBrandPalette0270: ColorBrandPalette0270$1,
    ColorBrandPalette0280: ColorBrandPalette0280$1,
    ColorBrandPalette0290: ColorBrandPalette0290$1,
    ColorBrandPalette02100: ColorBrandPalette02100$1,
    ColorBrandPalette02110: ColorBrandPalette02110$1,
    ColorBrandPalette02120: ColorBrandPalette02120$1,
    ColorBrandPalette02130: ColorBrandPalette02130$1,
    ColorBrandPalette02140: ColorBrandPalette02140$1,
    ColorBrandPalette02150: ColorBrandPalette02150$1,
    ColorBrandPalette02160: ColorBrandPalette02160$1,
    ColorFeedbackErrorText: ColorFeedbackErrorText$2,
    ColorFeedbackErrorShape: ColorFeedbackErrorShape$2,
    ColorFeedbackSuccessText: ColorFeedbackSuccessText$2,
    ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$2,
    ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$2,
    ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$2,
    ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$2,
    ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$2,
    ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$2,
    ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$2,
    ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$2,
    ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$2,
    ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$2,
    ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$2,
    ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$2,
    ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$2,
    ColorSupport01: ColorSupport01$2,
    ColorSupport02: ColorSupport02$2,
    ColorSupportOnBrand01: ColorSupportOnBrand01$2,
    ColorSupportOnBrand02: ColorSupportOnBrand02$2,
    ColorSupportInverse01: ColorSupportInverse01$2,
    ColorSupportInverse02: ColorSupportInverse02$2,
    ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$2,
    ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$2,
    Opacity01: Opacity01$2,
    Opacity02: Opacity02$2,
    Opacity03: Opacity03$2,
    Opacity04: Opacity04$2,
    Opacity05: Opacity05$2,
    Opacity06: Opacity06$2,
    Opacity07: Opacity07$2,
    Opacity08: Opacity08$2,
    Opacity09: Opacity09$2,
    Shadow01: Shadow01$2,
    Shadow02: Shadow02$2,
    Shadow03: Shadow03$2,
    Shadow04: Shadow04$2,
    SpacingInlineQuark: SpacingInlineQuark$2,
    SpacingInlineNano: SpacingInlineNano$2,
    SpacingInlineXxxs: SpacingInlineXxxs$2,
    SpacingInlineXxs: SpacingInlineXxs$2,
    SpacingInlineXs: SpacingInlineXs$2,
    SpacingInlineSm: SpacingInlineSm$2,
    SpacingInlineMd: SpacingInlineMd$2,
    SpacingInlineLg: SpacingInlineLg$2,
    SpacingInlineXl: SpacingInlineXl$2,
    SpacingInlineXxl: SpacingInlineXxl$2,
    SpacingInlineXxxl: SpacingInlineXxxl$2,
    SpacingInlineHuge: SpacingInlineHuge$2,
    SpacingInlineGiant: SpacingInlineGiant$2,
    SpacingInsetQuark: SpacingInsetQuark$2,
    SpacingInsetNano: SpacingInsetNano$2,
    SpacingInsetXs: SpacingInsetXs$2,
    SpacingInsetSm: SpacingInsetSm$2,
    SpacingInsetMd: SpacingInsetMd$2,
    SpacingInsetLg: SpacingInsetLg$2,
    SpacingSquishQuark: SpacingSquishQuark$2,
    SpacingSquishNano: SpacingSquishNano$2,
    SpacingSquishXs: SpacingSquishXs$2,
    SpacingSquishSm: SpacingSquishSm$2,
    SpacingStackQuark: SpacingStackQuark$2,
    SpacingStackNano: SpacingStackNano$2,
    SpacingStackXxxs: SpacingStackXxxs$2,
    SpacingStackXxs: SpacingStackXxs$2,
    SpacingStackXs: SpacingStackXs$2,
    SpacingStackSm: SpacingStackSm$2,
    SpacingStackMd: SpacingStackMd$2,
    SpacingStackLg: SpacingStackLg$2,
    SpacingStackXl: SpacingStackXl$2,
    SpacingStackXxl: SpacingStackXxl$2,
    SpacingStackXxxl: SpacingStackXxxl$2,
    SpacingStackHuge: SpacingStackHuge$2,
    SpacingStackGiant: SpacingStackGiant$2,
    FontFamilyBase: FontFamilyBase$2,
    FontSizeXxxs: FontSizeXxxs$2,
    FontSizeXxs: FontSizeXxs$2,
    FontSizeXs: FontSizeXs$2,
    FontSizeSm: FontSizeSm$2,
    FontSizeMd: FontSizeMd$2,
    FontSizeLg: FontSizeLg$2,
    FontSizeXl: FontSizeXl$2,
    FontSizeXxl: FontSizeXxl$2,
    FontSizeXxxl: FontSizeXxxl$2,
    FontSizeDisplay: FontSizeDisplay$2,
    FontSizeGiant: FontSizeGiant$2,
    FontWeightBold: FontWeightBold$2,
    FontWeightSemibold: FontWeightSemibold$2,
    FontWeightMedium: FontWeightMedium$2,
    FontWeightRegular: FontWeightRegular$2,
    FontWeightLight: FontWeightLight$2,
    LetterSpacingStandard: LetterSpacingStandard$2,
    LetterSpacingSmall: LetterSpacingSmall$2,
    LetterSpacingMedium: LetterSpacingMedium$2,
    LineHeightStandard: LineHeightStandard$2,
    LineHeightTiny: LineHeightTiny$2,
    LineHeightMedium: LineHeightMedium$2,
    LineHeightLarge: LineHeightLarge$2,
    LineHeightDistant: LineHeightDistant$2,
    LineHeightSuperdistant: LineHeightSuperdistant$2,
    LineHeightHuge: LineHeightHuge$2
  });
  /**
   * Do not edit directly
   * Generated on Thu, 27 Oct 2022 18:07:47 GMT
   */

  var BorderRadiusNone$1 = "0px";
  var BorderRadiusXs$1 = "4px";
  var BorderRadiusSm$1 = "8px";
  var BorderRadiusMd$1 = "16px";
  var BorderRadiusLg$1 = "24px";
  var BorderRadiusPill$1 = "960px";
  var BorderRadiusCircle$1 = "50%";
  var BorderWidthNone$1 = "0px";
  var BorderWidthHairline$1 = "1px";
  var BorderWidthThin$1 = "2px";
  var BorderWidthThick$1 = "4px";
  var BorderWidthHeavy$1 = "8px";
  var ColorDatavizInfoText$1 = "#0F58EA";
  var ColorDatavizInfoShape01$1 = "#3F7BF2";
  var ColorDatavizInfoShape02$1 = "#D9E5FC";
  var ColorDatavizInfoShape03$1 = "#F1F5FE";
  var ColorDatavizNegativeText$1 = "#BC293A";
  var ColorDatavizNegativeShape01$1 = "#EA4356";
  var ColorDatavizNegativeShape02$1 = "#FDDDE1";
  var ColorDatavizNegativeShape03$1 = "#FEF1F2";
  var ColorDatavizWarningText$1 = "#A04C03";
  var ColorDatavizWarningShape01$1 = "#D26404";
  var ColorDatavizWarningShape02$1 = "#FEE1C8";
  var ColorDatavizWarningShape03$1 = "#FEF1E6";
  var ColorDatavizPositiveText$1 = "#22723A";
  var ColorDatavizPositiveShape01$1 = "#2D954C";
  var ColorDatavizPositiveShape02$1 = "#C8EED3";
  var ColorDatavizPositiveShape03$1 = "#E8F8EC";
  var ColorDatavizCatAText$1 = "#9B18DC";
  var ColorDatavizCatAShape01$1 = "#B851EC";
  var ColorDatavizCatAShape02$1 = "#F2DFFB";
  var ColorDatavizCatAShape03$1 = "#F9F1FD";
  var ColorDatavizCatBText$1 = "#BA267B";
  var ColorDatavizCatBShape01$1 = "#DA499B";
  var ColorDatavizCatBShape02$1 = "#F8DDEC";
  var ColorDatavizCatBShape03$1 = "#FCF2F8";
  var ColorDatavizCatCText$1 = "#546E21";
  var ColorDatavizCatCShape01$1 = "#6C8D2B";
  var ColorDatavizCatCShape02$1 = "#DBEBBD";
  var ColorDatavizCatCShape03$1 = "#F0F7E4";
  var ColorDatavizCatDText$1 = "#0D735E";
  var ColorDatavizCatDShape01$1 = "#109379";
  var ColorDatavizCatDShape02$1 = "#BCF0E6";
  var ColorDatavizCatDShape03$1 = "#DFFBF6";
  var ColorDatavizInverseInfoText$1 = "#5C8FF5";
  var ColorDatavizInverseInfoShape01$1 = "#286BF1";
  var ColorDatavizInverseInfoShape02$1 = "#062560";
  var ColorDatavizInverseInfoShape03$1 = "#051B48";
  var ColorDatavizInverseNegativeText$1 = "#F55C6E";
  var ColorDatavizInverseNegativeShape01$1 = "#D83145";
  var ColorDatavizInverseNegativeShape02$1 = "#4F1119";
  var ColorDatavizInverseNegativeShape03$1 = "#3B0D12";
  var ColorDatavizInverseWarningText$1 = "#EB7005";
  var ColorDatavizInverseWarningShape01$1 = "#B95804";
  var ColorDatavizInverseWarningShape02$1 = "#462101";
  var ColorDatavizInverseWarningShape03$1 = "#321701";
  var ColorDatavizInversePositiveText$1 = "#32A454";
  var ColorDatavizInversePositiveShape01$1 = "#278142";
  var ColorDatavizInversePositiveShape02$1 = "#0E2F18";
  var ColorDatavizInversePositiveShape03$1 = "#0B2312";
  var ColorDatavizInverseCatAText$1 = "#C36CEF";
  var ColorDatavizInverseCatAShape01$1 = "#AD35E9";
  var ColorDatavizInverseCatAShape02$1 = "#440B60";
  var ColorDatavizInverseCatAShape03$1 = "#340849";
  var ColorDatavizInverseCatBText$1 = "#E067AB";
  var ColorDatavizInverseCatBShape01$1 = "#D42B8C";
  var ColorDatavizInverseCatBShape02$1 = "#4C1032";
  var ColorDatavizInverseCatBShape03$1 = "#3B0C27";
  var ColorDatavizInverseCatCText$1 = "#789D2F";
  var ColorDatavizInverseCatCShape01$1 = "#607E26";
  var ColorDatavizInverseCatCShape02$1 = "#212B0D";
  var ColorDatavizInverseCatCShape03$1 = "#1B230B";
  var ColorDatavizInverseCatDText$1 = "#12A588";
  var ColorDatavizInverseCatDShape01$1 = "#0F856D";
  var ColorDatavizInverseCatDShape02$1 = "#052E26";
  var ColorDatavizInverseCatDShape03$1 = "#04251E";
  var ColorInteractionBlend01$1 = "#1616160A";
  var ColorInteractionBlend02$1 = "#16161614";
  var ColorInteractionBlend03$1 = "#1616161F";
  var ColorInteractionBlend04$1 = "#1616163D";
  var ColorInteractionBlend05$1 = "#161616A3";
  var ColorInteractionBlend06$1 = "#161616B8";
  var ColorInteractionBlend07$1 = "#161616E0";
  var ColorInteractionBlend08$1 = "#161616";
  var ColorInteractionInverseBlend01$1 = "#FEFEFE14";
  var ColorInteractionInverseBlend02$1 = "#FEFEFE1F";
  var ColorInteractionInverseBlend03$1 = "#FEFEFE3D";
  var ColorInteractionInverseBlend04$1 = "#FEFEFE52";
  var ColorInteractionInverseBlend05$1 = "#FEFEFEA3";
  var ColorInteractionInverseBlend06$1 = "#FEFEFEB8";
  var ColorInteractionInverseBlend07$1 = "#FEFEFEE0";
  var ColorInteractionInverseBlend08$1 = "#FEFEFE";
  var ColorInteractionInverseAccent01$1 = "#8AA3FF";
  var ColorInteractionInverseAccent02$1 = "#99AFFF";
  var ColorInteractionInverseAccent03$1 = "#B3C3FF";
  var ColorInteractionInverseSubtle01$1 = "#6D8DFF1F";
  var ColorInteractionInverseSubtle02$1 = "#6D8DFF3D";
  var ColorInteractionInverseSubtle03$1 = "#6D8DFF52";
  var ColorInteractionInverseSelectDefault$1 = "#666666";
  var ColorInteractionInverseSelectFocus$1 = "#919191";
  var ColorInteractionInverseSelectActive$1 = "#8AA3FF";
  var ColorInteractionInverseDanger01$1 = "#D83145";
  var ColorInteractionInverseDanger02$1 = "#EA4356";
  var ColorInteractionInverseDanger03$1 = "#F55C6E";
  var ColorInteractionInverseOnBrandAccent01$1 = "#002FDB";
  var ColorInteractionInverseOnBrandAccent02$1 = "#0028B8";
  var ColorInteractionInverseOnBrandAccent03$1 = "#00229E";
  var ColorInteractionInverseOnBrandSubtle01$1 = "#0B278F14";
  var ColorInteractionInverseOnBrandSubtle02$1 = "#0B278F1F";
  var ColorInteractionInverseOnBrandSubtle03$1 = "#0B278F3D";
  var ColorInteractionInverseOnBrandSelectDefault$1 = "#363636";
  var ColorInteractionInverseOnBrandSelectFocus$1 = "#292929";
  var ColorInteractionInverseOnBrandSelectActive$1 = "#002FDB";
  var ColorInteractionInverseOnBrandBlend01$1 = "#1616160A";
  var ColorInteractionInverseOnBrandBlend02$1 = "#16161614";
  var ColorInteractionInverseOnBrandBlend03$1 = "#1616161F";
  var ColorInteractionInverseOnBrandBlend04$1 = "#1616163D";
  var ColorInteractionInverseOnBrandBlend05$1 = "#161616A3";
  var ColorInteractionInverseOnBrandBlend06$1 = "#161616B8";
  var ColorInteractionInverseOnBrandBlend07$1 = "#161616E0";
  var ColorInteractionInverseOnBrandBlend08$1 = "#161616";
  var ColorInteractionInverseOnBrandDanger01$1 = "#4F1119";
  var ColorInteractionInverseOnBrandDanger02$1 = "#691721";
  var ColorInteractionInverseOnBrandDanger03$1 = "#7E1B27";
  var ColorInteractionAccent01$1 = "#0037FF";
  var ColorInteractionAccent02$1 = "#002FDB";
  var ColorInteractionAccent03$1 = "#0028B8";
  var ColorInteractionSubtle01$1 = "#0037FF1F";
  var ColorInteractionSubtle02$1 = "#0037FF3D";
  var ColorInteractionSubtle03$1 = "#0037FF52";
  var ColorInteractionSelectDefault$1 = "#595959";
  var ColorInteractionSelectFocus$1 = "#363636";
  var ColorInteractionSelectActive$1 = "#0037FF";
  var ColorInteractionDanger01$1 = "#92202E";
  var ColorInteractionDanger02$1 = "#7E1B27";
  var ColorInteractionDanger03$1 = "#691721";
  var ColorInteractionOnBrandAccent01$1 = "#FEFEFE";
  var ColorInteractionOnBrandAccent02$1 = "#DBE3FF";
  var ColorInteractionOnBrandAccent03$1 = "#C7D3FF";
  var ColorInteractionOnBrandSubtle01$1 = "#FEFEFE1F";
  var ColorInteractionOnBrandSubtle02$1 = "#FEFEFE3D";
  var ColorInteractionOnBrandSubtle03$1 = "#FEFEFE52";
  var ColorInteractionOnBrandSelectDefault$1 = "#C7D3FF";
  var ColorInteractionOnBrandSelectFocus$1 = "#DBE3FF";
  var ColorInteractionOnBrandSelectActive$1 = "#FEFEFE";
  var ColorInteractionOnBrandBlend01$1 = "#FEFEFE14";
  var ColorInteractionOnBrandBlend02$1 = "#FEFEFE1F";
  var ColorInteractionOnBrandBlend03$1 = "#FEFEFE3D";
  var ColorInteractionOnBrandBlend04$1 = "#FEFEFE52";
  var ColorInteractionOnBrandBlend05$1 = "#FEFEFEA3";
  var ColorInteractionOnBrandBlend06$1 = "#FEFEFEB8";
  var ColorInteractionOnBrandBlend07$1 = "#FEFEFEE0";
  var ColorInteractionOnBrandBlend08$1 = "#FEFEFE";
  var ColorInteractionOnBrandDanger01$1 = "#F895A1";
  var ColorInteractionOnBrandDanger02$1 = "#F77E8C";
  var ColorInteractionOnBrandDanger03$1 = "#F55C6E";
  var ColorNeutral10$1 = "#F5F5F5";
  var ColorNeutral20$1 = "#E6E6E6";
  var ColorNeutral30$1 = "#1616163D";
  var ColorNeutral00$1 = "#FEFEFE";
  var ColorNeutralInverse10$1 = "#1F1F1F";
  var ColorNeutralInverse20$1 = "#292929";
  var ColorNeutralInverse30$1 = "#FEFEFE3D";
  var ColorNeutralInverse00$1 = "#161616";
  var ColorNeutralInverseOnBrand10$1 = "#DBE3FF";
  var ColorNeutralInverseOnBrand20$1 = "#C7D3FF";
  var ColorNeutralInverseOnBrand30$1 = "#0037FF7A";
  var ColorNeutralInverseOnBrand00$1 = "#F0F3FF";
  var ColorNeutralOnBrand10$1 = "#002FDB";
  var ColorNeutralOnBrand20$1 = "#0028B8";
  var ColorNeutralOnBrand30$1 = "#00229EE0";
  var ColorNeutralOnBrand00$1 = "#0037FF";
  var ColorPaletteBlack$1 = "#161616";
  var ColorPaletteWhite$1 = "#FEFEFE";
  var ColorPaletteGray10$1 = "#1F1F1F";
  var ColorPaletteGray20$1 = "#292929";
  var ColorPaletteGray30$1 = "#363636";
  var ColorPaletteGray40$1 = "#404040";
  var ColorPaletteGray50$1 = "#4C4C4C";
  var ColorPaletteGray60$1 = "#595959";
  var ColorPaletteGray70$1 = "#666666";
  var ColorPaletteGray80$1 = "#737373";
  var ColorPaletteGray90$1 = "#828282";
  var ColorPaletteGray100$1 = "#919191";
  var ColorPaletteGray110$1 = "#A1A1A1";
  var ColorPaletteGray120$1 = "#B0B0B0";
  var ColorPaletteGray130$1 = "#C2C2C2";
  var ColorPaletteGray140$1 = "#D4D4D4";
  var ColorPaletteGray150$1 = "#E6E6E6";
  var ColorPaletteGray160$1 = "#F5F5F5";
  var ColorPaletteRed10$1 = "#3B0D12";
  var ColorPaletteRed20$1 = "#4F1119";
  var ColorPaletteRed30$1 = "#691721";
  var ColorPaletteRed40$1 = "#7E1B27";
  var ColorPaletteRed50$1 = "#92202E";
  var ColorPaletteRed60$1 = "#A72534";
  var ColorPaletteRed70$1 = "#BC293A";
  var ColorPaletteRed80$1 = "#D83145";
  var ColorPaletteRed90$1 = "#EA4356";
  var ColorPaletteRed100$1 = "#F55C6E";
  var ColorPaletteRed110$1 = "#F77E8C";
  var ColorPaletteRed120$1 = "#F895A1";
  var ColorPaletteRed130$1 = "#FAAEB6";
  var ColorPaletteRed140$1 = "#FBC5CC";
  var ColorPaletteRed150$1 = "#FDDDE1";
  var ColorPaletteRed160$1 = "#FEF1F2";
  var ColorPaletteYellow10$1 = "#321701";
  var ColorPaletteYellow20$1 = "#462101";
  var ColorPaletteYellow30$1 = "#552802";
  var ColorPaletteYellow40$1 = "#693102";
  var ColorPaletteYellow50$1 = "#7D3B03";
  var ColorPaletteYellow60$1 = "#914503";
  var ColorPaletteYellow70$1 = "#A04C03";
  var ColorPaletteYellow80$1 = "#B95804";
  var ColorPaletteYellow90$1 = "#D26404";
  var ColorPaletteYellow100$1 = "#EB7005";
  var ColorPaletteYellow110$1 = "#FA8219";
  var ColorPaletteYellow120$1 = "#FB9B46";
  var ColorPaletteYellow130$1 = "#FCB06E";
  var ColorPaletteYellow140$1 = "#FDC99B";
  var ColorPaletteYellow150$1 = "#FEE1C8";
  var ColorPaletteYellow160$1 = "#FEF1E6";
  var ColorPaletteLime10$1 = "#1B230B";
  var ColorPaletteLime20$1 = "#212B0D";
  var ColorPaletteLime30$1 = "#2D3B12";
  var ColorPaletteLime40$1 = "#364616";
  var ColorPaletteLime50$1 = "#3F5219";
  var ColorPaletteLime60$1 = "#485E1D";
  var ColorPaletteLime70$1 = "#546E21";
  var ColorPaletteLime80$1 = "#607E26";
  var ColorPaletteLime90$1 = "#6C8D2B";
  var ColorPaletteLime100$1 = "#789D2F";
  var ColorPaletteLime110$1 = "#84AC34";
  var ColorPaletteLime120$1 = "#93BF3A";
  var ColorPaletteLime130$1 = "#A9CF5E";
  var ColorPaletteLime140$1 = "#C2DD8D";
  var ColorPaletteLime150$1 = "#DBEBBD";
  var ColorPaletteLime160$1 = "#F0F7E4";
  var ColorPaletteGreen10$1 = "#0B2312";
  var ColorPaletteGreen20$1 = "#0E2F18";
  var ColorPaletteGreen30$1 = "#133E20";
  var ColorPaletteGreen40$1 = "#174A26";
  var ColorPaletteGreen50$1 = "#1A562C";
  var ColorPaletteGreen60$1 = "#1F6634";
  var ColorPaletteGreen70$1 = "#22723A";
  var ColorPaletteGreen80$1 = "#278142";
  var ColorPaletteGreen90$1 = "#2D954C";
  var ColorPaletteGreen100$1 = "#32A454";
  var ColorPaletteGreen110$1 = "#38B85E";
  var ColorPaletteGreen120$1 = "#4BC870";
  var ColorPaletteGreen130$1 = "#76D692";
  var ColorPaletteGreen140$1 = "#9DE2B1";
  var ColorPaletteGreen150$1 = "#C8EED3";
  var ColorPaletteGreen160$1 = "#E8F8EC";
  var ColorPaletteAcqua10$1 = "#04251E";
  var ColorPaletteAcqua20$1 = "#052E26";
  var ColorPaletteAcqua30$1 = "#073C31";
  var ColorPaletteAcqua40$1 = "#08493C";
  var ColorPaletteAcqua50$1 = "#0A5748";
  var ColorPaletteAcqua60$1 = "#0B6553";
  var ColorPaletteAcqua70$1 = "#0D735E";
  var ColorPaletteAcqua80$1 = "#0F856D";
  var ColorPaletteAcqua90$1 = "#109379";
  var ColorPaletteAcqua100$1 = "#12A588";
  var ColorPaletteAcqua110$1 = "#14B897";
  var ColorPaletteAcqua120$1 = "#31C4A6";
  var ColorPaletteAcqua130$1 = "#68D4BF";
  var ColorPaletteAcqua140$1 = "#8DE2D1";
  var ColorPaletteAcqua150$1 = "#BCF0E6";
  var ColorPaletteAcqua160$1 = "#DFFBF6";
  var ColorPaletteBlue10$1 = "#051B48";
  var ColorPaletteBlue20$1 = "#062560";
  var ColorPaletteBlue30$1 = "#082F7D";
  var ColorPaletteBlue40$1 = "#0A3A9A";
  var ColorPaletteBlue50$1 = "#0B43B1";
  var ColorPaletteBlue60$1 = "#0D4ECE";
  var ColorPaletteBlue70$1 = "#0F58EA";
  var ColorPaletteBlue80$1 = "#286BF1";
  var ColorPaletteBlue90$1 = "#3F7BF2";
  var ColorPaletteBlue100$1 = "#5C8FF5";
  var ColorPaletteBlue110$1 = "#73A0F7";
  var ColorPaletteBlue120$1 = "#8CB0F8";
  var ColorPaletteBlue130$1 = "#A9C4F9";
  var ColorPaletteBlue140$1 = "#C1D4FB";
  var ColorPaletteBlue150$1 = "#D9E5FC";
  var ColorPaletteBlue160$1 = "#F1F5FE";
  var ColorPalettePurple10$1 = "#340849";
  var ColorPalettePurple20$1 = "#440B60";
  var ColorPalettePurple30$1 = "#540D78";
  var ColorPalettePurple40$1 = "#671093";
  var ColorPalettePurple50$1 = "#7713AA";
  var ColorPalettePurple60$1 = "#8B16C5";
  var ColorPalettePurple70$1 = "#9B18DC";
  var ColorPalettePurple80$1 = "#AD35E9";
  var ColorPalettePurple90$1 = "#B851EC";
  var ColorPalettePurple100$1 = "#C36CEF";
  var ColorPalettePurple110$1 = "#CC83F1";
  var ColorPalettePurple120$1 = "#D69AF4";
  var ColorPalettePurple130$1 = "#DFB1F6";
  var ColorPalettePurple140$1 = "#E8C8F9";
  var ColorPalettePurple150$1 = "#F2DFFB";
  var ColorPalettePurple160$1 = "#F9F1FD";
  var ColorPalettePink10$1 = "#3B0C27";
  var ColorPalettePink20$1 = "#4C1032";
  var ColorPalettePink30$1 = "#661543";
  var ColorPalettePink40$1 = "#77184E";
  var ColorPalettePink50$1 = "#8C1C5D";
  var ColorPalettePink60$1 = "#A12169";
  var ColorPalettePink70$1 = "#BA267B";
  var ColorPalettePink80$1 = "#D42B8C";
  var ColorPalettePink90$1 = "#DA499B";
  var ColorPalettePink100$1 = "#E067AB";
  var ColorPalettePink110$1 = "#E580B9";
  var ColorPalettePink120$1 = "#EA99C7";
  var ColorPalettePink130$1 = "#EFAFD3";
  var ColorPalettePink140$1 = "#F4C8E1";
  var ColorPalettePink150$1 = "#F8DDEC";
  var ColorPalettePink160$1 = "#FCF2F8";
  var ColorTypefaceStrong$1 = "#161616";
  var ColorTypefacePure$1 = "#363636";
  var ColorTypefaceSmooth$1 = "#666666";
  var ColorTypefaceMeld$1 = "#1616163D";
  var ColorTypefaceInverseStrong$1 = "#FEFEFE";
  var ColorTypefaceInversePure$1 = "#D4D4D4";
  var ColorTypefaceInverseSmooth$1 = "#919191";
  var ColorTypefaceInverseMeld$1 = "#FEFEFE52";
  var ColorTypefaceInverseOnBrandStrong$1 = "#161616";
  var ColorTypefaceInverseOnBrandPure$1 = "#363636";
  var ColorTypefaceInverseOnBrandSmooth$1 = "#404040";
  var ColorTypefaceInverseOnBrandMeld$1 = "#1616163D";
  var ColorTypefaceOnBrandStrong$1 = "#FEFEFE";
  var ColorTypefaceOnBrandPure$1 = "#F0F3FF";
  var ColorTypefaceOnBrandSmooth$1 = "#DBE3FF";
  var ColorTypefaceOnBrandMeld$1 = "#FEFEFE52";
  var ColorBrandPrimary10$1 = "#001561";
  var ColorBrandPrimary20$1 = "#001A7A";
  var ColorBrandPrimary30$1 = "#00229E";
  var ColorBrandPrimary40$1 = "#0028B8";
  var ColorBrandPrimary50$1 = "#002FDB";
  var ColorBrandPrimary60$1 = "#0037FF";
  var ColorBrandPrimary70$1 = "#8AA3FF";
  var ColorBrandPrimary80$1 = "#99AFFF";
  var ColorBrandPrimary90$1 = "#B3C3FF";
  var ColorBrandPrimary100$1 = "#C7D3FF";
  var ColorBrandPrimary110$1 = "#DBE3FF";
  var ColorBrandPrimary120$1 = "#F0F3FF";
  var ColorBrandBase01$1 = "#0037FF";
  var ColorBrandBase02$1 = "#FF4E33";
  var ColorBrandBase03$1 = "#A6E1FF";
  var ColorBrandBase04$1 = "#E5FF00";
  var ColorBrandBase05$1 = "#D1B287";
  var ColorFeedbackErrorText$1 = "#92202E";
  var ColorFeedbackErrorShape$1 = "#BC293A";
  var ColorFeedbackSuccessText$1 = "#1A562C";
  var ColorFeedbackSuccessShape$1 = "#22723A";
  var ColorFeedbackOnBrandErrorText$1 = "#F77E8C";
  var ColorFeedbackOnBrandErrorShape$1 = "#F55C6E";
  var ColorFeedbackOnBrandSuccessText$1 = "#38B85E";
  var ColorFeedbackOnBrandSuccessShape$1 = "#32A454";
  var ColorFeedbackInverseErrorText$1 = "#F55C6E";
  var ColorFeedbackInverseErrorShape$1 = "#D83145";
  var ColorFeedbackInverseSuccessText$1 = "#32A454";
  var ColorFeedbackInverseSuccessShape$1 = "#278142";
  var ColorFeedbackInverseOnBrandErrorText$1 = "#7E1B27";
  var ColorFeedbackInverseOnBrandErrorShape$1 = "#92202E";
  var ColorFeedbackInverseOnBrandSuccessText$1 = "#174A26";
  var ColorFeedbackInverseOnBrandSuccessShape$1 = "#1A562C";
  var ColorIllustrationDeepBlue = "#000F40";
  var ColorIllustrationNeonBlue = "#0037FF";
  var ColorIllustrationNeonRed = "#FF4F33";
  var ColorIllustrationClearBlue = "#ABE6FF";
  var ColorIllustrationBiscuit = "#D1B287";
  var ColorSupport01$1 = "#FF4E33";
  var ColorSupport02$1 = "#EC4A31";
  var ColorSupportOnBrand01$1 = "#E9FF00";
  var ColorSupportOnBrand02$1 = "#E9FF00";
  var ColorSupportInverse01$1 = "#FF4E33";
  var ColorSupportInverse02$1 = "#FF4E33";
  var ColorSupportInverseOnBrand01$1 = "#0028B8";
  var ColorSupportInverseOnBrand02$1 = "#00229E";
  var Opacity01$1 = "0.04";
  var Opacity02$1 = "0.08";
  var Opacity03$1 = "0.12";
  var Opacity04$1 = "0.24";
  var Opacity05$1 = "0.32";
  var Opacity06$1 = "0.56";
  var Opacity07$1 = "0.64";
  var Opacity08$1 = "0.72";
  var Opacity09$1 = "0.88";
  var Shadow01$1 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
  var Shadow02$1 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
  var Shadow03$1 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
  var Shadow04$1 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
  var SpacingInlineQuark$1 = "4px";
  var SpacingInlineNano$1 = "8px";
  var SpacingInlineXxxs$1 = "16px";
  var SpacingInlineXxs$1 = "24px";
  var SpacingInlineXs$1 = "32px";
  var SpacingInlineSm$1 = "40px";
  var SpacingInlineMd$1 = "48px";
  var SpacingInlineLg$1 = "56px";
  var SpacingInlineXl$1 = "64px";
  var SpacingInlineXxl$1 = "80px";
  var SpacingInlineXxxl$1 = "120px";
  var SpacingInlineHuge$1 = "160px";
  var SpacingInlineGiant$1 = "200px";
  var SpacingInsetQuark$1 = "4px";
  var SpacingInsetNano$1 = "8px";
  var SpacingInsetXs$1 = "16px";
  var SpacingInsetSm$1 = "24px";
  var SpacingInsetMd$1 = "32px";
  var SpacingInsetLg$1 = "40px";
  var SpacingSquishQuark$1 = "4px 8px";
  var SpacingSquishNano$1 = "8px 16px";
  var SpacingSquishXs$1 = "16px 24px";
  var SpacingSquishSm$1 = "16px 32px";
  var SpacingStackQuark$1 = "4px";
  var SpacingStackNano$1 = "8px";
  var SpacingStackXxxs$1 = "16px";
  var SpacingStackXxs$1 = "24px";
  var SpacingStackXs$1 = "32px";
  var SpacingStackSm$1 = "40px";
  var SpacingStackMd$1 = "48px";
  var SpacingStackLg$1 = "56px";
  var SpacingStackXl$1 = "64px";
  var SpacingStackXxl$1 = "80px";
  var SpacingStackXxxl$1 = "120px";
  var SpacingStackHuge$1 = "160px";
  var SpacingStackGiant$1 = "200px";
  var FontFamilyBase$1 = "'Dasa Sans', 'sans-serif'";
  var FontSizeXxxs$1 = "0.75rem";
  var FontSizeXxs$1 = "0.875rem";
  var FontSizeXs$1 = "1rem";
  var FontSizeSm$1 = "1.25rem";
  var FontSizeMd$1 = "1.5rem";
  var FontSizeLg$1 = "2rem";
  var FontSizeXl$1 = "2.5rem";
  var FontSizeXxl$1 = "3rem";
  var FontSizeXxxl$1 = "4rem";
  var FontSizeDisplay$1 = "5rem";
  var FontSizeGiant$1 = "6rem";
  var FontWeightBold$1 = 700;
  var FontWeightSemibold$1 = 600;
  var FontWeightMedium$1 = 500;
  var FontWeightRegular$1 = 400;
  var FontWeightLight$1 = 300;
  var LetterSpacingStandard$1 = "0px";
  var LetterSpacingSmall$1 = "-1px";
  var LetterSpacingMedium$1 = "1.5px";
  var LineHeightStandard$1 = "100%";
  var LineHeightTiny$1 = "115%";
  var LineHeightMedium$1 = "120%";
  var LineHeightLarge$1 = "125%";
  var LineHeightDistant$1 = "133%";
  var LineHeightSuperdistant$1 = "150%";
  var LineHeightHuge$1 = "170%";
  var index$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BorderRadiusNone: BorderRadiusNone$1,
    BorderRadiusXs: BorderRadiusXs$1,
    BorderRadiusSm: BorderRadiusSm$1,
    BorderRadiusMd: BorderRadiusMd$1,
    BorderRadiusLg: BorderRadiusLg$1,
    BorderRadiusPill: BorderRadiusPill$1,
    BorderRadiusCircle: BorderRadiusCircle$1,
    BorderWidthNone: BorderWidthNone$1,
    BorderWidthHairline: BorderWidthHairline$1,
    BorderWidthThin: BorderWidthThin$1,
    BorderWidthThick: BorderWidthThick$1,
    BorderWidthHeavy: BorderWidthHeavy$1,
    ColorDatavizInfoText: ColorDatavizInfoText$1,
    ColorDatavizInfoShape01: ColorDatavizInfoShape01$1,
    ColorDatavizInfoShape02: ColorDatavizInfoShape02$1,
    ColorDatavizInfoShape03: ColorDatavizInfoShape03$1,
    ColorDatavizNegativeText: ColorDatavizNegativeText$1,
    ColorDatavizNegativeShape01: ColorDatavizNegativeShape01$1,
    ColorDatavizNegativeShape02: ColorDatavizNegativeShape02$1,
    ColorDatavizNegativeShape03: ColorDatavizNegativeShape03$1,
    ColorDatavizWarningText: ColorDatavizWarningText$1,
    ColorDatavizWarningShape01: ColorDatavizWarningShape01$1,
    ColorDatavizWarningShape02: ColorDatavizWarningShape02$1,
    ColorDatavizWarningShape03: ColorDatavizWarningShape03$1,
    ColorDatavizPositiveText: ColorDatavizPositiveText$1,
    ColorDatavizPositiveShape01: ColorDatavizPositiveShape01$1,
    ColorDatavizPositiveShape02: ColorDatavizPositiveShape02$1,
    ColorDatavizPositiveShape03: ColorDatavizPositiveShape03$1,
    ColorDatavizCatAText: ColorDatavizCatAText$1,
    ColorDatavizCatAShape01: ColorDatavizCatAShape01$1,
    ColorDatavizCatAShape02: ColorDatavizCatAShape02$1,
    ColorDatavizCatAShape03: ColorDatavizCatAShape03$1,
    ColorDatavizCatBText: ColorDatavizCatBText$1,
    ColorDatavizCatBShape01: ColorDatavizCatBShape01$1,
    ColorDatavizCatBShape02: ColorDatavizCatBShape02$1,
    ColorDatavizCatBShape03: ColorDatavizCatBShape03$1,
    ColorDatavizCatCText: ColorDatavizCatCText$1,
    ColorDatavizCatCShape01: ColorDatavizCatCShape01$1,
    ColorDatavizCatCShape02: ColorDatavizCatCShape02$1,
    ColorDatavizCatCShape03: ColorDatavizCatCShape03$1,
    ColorDatavizCatDText: ColorDatavizCatDText$1,
    ColorDatavizCatDShape01: ColorDatavizCatDShape01$1,
    ColorDatavizCatDShape02: ColorDatavizCatDShape02$1,
    ColorDatavizCatDShape03: ColorDatavizCatDShape03$1,
    ColorDatavizInverseInfoText: ColorDatavizInverseInfoText$1,
    ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01$1,
    ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02$1,
    ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03$1,
    ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText$1,
    ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01$1,
    ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02$1,
    ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03$1,
    ColorDatavizInverseWarningText: ColorDatavizInverseWarningText$1,
    ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01$1,
    ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02$1,
    ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03$1,
    ColorDatavizInversePositiveText: ColorDatavizInversePositiveText$1,
    ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01$1,
    ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02$1,
    ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03$1,
    ColorDatavizInverseCatAText: ColorDatavizInverseCatAText$1,
    ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01$1,
    ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02$1,
    ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03$1,
    ColorDatavizInverseCatBText: ColorDatavizInverseCatBText$1,
    ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01$1,
    ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02$1,
    ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03$1,
    ColorDatavizInverseCatCText: ColorDatavizInverseCatCText$1,
    ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01$1,
    ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02$1,
    ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03$1,
    ColorDatavizInverseCatDText: ColorDatavizInverseCatDText$1,
    ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01$1,
    ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02$1,
    ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03$1,
    ColorInteractionBlend01: ColorInteractionBlend01$1,
    ColorInteractionBlend02: ColorInteractionBlend02$1,
    ColorInteractionBlend03: ColorInteractionBlend03$1,
    ColorInteractionBlend04: ColorInteractionBlend04$1,
    ColorInteractionBlend05: ColorInteractionBlend05$1,
    ColorInteractionBlend06: ColorInteractionBlend06$1,
    ColorInteractionBlend07: ColorInteractionBlend07$1,
    ColorInteractionBlend08: ColorInteractionBlend08$1,
    ColorInteractionInverseBlend01: ColorInteractionInverseBlend01$1,
    ColorInteractionInverseBlend02: ColorInteractionInverseBlend02$1,
    ColorInteractionInverseBlend03: ColorInteractionInverseBlend03$1,
    ColorInteractionInverseBlend04: ColorInteractionInverseBlend04$1,
    ColorInteractionInverseBlend05: ColorInteractionInverseBlend05$1,
    ColorInteractionInverseBlend06: ColorInteractionInverseBlend06$1,
    ColorInteractionInverseBlend07: ColorInteractionInverseBlend07$1,
    ColorInteractionInverseBlend08: ColorInteractionInverseBlend08$1,
    ColorInteractionInverseAccent01: ColorInteractionInverseAccent01$1,
    ColorInteractionInverseAccent02: ColorInteractionInverseAccent02$1,
    ColorInteractionInverseAccent03: ColorInteractionInverseAccent03$1,
    ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01$1,
    ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02$1,
    ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03$1,
    ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault$1,
    ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus$1,
    ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive$1,
    ColorInteractionInverseDanger01: ColorInteractionInverseDanger01$1,
    ColorInteractionInverseDanger02: ColorInteractionInverseDanger02$1,
    ColorInteractionInverseDanger03: ColorInteractionInverseDanger03$1,
    ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01$1,
    ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02$1,
    ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03$1,
    ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01$1,
    ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02$1,
    ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03$1,
    ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault$1,
    ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus$1,
    ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive$1,
    ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01$1,
    ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02$1,
    ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03$1,
    ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04$1,
    ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05$1,
    ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06$1,
    ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07$1,
    ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08$1,
    ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01$1,
    ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02$1,
    ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03$1,
    ColorInteractionAccent01: ColorInteractionAccent01$1,
    ColorInteractionAccent02: ColorInteractionAccent02$1,
    ColorInteractionAccent03: ColorInteractionAccent03$1,
    ColorInteractionSubtle01: ColorInteractionSubtle01$1,
    ColorInteractionSubtle02: ColorInteractionSubtle02$1,
    ColorInteractionSubtle03: ColorInteractionSubtle03$1,
    ColorInteractionSelectDefault: ColorInteractionSelectDefault$1,
    ColorInteractionSelectFocus: ColorInteractionSelectFocus$1,
    ColorInteractionSelectActive: ColorInteractionSelectActive$1,
    ColorInteractionDanger01: ColorInteractionDanger01$1,
    ColorInteractionDanger02: ColorInteractionDanger02$1,
    ColorInteractionDanger03: ColorInteractionDanger03$1,
    ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01$1,
    ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02$1,
    ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03$1,
    ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01$1,
    ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02$1,
    ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03$1,
    ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault$1,
    ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus$1,
    ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive$1,
    ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01$1,
    ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02$1,
    ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03$1,
    ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04$1,
    ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05$1,
    ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06$1,
    ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07$1,
    ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08$1,
    ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01$1,
    ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02$1,
    ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03$1,
    ColorNeutral10: ColorNeutral10$1,
    ColorNeutral20: ColorNeutral20$1,
    ColorNeutral30: ColorNeutral30$1,
    ColorNeutral00: ColorNeutral00$1,
    ColorNeutralInverse10: ColorNeutralInverse10$1,
    ColorNeutralInverse20: ColorNeutralInverse20$1,
    ColorNeutralInverse30: ColorNeutralInverse30$1,
    ColorNeutralInverse00: ColorNeutralInverse00$1,
    ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10$1,
    ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20$1,
    ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30$1,
    ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00$1,
    ColorNeutralOnBrand10: ColorNeutralOnBrand10$1,
    ColorNeutralOnBrand20: ColorNeutralOnBrand20$1,
    ColorNeutralOnBrand30: ColorNeutralOnBrand30$1,
    ColorNeutralOnBrand00: ColorNeutralOnBrand00$1,
    ColorPaletteBlack: ColorPaletteBlack$1,
    ColorPaletteWhite: ColorPaletteWhite$1,
    ColorPaletteGray10: ColorPaletteGray10$1,
    ColorPaletteGray20: ColorPaletteGray20$1,
    ColorPaletteGray30: ColorPaletteGray30$1,
    ColorPaletteGray40: ColorPaletteGray40$1,
    ColorPaletteGray50: ColorPaletteGray50$1,
    ColorPaletteGray60: ColorPaletteGray60$1,
    ColorPaletteGray70: ColorPaletteGray70$1,
    ColorPaletteGray80: ColorPaletteGray80$1,
    ColorPaletteGray90: ColorPaletteGray90$1,
    ColorPaletteGray100: ColorPaletteGray100$1,
    ColorPaletteGray110: ColorPaletteGray110$1,
    ColorPaletteGray120: ColorPaletteGray120$1,
    ColorPaletteGray130: ColorPaletteGray130$1,
    ColorPaletteGray140: ColorPaletteGray140$1,
    ColorPaletteGray150: ColorPaletteGray150$1,
    ColorPaletteGray160: ColorPaletteGray160$1,
    ColorPaletteRed10: ColorPaletteRed10$1,
    ColorPaletteRed20: ColorPaletteRed20$1,
    ColorPaletteRed30: ColorPaletteRed30$1,
    ColorPaletteRed40: ColorPaletteRed40$1,
    ColorPaletteRed50: ColorPaletteRed50$1,
    ColorPaletteRed60: ColorPaletteRed60$1,
    ColorPaletteRed70: ColorPaletteRed70$1,
    ColorPaletteRed80: ColorPaletteRed80$1,
    ColorPaletteRed90: ColorPaletteRed90$1,
    ColorPaletteRed100: ColorPaletteRed100$1,
    ColorPaletteRed110: ColorPaletteRed110$1,
    ColorPaletteRed120: ColorPaletteRed120$1,
    ColorPaletteRed130: ColorPaletteRed130$1,
    ColorPaletteRed140: ColorPaletteRed140$1,
    ColorPaletteRed150: ColorPaletteRed150$1,
    ColorPaletteRed160: ColorPaletteRed160$1,
    ColorPaletteYellow10: ColorPaletteYellow10$1,
    ColorPaletteYellow20: ColorPaletteYellow20$1,
    ColorPaletteYellow30: ColorPaletteYellow30$1,
    ColorPaletteYellow40: ColorPaletteYellow40$1,
    ColorPaletteYellow50: ColorPaletteYellow50$1,
    ColorPaletteYellow60: ColorPaletteYellow60$1,
    ColorPaletteYellow70: ColorPaletteYellow70$1,
    ColorPaletteYellow80: ColorPaletteYellow80$1,
    ColorPaletteYellow90: ColorPaletteYellow90$1,
    ColorPaletteYellow100: ColorPaletteYellow100$1,
    ColorPaletteYellow110: ColorPaletteYellow110$1,
    ColorPaletteYellow120: ColorPaletteYellow120$1,
    ColorPaletteYellow130: ColorPaletteYellow130$1,
    ColorPaletteYellow140: ColorPaletteYellow140$1,
    ColorPaletteYellow150: ColorPaletteYellow150$1,
    ColorPaletteYellow160: ColorPaletteYellow160$1,
    ColorPaletteLime10: ColorPaletteLime10$1,
    ColorPaletteLime20: ColorPaletteLime20$1,
    ColorPaletteLime30: ColorPaletteLime30$1,
    ColorPaletteLime40: ColorPaletteLime40$1,
    ColorPaletteLime50: ColorPaletteLime50$1,
    ColorPaletteLime60: ColorPaletteLime60$1,
    ColorPaletteLime70: ColorPaletteLime70$1,
    ColorPaletteLime80: ColorPaletteLime80$1,
    ColorPaletteLime90: ColorPaletteLime90$1,
    ColorPaletteLime100: ColorPaletteLime100$1,
    ColorPaletteLime110: ColorPaletteLime110$1,
    ColorPaletteLime120: ColorPaletteLime120$1,
    ColorPaletteLime130: ColorPaletteLime130$1,
    ColorPaletteLime140: ColorPaletteLime140$1,
    ColorPaletteLime150: ColorPaletteLime150$1,
    ColorPaletteLime160: ColorPaletteLime160$1,
    ColorPaletteGreen10: ColorPaletteGreen10$1,
    ColorPaletteGreen20: ColorPaletteGreen20$1,
    ColorPaletteGreen30: ColorPaletteGreen30$1,
    ColorPaletteGreen40: ColorPaletteGreen40$1,
    ColorPaletteGreen50: ColorPaletteGreen50$1,
    ColorPaletteGreen60: ColorPaletteGreen60$1,
    ColorPaletteGreen70: ColorPaletteGreen70$1,
    ColorPaletteGreen80: ColorPaletteGreen80$1,
    ColorPaletteGreen90: ColorPaletteGreen90$1,
    ColorPaletteGreen100: ColorPaletteGreen100$1,
    ColorPaletteGreen110: ColorPaletteGreen110$1,
    ColorPaletteGreen120: ColorPaletteGreen120$1,
    ColorPaletteGreen130: ColorPaletteGreen130$1,
    ColorPaletteGreen140: ColorPaletteGreen140$1,
    ColorPaletteGreen150: ColorPaletteGreen150$1,
    ColorPaletteGreen160: ColorPaletteGreen160$1,
    ColorPaletteAcqua10: ColorPaletteAcqua10$1,
    ColorPaletteAcqua20: ColorPaletteAcqua20$1,
    ColorPaletteAcqua30: ColorPaletteAcqua30$1,
    ColorPaletteAcqua40: ColorPaletteAcqua40$1,
    ColorPaletteAcqua50: ColorPaletteAcqua50$1,
    ColorPaletteAcqua60: ColorPaletteAcqua60$1,
    ColorPaletteAcqua70: ColorPaletteAcqua70$1,
    ColorPaletteAcqua80: ColorPaletteAcqua80$1,
    ColorPaletteAcqua90: ColorPaletteAcqua90$1,
    ColorPaletteAcqua100: ColorPaletteAcqua100$1,
    ColorPaletteAcqua110: ColorPaletteAcqua110$1,
    ColorPaletteAcqua120: ColorPaletteAcqua120$1,
    ColorPaletteAcqua130: ColorPaletteAcqua130$1,
    ColorPaletteAcqua140: ColorPaletteAcqua140$1,
    ColorPaletteAcqua150: ColorPaletteAcqua150$1,
    ColorPaletteAcqua160: ColorPaletteAcqua160$1,
    ColorPaletteBlue10: ColorPaletteBlue10$1,
    ColorPaletteBlue20: ColorPaletteBlue20$1,
    ColorPaletteBlue30: ColorPaletteBlue30$1,
    ColorPaletteBlue40: ColorPaletteBlue40$1,
    ColorPaletteBlue50: ColorPaletteBlue50$1,
    ColorPaletteBlue60: ColorPaletteBlue60$1,
    ColorPaletteBlue70: ColorPaletteBlue70$1,
    ColorPaletteBlue80: ColorPaletteBlue80$1,
    ColorPaletteBlue90: ColorPaletteBlue90$1,
    ColorPaletteBlue100: ColorPaletteBlue100$1,
    ColorPaletteBlue110: ColorPaletteBlue110$1,
    ColorPaletteBlue120: ColorPaletteBlue120$1,
    ColorPaletteBlue130: ColorPaletteBlue130$1,
    ColorPaletteBlue140: ColorPaletteBlue140$1,
    ColorPaletteBlue150: ColorPaletteBlue150$1,
    ColorPaletteBlue160: ColorPaletteBlue160$1,
    ColorPalettePurple10: ColorPalettePurple10$1,
    ColorPalettePurple20: ColorPalettePurple20$1,
    ColorPalettePurple30: ColorPalettePurple30$1,
    ColorPalettePurple40: ColorPalettePurple40$1,
    ColorPalettePurple50: ColorPalettePurple50$1,
    ColorPalettePurple60: ColorPalettePurple60$1,
    ColorPalettePurple70: ColorPalettePurple70$1,
    ColorPalettePurple80: ColorPalettePurple80$1,
    ColorPalettePurple90: ColorPalettePurple90$1,
    ColorPalettePurple100: ColorPalettePurple100$1,
    ColorPalettePurple110: ColorPalettePurple110$1,
    ColorPalettePurple120: ColorPalettePurple120$1,
    ColorPalettePurple130: ColorPalettePurple130$1,
    ColorPalettePurple140: ColorPalettePurple140$1,
    ColorPalettePurple150: ColorPalettePurple150$1,
    ColorPalettePurple160: ColorPalettePurple160$1,
    ColorPalettePink10: ColorPalettePink10$1,
    ColorPalettePink20: ColorPalettePink20$1,
    ColorPalettePink30: ColorPalettePink30$1,
    ColorPalettePink40: ColorPalettePink40$1,
    ColorPalettePink50: ColorPalettePink50$1,
    ColorPalettePink60: ColorPalettePink60$1,
    ColorPalettePink70: ColorPalettePink70$1,
    ColorPalettePink80: ColorPalettePink80$1,
    ColorPalettePink90: ColorPalettePink90$1,
    ColorPalettePink100: ColorPalettePink100$1,
    ColorPalettePink110: ColorPalettePink110$1,
    ColorPalettePink120: ColorPalettePink120$1,
    ColorPalettePink130: ColorPalettePink130$1,
    ColorPalettePink140: ColorPalettePink140$1,
    ColorPalettePink150: ColorPalettePink150$1,
    ColorPalettePink160: ColorPalettePink160$1,
    ColorTypefaceStrong: ColorTypefaceStrong$1,
    ColorTypefacePure: ColorTypefacePure$1,
    ColorTypefaceSmooth: ColorTypefaceSmooth$1,
    ColorTypefaceMeld: ColorTypefaceMeld$1,
    ColorTypefaceInverseStrong: ColorTypefaceInverseStrong$1,
    ColorTypefaceInversePure: ColorTypefaceInversePure$1,
    ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth$1,
    ColorTypefaceInverseMeld: ColorTypefaceInverseMeld$1,
    ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong$1,
    ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure$1,
    ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth$1,
    ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld$1,
    ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong$1,
    ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure$1,
    ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth$1,
    ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld$1,
    ColorBrandPrimary10: ColorBrandPrimary10$1,
    ColorBrandPrimary20: ColorBrandPrimary20$1,
    ColorBrandPrimary30: ColorBrandPrimary30$1,
    ColorBrandPrimary40: ColorBrandPrimary40$1,
    ColorBrandPrimary50: ColorBrandPrimary50$1,
    ColorBrandPrimary60: ColorBrandPrimary60$1,
    ColorBrandPrimary70: ColorBrandPrimary70$1,
    ColorBrandPrimary80: ColorBrandPrimary80$1,
    ColorBrandPrimary90: ColorBrandPrimary90$1,
    ColorBrandPrimary100: ColorBrandPrimary100$1,
    ColorBrandPrimary110: ColorBrandPrimary110$1,
    ColorBrandPrimary120: ColorBrandPrimary120$1,
    ColorBrandBase01: ColorBrandBase01$1,
    ColorBrandBase02: ColorBrandBase02$1,
    ColorBrandBase03: ColorBrandBase03$1,
    ColorBrandBase04: ColorBrandBase04$1,
    ColorBrandBase05: ColorBrandBase05$1,
    ColorFeedbackErrorText: ColorFeedbackErrorText$1,
    ColorFeedbackErrorShape: ColorFeedbackErrorShape$1,
    ColorFeedbackSuccessText: ColorFeedbackSuccessText$1,
    ColorFeedbackSuccessShape: ColorFeedbackSuccessShape$1,
    ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText$1,
    ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape$1,
    ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText$1,
    ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape$1,
    ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText$1,
    ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape$1,
    ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText$1,
    ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape$1,
    ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText$1,
    ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape$1,
    ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText$1,
    ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape$1,
    ColorIllustrationDeepBlue: ColorIllustrationDeepBlue,
    ColorIllustrationNeonBlue: ColorIllustrationNeonBlue,
    ColorIllustrationNeonRed: ColorIllustrationNeonRed,
    ColorIllustrationClearBlue: ColorIllustrationClearBlue,
    ColorIllustrationBiscuit: ColorIllustrationBiscuit,
    ColorSupport01: ColorSupport01$1,
    ColorSupport02: ColorSupport02$1,
    ColorSupportOnBrand01: ColorSupportOnBrand01$1,
    ColorSupportOnBrand02: ColorSupportOnBrand02$1,
    ColorSupportInverse01: ColorSupportInverse01$1,
    ColorSupportInverse02: ColorSupportInverse02$1,
    ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01$1,
    ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02$1,
    Opacity01: Opacity01$1,
    Opacity02: Opacity02$1,
    Opacity03: Opacity03$1,
    Opacity04: Opacity04$1,
    Opacity05: Opacity05$1,
    Opacity06: Opacity06$1,
    Opacity07: Opacity07$1,
    Opacity08: Opacity08$1,
    Opacity09: Opacity09$1,
    Shadow01: Shadow01$1,
    Shadow02: Shadow02$1,
    Shadow03: Shadow03$1,
    Shadow04: Shadow04$1,
    SpacingInlineQuark: SpacingInlineQuark$1,
    SpacingInlineNano: SpacingInlineNano$1,
    SpacingInlineXxxs: SpacingInlineXxxs$1,
    SpacingInlineXxs: SpacingInlineXxs$1,
    SpacingInlineXs: SpacingInlineXs$1,
    SpacingInlineSm: SpacingInlineSm$1,
    SpacingInlineMd: SpacingInlineMd$1,
    SpacingInlineLg: SpacingInlineLg$1,
    SpacingInlineXl: SpacingInlineXl$1,
    SpacingInlineXxl: SpacingInlineXxl$1,
    SpacingInlineXxxl: SpacingInlineXxxl$1,
    SpacingInlineHuge: SpacingInlineHuge$1,
    SpacingInlineGiant: SpacingInlineGiant$1,
    SpacingInsetQuark: SpacingInsetQuark$1,
    SpacingInsetNano: SpacingInsetNano$1,
    SpacingInsetXs: SpacingInsetXs$1,
    SpacingInsetSm: SpacingInsetSm$1,
    SpacingInsetMd: SpacingInsetMd$1,
    SpacingInsetLg: SpacingInsetLg$1,
    SpacingSquishQuark: SpacingSquishQuark$1,
    SpacingSquishNano: SpacingSquishNano$1,
    SpacingSquishXs: SpacingSquishXs$1,
    SpacingSquishSm: SpacingSquishSm$1,
    SpacingStackQuark: SpacingStackQuark$1,
    SpacingStackNano: SpacingStackNano$1,
    SpacingStackXxxs: SpacingStackXxxs$1,
    SpacingStackXxs: SpacingStackXxs$1,
    SpacingStackXs: SpacingStackXs$1,
    SpacingStackSm: SpacingStackSm$1,
    SpacingStackMd: SpacingStackMd$1,
    SpacingStackLg: SpacingStackLg$1,
    SpacingStackXl: SpacingStackXl$1,
    SpacingStackXxl: SpacingStackXxl$1,
    SpacingStackXxxl: SpacingStackXxxl$1,
    SpacingStackHuge: SpacingStackHuge$1,
    SpacingStackGiant: SpacingStackGiant$1,
    FontFamilyBase: FontFamilyBase$1,
    FontSizeXxxs: FontSizeXxxs$1,
    FontSizeXxs: FontSizeXxs$1,
    FontSizeXs: FontSizeXs$1,
    FontSizeSm: FontSizeSm$1,
    FontSizeMd: FontSizeMd$1,
    FontSizeLg: FontSizeLg$1,
    FontSizeXl: FontSizeXl$1,
    FontSizeXxl: FontSizeXxl$1,
    FontSizeXxxl: FontSizeXxxl$1,
    FontSizeDisplay: FontSizeDisplay$1,
    FontSizeGiant: FontSizeGiant$1,
    FontWeightBold: FontWeightBold$1,
    FontWeightSemibold: FontWeightSemibold$1,
    FontWeightMedium: FontWeightMedium$1,
    FontWeightRegular: FontWeightRegular$1,
    FontWeightLight: FontWeightLight$1,
    LetterSpacingStandard: LetterSpacingStandard$1,
    LetterSpacingSmall: LetterSpacingSmall$1,
    LetterSpacingMedium: LetterSpacingMedium$1,
    LineHeightStandard: LineHeightStandard$1,
    LineHeightTiny: LineHeightTiny$1,
    LineHeightMedium: LineHeightMedium$1,
    LineHeightLarge: LineHeightLarge$1,
    LineHeightDistant: LineHeightDistant$1,
    LineHeightSuperdistant: LineHeightSuperdistant$1,
    LineHeightHuge: LineHeightHuge$1
  });
  /**
   * Do not edit directly
   * Generated on Thu, 27 Oct 2022 18:07:47 GMT
   */

  var BorderRadiusNone = "0px";
  var BorderRadiusXs = "4px";
  var BorderRadiusSm = "8px";
  var BorderRadiusMd = "16px";
  var BorderRadiusLg = "24px";
  var BorderRadiusPill = "960px";
  var BorderRadiusCircle = "50%";
  var BorderWidthNone = "0px";
  var BorderWidthHairline = "1px";
  var BorderWidthThin = "2px";
  var BorderWidthThick = "4px";
  var BorderWidthHeavy = "8px";
  var ColorDatavizInfoText = "#0F58EA";
  var ColorDatavizInfoShape01 = "#3F7BF2";
  var ColorDatavizInfoShape02 = "#D9E5FC";
  var ColorDatavizInfoShape03 = "#F1F5FE";
  var ColorDatavizNegativeText = "#BC293A";
  var ColorDatavizNegativeShape01 = "#EA4356";
  var ColorDatavizNegativeShape02 = "#FDDDE1";
  var ColorDatavizNegativeShape03 = "#FEF1F2";
  var ColorDatavizWarningText = "#A04C03";
  var ColorDatavizWarningShape01 = "#D26404";
  var ColorDatavizWarningShape02 = "#FEE1C8";
  var ColorDatavizWarningShape03 = "#FEF1E6";
  var ColorDatavizPositiveText = "#22723A";
  var ColorDatavizPositiveShape01 = "#2D954C";
  var ColorDatavizPositiveShape02 = "#C8EED3";
  var ColorDatavizPositiveShape03 = "#E8F8EC";
  var ColorDatavizCatAText = "#9B18DC";
  var ColorDatavizCatAShape01 = "#B851EC";
  var ColorDatavizCatAShape02 = "#F2DFFB";
  var ColorDatavizCatAShape03 = "#F9F1FD";
  var ColorDatavizCatBText = "#BA267B";
  var ColorDatavizCatBShape01 = "#DA499B";
  var ColorDatavizCatBShape02 = "#F8DDEC";
  var ColorDatavizCatBShape03 = "#FCF2F8";
  var ColorDatavizCatCText = "#546E21";
  var ColorDatavizCatCShape01 = "#6C8D2B";
  var ColorDatavizCatCShape02 = "#DBEBBD";
  var ColorDatavizCatCShape03 = "#F0F7E4";
  var ColorDatavizCatDText = "#0D735E";
  var ColorDatavizCatDShape01 = "#109379";
  var ColorDatavizCatDShape02 = "#BCF0E6";
  var ColorDatavizCatDShape03 = "#DFFBF6";
  var ColorDatavizInverseInfoText = "#5C8FF5";
  var ColorDatavizInverseInfoShape01 = "#286BF1";
  var ColorDatavizInverseInfoShape02 = "#062560";
  var ColorDatavizInverseInfoShape03 = "#051B48";
  var ColorDatavizInverseNegativeText = "#F55C6E";
  var ColorDatavizInverseNegativeShape01 = "#D83145";
  var ColorDatavizInverseNegativeShape02 = "#4F1119";
  var ColorDatavizInverseNegativeShape03 = "#3B0D12";
  var ColorDatavizInverseWarningText = "#EB7005";
  var ColorDatavizInverseWarningShape01 = "#B95804";
  var ColorDatavizInverseWarningShape02 = "#462101";
  var ColorDatavizInverseWarningShape03 = "#321701";
  var ColorDatavizInversePositiveText = "#32A454";
  var ColorDatavizInversePositiveShape01 = "#278142";
  var ColorDatavizInversePositiveShape02 = "#0E2F18";
  var ColorDatavizInversePositiveShape03 = "#0B2312";
  var ColorDatavizInverseCatAText = "#C36CEF";
  var ColorDatavizInverseCatAShape01 = "#AD35E9";
  var ColorDatavizInverseCatAShape02 = "#440B60";
  var ColorDatavizInverseCatAShape03 = "#340849";
  var ColorDatavizInverseCatBText = "#E067AB";
  var ColorDatavizInverseCatBShape01 = "#D42B8C";
  var ColorDatavizInverseCatBShape02 = "#4C1032";
  var ColorDatavizInverseCatBShape03 = "#3B0C27";
  var ColorDatavizInverseCatCText = "#789D2F";
  var ColorDatavizInverseCatCShape01 = "#607E26";
  var ColorDatavizInverseCatCShape02 = "#212B0D";
  var ColorDatavizInverseCatCShape03 = "#1B230B";
  var ColorDatavizInverseCatDText = "#12A588";
  var ColorDatavizInverseCatDShape01 = "#0F856D";
  var ColorDatavizInverseCatDShape02 = "#052E26";
  var ColorDatavizInverseCatDShape03 = "#04251E";
  var ColorInteractionBlend01 = "#1616160A";
  var ColorInteractionBlend02 = "#16161614";
  var ColorInteractionBlend03 = "#1616161F";
  var ColorInteractionBlend04 = "#1616163D";
  var ColorInteractionBlend05 = "#161616A3";
  var ColorInteractionBlend06 = "#161616B8";
  var ColorInteractionBlend07 = "#161616E0";
  var ColorInteractionBlend08 = "#161616";
  var ColorInteractionInverseBlend01 = "#FEFEFE14";
  var ColorInteractionInverseBlend02 = "#FEFEFE1F";
  var ColorInteractionInverseBlend03 = "#FEFEFE3D";
  var ColorInteractionInverseBlend04 = "#FEFEFE52";
  var ColorInteractionInverseBlend05 = "#FEFEFEA3";
  var ColorInteractionInverseBlend06 = "#FEFEFEB8";
  var ColorInteractionInverseBlend07 = "#FEFEFEE0";
  var ColorInteractionInverseBlend08 = "#FEFEFE";
  var ColorInteractionInverseAccent01 = "#6B8BFF";
  var ColorInteractionInverseAccent02 = "#809BFF";
  var ColorInteractionInverseAccent03 = "#99AFFF";
  var ColorInteractionInverseSubtle01 = "#5277FF1F";
  var ColorInteractionInverseSubtle02 = "#5277FF3D";
  var ColorInteractionInverseSubtle03 = "#5277FF52";
  var ColorInteractionInverseSelectDefault = "#919191";
  var ColorInteractionInverseSelectFocus = "#D4D4D4";
  var ColorInteractionInverseSelectActive = "#2BD6C4";
  var ColorInteractionInverseDanger01 = "#F55C6E";
  var ColorInteractionInverseDanger02 = "#F77E8C";
  var ColorInteractionInverseDanger03 = "#F895A1";
  var ColorInteractionInverseOnBrandAccent01 = "#000E40";
  var ColorInteractionInverseOnBrandAccent02 = "#001A7A";
  var ColorInteractionInverseOnBrandAccent03 = "#00229E";
  var ColorInteractionInverseOnBrandSubtle01 = "#002FDB14";
  var ColorInteractionInverseOnBrandSubtle02 = "#002FDB1F";
  var ColorInteractionInverseOnBrandSubtle03 = "#002FDB3D";
  var ColorInteractionInverseOnBrandSelectDefault = "#595959";
  var ColorInteractionInverseOnBrandSelectFocus = "#404040";
  var ColorInteractionInverseOnBrandSelectActive = "#603CCD";
  var ColorInteractionInverseOnBrandBlend01 = "#1616160A";
  var ColorInteractionInverseOnBrandBlend02 = "#16161614";
  var ColorInteractionInverseOnBrandBlend03 = "#1616161F";
  var ColorInteractionInverseOnBrandBlend04 = "#1616163D";
  var ColorInteractionInverseOnBrandBlend05 = "#161616A3";
  var ColorInteractionInverseOnBrandBlend06 = "#161616B8";
  var ColorInteractionInverseOnBrandBlend07 = "#161616E0";
  var ColorInteractionInverseOnBrandBlend08 = "#161616";
  var ColorInteractionInverseOnBrandDanger01 = "#A72534";
  var ColorInteractionInverseOnBrandDanger02 = "#92202E";
  var ColorInteractionInverseOnBrandDanger03 = "#7E1B27";
  var ColorInteractionAccent01 = "#000E40";
  var ColorInteractionAccent02 = "#001A7A";
  var ColorInteractionAccent03 = "#00229E";
  var ColorInteractionSubtle01 = "#0029BD1F";
  var ColorInteractionSubtle02 = "#0029BD3D";
  var ColorInteractionSubtle03 = "#0029BD52";
  var ColorInteractionSelectDefault = "#666666";
  var ColorInteractionSelectFocus = "#363636";
  var ColorInteractionSelectActive = "#603CCD";
  var ColorInteractionDanger01 = "#BC293A";
  var ColorInteractionDanger02 = "#A72534";
  var ColorInteractionDanger03 = "#92202E";
  var ColorInteractionOnBrandAccent01 = "#ADBFFF";
  var ColorInteractionOnBrandAccent02 = "#99AFFF";
  var ColorInteractionOnBrandAccent03 = "#809BFF";
  var ColorInteractionOnBrandSubtle01 = "#5277FF1F";
  var ColorInteractionOnBrandSubtle02 = "#5277FF3D";
  var ColorInteractionOnBrandSubtle03 = "#5277FF52";
  var ColorInteractionOnBrandSelectDefault = "#B0B0B0";
  var ColorInteractionOnBrandSelectFocus = "#D4D4D4";
  var ColorInteractionOnBrandSelectActive = "#2BD6C4";
  var ColorInteractionOnBrandBlend01 = "#FEFEFE14";
  var ColorInteractionOnBrandBlend02 = "#FEFEFE1F";
  var ColorInteractionOnBrandBlend03 = "#FEFEFE3D";
  var ColorInteractionOnBrandBlend04 = "#FEFEFE52";
  var ColorInteractionOnBrandBlend05 = "#FEFEFEA3";
  var ColorInteractionOnBrandBlend06 = "#FEFEFEB8";
  var ColorInteractionOnBrandBlend07 = "#FEFEFEE0";
  var ColorInteractionOnBrandBlend08 = "#FEFEFE";
  var ColorInteractionOnBrandDanger01 = "#F77E8C";
  var ColorInteractionOnBrandDanger02 = "#F895A1";
  var ColorInteractionOnBrandDanger03 = "#FAAEB6";
  var ColorNeutral10 = "#F5F5F5";
  var ColorNeutral20 = "#E6E6E6";
  var ColorNeutral30 = "#1616163D";
  var ColorNeutral00 = "#FEFEFE";
  var ColorNeutralInverse10 = "#1F1F1F";
  var ColorNeutralInverse20 = "#292929";
  var ColorNeutralInverse30 = "#FEFEFE3D";
  var ColorNeutralInverse00 = "#161616";
  var ColorNeutralInverseOnBrand10 = "#DBE3FF";
  var ColorNeutralInverseOnBrand20 = "#C7D3FF";
  var ColorNeutralInverseOnBrand30 = "#0029BD52";
  var ColorNeutralInverseOnBrand00 = "#F0F3FF";
  var ColorNeutralOnBrand10 = "#001A7A";
  var ColorNeutralOnBrand20 = "#00229E";
  var ColorNeutralOnBrand30 = "#5277FFA3";
  var ColorNeutralOnBrand00 = "#000E40";
  var ColorPaletteBlack = "#161616";
  var ColorPaletteWhite = "#FEFEFE";
  var ColorPaletteGray10 = "#1F1F1F";
  var ColorPaletteGray20 = "#292929";
  var ColorPaletteGray30 = "#363636";
  var ColorPaletteGray40 = "#404040";
  var ColorPaletteGray50 = "#4C4C4C";
  var ColorPaletteGray60 = "#595959";
  var ColorPaletteGray70 = "#666666";
  var ColorPaletteGray80 = "#737373";
  var ColorPaletteGray90 = "#828282";
  var ColorPaletteGray100 = "#919191";
  var ColorPaletteGray110 = "#A1A1A1";
  var ColorPaletteGray120 = "#B0B0B0";
  var ColorPaletteGray130 = "#C2C2C2";
  var ColorPaletteGray140 = "#D4D4D4";
  var ColorPaletteGray150 = "#E6E6E6";
  var ColorPaletteGray160 = "#F5F5F5";
  var ColorPaletteRed10 = "#3B0D12";
  var ColorPaletteRed20 = "#4F1119";
  var ColorPaletteRed30 = "#691721";
  var ColorPaletteRed40 = "#7E1B27";
  var ColorPaletteRed50 = "#92202E";
  var ColorPaletteRed60 = "#A72534";
  var ColorPaletteRed70 = "#BC293A";
  var ColorPaletteRed80 = "#D83145";
  var ColorPaletteRed90 = "#EA4356";
  var ColorPaletteRed100 = "#F55C6E";
  var ColorPaletteRed110 = "#F77E8C";
  var ColorPaletteRed120 = "#F895A1";
  var ColorPaletteRed130 = "#FAAEB6";
  var ColorPaletteRed140 = "#FBC5CC";
  var ColorPaletteRed150 = "#FDDDE1";
  var ColorPaletteRed160 = "#FEF1F2";
  var ColorPaletteYellow10 = "#321701";
  var ColorPaletteYellow20 = "#462101";
  var ColorPaletteYellow30 = "#552802";
  var ColorPaletteYellow40 = "#693102";
  var ColorPaletteYellow50 = "#7D3B03";
  var ColorPaletteYellow60 = "#914503";
  var ColorPaletteYellow70 = "#A04C03";
  var ColorPaletteYellow80 = "#B95804";
  var ColorPaletteYellow90 = "#D26404";
  var ColorPaletteYellow100 = "#EB7005";
  var ColorPaletteYellow110 = "#FA8219";
  var ColorPaletteYellow120 = "#FB9B46";
  var ColorPaletteYellow130 = "#FCB06E";
  var ColorPaletteYellow140 = "#FDC99B";
  var ColorPaletteYellow150 = "#FEE1C8";
  var ColorPaletteYellow160 = "#FEF1E6";
  var ColorPaletteLime10 = "#1B230B";
  var ColorPaletteLime20 = "#212B0D";
  var ColorPaletteLime30 = "#2D3B12";
  var ColorPaletteLime40 = "#364616";
  var ColorPaletteLime50 = "#3F5219";
  var ColorPaletteLime60 = "#485E1D";
  var ColorPaletteLime70 = "#546E21";
  var ColorPaletteLime80 = "#607E26";
  var ColorPaletteLime90 = "#6C8D2B";
  var ColorPaletteLime100 = "#789D2F";
  var ColorPaletteLime110 = "#84AC34";
  var ColorPaletteLime120 = "#93BF3A";
  var ColorPaletteLime130 = "#A9CF5E";
  var ColorPaletteLime140 = "#C2DD8D";
  var ColorPaletteLime150 = "#DBEBBD";
  var ColorPaletteLime160 = "#F0F7E4";
  var ColorPaletteGreen10 = "#0B2312";
  var ColorPaletteGreen20 = "#0E2F18";
  var ColorPaletteGreen30 = "#133E20";
  var ColorPaletteGreen40 = "#174A26";
  var ColorPaletteGreen50 = "#1A562C";
  var ColorPaletteGreen60 = "#1F6634";
  var ColorPaletteGreen70 = "#22723A";
  var ColorPaletteGreen80 = "#278142";
  var ColorPaletteGreen90 = "#2D954C";
  var ColorPaletteGreen100 = "#32A454";
  var ColorPaletteGreen110 = "#38B85E";
  var ColorPaletteGreen120 = "#4BC870";
  var ColorPaletteGreen130 = "#76D692";
  var ColorPaletteGreen140 = "#9DE2B1";
  var ColorPaletteGreen150 = "#C8EED3";
  var ColorPaletteGreen160 = "#E8F8EC";
  var ColorPaletteAcqua10 = "#04251E";
  var ColorPaletteAcqua20 = "#052E26";
  var ColorPaletteAcqua30 = "#073C31";
  var ColorPaletteAcqua40 = "#08493C";
  var ColorPaletteAcqua50 = "#0A5748";
  var ColorPaletteAcqua60 = "#0B6553";
  var ColorPaletteAcqua70 = "#0D735E";
  var ColorPaletteAcqua80 = "#0F856D";
  var ColorPaletteAcqua90 = "#109379";
  var ColorPaletteAcqua100 = "#12A588";
  var ColorPaletteAcqua110 = "#14B897";
  var ColorPaletteAcqua120 = "#31C4A6";
  var ColorPaletteAcqua130 = "#68D4BF";
  var ColorPaletteAcqua140 = "#8DE2D1";
  var ColorPaletteAcqua150 = "#BCF0E6";
  var ColorPaletteAcqua160 = "#DFFBF6";
  var ColorPaletteBlue10 = "#051B48";
  var ColorPaletteBlue20 = "#062560";
  var ColorPaletteBlue30 = "#082F7D";
  var ColorPaletteBlue40 = "#0A3A9A";
  var ColorPaletteBlue50 = "#0B43B1";
  var ColorPaletteBlue60 = "#0D4ECE";
  var ColorPaletteBlue70 = "#0F58EA";
  var ColorPaletteBlue80 = "#286BF1";
  var ColorPaletteBlue90 = "#3F7BF2";
  var ColorPaletteBlue100 = "#5C8FF5";
  var ColorPaletteBlue110 = "#73A0F7";
  var ColorPaletteBlue120 = "#8CB0F8";
  var ColorPaletteBlue130 = "#A9C4F9";
  var ColorPaletteBlue140 = "#C1D4FB";
  var ColorPaletteBlue150 = "#D9E5FC";
  var ColorPaletteBlue160 = "#F1F5FE";
  var ColorPalettePurple10 = "#340849";
  var ColorPalettePurple20 = "#440B60";
  var ColorPalettePurple30 = "#540D78";
  var ColorPalettePurple40 = "#671093";
  var ColorPalettePurple50 = "#7713AA";
  var ColorPalettePurple60 = "#8B16C5";
  var ColorPalettePurple70 = "#9B18DC";
  var ColorPalettePurple80 = "#AD35E9";
  var ColorPalettePurple90 = "#B851EC";
  var ColorPalettePurple100 = "#C36CEF";
  var ColorPalettePurple110 = "#CC83F1";
  var ColorPalettePurple120 = "#D69AF4";
  var ColorPalettePurple130 = "#DFB1F6";
  var ColorPalettePurple140 = "#E8C8F9";
  var ColorPalettePurple150 = "#F2DFFB";
  var ColorPalettePurple160 = "#F9F1FD";
  var ColorPalettePink10 = "#3B0C27";
  var ColorPalettePink20 = "#4C1032";
  var ColorPalettePink30 = "#661543";
  var ColorPalettePink40 = "#77184E";
  var ColorPalettePink50 = "#8C1C5D";
  var ColorPalettePink60 = "#A12169";
  var ColorPalettePink70 = "#BA267B";
  var ColorPalettePink80 = "#D42B8C";
  var ColorPalettePink90 = "#DA499B";
  var ColorPalettePink100 = "#E067AB";
  var ColorPalettePink110 = "#E580B9";
  var ColorPalettePink120 = "#EA99C7";
  var ColorPalettePink130 = "#EFAFD3";
  var ColorPalettePink140 = "#F4C8E1";
  var ColorPalettePink150 = "#F8DDEC";
  var ColorPalettePink160 = "#FCF2F8";
  var ColorTypefaceStrong = "#161616";
  var ColorTypefacePure = "#363636";
  var ColorTypefaceSmooth = "#666666";
  var ColorTypefaceMeld = "#1616163D";
  var ColorTypefaceInverseStrong = "#FEFEFE";
  var ColorTypefaceInversePure = "#D4D4D4";
  var ColorTypefaceInverseSmooth = "#919191";
  var ColorTypefaceInverseMeld = "#FEFEFE52";
  var ColorTypefaceInverseOnBrandStrong = "#161616";
  var ColorTypefaceInverseOnBrandPure = "#363636";
  var ColorTypefaceInverseOnBrandSmooth = "#595959";
  var ColorTypefaceInverseOnBrandMeld = "#1616163D";
  var ColorTypefaceOnBrandStrong = "#FEFEFE";
  var ColorTypefaceOnBrandPure = "#DBE3FF";
  var ColorTypefaceOnBrandSmooth = "#C7D3FF";
  var ColorTypefaceOnBrandMeld = "#FEFEFE52";
  var ColorBrandPrimary10 = "#000E40";
  var ColorBrandPrimary20 = "#001A7A";
  var ColorBrandPrimary30 = "#00229E";
  var ColorBrandPrimary40 = "#0029BD";
  var ColorBrandPrimary50 = "#002FDB";
  var ColorBrandPrimary60 = "#0037FF";
  var ColorBrandPrimary70 = "#1F4FFF";
  var ColorBrandPrimary80 = "#3863FF";
  var ColorBrandPrimary90 = "#5277FF";
  var ColorBrandPrimary100 = "#6B8BFF";
  var ColorBrandPrimary110 = "#809BFF";
  var ColorBrandPrimary120 = "#99AFFF";
  var ColorBrandPrimary130 = "#ADBFFF";
  var ColorBrandPrimary140 = "#C7D3FF";
  var ColorBrandPrimary150 = "#DBE3FF";
  var ColorBrandPrimary160 = "#F0F3FF";
  var ColorBrandBase01 = "#000E40";
  var ColorBrandBase02 = "#2BD6C4";
  var ColorBrandBase03 = "#B2DFD8";
  var ColorBrandBase04 = "#9C86E0";
  var ColorBrandBase05 = "#D8BD97";
  var ColorBrandBase06 = "#F6F4F4";
  var ColorBrandPalette0110 = "#000E40";
  var ColorBrandPalette0120 = "#001A7A";
  var ColorBrandPalette0130 = "#00229E";
  var ColorBrandPalette0140 = "#0029BD";
  var ColorBrandPalette0150 = "#002FDB";
  var ColorBrandPalette0160 = "#0037FF";
  var ColorBrandPalette0170 = "#1F4FFF";
  var ColorBrandPalette0180 = "#3863FF";
  var ColorBrandPalette0190 = "#5277FF";
  var ColorBrandPalette01100 = "#6B8BFF";
  var ColorBrandPalette01110 = "#809BFF";
  var ColorBrandPalette01120 = "#99AFFF";
  var ColorBrandPalette01130 = "#ADBFFF";
  var ColorBrandPalette01140 = "#C7D3FF";
  var ColorBrandPalette01150 = "#DBE3FF";
  var ColorBrandPalette01160 = "#F0F3FF";
  var ColorBrandPalette0210 = "#07221F";
  var ColorBrandPalette0220 = "#092F2B";
  var ColorBrandPalette0230 = "#0B3C37";
  var ColorBrandPalette0240 = "#0E4943";
  var ColorBrandPalette0250 = "#10564F";
  var ColorBrandPalette0260 = "#13635B";
  var ColorBrandPalette0270 = "#16746A";
  var ColorBrandPalette0280 = "#188176";
  var ColorBrandPalette0290 = "#1C9286";
  var ColorBrandPalette02100 = "#1FA396";
  var ColorBrandPalette02110 = "#22B4A5";
  var ColorBrandPalette02120 = "#26C5B5";
  var ColorBrandPalette02130 = "#2BD6C4";
  var ColorBrandPalette02140 = "#B2DFD8";
  var ColorBrandPalette02150 = "#D0EBE7";
  var ColorBrandPalette02160 = "#E9F6F4";
  var ColorBrandPalette0410 = "#22144D";
  var ColorBrandPalette0420 = "#2D1A65";
  var ColorBrandPalette0430 = "#3A2182";
  var ColorBrandPalette0440 = "#46299E";
  var ColorBrandPalette0450 = "#5330BB";
  var ColorBrandPalette0460 = "#603CCD";
  var ColorBrandPalette0470 = "#6E4DD1";
  var ColorBrandPalette0480 = "#7E61D6";
  var ColorBrandPalette0490 = "#8B71DA";
  var ColorBrandPalette04100 = "#9C86E0";
  var ColorBrandPalette04110 = "#A996E4";
  var ColorBrandPalette04120 = "#BAAAE9";
  var ColorBrandPalette04130 = "#C7BAED";
  var ColorBrandPalette04140 = "#D7CEF2";
  var ColorBrandPalette04150 = "#E8E3F8";
  var ColorBrandPalette04160 = "#F5F3FC";
  var ColorBrandPalette0510 = "#251B0E";
  var ColorBrandPalette0520 = "#342614";
  var ColorBrandPalette0530 = "#433119";
  var ColorBrandPalette0540 = "#513C1F";
  var ColorBrandPalette0550 = "#604724";
  var ColorBrandPalette0560 = "#73552B";
  var ColorBrandPalette0570 = "#816031";
  var ColorBrandPalette0580 = "#946E38";
  var ColorBrandPalette0590 = "#A3793E";
  var ColorBrandPalette05100 = "#B98946";
  var ColorBrandPalette05110 = "#C39A60";
  var ColorBrandPalette05120 = "#CEAC7E";
  var ColorBrandPalette05130 = "#D8BD97";
  var ColorBrandPalette05140 = "#E3D0B5";
  var ColorBrandPalette05150 = "#EEE3D3";
  var ColorBrandPalette05160 = "#F8F3EC";
  var ColorBrandPalette0610 = "#1A1514";
  var ColorBrandPalette0620 = "#312826";
  var ColorBrandPalette0630 = "#3F3431";
  var ColorBrandPalette0640 = "#4A3D3A";
  var ColorBrandPalette0650 = "#594946";
  var ColorBrandPalette0660 = "#675451";
  var ColorBrandPalette0670 = "#75605C";
  var ColorBrandPalette0680 = "#866E69";
  var ColorBrandPalette0690 = "#967E79";
  var ColorBrandPalette06100 = "#A38E8A";
  var ColorBrandPalette06110 = "#AE9C98";
  var ColorBrandPalette06120 = "#BEAFAC";
  var ColorBrandPalette06130 = "#CBC0BD";
  var ColorBrandPalette06140 = "#D9D0CE";
  var ColorBrandPalette06150 = "#E9E4E3";
  var ColorBrandPalette06160 = "#F6F4F4";
  var ColorFeedbackErrorText = "#BC293A";
  var ColorFeedbackErrorShape = "#EA4356";
  var ColorFeedbackSuccessText = "#22723A";
  var ColorFeedbackSuccessShape = "#2D954C";
  var ColorFeedbackOnBrandErrorText = "#F77E8C";
  var ColorFeedbackOnBrandErrorShape = "#EA4356";
  var ColorFeedbackOnBrandSuccessText = "#38B85E";
  var ColorFeedbackOnBrandSuccessShape = "#2D954C";
  var ColorFeedbackInverseErrorText = "#F55C6E";
  var ColorFeedbackInverseErrorShape = "#D83145";
  var ColorFeedbackInverseSuccessText = "#32A454";
  var ColorFeedbackInverseSuccessShape = "#278142";
  var ColorFeedbackInverseOnBrandErrorText = "#A72534";
  var ColorFeedbackInverseOnBrandErrorShape = "#D83145";
  var ColorFeedbackInverseOnBrandSuccessText = "#1F6634";
  var ColorFeedbackInverseOnBrandSuccessShape = "#278142";
  var ColorSupport01 = "#8B71DA";
  var ColorSupport02 = "#8B71DA";
  var ColorSupportOnBrand01 = "#2BD6C4";
  var ColorSupportOnBrand02 = "#2BD6C4";
  var ColorSupportInverse01 = "#2BD6C4";
  var ColorSupportInverse02 = "#2BD6C4";
  var ColorSupportInverseOnBrand01 = "#7E61D6";
  var ColorSupportInverseOnBrand02 = "#7E61D6";
  var Opacity01 = "0.04";
  var Opacity02 = "0.08";
  var Opacity03 = "0.12";
  var Opacity04 = "0.24";
  var Opacity05 = "0.32";
  var Opacity06 = "0.56";
  var Opacity07 = "0.64";
  var Opacity08 = "0.72";
  var Opacity09 = "0.88";
  var Shadow01 = "0px 2px 2px rgba(22, 22, 22, 0.04), 0px 4px 8px rgba(22, 22, 22, 0.08)";
  var Shadow02 = "0px 4px 4px rgba(22, 22, 22, 0.04), 0px 8px 24px rgba(22, 22, 22, 0.08)";
  var Shadow03 = "0px 8px 8px rgba(22, 22, 22, 0.04), 0px 16px 40px rgba(22, 22, 22, 0.08)";
  var Shadow04 = "0px 12px 12px rgba(22, 22, 22, 0.04), 0px 24px 56px rgba(22, 22, 22, 0.08)";
  var SpacingInlineQuark = "4px";
  var SpacingInlineNano = "8px";
  var SpacingInlineXxxs = "16px";
  var SpacingInlineXxs = "24px";
  var SpacingInlineXs = "32px";
  var SpacingInlineSm = "40px";
  var SpacingInlineMd = "48px";
  var SpacingInlineLg = "56px";
  var SpacingInlineXl = "64px";
  var SpacingInlineXxl = "80px";
  var SpacingInlineXxxl = "120px";
  var SpacingInlineHuge = "160px";
  var SpacingInlineGiant = "200px";
  var SpacingInsetQuark = "4px";
  var SpacingInsetNano = "8px";
  var SpacingInsetXs = "16px";
  var SpacingInsetSm = "24px";
  var SpacingInsetMd = "32px";
  var SpacingInsetLg = "40px";
  var SpacingSquishQuark = "4px 8px";
  var SpacingSquishNano = "8px 16px";
  var SpacingSquishXs = "16px 24px";
  var SpacingSquishSm = "16px 32px";
  var SpacingStackQuark = "4px";
  var SpacingStackNano = "8px";
  var SpacingStackXxxs = "16px";
  var SpacingStackXxs = "24px";
  var SpacingStackXs = "32px";
  var SpacingStackSm = "40px";
  var SpacingStackMd = "48px";
  var SpacingStackLg = "56px";
  var SpacingStackXl = "64px";
  var SpacingStackXxl = "80px";
  var SpacingStackXxxl = "120px";
  var SpacingStackHuge = "160px";
  var SpacingStackGiant = "200px";
  var FontFamilyBase = "'Dasa Sans', 'sans-serif'";
  var FontSizeXxxs = "0.75rem";
  var FontSizeXxs = "0.875rem";
  var FontSizeXs = "1rem";
  var FontSizeSm = "1.25rem";
  var FontSizeMd = "1.5rem";
  var FontSizeLg = "2rem";
  var FontSizeXl = "2.5rem";
  var FontSizeXxl = "3rem";
  var FontSizeXxxl = "4rem";
  var FontSizeDisplay = "5rem";
  var FontSizeGiant = "6rem";
  var FontWeightBold = 700;
  var FontWeightSemibold = 600;
  var FontWeightMedium = 500;
  var FontWeightRegular = 400;
  var FontWeightLight = 300;
  var LetterSpacingStandard = "0px";
  var LetterSpacingSmall = "-1px";
  var LetterSpacingMedium = "1.5px";
  var LineHeightStandard = "100%";
  var LineHeightTiny = "115%";
  var LineHeightMedium = "120%";
  var LineHeightLarge = "125%";
  var LineHeightDistant = "133%";
  var LineHeightSuperdistant = "150%";
  var LineHeightHuge = "170%";
  var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BorderRadiusNone: BorderRadiusNone,
    BorderRadiusXs: BorderRadiusXs,
    BorderRadiusSm: BorderRadiusSm,
    BorderRadiusMd: BorderRadiusMd,
    BorderRadiusLg: BorderRadiusLg,
    BorderRadiusPill: BorderRadiusPill,
    BorderRadiusCircle: BorderRadiusCircle,
    BorderWidthNone: BorderWidthNone,
    BorderWidthHairline: BorderWidthHairline,
    BorderWidthThin: BorderWidthThin,
    BorderWidthThick: BorderWidthThick,
    BorderWidthHeavy: BorderWidthHeavy,
    ColorDatavizInfoText: ColorDatavizInfoText,
    ColorDatavizInfoShape01: ColorDatavizInfoShape01,
    ColorDatavizInfoShape02: ColorDatavizInfoShape02,
    ColorDatavizInfoShape03: ColorDatavizInfoShape03,
    ColorDatavizNegativeText: ColorDatavizNegativeText,
    ColorDatavizNegativeShape01: ColorDatavizNegativeShape01,
    ColorDatavizNegativeShape02: ColorDatavizNegativeShape02,
    ColorDatavizNegativeShape03: ColorDatavizNegativeShape03,
    ColorDatavizWarningText: ColorDatavizWarningText,
    ColorDatavizWarningShape01: ColorDatavizWarningShape01,
    ColorDatavizWarningShape02: ColorDatavizWarningShape02,
    ColorDatavizWarningShape03: ColorDatavizWarningShape03,
    ColorDatavizPositiveText: ColorDatavizPositiveText,
    ColorDatavizPositiveShape01: ColorDatavizPositiveShape01,
    ColorDatavizPositiveShape02: ColorDatavizPositiveShape02,
    ColorDatavizPositiveShape03: ColorDatavizPositiveShape03,
    ColorDatavizCatAText: ColorDatavizCatAText,
    ColorDatavizCatAShape01: ColorDatavizCatAShape01,
    ColorDatavizCatAShape02: ColorDatavizCatAShape02,
    ColorDatavizCatAShape03: ColorDatavizCatAShape03,
    ColorDatavizCatBText: ColorDatavizCatBText,
    ColorDatavizCatBShape01: ColorDatavizCatBShape01,
    ColorDatavizCatBShape02: ColorDatavizCatBShape02,
    ColorDatavizCatBShape03: ColorDatavizCatBShape03,
    ColorDatavizCatCText: ColorDatavizCatCText,
    ColorDatavizCatCShape01: ColorDatavizCatCShape01,
    ColorDatavizCatCShape02: ColorDatavizCatCShape02,
    ColorDatavizCatCShape03: ColorDatavizCatCShape03,
    ColorDatavizCatDText: ColorDatavizCatDText,
    ColorDatavizCatDShape01: ColorDatavizCatDShape01,
    ColorDatavizCatDShape02: ColorDatavizCatDShape02,
    ColorDatavizCatDShape03: ColorDatavizCatDShape03,
    ColorDatavizInverseInfoText: ColorDatavizInverseInfoText,
    ColorDatavizInverseInfoShape01: ColorDatavizInverseInfoShape01,
    ColorDatavizInverseInfoShape02: ColorDatavizInverseInfoShape02,
    ColorDatavizInverseInfoShape03: ColorDatavizInverseInfoShape03,
    ColorDatavizInverseNegativeText: ColorDatavizInverseNegativeText,
    ColorDatavizInverseNegativeShape01: ColorDatavizInverseNegativeShape01,
    ColorDatavizInverseNegativeShape02: ColorDatavizInverseNegativeShape02,
    ColorDatavizInverseNegativeShape03: ColorDatavizInverseNegativeShape03,
    ColorDatavizInverseWarningText: ColorDatavizInverseWarningText,
    ColorDatavizInverseWarningShape01: ColorDatavizInverseWarningShape01,
    ColorDatavizInverseWarningShape02: ColorDatavizInverseWarningShape02,
    ColorDatavizInverseWarningShape03: ColorDatavizInverseWarningShape03,
    ColorDatavizInversePositiveText: ColorDatavizInversePositiveText,
    ColorDatavizInversePositiveShape01: ColorDatavizInversePositiveShape01,
    ColorDatavizInversePositiveShape02: ColorDatavizInversePositiveShape02,
    ColorDatavizInversePositiveShape03: ColorDatavizInversePositiveShape03,
    ColorDatavizInverseCatAText: ColorDatavizInverseCatAText,
    ColorDatavizInverseCatAShape01: ColorDatavizInverseCatAShape01,
    ColorDatavizInverseCatAShape02: ColorDatavizInverseCatAShape02,
    ColorDatavizInverseCatAShape03: ColorDatavizInverseCatAShape03,
    ColorDatavizInverseCatBText: ColorDatavizInverseCatBText,
    ColorDatavizInverseCatBShape01: ColorDatavizInverseCatBShape01,
    ColorDatavizInverseCatBShape02: ColorDatavizInverseCatBShape02,
    ColorDatavizInverseCatBShape03: ColorDatavizInverseCatBShape03,
    ColorDatavizInverseCatCText: ColorDatavizInverseCatCText,
    ColorDatavizInverseCatCShape01: ColorDatavizInverseCatCShape01,
    ColorDatavizInverseCatCShape02: ColorDatavizInverseCatCShape02,
    ColorDatavizInverseCatCShape03: ColorDatavizInverseCatCShape03,
    ColorDatavizInverseCatDText: ColorDatavizInverseCatDText,
    ColorDatavizInverseCatDShape01: ColorDatavizInverseCatDShape01,
    ColorDatavizInverseCatDShape02: ColorDatavizInverseCatDShape02,
    ColorDatavizInverseCatDShape03: ColorDatavizInverseCatDShape03,
    ColorInteractionBlend01: ColorInteractionBlend01,
    ColorInteractionBlend02: ColorInteractionBlend02,
    ColorInteractionBlend03: ColorInteractionBlend03,
    ColorInteractionBlend04: ColorInteractionBlend04,
    ColorInteractionBlend05: ColorInteractionBlend05,
    ColorInteractionBlend06: ColorInteractionBlend06,
    ColorInteractionBlend07: ColorInteractionBlend07,
    ColorInteractionBlend08: ColorInteractionBlend08,
    ColorInteractionInverseBlend01: ColorInteractionInverseBlend01,
    ColorInteractionInverseBlend02: ColorInteractionInverseBlend02,
    ColorInteractionInverseBlend03: ColorInteractionInverseBlend03,
    ColorInteractionInverseBlend04: ColorInteractionInverseBlend04,
    ColorInteractionInverseBlend05: ColorInteractionInverseBlend05,
    ColorInteractionInverseBlend06: ColorInteractionInverseBlend06,
    ColorInteractionInverseBlend07: ColorInteractionInverseBlend07,
    ColorInteractionInverseBlend08: ColorInteractionInverseBlend08,
    ColorInteractionInverseAccent01: ColorInteractionInverseAccent01,
    ColorInteractionInverseAccent02: ColorInteractionInverseAccent02,
    ColorInteractionInverseAccent03: ColorInteractionInverseAccent03,
    ColorInteractionInverseSubtle01: ColorInteractionInverseSubtle01,
    ColorInteractionInverseSubtle02: ColorInteractionInverseSubtle02,
    ColorInteractionInverseSubtle03: ColorInteractionInverseSubtle03,
    ColorInteractionInverseSelectDefault: ColorInteractionInverseSelectDefault,
    ColorInteractionInverseSelectFocus: ColorInteractionInverseSelectFocus,
    ColorInteractionInverseSelectActive: ColorInteractionInverseSelectActive,
    ColorInteractionInverseDanger01: ColorInteractionInverseDanger01,
    ColorInteractionInverseDanger02: ColorInteractionInverseDanger02,
    ColorInteractionInverseDanger03: ColorInteractionInverseDanger03,
    ColorInteractionInverseOnBrandAccent01: ColorInteractionInverseOnBrandAccent01,
    ColorInteractionInverseOnBrandAccent02: ColorInteractionInverseOnBrandAccent02,
    ColorInteractionInverseOnBrandAccent03: ColorInteractionInverseOnBrandAccent03,
    ColorInteractionInverseOnBrandSubtle01: ColorInteractionInverseOnBrandSubtle01,
    ColorInteractionInverseOnBrandSubtle02: ColorInteractionInverseOnBrandSubtle02,
    ColorInteractionInverseOnBrandSubtle03: ColorInteractionInverseOnBrandSubtle03,
    ColorInteractionInverseOnBrandSelectDefault: ColorInteractionInverseOnBrandSelectDefault,
    ColorInteractionInverseOnBrandSelectFocus: ColorInteractionInverseOnBrandSelectFocus,
    ColorInteractionInverseOnBrandSelectActive: ColorInteractionInverseOnBrandSelectActive,
    ColorInteractionInverseOnBrandBlend01: ColorInteractionInverseOnBrandBlend01,
    ColorInteractionInverseOnBrandBlend02: ColorInteractionInverseOnBrandBlend02,
    ColorInteractionInverseOnBrandBlend03: ColorInteractionInverseOnBrandBlend03,
    ColorInteractionInverseOnBrandBlend04: ColorInteractionInverseOnBrandBlend04,
    ColorInteractionInverseOnBrandBlend05: ColorInteractionInverseOnBrandBlend05,
    ColorInteractionInverseOnBrandBlend06: ColorInteractionInverseOnBrandBlend06,
    ColorInteractionInverseOnBrandBlend07: ColorInteractionInverseOnBrandBlend07,
    ColorInteractionInverseOnBrandBlend08: ColorInteractionInverseOnBrandBlend08,
    ColorInteractionInverseOnBrandDanger01: ColorInteractionInverseOnBrandDanger01,
    ColorInteractionInverseOnBrandDanger02: ColorInteractionInverseOnBrandDanger02,
    ColorInteractionInverseOnBrandDanger03: ColorInteractionInverseOnBrandDanger03,
    ColorInteractionAccent01: ColorInteractionAccent01,
    ColorInteractionAccent02: ColorInteractionAccent02,
    ColorInteractionAccent03: ColorInteractionAccent03,
    ColorInteractionSubtle01: ColorInteractionSubtle01,
    ColorInteractionSubtle02: ColorInteractionSubtle02,
    ColorInteractionSubtle03: ColorInteractionSubtle03,
    ColorInteractionSelectDefault: ColorInteractionSelectDefault,
    ColorInteractionSelectFocus: ColorInteractionSelectFocus,
    ColorInteractionSelectActive: ColorInteractionSelectActive,
    ColorInteractionDanger01: ColorInteractionDanger01,
    ColorInteractionDanger02: ColorInteractionDanger02,
    ColorInteractionDanger03: ColorInteractionDanger03,
    ColorInteractionOnBrandAccent01: ColorInteractionOnBrandAccent01,
    ColorInteractionOnBrandAccent02: ColorInteractionOnBrandAccent02,
    ColorInteractionOnBrandAccent03: ColorInteractionOnBrandAccent03,
    ColorInteractionOnBrandSubtle01: ColorInteractionOnBrandSubtle01,
    ColorInteractionOnBrandSubtle02: ColorInteractionOnBrandSubtle02,
    ColorInteractionOnBrandSubtle03: ColorInteractionOnBrandSubtle03,
    ColorInteractionOnBrandSelectDefault: ColorInteractionOnBrandSelectDefault,
    ColorInteractionOnBrandSelectFocus: ColorInteractionOnBrandSelectFocus,
    ColorInteractionOnBrandSelectActive: ColorInteractionOnBrandSelectActive,
    ColorInteractionOnBrandBlend01: ColorInteractionOnBrandBlend01,
    ColorInteractionOnBrandBlend02: ColorInteractionOnBrandBlend02,
    ColorInteractionOnBrandBlend03: ColorInteractionOnBrandBlend03,
    ColorInteractionOnBrandBlend04: ColorInteractionOnBrandBlend04,
    ColorInteractionOnBrandBlend05: ColorInteractionOnBrandBlend05,
    ColorInteractionOnBrandBlend06: ColorInteractionOnBrandBlend06,
    ColorInteractionOnBrandBlend07: ColorInteractionOnBrandBlend07,
    ColorInteractionOnBrandBlend08: ColorInteractionOnBrandBlend08,
    ColorInteractionOnBrandDanger01: ColorInteractionOnBrandDanger01,
    ColorInteractionOnBrandDanger02: ColorInteractionOnBrandDanger02,
    ColorInteractionOnBrandDanger03: ColorInteractionOnBrandDanger03,
    ColorNeutral10: ColorNeutral10,
    ColorNeutral20: ColorNeutral20,
    ColorNeutral30: ColorNeutral30,
    ColorNeutral00: ColorNeutral00,
    ColorNeutralInverse10: ColorNeutralInverse10,
    ColorNeutralInverse20: ColorNeutralInverse20,
    ColorNeutralInverse30: ColorNeutralInverse30,
    ColorNeutralInverse00: ColorNeutralInverse00,
    ColorNeutralInverseOnBrand10: ColorNeutralInverseOnBrand10,
    ColorNeutralInverseOnBrand20: ColorNeutralInverseOnBrand20,
    ColorNeutralInverseOnBrand30: ColorNeutralInverseOnBrand30,
    ColorNeutralInverseOnBrand00: ColorNeutralInverseOnBrand00,
    ColorNeutralOnBrand10: ColorNeutralOnBrand10,
    ColorNeutralOnBrand20: ColorNeutralOnBrand20,
    ColorNeutralOnBrand30: ColorNeutralOnBrand30,
    ColorNeutralOnBrand00: ColorNeutralOnBrand00,
    ColorPaletteBlack: ColorPaletteBlack,
    ColorPaletteWhite: ColorPaletteWhite,
    ColorPaletteGray10: ColorPaletteGray10,
    ColorPaletteGray20: ColorPaletteGray20,
    ColorPaletteGray30: ColorPaletteGray30,
    ColorPaletteGray40: ColorPaletteGray40,
    ColorPaletteGray50: ColorPaletteGray50,
    ColorPaletteGray60: ColorPaletteGray60,
    ColorPaletteGray70: ColorPaletteGray70,
    ColorPaletteGray80: ColorPaletteGray80,
    ColorPaletteGray90: ColorPaletteGray90,
    ColorPaletteGray100: ColorPaletteGray100,
    ColorPaletteGray110: ColorPaletteGray110,
    ColorPaletteGray120: ColorPaletteGray120,
    ColorPaletteGray130: ColorPaletteGray130,
    ColorPaletteGray140: ColorPaletteGray140,
    ColorPaletteGray150: ColorPaletteGray150,
    ColorPaletteGray160: ColorPaletteGray160,
    ColorPaletteRed10: ColorPaletteRed10,
    ColorPaletteRed20: ColorPaletteRed20,
    ColorPaletteRed30: ColorPaletteRed30,
    ColorPaletteRed40: ColorPaletteRed40,
    ColorPaletteRed50: ColorPaletteRed50,
    ColorPaletteRed60: ColorPaletteRed60,
    ColorPaletteRed70: ColorPaletteRed70,
    ColorPaletteRed80: ColorPaletteRed80,
    ColorPaletteRed90: ColorPaletteRed90,
    ColorPaletteRed100: ColorPaletteRed100,
    ColorPaletteRed110: ColorPaletteRed110,
    ColorPaletteRed120: ColorPaletteRed120,
    ColorPaletteRed130: ColorPaletteRed130,
    ColorPaletteRed140: ColorPaletteRed140,
    ColorPaletteRed150: ColorPaletteRed150,
    ColorPaletteRed160: ColorPaletteRed160,
    ColorPaletteYellow10: ColorPaletteYellow10,
    ColorPaletteYellow20: ColorPaletteYellow20,
    ColorPaletteYellow30: ColorPaletteYellow30,
    ColorPaletteYellow40: ColorPaletteYellow40,
    ColorPaletteYellow50: ColorPaletteYellow50,
    ColorPaletteYellow60: ColorPaletteYellow60,
    ColorPaletteYellow70: ColorPaletteYellow70,
    ColorPaletteYellow80: ColorPaletteYellow80,
    ColorPaletteYellow90: ColorPaletteYellow90,
    ColorPaletteYellow100: ColorPaletteYellow100,
    ColorPaletteYellow110: ColorPaletteYellow110,
    ColorPaletteYellow120: ColorPaletteYellow120,
    ColorPaletteYellow130: ColorPaletteYellow130,
    ColorPaletteYellow140: ColorPaletteYellow140,
    ColorPaletteYellow150: ColorPaletteYellow150,
    ColorPaletteYellow160: ColorPaletteYellow160,
    ColorPaletteLime10: ColorPaletteLime10,
    ColorPaletteLime20: ColorPaletteLime20,
    ColorPaletteLime30: ColorPaletteLime30,
    ColorPaletteLime40: ColorPaletteLime40,
    ColorPaletteLime50: ColorPaletteLime50,
    ColorPaletteLime60: ColorPaletteLime60,
    ColorPaletteLime70: ColorPaletteLime70,
    ColorPaletteLime80: ColorPaletteLime80,
    ColorPaletteLime90: ColorPaletteLime90,
    ColorPaletteLime100: ColorPaletteLime100,
    ColorPaletteLime110: ColorPaletteLime110,
    ColorPaletteLime120: ColorPaletteLime120,
    ColorPaletteLime130: ColorPaletteLime130,
    ColorPaletteLime140: ColorPaletteLime140,
    ColorPaletteLime150: ColorPaletteLime150,
    ColorPaletteLime160: ColorPaletteLime160,
    ColorPaletteGreen10: ColorPaletteGreen10,
    ColorPaletteGreen20: ColorPaletteGreen20,
    ColorPaletteGreen30: ColorPaletteGreen30,
    ColorPaletteGreen40: ColorPaletteGreen40,
    ColorPaletteGreen50: ColorPaletteGreen50,
    ColorPaletteGreen60: ColorPaletteGreen60,
    ColorPaletteGreen70: ColorPaletteGreen70,
    ColorPaletteGreen80: ColorPaletteGreen80,
    ColorPaletteGreen90: ColorPaletteGreen90,
    ColorPaletteGreen100: ColorPaletteGreen100,
    ColorPaletteGreen110: ColorPaletteGreen110,
    ColorPaletteGreen120: ColorPaletteGreen120,
    ColorPaletteGreen130: ColorPaletteGreen130,
    ColorPaletteGreen140: ColorPaletteGreen140,
    ColorPaletteGreen150: ColorPaletteGreen150,
    ColorPaletteGreen160: ColorPaletteGreen160,
    ColorPaletteAcqua10: ColorPaletteAcqua10,
    ColorPaletteAcqua20: ColorPaletteAcqua20,
    ColorPaletteAcqua30: ColorPaletteAcqua30,
    ColorPaletteAcqua40: ColorPaletteAcqua40,
    ColorPaletteAcqua50: ColorPaletteAcqua50,
    ColorPaletteAcqua60: ColorPaletteAcqua60,
    ColorPaletteAcqua70: ColorPaletteAcqua70,
    ColorPaletteAcqua80: ColorPaletteAcqua80,
    ColorPaletteAcqua90: ColorPaletteAcqua90,
    ColorPaletteAcqua100: ColorPaletteAcqua100,
    ColorPaletteAcqua110: ColorPaletteAcqua110,
    ColorPaletteAcqua120: ColorPaletteAcqua120,
    ColorPaletteAcqua130: ColorPaletteAcqua130,
    ColorPaletteAcqua140: ColorPaletteAcqua140,
    ColorPaletteAcqua150: ColorPaletteAcqua150,
    ColorPaletteAcqua160: ColorPaletteAcqua160,
    ColorPaletteBlue10: ColorPaletteBlue10,
    ColorPaletteBlue20: ColorPaletteBlue20,
    ColorPaletteBlue30: ColorPaletteBlue30,
    ColorPaletteBlue40: ColorPaletteBlue40,
    ColorPaletteBlue50: ColorPaletteBlue50,
    ColorPaletteBlue60: ColorPaletteBlue60,
    ColorPaletteBlue70: ColorPaletteBlue70,
    ColorPaletteBlue80: ColorPaletteBlue80,
    ColorPaletteBlue90: ColorPaletteBlue90,
    ColorPaletteBlue100: ColorPaletteBlue100,
    ColorPaletteBlue110: ColorPaletteBlue110,
    ColorPaletteBlue120: ColorPaletteBlue120,
    ColorPaletteBlue130: ColorPaletteBlue130,
    ColorPaletteBlue140: ColorPaletteBlue140,
    ColorPaletteBlue150: ColorPaletteBlue150,
    ColorPaletteBlue160: ColorPaletteBlue160,
    ColorPalettePurple10: ColorPalettePurple10,
    ColorPalettePurple20: ColorPalettePurple20,
    ColorPalettePurple30: ColorPalettePurple30,
    ColorPalettePurple40: ColorPalettePurple40,
    ColorPalettePurple50: ColorPalettePurple50,
    ColorPalettePurple60: ColorPalettePurple60,
    ColorPalettePurple70: ColorPalettePurple70,
    ColorPalettePurple80: ColorPalettePurple80,
    ColorPalettePurple90: ColorPalettePurple90,
    ColorPalettePurple100: ColorPalettePurple100,
    ColorPalettePurple110: ColorPalettePurple110,
    ColorPalettePurple120: ColorPalettePurple120,
    ColorPalettePurple130: ColorPalettePurple130,
    ColorPalettePurple140: ColorPalettePurple140,
    ColorPalettePurple150: ColorPalettePurple150,
    ColorPalettePurple160: ColorPalettePurple160,
    ColorPalettePink10: ColorPalettePink10,
    ColorPalettePink20: ColorPalettePink20,
    ColorPalettePink30: ColorPalettePink30,
    ColorPalettePink40: ColorPalettePink40,
    ColorPalettePink50: ColorPalettePink50,
    ColorPalettePink60: ColorPalettePink60,
    ColorPalettePink70: ColorPalettePink70,
    ColorPalettePink80: ColorPalettePink80,
    ColorPalettePink90: ColorPalettePink90,
    ColorPalettePink100: ColorPalettePink100,
    ColorPalettePink110: ColorPalettePink110,
    ColorPalettePink120: ColorPalettePink120,
    ColorPalettePink130: ColorPalettePink130,
    ColorPalettePink140: ColorPalettePink140,
    ColorPalettePink150: ColorPalettePink150,
    ColorPalettePink160: ColorPalettePink160,
    ColorTypefaceStrong: ColorTypefaceStrong,
    ColorTypefacePure: ColorTypefacePure,
    ColorTypefaceSmooth: ColorTypefaceSmooth,
    ColorTypefaceMeld: ColorTypefaceMeld,
    ColorTypefaceInverseStrong: ColorTypefaceInverseStrong,
    ColorTypefaceInversePure: ColorTypefaceInversePure,
    ColorTypefaceInverseSmooth: ColorTypefaceInverseSmooth,
    ColorTypefaceInverseMeld: ColorTypefaceInverseMeld,
    ColorTypefaceInverseOnBrandStrong: ColorTypefaceInverseOnBrandStrong,
    ColorTypefaceInverseOnBrandPure: ColorTypefaceInverseOnBrandPure,
    ColorTypefaceInverseOnBrandSmooth: ColorTypefaceInverseOnBrandSmooth,
    ColorTypefaceInverseOnBrandMeld: ColorTypefaceInverseOnBrandMeld,
    ColorTypefaceOnBrandStrong: ColorTypefaceOnBrandStrong,
    ColorTypefaceOnBrandPure: ColorTypefaceOnBrandPure,
    ColorTypefaceOnBrandSmooth: ColorTypefaceOnBrandSmooth,
    ColorTypefaceOnBrandMeld: ColorTypefaceOnBrandMeld,
    ColorBrandPrimary10: ColorBrandPrimary10,
    ColorBrandPrimary20: ColorBrandPrimary20,
    ColorBrandPrimary30: ColorBrandPrimary30,
    ColorBrandPrimary40: ColorBrandPrimary40,
    ColorBrandPrimary50: ColorBrandPrimary50,
    ColorBrandPrimary60: ColorBrandPrimary60,
    ColorBrandPrimary70: ColorBrandPrimary70,
    ColorBrandPrimary80: ColorBrandPrimary80,
    ColorBrandPrimary90: ColorBrandPrimary90,
    ColorBrandPrimary100: ColorBrandPrimary100,
    ColorBrandPrimary110: ColorBrandPrimary110,
    ColorBrandPrimary120: ColorBrandPrimary120,
    ColorBrandPrimary130: ColorBrandPrimary130,
    ColorBrandPrimary140: ColorBrandPrimary140,
    ColorBrandPrimary150: ColorBrandPrimary150,
    ColorBrandPrimary160: ColorBrandPrimary160,
    ColorBrandBase01: ColorBrandBase01,
    ColorBrandBase02: ColorBrandBase02,
    ColorBrandBase03: ColorBrandBase03,
    ColorBrandBase04: ColorBrandBase04,
    ColorBrandBase05: ColorBrandBase05,
    ColorBrandBase06: ColorBrandBase06,
    ColorBrandPalette0110: ColorBrandPalette0110,
    ColorBrandPalette0120: ColorBrandPalette0120,
    ColorBrandPalette0130: ColorBrandPalette0130,
    ColorBrandPalette0140: ColorBrandPalette0140,
    ColorBrandPalette0150: ColorBrandPalette0150,
    ColorBrandPalette0160: ColorBrandPalette0160,
    ColorBrandPalette0170: ColorBrandPalette0170,
    ColorBrandPalette0180: ColorBrandPalette0180,
    ColorBrandPalette0190: ColorBrandPalette0190,
    ColorBrandPalette01100: ColorBrandPalette01100,
    ColorBrandPalette01110: ColorBrandPalette01110,
    ColorBrandPalette01120: ColorBrandPalette01120,
    ColorBrandPalette01130: ColorBrandPalette01130,
    ColorBrandPalette01140: ColorBrandPalette01140,
    ColorBrandPalette01150: ColorBrandPalette01150,
    ColorBrandPalette01160: ColorBrandPalette01160,
    ColorBrandPalette0210: ColorBrandPalette0210,
    ColorBrandPalette0220: ColorBrandPalette0220,
    ColorBrandPalette0230: ColorBrandPalette0230,
    ColorBrandPalette0240: ColorBrandPalette0240,
    ColorBrandPalette0250: ColorBrandPalette0250,
    ColorBrandPalette0260: ColorBrandPalette0260,
    ColorBrandPalette0270: ColorBrandPalette0270,
    ColorBrandPalette0280: ColorBrandPalette0280,
    ColorBrandPalette0290: ColorBrandPalette0290,
    ColorBrandPalette02100: ColorBrandPalette02100,
    ColorBrandPalette02110: ColorBrandPalette02110,
    ColorBrandPalette02120: ColorBrandPalette02120,
    ColorBrandPalette02130: ColorBrandPalette02130,
    ColorBrandPalette02140: ColorBrandPalette02140,
    ColorBrandPalette02150: ColorBrandPalette02150,
    ColorBrandPalette02160: ColorBrandPalette02160,
    ColorBrandPalette0410: ColorBrandPalette0410,
    ColorBrandPalette0420: ColorBrandPalette0420,
    ColorBrandPalette0430: ColorBrandPalette0430,
    ColorBrandPalette0440: ColorBrandPalette0440,
    ColorBrandPalette0450: ColorBrandPalette0450,
    ColorBrandPalette0460: ColorBrandPalette0460,
    ColorBrandPalette0470: ColorBrandPalette0470,
    ColorBrandPalette0480: ColorBrandPalette0480,
    ColorBrandPalette0490: ColorBrandPalette0490,
    ColorBrandPalette04100: ColorBrandPalette04100,
    ColorBrandPalette04110: ColorBrandPalette04110,
    ColorBrandPalette04120: ColorBrandPalette04120,
    ColorBrandPalette04130: ColorBrandPalette04130,
    ColorBrandPalette04140: ColorBrandPalette04140,
    ColorBrandPalette04150: ColorBrandPalette04150,
    ColorBrandPalette04160: ColorBrandPalette04160,
    ColorBrandPalette0510: ColorBrandPalette0510,
    ColorBrandPalette0520: ColorBrandPalette0520,
    ColorBrandPalette0530: ColorBrandPalette0530,
    ColorBrandPalette0540: ColorBrandPalette0540,
    ColorBrandPalette0550: ColorBrandPalette0550,
    ColorBrandPalette0560: ColorBrandPalette0560,
    ColorBrandPalette0570: ColorBrandPalette0570,
    ColorBrandPalette0580: ColorBrandPalette0580,
    ColorBrandPalette0590: ColorBrandPalette0590,
    ColorBrandPalette05100: ColorBrandPalette05100,
    ColorBrandPalette05110: ColorBrandPalette05110,
    ColorBrandPalette05120: ColorBrandPalette05120,
    ColorBrandPalette05130: ColorBrandPalette05130,
    ColorBrandPalette05140: ColorBrandPalette05140,
    ColorBrandPalette05150: ColorBrandPalette05150,
    ColorBrandPalette05160: ColorBrandPalette05160,
    ColorBrandPalette0610: ColorBrandPalette0610,
    ColorBrandPalette0620: ColorBrandPalette0620,
    ColorBrandPalette0630: ColorBrandPalette0630,
    ColorBrandPalette0640: ColorBrandPalette0640,
    ColorBrandPalette0650: ColorBrandPalette0650,
    ColorBrandPalette0660: ColorBrandPalette0660,
    ColorBrandPalette0670: ColorBrandPalette0670,
    ColorBrandPalette0680: ColorBrandPalette0680,
    ColorBrandPalette0690: ColorBrandPalette0690,
    ColorBrandPalette06100: ColorBrandPalette06100,
    ColorBrandPalette06110: ColorBrandPalette06110,
    ColorBrandPalette06120: ColorBrandPalette06120,
    ColorBrandPalette06130: ColorBrandPalette06130,
    ColorBrandPalette06140: ColorBrandPalette06140,
    ColorBrandPalette06150: ColorBrandPalette06150,
    ColorBrandPalette06160: ColorBrandPalette06160,
    ColorFeedbackErrorText: ColorFeedbackErrorText,
    ColorFeedbackErrorShape: ColorFeedbackErrorShape,
    ColorFeedbackSuccessText: ColorFeedbackSuccessText,
    ColorFeedbackSuccessShape: ColorFeedbackSuccessShape,
    ColorFeedbackOnBrandErrorText: ColorFeedbackOnBrandErrorText,
    ColorFeedbackOnBrandErrorShape: ColorFeedbackOnBrandErrorShape,
    ColorFeedbackOnBrandSuccessText: ColorFeedbackOnBrandSuccessText,
    ColorFeedbackOnBrandSuccessShape: ColorFeedbackOnBrandSuccessShape,
    ColorFeedbackInverseErrorText: ColorFeedbackInverseErrorText,
    ColorFeedbackInverseErrorShape: ColorFeedbackInverseErrorShape,
    ColorFeedbackInverseSuccessText: ColorFeedbackInverseSuccessText,
    ColorFeedbackInverseSuccessShape: ColorFeedbackInverseSuccessShape,
    ColorFeedbackInverseOnBrandErrorText: ColorFeedbackInverseOnBrandErrorText,
    ColorFeedbackInverseOnBrandErrorShape: ColorFeedbackInverseOnBrandErrorShape,
    ColorFeedbackInverseOnBrandSuccessText: ColorFeedbackInverseOnBrandSuccessText,
    ColorFeedbackInverseOnBrandSuccessShape: ColorFeedbackInverseOnBrandSuccessShape,
    ColorSupport01: ColorSupport01,
    ColorSupport02: ColorSupport02,
    ColorSupportOnBrand01: ColorSupportOnBrand01,
    ColorSupportOnBrand02: ColorSupportOnBrand02,
    ColorSupportInverse01: ColorSupportInverse01,
    ColorSupportInverse02: ColorSupportInverse02,
    ColorSupportInverseOnBrand01: ColorSupportInverseOnBrand01,
    ColorSupportInverseOnBrand02: ColorSupportInverseOnBrand02,
    Opacity01: Opacity01,
    Opacity02: Opacity02,
    Opacity03: Opacity03,
    Opacity04: Opacity04,
    Opacity05: Opacity05,
    Opacity06: Opacity06,
    Opacity07: Opacity07,
    Opacity08: Opacity08,
    Opacity09: Opacity09,
    Shadow01: Shadow01,
    Shadow02: Shadow02,
    Shadow03: Shadow03,
    Shadow04: Shadow04,
    SpacingInlineQuark: SpacingInlineQuark,
    SpacingInlineNano: SpacingInlineNano,
    SpacingInlineXxxs: SpacingInlineXxxs,
    SpacingInlineXxs: SpacingInlineXxs,
    SpacingInlineXs: SpacingInlineXs,
    SpacingInlineSm: SpacingInlineSm,
    SpacingInlineMd: SpacingInlineMd,
    SpacingInlineLg: SpacingInlineLg,
    SpacingInlineXl: SpacingInlineXl,
    SpacingInlineXxl: SpacingInlineXxl,
    SpacingInlineXxxl: SpacingInlineXxxl,
    SpacingInlineHuge: SpacingInlineHuge,
    SpacingInlineGiant: SpacingInlineGiant,
    SpacingInsetQuark: SpacingInsetQuark,
    SpacingInsetNano: SpacingInsetNano,
    SpacingInsetXs: SpacingInsetXs,
    SpacingInsetSm: SpacingInsetSm,
    SpacingInsetMd: SpacingInsetMd,
    SpacingInsetLg: SpacingInsetLg,
    SpacingSquishQuark: SpacingSquishQuark,
    SpacingSquishNano: SpacingSquishNano,
    SpacingSquishXs: SpacingSquishXs,
    SpacingSquishSm: SpacingSquishSm,
    SpacingStackQuark: SpacingStackQuark,
    SpacingStackNano: SpacingStackNano,
    SpacingStackXxxs: SpacingStackXxxs,
    SpacingStackXxs: SpacingStackXxs,
    SpacingStackXs: SpacingStackXs,
    SpacingStackSm: SpacingStackSm,
    SpacingStackMd: SpacingStackMd,
    SpacingStackLg: SpacingStackLg,
    SpacingStackXl: SpacingStackXl,
    SpacingStackXxl: SpacingStackXxl,
    SpacingStackXxxl: SpacingStackXxxl,
    SpacingStackHuge: SpacingStackHuge,
    SpacingStackGiant: SpacingStackGiant,
    FontFamilyBase: FontFamilyBase,
    FontSizeXxxs: FontSizeXxxs,
    FontSizeXxs: FontSizeXxs,
    FontSizeXs: FontSizeXs,
    FontSizeSm: FontSizeSm,
    FontSizeMd: FontSizeMd,
    FontSizeLg: FontSizeLg,
    FontSizeXl: FontSizeXl,
    FontSizeXxl: FontSizeXxl,
    FontSizeXxxl: FontSizeXxxl,
    FontSizeDisplay: FontSizeDisplay,
    FontSizeGiant: FontSizeGiant,
    FontWeightBold: FontWeightBold,
    FontWeightSemibold: FontWeightSemibold,
    FontWeightMedium: FontWeightMedium,
    FontWeightRegular: FontWeightRegular,
    FontWeightLight: FontWeightLight,
    LetterSpacingStandard: LetterSpacingStandard,
    LetterSpacingSmall: LetterSpacingSmall,
    LetterSpacingMedium: LetterSpacingMedium,
    LineHeightStandard: LineHeightStandard,
    LineHeightTiny: LineHeightTiny,
    LineHeightMedium: LineHeightMedium,
    LineHeightLarge: LineHeightLarge,
    LineHeightDistant: LineHeightDistant,
    LineHeightSuperdistant: LineHeightSuperdistant,
    LineHeightHuge: LineHeightHuge
  });
  exports.almTokens = index$8;
  exports.alvTokens = index$7;
  exports.dasTokens = index$6;
  exports.dbnTokens = index$5;
  exports.exmTokens = index$4;
  exports.genTokens = index$3;
  exports.mpuTokens = index$2;
  exports.navTokens = index$1;
  exports.slzTokens = index;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});